(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 5620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(5153);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fetchDocumentsToBeUploaded": function() { return /* binding */ fetchDocumentsToBeUploaded; },
/* harmony export */   "postOrderDetails": function() { return /* binding */ postOrderDetails; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2729);
/* harmony import */ var utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4733);





var postOrderDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(orderDetails, partner, groupName) {
        var ref, status, data, e, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            method: "POST",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getDomainOrigin */ .IY)(), "/api/mpos/partner/").concat(partner, "/order?group_name=").concat(groupName),
                            data: orderDetails
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200 && data) {
                        return [
                            2,
                            {
                                status: true,
                                data: data
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                statusCode: 401
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 400) {
                        ;
                        return [
                            2,
                            {
                                statusCode: 400,
                                errorMessage: e === null || e === void 0 ? void 0 : (ref5 = e.response) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.message
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref3 = e.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 409) {
                        ;
                        return [
                            2,
                            {
                                statusCode: 409,
                                errorMessage: e === null || e === void 0 ? void 0 : (ref7 = e.response) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.message
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref4 = e.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 410) {
                        ;
                        return [
                            2,
                            {
                                statusCode: 410,
                                errorMessage: e === null || e === void 0 ? void 0 : (ref9 = e.response) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : ref10.message
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function postOrderDetails(orderDetails, partner, groupName) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDocumentsToBeUploaded = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(partnerId, planId, programId) {
        var ref, status, data, e, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getDomainOrigin */ .IY)(), "/api/mpos/partner/").concat(partnerId, "/plan/documents?plan_id=").concat(planId, "&program_id=").concat(programId)
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    return [
                        2,
                        {
                            statusCode: status,
                            data: data
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                statusCode: 401,
                                data: []
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 400) {
                        ;
                        return [
                            2,
                            {
                                statusCode: 400,
                                errorMessage: e === null || e === void 0 ? void 0 : (ref5 = e.response) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.message,
                                data: []
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref3 = e.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 409) {
                        ;
                        return [
                            2,
                            {
                                statusCode: 409,
                                errorMessage: e === null || e === void 0 ? void 0 : (ref7 = e.response) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.message,
                                data: []
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref4 = e.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 410) {
                        ;
                        return [
                            2,
                            {
                                statusCode: 410,
                                errorMessage: e === null || e === void 0 ? void 0 : (ref9 = e.response) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : ref10.message,
                                data: []
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            statusCode: 500,
                            data: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDocumentsToBeUploaded(partnerId, planId, programId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 5153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.theme/dist/index.js
var dist = __webpack_require__(549);
// EXTERNAL MODULE: ./components/dashboard/index.tsx + 23 modules
var dashboard = __webpack_require__(8674);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92);
// EXTERNAL MODULE: ./hooks/useSegmentView.ts
var useSegmentView = __webpack_require__(5122);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./utils/context/index.ts
var context = __webpack_require__(7720);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./utils/segment/constants.ts
var constants = __webpack_require__(7316);
// EXTERNAL MODULE: ./widgets/errorScreen/index.tsx + 1 modules
var errorScreen = __webpack_require__(8269);
// EXTERNAL MODULE: ./widgets/header/index.tsx + 1 modules
var header = __webpack_require__(9015);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.input/dist/index.js
var building_blocks_ui_input_dist = __webpack_require__(3282);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.button/dist/index.js
var building_blocks_ui_button_dist = __webpack_require__(2518);
// EXTERNAL MODULE: ./library/snackbar/index.tsx + 1 modules
var library_snackbar = __webpack_require__(6241);
// EXTERNAL MODULE: ./utils/validation/index.ts
var validation = __webpack_require__(4150);
// EXTERNAL MODULE: ./utils/responsive/index.tsx
var responsive = __webpack_require__(1798);
// EXTERNAL MODULE: ./widgets/otp/index.tsx + 1 modules
var otp = __webpack_require__(4850);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var building_blocks_ui_common_dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./components/manageDealers/addNewSubDealer/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    color: #040222;\n    margin: 16px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin: 16px 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Wrapper = building_blocks_ui_common_dist.styled.div(_templateObject());
var Header = building_blocks_ui_common_dist.styled.div(_templateObject1());
var BackArrowIcon = building_blocks_ui_common_dist.styled.div(_templateObject2());
var Title = building_blocks_ui_common_dist.styled.div(_templateObject3());
var InputWrapper = building_blocks_ui_common_dist.styled.div(_templateObject4());
var AddButtonWrapper = building_blocks_ui_common_dist.styled.div(_templateObject5());

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.acko-analytics/dist/index.js
var building_blocks_ui_acko_analytics_dist = __webpack_require__(4262);
;// CONCATENATED MODULE: ./components/manageDealers/addNewSubDealer/index.tsx




















function AddNewSubDealer(param) {
    var subDealers = param.subDealers, setSubDealers = param.setSubDealers, setShowAddNewSubDealer = param.setShowAddNewSubDealer;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, userDetails = ref.userDetails, permissions = ref.permissions;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,compat_module.useState)(""), phoneNumber = ref1[0], setPhoneNumber = ref1[1];
    var ref2 = (0,compat_module.useState)(""), name = ref2[0], setName = ref2[1];
    var ref3 = (0,compat_module.useState)(""), dealerCode = ref3[0], setDealerCode = ref3[1];
    var ref4 = (0,compat_module.useState)(false), showOTP = ref4[0], setShowOTP = ref4[1];
    var ref5 = (0,compat_module.useState)(true), isDisabled = ref5[0], setIsDisabled = ref5[1];
    var ref6 = (0,compat_module.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var ref7 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref7[0], setSnackbar = ref7[1];
    var ref8 = (0,compat_module.useState)({
        name: "",
        phoneNumber: "",
        dealerCode: ""
    }), validationErr = ref8[0], setValidationErr = ref8[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var group = permissions.group;
    (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_CONFIRM_SUB_DEALER */.g0.VIEW_CONFIRM_SUB_DEALER,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    (0,compat_module.useEffect)(function() {
        var validationStatus = false;
        if (!((0,validation/* inputRegexValidation */.xz)(phoneNumber) && (0,validation/* phoneNumberValidation */.q$)(phoneNumber))) {
            validationStatus = true;
            if (phoneNumber) {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    phoneNumber: "Invalid mobile number"
                }));
            }
        } else {
            setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                phoneNumber: ""
            }));
        }
        if (!((0,validation/* inputRegexValidation */.xz)(name) && (name === null || name === void 0 ? void 0 : name.length) > 2)) {
            validationStatus = true;
            if (name) {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    name: "Invalid name"
                }));
            }
        } else {
            setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                name: ""
            }));
        }
        if (dealerCode) {
            if (!((0,validation/* inputRegexValidation */.xz)(dealerCode) && (dealerCode === null || dealerCode === void 0 ? void 0 : dealerCode.length) > 2)) {
                validationStatus = true;
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    dealerCode: "Invalid dealer code"
                }));
            } else {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    dealerCode: ""
                }));
            }
        }
        setIsDisabled(validationStatus);
    }, [
        phoneNumber,
        name,
        dealerCode
    ]);
    var addDealer = function() {
        var ref;
        if (phoneNumber === userDetails.phone) {
            setSnackbar({
                type: "failure",
                message: "Sub dealer phone should not be a dealer`s phone number"
            });
            return;
        }
        var filteredList = subDealers === null || subDealers === void 0 ? void 0 : subDealers.filter(function(subDealer) {
            return (subDealer === null || subDealer === void 0 ? void 0 : subDealer.phone) === phoneNumber;
        });
        if ((filteredList === null || filteredList === void 0 ? void 0 : filteredList.length) > 0) {
            setSnackbar({
                type: "failure",
                message: "Sub dealer phone number is already exists."
            });
            return;
        }
        __webpack_require__.e(/* import() */ 79).then(__webpack_require__.bind(__webpack_require__, 5079)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, errMsg;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            return [
                                4,
                                req.triggerSubDealerAddOTP(userDetails.phone)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, errMsg = ref.errMsg;
                            if (status) {
                                setShowOTP(true);
                            } else {
                                setSnackbar({
                                    type: "failure",
                                    message: errMsg || "Oops. Something went wrong."
                                });
                            }
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
        /**
         * Segment event
         */ (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            page_url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "",
            button_name: constants/* SegmentEventButtonNames.CONFIRM_SUB_DEALER */.A3.CONFIRM_SUB_DEALER,
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.CLICK_CONFIRM_SUB_DEALERS */.iV.CLICK_CONFIRM_SUB_DEALERS,
            product: constants/* PRODUCT */.c5,
            sub_product: constants/* SUB_PRODUCT_NAME */.tM,
            platform: isMobile ? "mweb" : "web",
            device: navigator.userAgent || "",
            partner: partnerId
        });
    };
    var handleSnakbarComplete = function() {
        setSnackbar({
            type: "",
            message: ""
        });
    };
    var onSuccess = function() {
        __webpack_require__.e(/* import() */ 538).then(__webpack_require__.bind(__webpack_require__, 2538)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, statusCode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            return [
                                4,
                                req.addSubDealer(partnerId, [
                                    {
                                        name: name,
                                        phone: phoneNumber,
                                        partner_id: partnerId,
                                        dealer_code: dealerCode
                                    }
                                ], group)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, statusCode = ref.statusCode;
                            setIsLoading(false);
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status) {
                                setSubDealers(function(subDealers) {
                                    return subDealers.concat([
                                        {
                                            phone: phoneNumber,
                                            name: name
                                        }
                                    ]);
                                });
                                setName("");
                                setPhoneNumber("");
                                setDealerCode("");
                                setShowAddNewSubDealer(false);
                                setSnackbar({
                                    type: "success",
                                    message: "Sub-dealer successfully added"
                                });
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: "Oops. Something went wrong."
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var onBack = function() {
        setShowAddNewSubDealer(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        children: [
            showOTP ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(otp/* default */.Z, {
                phoneNumber: userDetails.phone,
                onClickBack: function() {
                    return setShowOTP(false);
                },
                onClickEdit: function() {
                    return setShowOTP(false);
                },
                onSuccess: onSuccess
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Header, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BackArrowIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: "10px",
                                height: "24px",
                                alt: "",
                                src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                                onClick: onBack
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Title, {
                        children: "Add Sub-dealer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "phone",
                            type: "text",
                            className: "",
                            value: phoneNumber,
                            onChange: function(e) {
                                return setPhoneNumber(e.target.value);
                            },
                            placeHolder: "Enter mobile number",
                            leftElement: "+91",
                            maxLength: "10",
                            hasError: validationErr.phoneNumber.length > 0,
                            errMsg: validationErr.phoneNumber
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "name",
                            type: "text",
                            className: "",
                            value: name,
                            onChange: function(e) {
                                return setName(e.target.value);
                            },
                            placeHolder: "Enter name",
                            hasError: validationErr.name.length > 0,
                            errMsg: validationErr.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "dealer_code",
                            type: "text",
                            className: "",
                            value: dealerCode,
                            onChange: function(e) {
                                return setDealerCode(e.target.value);
                            },
                            placeHolder: "Enter your dealer code"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AddButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                            loading: isLoading,
                            disabled: isDisabled,
                            onClick: addDealer,
                            children: "Add dealer"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: handleSnakbarComplete
            }))
        ]
    });
}
/* harmony default export */ var addNewSubDealer = (AddNewSubDealer);

;// CONCATENATED MODULE: ./components/manageDealers/dealerDetails/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 2;\n    flex-direction: column;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: #040222;\n    margin-top: 4px;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    height: 0;\n    border: 1px solid #e7e7f0;\n    margin-top: 10px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var styles_Wrapper = building_blocks_ui_common_dist.styled.div(styles_templateObject());
var DetailsFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject1());
var DealerDetailsFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject2());
var Name = building_blocks_ui_common_dist.styled.div(styles_templateObject3());
var Phone = building_blocks_ui_common_dist.styled.div(styles_templateObject4());
var DeleteIconFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject5());
var Hr = building_blocks_ui_common_dist.styled.div(_templateObject6());

;// CONCATENATED MODULE: ./components/manageDealers/dealerDetails/index.tsx




function DealerDetails(param) {
    var index = param.index, name = param.name, phone = param.phone, hasPermission = param.hasPermission, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DetailsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DealerDetailsFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Name, {
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Phone, {
                                children: phone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DeleteIconFlex, {
                        children: hasPermission && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "24px",
                            height: "24px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/trash.svg"),
                            onClick: function() {
                                return onClick(index, name, phone);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
        ]
    });
}
/* harmony default export */ var dealerDetails = (DealerDetails);

// EXTERNAL MODULE: ./widgets/confirmation/index.tsx + 1 modules
var confirmation = __webpack_require__(7834);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.modal/dist/index.js
var building_blocks_ui_modal_dist = __webpack_require__(5251);
// EXTERNAL MODULE: ./utils/styles/index.ts
var styles = __webpack_require__(7631);
// EXTERNAL MODULE: ./hooks/useResponsiveDevice.ts
var useResponsiveDevice = __webpack_require__(9047);
// EXTERNAL MODULE: ./utils/constants/index.ts
var utils_constants = __webpack_require__(1485);
;// CONCATENATED MODULE: ./components/manageDealers/styles.ts

function manageDealers_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    manageDealers_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function manageDealers_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    manageDealers_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function manageDealers_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    manageDealers_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function manageDealers_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 26px;\n"
    ]);
    manageDealers_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function manageDealers_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    manageDealers_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function manageDealers_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-left: 8px;\n    align-items: center;\n    cursor: pointer;\n"
    ]);
    manageDealers_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 24px;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var manageDealers_styles_Wrapper = building_blocks_ui_common_dist.styled.div(manageDealers_styles_templateObject());
var styles_Header = building_blocks_ui_common_dist.styled.div(manageDealers_styles_templateObject1());
var styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(manageDealers_styles_templateObject2());
var AddSubDealerFlex = building_blocks_ui_common_dist.styled.div(manageDealers_styles_templateObject3());
var IconFlex = building_blocks_ui_common_dist.styled.div(manageDealers_styles_templateObject4());
var AddSubDealer = building_blocks_ui_common_dist.styled.div(manageDealers_styles_templateObject5());
var SubDealerDetails = building_blocks_ui_common_dist.styled.div(styles_templateObject6());
var AddRemoveDealerText = building_blocks_ui_common_dist.styled.div(_templateObject7());

;// CONCATENATED MODULE: ./components/manageDealers/index.tsx























function ManageDealers() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), setShowHamburger = ref.setShowHamburger, partnerId = ref.partnerId, permissions = ref.permissions, permissionsMap = ref.permissionsMap;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref1 = (0,compat_module.useState)([]), subDealers = ref1[0], setSubDealers = ref1[1];
    var ref2 = (0,compat_module.useState)({
        name: "",
        phone: "",
        index: -1
    }), selectedSubDealer = ref2[0], setSelectedSubDealer = ref2[1];
    var ref3 = (0,compat_module.useState)(false), showAddNewSubDealer = ref3[0], setShowAddNewSubDealer = ref3[1];
    var ref4 = (0,compat_module.useState)(false), showDeleteModal = ref4[0], setShowDeleteModal = ref4[1];
    var ref5 = (0,compat_module.useState)(permissionsMap[utils_constants/* Permissions.ADD_SUB_DEALERS */.Pl.ADD_SUB_DEALERS] || permissions.permission_list.length > 0 || false), hasPermission = ref5[0], setHasPermission = ref5[1];
    var ref6 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref6[0], setSnackbar = ref6[1];
    var ref7 = (0,compat_module.useState)(true), isPageLoading = ref7[0], setIsPageLoading = ref7[1];
    var ref8 = (0,compat_module.useState)(false), showErrorPage = ref8[0], setShowErrorPage = ref8[1];
    var group = permissions.group;
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_ADD_REMOVE_SUB_DEALER */.g0.VIEW_ADD_REMOVE_SUB_DEALER,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    (0,compat_module.useEffect)(function() {
        setHasPermission(permissionsMap[utils_constants/* Permissions.ADD_SUB_DEALERS */.Pl.ADD_SUB_DEALERS] || permissions.permission_list.length > 0 || false);
    }, [
        permissionsMap
    ]);
    (0,compat_module.useEffect)(function() {
        if (!showAddNewSubDealer) {
            getSubDealers();
        }
    }, [
        showAddNewSubDealer
    ]);
    var getSubDealers = function() {
        __webpack_require__.e(/* import() */ 538).then(__webpack_require__.bind(__webpack_require__, 2538)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, statusCode, data, sub_dealers;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getSubDealers(partnerId, group)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, statusCode = ref.statusCode, data = ref.data;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status && data) {
                                sub_dealers = data.sub_dealers;
                                setSubDealers(sub_dealers || []);
                                setShowErrorPage(false);
                            } else {
                                setShowErrorPage(true);
                            }
                            setIsPageLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var onDeleteSubDealer = function(index, name, phone) {
        setShowDeleteModal(true);
        setSelectedSubDealer({
            name: name,
            phone: phone,
            index: index
        });
    };
    var onConfirmDelete = function(_e, action) {
        setShowDeleteModal(false);
        if (action === "no") {
            return;
        }
        __webpack_require__.e(/* import() */ 538).then(__webpack_require__.bind(__webpack_require__, 2538)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, statusCode, subDealersCopy;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.removeSubDealers(partnerId, selectedSubDealer.phone, group)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, statusCode = ref.statusCode;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status) {
                                setSnackbar({
                                    type: "success",
                                    message: "Sub-dealer successfully deleted"
                                });
                                subDealersCopy = Object.assign([], subDealers);
                                subDealersCopy.splice(selectedSubDealer.index, 1);
                                setSubDealers(subDealersCopy);
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: "Oops. Something went wrong."
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var onBack = function() {
        setShowHamburger(true);
    };
    var onClickAddSubDealer = function() {
        if ((subDealers === null || subDealers === void 0 ? void 0 : subDealers.length) > 2) {
            setSnackbar({
                type: "failure",
                message: "You can only add upto 3 sub dealers"
            });
            return;
        }
        setShowAddNewSubDealer(true);
    };
    var checkPermission = function(p) {
        var index = permissions.permission_list.findIndex(function(permission) {
            return permission === p;
        });
        return index !== -1;
    };
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    if (isPageLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (!hasPermission || showErrorPage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            errorMessage: showErrorPage ? "" : "You don't have permission to view this page"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(manageDealers_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            showAddNewSubDealer ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(addNewSubDealer, {
                subDealers: subDealers,
                setSubDealers: setSubDealers,
                setShowAddNewSubDealer: setShowAddNewSubDealer
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Header, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_BackArrowIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: "10px",
                                height: "24px",
                                alt: "",
                                src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                                onClick: onBack
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AddRemoveDealerText, {
                        children: "Add/ remove sub-dealer"
                    }),
                    subDealers === null || subDealers === void 0 ? void 0 : subDealers.map(function(dealer, index) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubDealerDetails, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dealerDetails, {
                                index: index,
                                name: dealer.name,
                                phone: dealer.phone,
                                onClick: onDeleteSubDealer,
                                hasPermission: checkPermission(utils_constants/* Permissions.REMOVE_SUB_DEALERS */.Pl.REMOVE_SUB_DEALERS)
                            })
                        }, dealer.phone);
                    }),
                    checkPermission(utils_constants/* Permissions.ADD_SUB_DEALERS */.Pl.ADD_SUB_DEALERS) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(AddSubDealerFlex, {
                        onClick: onClickAddSubDealer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconFlex, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    width: "24px",
                                    height: "24px",
                                    alt: "",
                                    src: (subDealers === null || subDealers === void 0 ? void 0 : subDealers.length) < 3 ? (0,generics/* getImageBasePath */.m4)("/icons/greenPlus.svg") : (0,generics/* getImageBasePath */.m4)("/icons/grayPlus.svg")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AddSubDealer, {
                                children: "Add new sub-dealer"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                show: showDeleteModal,
                onHide: function() {
                    return setShowDeleteModal(false);
                },
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(confirmation/* default */.Z, {
                    image: "/images/alert.svg",
                    text: "Are you sure you want to remove the sub-dealer?",
                    subText: selectedSubDealer.name,
                    onClick: onConfirmDelete
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var manageDealers = (ManageDealers);

// EXTERNAL MODULE: ./components/newPlan/constants.ts
var newPlan_constants = __webpack_require__(5327);
// EXTERNAL MODULE: ./hooks/useFetchParams.ts
var useFetchParams = __webpack_require__(6982);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.dropdown/dist/index.js
var building_blocks_ui_dropdown_dist = __webpack_require__(9657);
;// CONCATENATED MODULE: ./components/newPlan/mobileModels/utils.ts

var getLabels = function(partner) {
    switch(partner){
        case utils_constants/* Partners.REALME */.wV.REALME:
            return {
                label1: "Select appliance",
                label2: "Search appliance"
            };
        case utils_constants/* Partners.XIAOMI */.wV.XIAOMI:
            return {
                label1: "Select Product Model",
                label2: "Search model"
            };
        default:
            return {
                label1: "Select Product Model",
                label2: "Search mobile"
            };
    }
};

;// CONCATENATED MODULE: ./components/newPlan/mobileModels/styles.ts

function mobileModels_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    /* height: 100vh; */\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    mobileModels_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mobileModels_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    mobileModels_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mobileModels_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    mobileModels_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mobileModels_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    mobileModels_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function mobileModels_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 24px;\n    .mobileModalDropdown > div > div {\n        display: flex;\n        flex-direction: column;\n\n        /* Add margin-bottom to the last item */\n        > div:last-child {\n            margin-bottom: 24px;\n        }\n    }\n"
    ]);
    mobileModels_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function mobileModels_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #040222;\n    border-radius: 8px;\n    padding: 10px;\n"
    ]);
    mobileModels_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function mobileModels_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    height: 1000px;\n"
    ]);
    mobileModels_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var mobileModels_styles_Wrapper = building_blocks_ui_common_dist.styled.div(mobileModels_styles_templateObject());
var mobileModels_styles_Header = building_blocks_ui_common_dist.styled.div(mobileModels_styles_templateObject1());
var mobileModels_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(mobileModels_styles_templateObject2());
var SelectModelText = building_blocks_ui_common_dist.styled.div(mobileModels_styles_templateObject3());
var SelectModelDropdown = building_blocks_ui_common_dist.styled.div(mobileModels_styles_templateObject4());
var SearchInput = building_blocks_ui_common_dist.styled.input(mobileModels_styles_templateObject5());
var MobileModelContainer = building_blocks_ui_common_dist.styled.div(mobileModels_styles_templateObject6());
var IMEIValidationContainer = building_blocks_ui_common_dist.styled.div(styles_templateObject7()); // export const;

;// CONCATENATED MODULE: ./components/newPlan/imeiModelScreen/styles.ts

function imeiModelScreen_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    imeiModelScreen_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function imeiModelScreen_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    imeiModelScreen_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function imeiModelScreen_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    imeiModelScreen_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function imeiModelScreen_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n    flex-direction: column;\n"
    ]);
    imeiModelScreen_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function imeiModelScreen_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n"
    ]);
    imeiModelScreen_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function imeiModelScreen_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 25px 0;\n"
    ]);
    imeiModelScreen_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function imeiModelScreen_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 12px;\n    align-items: flex-end;\n    width: 100%;\n"
    ]);
    imeiModelScreen_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function imeiModelScreen_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n"
    ]);
    imeiModelScreen_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px 16px;\n    background-color: #40a7a3;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background-color 0.2s ease;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover:not(:disabled) {\n        background-color: #358a87;\n    }\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var imeiModelScreen_styles_Wrapper = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject());
var EnterSerialNumberText = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject1());
var SerialNumberText = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject2());
var styles_InputWrapper = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject3());
var EnterMoreDetails = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject4());
var ButtonWrapper = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject5());
var InputAndScanWrapper = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject6());
var InputContainer = building_blocks_ui_common_dist.styled.div(imeiModelScreen_styles_templateObject7());
var ScanButton = building_blocks_ui_common_dist.styled.button(_templateObject8());

;// CONCATENATED MODULE: ./components/newPlan/imeiModelScreen/utils.ts

var utils_getLabels = function(modelType) {
    if (modelType === "mobile" || modelType === "tablet") {
        return {
            title: "Enter IMEI number",
            label: "IMEI number",
            confirmLabel: "Confirm IMEI number",
            verifyLabel: "I have verified the IMEI number for plan issuance"
        };
    }
    return {
        title: "Appliance Serial Number",
        label: "Serial number",
        confirmLabel: "Confirm serial number",
        verifyLabel: "I have verified the serial number"
    };
};
var isValidIMEI = function(imei, partnerId) {
    if (partnerId === utils_constants/* Partners.HERO_VIDA */.wV.HERO_VIDA) {
        return true;
    }
    if (partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
        return imei.length >= 8 && imei.length <= 20;
    }
    if (partnerId === utils_constants/* Partners.XIAOMI */.wV.XIAOMI) {
        var trimmedValue = imei.trim().length === 0;
        var mobileValidation = (imei === null || imei === void 0 ? void 0 : imei.length) === 15 && /^[0-9]+$/.test(imei);
        var televisionValidation = (imei === null || imei === void 0 ? void 0 : imei.length) > 0 && /^\d{5}\/C\d{13}$/.test(imei);
        return mobileValidation || televisionValidation || !trimmedValue;
    }
    if ((imei === null || imei === void 0 ? void 0 : imei.length) === 15 && /^[0-9]+$/.test(imei)) return true;
    return false;
};

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 50 modules
var lib_axios = __webpack_require__(2729);
// EXTERNAL MODULE: ./utils/serverConfig/index.ts
var serverConfig = __webpack_require__(4733);
;// CONCATENATED MODULE: ./components/newPlan/imeiModelScreen/api.ts





var verifyDevice = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, serial_number, group) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, data, ref9, e, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/imei-detail?serial-number=").concat(serial_number, "&group_name=").concat(group)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            message: data.message,
                            isValid: data.is_valid,
                            modelDetails: {
                                id: data === null || data === void 0 ? void 0 : (ref = data.model_details) === null || ref === void 0 ? void 0 : ref.id,
                                activationDate: data === null || data === void 0 ? void 0 : (ref1 = data.model_details) === null || ref1 === void 0 ? void 0 : ref1.activation_date,
                                description: data === null || data === void 0 ? void 0 : (ref2 = data.model_details) === null || ref2 === void 0 ? void 0 : ref2.description,
                                modelMappingName: data === null || data === void 0 ? void 0 : (ref3 = data.model_details) === null || ref3 === void 0 ? void 0 : ref3.model_mapping_name,
                                name: data === null || data === void 0 ? void 0 : (ref4 = data.model_details) === null || ref4 === void 0 ? void 0 : ref4.name,
                                price: data === null || data === void 0 ? void 0 : (ref5 = data.model_details) === null || ref5 === void 0 ? void 0 : ref5.price,
                                type: data === null || data === void 0 ? void 0 : (ref6 = data.model_details) === null || ref6 === void 0 ? void 0 : ref6.type,
                                brand: data === null || data === void 0 ? void 0 : (ref7 = data.model_details) === null || ref7 === void 0 ? void 0 : ref7.brand,
                                showActivationDate: (ref9 = data === null || data === void 0 ? void 0 : (ref8 = data.model_details) === null || ref8 === void 0 ? void 0 : ref8.show_activation_date) !== null && ref9 !== void 0 ? ref9 : true
                            }
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref10 = e.response) === null || ref10 === void 0 ? void 0 : ref10.status) === 401) {
                        ;
                        return [
                            2,
                            {
                                isValid: false,
                                message: e === null || e === void 0 ? void 0 : (ref14 = e.response) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : ref15.message
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref11 = e.response) === null || ref11 === void 0 ? void 0 : ref11.status) === 400) {
                        ;
                        return [
                            2,
                            {
                                isValid: false,
                                message: e === null || e === void 0 ? void 0 : (ref16 = e.response) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.data) === null || ref17 === void 0 ? void 0 : ref17.message
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            isValid: false,
                            message: e === null || e === void 0 ? void 0 : (ref12 = e.response) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : ref13.message
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function verifyDevice(partnerId, serial_number, group) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(63);
;// CONCATENATED MODULE: ./components/modelDetails/styles.ts

function modelDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    margin-top: 10px;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    background: #0fa457;\n"
    ]);
    modelDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function modelDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #ffffff;\n    margin: 5px 0;\n"
    ]);
    modelDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var modelDetails_styles_Wrapper = styled_components_browser_esm["default"].div(modelDetails_styles_templateObject());
var Text = styled_components_browser_esm["default"].div(modelDetails_styles_templateObject1());

// EXTERNAL MODULE: ./utils/date/index.ts + 37 modules
var date = __webpack_require__(4679);
;// CONCATENATED MODULE: ./components/modelDetails/index.tsx



var ModelDetails = function(props) {
    var modelName = props.modelName, activationDate = props.activationDate, imei = props.imei, showActivationDate = props.showActivationDate;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(modelDetails_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Text, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        style: {
                            fontWeight: 600
                        },
                        children: "Model Name:"
                    }),
                    " ",
                    modelName
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Text, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        style: {
                            fontWeight: 600
                        },
                        children: "IMEI:"
                    }),
                    " ",
                    imei
                ]
            }),
            showActivationDate && activationDate && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Text, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        style: {
                            fontWeight: 600
                        },
                        children: "Activation Date:"
                    }),
                    " ",
                    (0,date/* formatDateTime */.o0)(activationDate)
                ]
            })
        ]
    });
};
/* harmony default export */ var components_modelDetails = (ModelDetails);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/html5-qrcode/esm/index.js + 22 modules
var esm = __webpack_require__(6916);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./features/imeiScanner/cameraSelection.ts





var REAR_CAMERA_LABEL_PATTERN = /\b(back|rear|environment|world|main|telephoto|wide)\b|facing\s*back/i;
var FRONT_CAMERA_LABEL_PATTERN = /\b(front|user|selfie)\b|facing\s*front/i;
function getCameraPreferenceScore(device, index) {
    var label = device.label.toLowerCase();
    if (FRONT_CAMERA_LABEL_PATTERN.test(label)) {
        return -100;
    }
    if (REAR_CAMERA_LABEL_PATTERN.test(label)) {
        return 100 + index;
    }
    return 0;
}
function getPreferredRearCamera(devices) {
    var ref = (0,_sliced_to_array/* default */.Z)(devices.reduce(function(param, device, index) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), currentDevice = _param[0], currentScore = _param[1];
        var score = getCameraPreferenceScore(device, index);
        return score > currentScore ? [
            device,
            score
        ] : [
            currentDevice,
            currentScore
        ];
    }, [
        null,
        0
    ]), 2), bestDevice = ref[0], bestScore = ref[1];
    return bestScore > 0 ? bestDevice : null;
}
function createDeviceOption(device) {
    return {
        constraints: {
            deviceId: {
                exact: device.id
            }
        },
        label: device.label || device.id
    };
}
function getCameraStartOptions(devices) {
    var seenDeviceIds = new Set();
    var deviceOptions = [
        getPreferredRearCamera(devices),
        devices[devices.length - 1], 
    ].concat((0,_to_consumable_array/* default */.Z)(devices.slice().reverse())).reduce(function(options, device) {
        if (!device || seenDeviceIds.has(device.id)) {
            return options;
        }
        seenDeviceIds.add(device.id);
        return (0,_to_consumable_array/* default */.Z)(options).concat([
            createDeviceOption(device)
        ]);
    }, []);
    return [
        {
            constraints: {
                facingMode: {
                    exact: "environment"
                }
            },
            label: "environment camera"
        },
        {
            constraints: {
                facingMode: "environment"
            },
            label: "preferred environment camera"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(deviceOptions));
}
function isUserFacingCamera(scanner) {
    try {
        return scanner.getRunningTrackSettings().facingMode === "user";
    } catch (err) {
        console.warn("[ImeiScanner] unable to read camera settings:", err);
        return false;
    }
}
function stopStartedScanner(scanner) {
    return _stopStartedScanner.apply(this, arguments);
}
function _stopStartedScanner() {
    _stopStartedScanner = (0,src_async_to_generator/* default */.Z)(function(scanner) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        scanner.stop()
                    ];
                case 1:
                    _state.sent();
                    scanner.clear();
                    return [
                        2
                    ];
            }
        });
    });
    return _stopStartedScanner.apply(this, arguments);
}
function startScannerWithFallback(_) {
    return _startScannerWithFallback.apply(this, arguments);
}
function _startScannerWithFallback() {
    _startScannerWithFallback = (0,src_async_to_generator/* default */.Z)(function(param) {
        var cameraOptions, scanConfig, createScanner, onDecode, onScannerChange, _shouldContinue, shouldContinue, tryStartCamera;
        return (0,tslib_es6.__generator)(this, function(_state) {
            cameraOptions = param.cameraOptions, scanConfig = param.scanConfig, createScanner = param.createScanner, onDecode = param.onDecode, onScannerChange = param.onScannerChange, _shouldContinue = param.shouldContinue, shouldContinue = _shouldContinue === void 0 ? function() {
                return true;
            } : _shouldContinue;
            tryStartCamera = function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(optionIndex) {
                    var lastError, cameraOption, scanner, err;
                    var _arguments = arguments;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                lastError = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                                if (!shouldContinue()) return [
                                    2,
                                    null
                                ];
                                cameraOption = cameraOptions[optionIndex];
                                if (!cameraOption) {
                                    throw (0,_instanceof/* default */.Z)(lastError, Error) ? lastError : new Error("Failed to start camera");
                                }
                                scanner = createScanner();
                                onScannerChange === null || onScannerChange === void 0 ? void 0 : onScannerChange(scanner);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    scanner.start(cameraOption.constraints, scanConfig, onDecode, undefined)
                                ];
                            case 2:
                                _state.sent();
                                if (!!shouldContinue()) return [
                                    3,
                                    4
                                ];
                                onScannerChange === null || onScannerChange === void 0 ? void 0 : onScannerChange(null);
                                return [
                                    4,
                                    stopStartedScanner(scanner)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    null
                                ];
                            case 4:
                                if (!(isUserFacingCamera(scanner) && optionIndex < cameraOptions.length - 1)) return [
                                    3,
                                    6
                                ];
                                onScannerChange === null || onScannerChange === void 0 ? void 0 : onScannerChange(null);
                                return [
                                    4,
                                    stopStartedScanner(scanner)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2,
                                    tryStartCamera(optionIndex + 1, new Error("".concat(cameraOption.label, " started the front camera")))
                                ];
                            case 6:
                                return [
                                    2,
                                    scanner
                                ];
                            case 7:
                                err = _state.sent();
                                onScannerChange === null || onScannerChange === void 0 ? void 0 : onScannerChange(null);
                                try {
                                    scanner.clear();
                                } catch (clearError) {
                                    console.warn("[ImeiScanner] clear error after failing to start ".concat(cameraOption.label, ":"), clearError);
                                }
                                return [
                                    2,
                                    tryStartCamera(optionIndex + 1, err)
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function tryStartCamera(optionIndex) {
                    return _ref.apply(this, arguments);
                };
            }();
            return [
                2,
                tryStartCamera(0)
            ];
        });
    });
    return _startScannerWithFallback.apply(this, arguments);
}

;// CONCATENATED MODULE: ./features/imeiScanner/useImeiScanner.ts








var INITIAL_STATE = {
    status: "initializing",
    errorMessage: null,
    cameraOptions: []
};
function scannerReducer(state, action) {
    switch(action.type){
        case "CAMERA_READY":
            return {
                status: "ready",
                errorMessage: null,
                cameraOptions: action.cameraOptions
            };
        case "SCANNING":
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                status: "scanning",
                errorMessage: null
            });
        case "SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                status: "success"
            });
        case "ERROR":
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                status: "error",
                errorMessage: action.message
            });
        case "NO_CAMERA":
            return {
                status: "noCamera",
                errorMessage: null,
                cameraOptions: []
            };
        case "PERMISSION_DENIED":
            return {
                status: "permissionDenied",
                errorMessage: null,
                cameraOptions: []
            };
        case "RESET":
            return INITIAL_STATE;
        default:
            return state;
    }
}
var READER_ELEMENT_ID = "imei-barcode-reader";
var SCAN_CONFIG = {
    fps: 10,
    qrbox: {
        width: 250,
        height: 150
    },
    formatsToSupport: [
        esm/* Html5QrcodeSupportedFormats.CODE_128 */.CE.CODE_128
    ]
};
function useImeiScanner(param) {
    var onSuccess = param.onSuccess;
    var ref = (0,compat_module.useReducer)(scannerReducer, INITIAL_STATE), state = ref[0], dispatch = ref[1];
    var scannerRef = (0,compat_module.useRef)(null);
    var lastScanRef = (0,compat_module.useRef)(null);
    var mountedRef = (0,compat_module.useRef)(true);
    // Ref avoids stale closure in the decode callback
    var onSuccessRef = (0,compat_module.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    var stopScanning = (0,compat_module.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var scanner, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    scanner = scannerRef.current;
                    if (!scanner) return [
                        2
                    ];
                    scannerRef.current = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        scanner.stop()
                    ];
                case 2:
                    _state.sent();
                    scanner.clear();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    console.warn("[ImeiScanner] stop error (safe to ignore):", e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var checkCamera = (0,compat_module.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var devices, err, message;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        esm/* Html5Qrcode.getCameras */.t2.getCameras()
                    ];
                case 1:
                    devices = _state.sent();
                    if (!mountedRef.current) return [
                        2
                    ];
                    if (devices.length === 0) {
                        dispatch({
                            type: "NO_CAMERA"
                        });
                        return [
                            2
                        ];
                    }
                    dispatch({
                        type: "CAMERA_READY",
                        cameraOptions: getCameraStartOptions(devices)
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    if (!mountedRef.current) return [
                        2
                    ];
                    message = (0,_instanceof/* default */.Z)(err, Error) ? err.message : String(err);
                    if (message.includes("Permission") || message.includes("NotAllowedError")) {
                        dispatch({
                            type: "PERMISSION_DENIED"
                        });
                    } else {
                        dispatch({
                            type: "NO_CAMERA"
                        });
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var startScanning = (0,compat_module.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(cameraOptions) {
            var scanner, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            stopScanning()
                        ];
                    case 1:
                        _state.sent();
                        if (!mountedRef.current) return [
                            2
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            startScannerWithFallback({
                                cameraOptions: cameraOptions,
                                scanConfig: SCAN_CONFIG,
                                createScanner: function() {
                                    return new esm/* Html5Qrcode */.t2(READER_ELEMENT_ID);
                                },
                                onScannerChange: function(scannerInstance) {
                                    scannerRef.current = scannerInstance;
                                },
                                shouldContinue: function() {
                                    return mountedRef.current;
                                },
                                onDecode: function(decodedText) {
                                    if (decodedText === lastScanRef.current) return;
                                    lastScanRef.current = decodedText;
                                    // Uncomment to restrict scanned values to 15-digit IMEI only:
                                    // const IMEI_PATTERN = /^\d{15}$/;
                                    // if (!IMEI_PATTERN.test(decodedText)) {
                                    //     dispatch({ type: 'ERROR', message: 'Invalid IMEI format. Expected 15 digits.' });
                                    //     setTimeout(() => stopScanning(), 0);
                                    //     return;
                                    // }
                                    dispatch({
                                        type: "SUCCESS"
                                    });
                                    onSuccessRef.current(decodedText);
                                    setTimeout(function() {
                                        return stopScanning();
                                    }, 0);
                                }
                            })
                        ];
                    case 3:
                        scanner = _state.sent();
                        if (!mountedRef.current || !scanner) return [
                            2
                        ];
                        dispatch({
                            type: "SCANNING"
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        if (!mountedRef.current) return [
                            2
                        ];
                        dispatch({
                            type: "ERROR",
                            message: (0,_instanceof/* default */.Z)(err, Error) ? err.message : "Failed to start camera"
                        });
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(cameraOptions) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stopScanning
    ]);
    var retry = (0,compat_module.useCallback)(function() {
        lastScanRef.current = null;
        dispatch({
            type: "RESET"
        });
    }, []);
    // Phase 1: enumerate cameras when status is 'initializing'
    (0,compat_module.useEffect)(function() {
        if (state.status === "initializing") {
            checkCamera();
        }
    }, [
        state.status,
        checkCamera
    ]);
    // Phase 2: start camera feed once we have camera options and reader div is in DOM
    (0,compat_module.useEffect)(function() {
        if (state.status === "ready" && state.cameraOptions.length > 0) {
            startScanning(state.cameraOptions);
        }
    }, [
        state.status,
        state.cameraOptions,
        startScanning
    ]);
    // Cleanup on unmount
    (0,compat_module.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
            stopScanning();
        };
    }, [
        stopScanning
    ]);
    return {
        status: state.status,
        errorMessage: state.errorMessage,
        stopScanning: stopScanning,
        retry: retry
    };
}

;// CONCATENATED MODULE: ./features/imeiScanner/openCameraSettings.ts
var openCameraSettings = function() {
    var ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
        // iOS: opens iOS Settings app (Safari only)
        window.open("app-settings:");
    } else if (/android/.test(ua)) {
        // Android Chrome: tries to open site settings
        window.open("chrome://settings/content/camera");
    } else {
        // Desktop fallback: instruct user manually
        alert("To enable camera access, click the lock icon in your browser address bar.");
    }
};

;// CONCATENATED MODULE: ./features/imeiScanner/styles.ts

function imeiScanner_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n"
    ]);
    imeiScanner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function imeiScanner_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n"
    ]);
    imeiScanner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function imeiScanner_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    to {\n        transform: rotate(360deg);\n    }\n"
    ]);
    imeiScanner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function imeiScanner_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    animation: ",
        " 0.2s ease-out;\n"
    ]);
    imeiScanner_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function imeiScanner_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.75);\n    cursor: pointer;\n"
    ]);
    imeiScanner_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function imeiScanner_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    background: #fff;\n    border-radius: 12px;\n    width: 90vw;\n    max-width: 400px;\n    overflow: hidden;\n    animation: ",
        " 0.25s ease-out;\n"
    ]);
    imeiScanner_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function imeiScanner_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid #eee;\n"
    ]);
    imeiScanner_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function imeiScanner_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    font-weight: 600;\n    color: #040222;\n"
    ]);
    imeiScanner_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: none;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    color: #666;\n    line-height: 1;\n    transition: background-color 0.15s;\n\n    &:hover {\n        background: #f0f0f0;\n    }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 20px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n    display: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 40px 0;\n    gap: 16px;\n\n    p {\n        margin: 0;\n        font-size: 14px;\n        color: #666;\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 36px;\n    height: 36px;\n    border: 3px solid #e0e0e0;\n    border-top-color: #40a7a3;\n    border-radius: 50%;\n    animation: ",
        " 0.8s linear infinite;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    padding: 20px 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 0 20px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #333;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    flex-wrap: wrap;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px 24px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.15s;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #40a7a3;\n    color: white;\n    border: none;\n\n    &:hover {\n        background: #358a87;\n    }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: white;\n    color: #333;\n    border: 1px solid #ddd;\n\n    &:hover {\n        background: #f5f5f5;\n        border-color: #ccc;\n    }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}

var fadeIn = (0,building_blocks_ui_common_dist.keyframes)(imeiScanner_styles_templateObject());
var slideUp = (0,building_blocks_ui_common_dist.keyframes)(imeiScanner_styles_templateObject1());
var spin = (0,building_blocks_ui_common_dist.keyframes)(imeiScanner_styles_templateObject2());
var Overlay = building_blocks_ui_common_dist.styled.div(imeiScanner_styles_templateObject3(), fadeIn);
var Backdrop = building_blocks_ui_common_dist.styled.div(imeiScanner_styles_templateObject4());
var Modal = building_blocks_ui_common_dist.styled.div(imeiScanner_styles_templateObject5(), slideUp);
var imeiScanner_styles_Header = building_blocks_ui_common_dist.styled.div(imeiScanner_styles_templateObject6());
var styles_Title = building_blocks_ui_common_dist.styled.span(imeiScanner_styles_templateObject7());
var CloseButton = building_blocks_ui_common_dist.styled.button(styles_templateObject8());
var Body = building_blocks_ui_common_dist.styled.div(_templateObject9());
var Reader = building_blocks_ui_common_dist.styled.div(_templateObject10(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
});
var LoadingContainer = building_blocks_ui_common_dist.styled.div(_templateObject11());
var Spinner = building_blocks_ui_common_dist.styled.div(_templateObject12(), spin);
var StatusContainer = building_blocks_ui_common_dist.styled.div(_templateObject13());
var ErrorText = building_blocks_ui_common_dist.styled.p(_templateObject14());
var Actions = building_blocks_ui_common_dist.styled.div(_templateObject15());
var BaseButton = building_blocks_ui_common_dist.styled.button(_templateObject16());
var PrimaryButton = (0,building_blocks_ui_common_dist.styled)(BaseButton)(_templateObject17());
var SecondaryButton = (0,building_blocks_ui_common_dist.styled)(BaseButton)(_templateObject18());

;// CONCATENATED MODULE: ./features/imeiScanner/ImeiScannerModal.tsx





/**
 * Conditionally renders scanner content.
 * Full unmount on close guarantees a clean scanner lifecycle on re-open.
 */ var ImeiScannerModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onImeiScanned = param.onImeiScanned;
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ScannerModalContent, {
        onClose: onClose,
        onImeiScanned: onImeiScanned
    });
};
var ScannerModalContent = function(param) {
    var onClose = param.onClose, onImeiScanned = param.onImeiScanned;
    var ref = useImeiScanner({
        onSuccess: function(imei) {
            onImeiScanned(imei);
            onClose();
        }
    }), status = ref.status, errorMessage = ref.errorMessage, stopScanning = ref.stopScanning, retry = ref.retry;
    var handleClose = (0,compat_module.useCallback)(function() {
        onClose();
        setTimeout(function() {
            return stopScanning();
        }, 0);
    }, [
        onClose,
        stopScanning
    ]);
    (0,compat_module.useEffect)(function() {
        var original = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = original;
        };
    }, []);
    (0,compat_module.useEffect)(function() {
        var onKeyDown = function(e) {
            if (e.key === "Escape") handleClose();
        };
        document.addEventListener("keydown", onKeyDown);
        return function() {
            return document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        handleClose
    ]);
    var isLoading = status === "initializing" || status === "ready";
    var showCamera = status === "ready" || status === "scanning";
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Overlay, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Backdrop, {
                onClick: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Modal, {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "IMEI Barcode Scanner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(imeiScanner_styles_Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Title, {
                                children: "Scan IMEI Barcode"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CloseButton, {
                                type: "button",
                                onClick: handleClose,
                                "aria-label": "Close scanner",
                                children: "✕"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Body, {
                        children: [
                            isLoading && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LoadingContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Spinner, {}),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                        children: "Opening camera..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Reader, {
                                id: READER_ELEMENT_ID,
                                isVisible: showCamera
                            }),
                            status === "error" && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StatusContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ErrorText, {
                                        children: errorMessage || "Could not read a valid IMEI. Ensure the barcode is within the frame."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Actions, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PrimaryButton, {
                                                type: "button",
                                                onClick: retry,
                                                children: "Try Again"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SecondaryButton, {
                                                type: "button",
                                                onClick: handleClose,
                                                children: "Enter Manually"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            status === "permissionDenied" && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StatusContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ErrorText, {
                                        children: "Camera access is blocked. Please enable it in your browser settings."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Actions, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PrimaryButton, {
                                                type: "button",
                                                onClick: openCameraSettings,
                                                children: "Open Settings"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SecondaryButton, {
                                                type: "button",
                                                onClick: handleClose,
                                                children: "Enter Manually"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            status === "noCamera" && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StatusContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ErrorText, {
                                        children: "No camera found on this device."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Actions, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SecondaryButton, {
                                            type: "button",
                                            onClick: handleClose,
                                            children: "Enter Manually"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/imeiScanner/index.ts




;// CONCATENATED MODULE: ./components/newPlan/imeiModelScreen/index.tsx




















var IMEIModelScreen = function() {
    var ref;
    var ref1 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref1.partnerId, dealerType = ref1.dealerType, setPlanDetails = ref1.setPlanDetails, planDetails = ref1.planDetails, setActiveStage = ref1.setActiveStage, permissions = ref1.permissions, permissionsMap = ref1.permissionsMap;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref2 = (0,compat_module.useState)(false), onClickSerialNumber = ref2[0], setOnClickSerialNumber = ref2[1];
    var ref3 = (0,compat_module.useState)(true), isContinueButtonDisabled = ref3[0], setIsContinueButtonDisabled = ref3[1];
    var ref4 = (0,compat_module.useState)(""), imei = ref4[0], setImei = ref4[1];
    var ref5 = (0,compat_module.useState)(false), isScannerOpen = ref5[0], setIsScannerOpen = ref5[1];
    var ref6 = (0,compat_module.useState)({
        imeiVerifyLoader: false,
        submitButtonLoaders: false
    }), buttonLoaders = ref6[0], setButtonLoaders = ref6[1];
    var ref7 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref7[0], setSnackbar = ref7[1];
    var ref8 = (0,compat_module.useState)(false), isSerialNumberVerified = ref8[0], setIsSerialNumberVerified = ref8[1];
    var ref9 = (0,compat_module.useState)({
        id: "",
        activationDate: "",
        description: "",
        modelMappingName: "",
        name: "",
        price: 0,
        type: "",
        brand: "",
        showActivationDate: true
    }), modelDetails = ref9[0], setModelDetails = ref9[1];
    var group = permissions.group;
    (0,compat_module.useEffect)(function() {
        if (isValidIMEI(imei, partnerId)) {
            setIsContinueButtonDisabled(false);
        } else {
            setIsContinueButtonDisabled(true);
        }
    }, [
        imei
    ]);
    (0,compat_module.useEffect)(function() {
        if (onClickSerialNumber) {
            var ref;
            (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                page_url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "",
                button_name: constants/* SegmentEventButtonNames.CLICK_SERIAL_NUMBER */.A3.CLICK_SERIAL_NUMBER,
                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                action_name: constants/* SegmentEventActionNames.CLICK_SERIAL_NUMBER */.iV.CLICK_SERIAL_NUMBER,
                product: constants/* PRODUCT */.c5,
                sub_product: constants/* SUB_PRODUCT_NAME */.tM,
                platform: isMobile ? "mweb" : "web",
                device: navigator.userAgent || "",
                partner: partnerId,
                field_selected: constants/* SegmentEventFieldTypes.TEXT */.OX.TEXT,
                plan_id: planDetails.plan.plan_id,
                device_model: planDetails.device.name,
                category: planDetails.device.type
            });
        }
    }, [
        onClickSerialNumber
    ]);
    var ref10 = (0,compat_module.useState)({
        serial_number: ""
    }), validationErr = ref10[0], setValidationErr = ref10[1];
    var validateIMEIHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var imeiNumber, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                imeiVerifyLoader: true
                            });
                        });
                        imeiNumber = imei.trim();
                        setImei(imei);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            verifyDevice(partnerId, imeiNumber, group)
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.isValid) {
                            setIsSerialNumberVerified(true);
                            if (response.modelDetails) {
                                setModelDetails(response.modelDetails);
                            }
                            setSnackbar({
                                type: "success",
                                message: response.message
                            });
                        } else {
                            setIsSerialNumberVerified(false);
                            setSnackbar({
                                type: "failure",
                                message: response.message
                            });
                            setValidationErr(function(validationErr) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                                    serial_number: response.message
                                });
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                imeiVerifyLoader: false
                            });
                        });
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function validateIMEIHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                submitButtonLoaders: true
                            });
                        });
                        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                            device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                                name: modelDetails.name,
                                id: modelDetails.id,
                                type: modelDetails.type,
                                serial_number: imei.trim(),
                                price: modelDetails.price,
                                model_mapping_name: modelDetails.modelMappingName,
                                brand: modelDetails.brand,
                                is_device_verified_in_model_page: isSerialNumberVerified,
                                activation_date: modelDetails.activationDate,
                                show_activation_date: modelDetails.showActivationDate
                            })
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentTrackEvents.TAP_SUBMIT_SERIAL_NUMBER_MODEL_PAGE */.Jk.TAP_SUBMIT_SERIAL_NUMBER_MODEL_PAGE, {
                                page: constants/* SegmentPages.NEW_PLAN_DEVICE_MODELS */.IT.NEW_PLAN_DEVICE_MODELS,
                                partner: partnerId,
                                product: "pos",
                                journey: "buy",
                                platform: "mweb",
                                type: dealerType
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                submitButtonLoaders: false
                            });
                        });
                        setActiveStage(newPlan_constants/* NewPlanStages.PLAN */.W6.PLAN);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeIMEIHandler = function(e) {
        setImei(e.target.value);
        setValidationErr(function(validationErr) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                serial_number: ""
            });
        });
    };
    var ref11 = (0,compat_module.useState)(false), cameraSupported = ref11[0], setCameraSupported = ref11[1];
    (0,compat_module.useEffect)(function() {
        var ref;
        setCameraSupported(typeof navigator !== "undefined" && !!((ref = navigator.mediaDevices) === null || ref === void 0 ? void 0 : ref.getUserMedia));
    }, []);
    var handleImeiScanned = function(scannedImei) {
        setImei(scannedImei);
        setValidationErr(function(validationErr) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                serial_number: ""
            });
        });
        setIsScannerOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(imeiModelScreen_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EnterSerialNumberText, {
                        children: "Device Validation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SerialNumberText, {
                        children: "Enter device IMEI/Serial number to verify the details of the device"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_InputWrapper, {
                        onClick: function() {
                            return setOnClickSerialNumber(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EnterMoreDetails, {
                                children: "Device IMEI/Serial number"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(InputAndScanWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                            className: "",
                                            name: "Device Serial Number",
                                            placeHolder: "Enter IMEI/Serial number",
                                            type: "text",
                                            value: imei,
                                            onChange: onChangeIMEIHandler,
                                            errMsg: validationErr.serial_number,
                                            hasError: (validationErr === null || validationErr === void 0 ? void 0 : (ref = validationErr.serial_number) === null || ref === void 0 ? void 0 : ref.length) > 0
                                        })
                                    }),
                                    permissionsMap[utils_constants/* Permissions.SCANNER */.Pl.SCANNER] && cameraSupported && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ScanButton, {
                                        type: "button",
                                        onClick: function() {
                                            return setIsScannerOpen(true);
                                        },
                                        title: "Scan IMEI barcode",
                                        children: "\uD83D\uDCF7 Scan"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                            disabled: isContinueButtonDisabled,
                            onClick: validateIMEIHandler,
                            loading: buttonLoaders.imeiVerifyLoader,
                            children: "Validate device"
                        })
                    }),
                    modelDetails && isSerialNumberVerified && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_modelDetails, {
                                activationDate: modelDetails.activationDate,
                                imei: imei,
                                modelName: modelDetails.name,
                                showActivationDate: modelDetails.showActivationDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                    disabled: isContinueButtonDisabled,
                                    onClick: onSubmit,
                                    loading: buttonLoaders.submitButtonLoaders,
                                    children: "Continue to plan selection"
                                })
                            })
                        ]
                    })
                ]
            }),
            permissionsMap[utils_constants/* Permissions.SCANNER */.Pl.SCANNER] && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImeiScannerModal, {
                isOpen: isScannerOpen,
                onClose: function() {
                    return setIsScannerOpen(false);
                },
                onImeiScanned: handleImeiScanned
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var imeiModelScreen = (IMEIModelScreen);

;// CONCATENATED MODULE: ./widgets/HorizontalDivider/styles.ts

function HorizontalDivider_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin: 20px 0;\n"
    ]);
    HorizontalDivider_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HorizontalDivider_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    border: none;\n    border-top: 1px solid #ccc;\n"
    ]);
    HorizontalDivider_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HorizontalDivider_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 10px;\n    color: #888;\n    font-weight: 500;\n    font-size: 14px;\n"
    ]);
    HorizontalDivider_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var DividerWrapper = building_blocks_ui_common_dist.styled.div(HorizontalDivider_styles_templateObject());
var Line = building_blocks_ui_common_dist.styled.hr(HorizontalDivider_styles_templateObject1());
var styles_Text = building_blocks_ui_common_dist.styled.span(HorizontalDivider_styles_templateObject2());

;// CONCATENATED MODULE: ./widgets/HorizontalDivider/index.tsx



var HorizontalDivider = function(props) {
    var text = props.text;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DividerWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Line, {}),
            text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Text, {
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Line, {})
        ]
    });
};
/* harmony default export */ var widgets_HorizontalDivider = (HorizontalDivider);

// EXTERNAL MODULE: ./utils/segment/index.ts
var segment = __webpack_require__(2199);
;// CONCATENATED MODULE: ./components/newPlan/mobileModels/index.tsx





















function MobileModel() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref2 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref2.partnerId, planDetails = ref2.planDetails, permissions = ref2.permissions, setActiveStage = ref2.setActiveStage, setPlanDetails = ref2.setPlanDetails, userDetails = ref2.userDetails, permissionsMap = ref2.permissionsMap;
    var ref3 = (0,compat_module.useState)([]), options = ref3[0], setOptions = ref3[1];
    var ref4 = (0,compat_module.useState)([]), modelOptions = ref4[0], setModelOptions = ref4[1];
    var ref5 = (0,compat_module.useState)(false), showDropdown = ref5[0], setShowDropdown = ref5[1];
    var ref6 = (0,compat_module.useState)({
        value: (planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.id) || "",
        displayValue: (planDetails === null || planDetails === void 0 ? void 0 : (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
    }), selectedModelOption = ref6[0], setSelectedModelOption = ref6[1];
    var ref7 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref7[0], setSnackbar = ref7[1];
    var ref8 = (0,compat_module.useState)(true), isLoading = ref8[0], setIsLoading = ref8[1];
    /**
     * view segment hook
     */ (0,compat_module.useEffect)(function() {
        if (true) {
            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
                page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
                view_name: constants/* SegmentEventPages.VIEW_DEVICE_MODEL */.g0.VIEW_DEVICE_MODEL
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        window
    ]);
    (0,compat_module.useEffect)(function() {
        var ref, ref1;
        setSelectedModelOption({
            value: (planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.id) || "",
            displayValue: (planDetails === null || planDetails === void 0 ? void 0 : (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
        });
    }, [
        planDetails
    ]);
    (0,compat_module.useEffect)(function() {
        if (!isMobile) return;
        var timeout = setTimeout(function() {
            try {
                var bottomSheetElement = document.querySelector("#bottomSheet");
                if (bottomSheetElement) {
                    var documents = bottomSheetElement.getElementsByTagName("div");
                    if (documents[0]) {
                        documents[0].style.top = "10vh";
                        documents[0].style.maxHeight = "100%";
                        documents[0].style.padding = "20px";
                        documents[0].style.paddingBottom = "0px";
                        var innerDocuments = documents[0].getElementsByTagName("div");
                        if (innerDocuments.length > 3 && innerDocuments[3]) {
                            innerDocuments[3].style.maxHeight = "100%";
                        }
                    }
                }
            } catch (e) {}
        }, 100);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        showDropdown
    ]);
    (0,compat_module.useEffect)(function() {
        try {
            __webpack_require__.e(/* import() */ 458).then(__webpack_require__.bind(__webpack_require__, 7458)).then(function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                    var ref, models, statusCode, options;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    req.getModelsForPartnerId(permissions.partner_id, permissions.group)
                                ];
                            case 1:
                                ref = _state.sent(), models = ref.models, statusCode = ref.statusCode;
                                setIsLoading(false);
                                if (statusCode === 401) {
                                    router.push("/login");
                                    setSnackbar({
                                        type: "failure",
                                        message: "Token expired. Redirecting to login page."
                                    });
                                    return [
                                        2
                                    ];
                                }
                                if (models.length > 0) {
                                    setOptions(models);
                                    options = models.map(function(param) {
                                        var id = param.id, name = param.name;
                                        return {
                                            displayValue: name,
                                            value: id
                                        };
                                    });
                                    setModelOptions(options);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(req) {
                    return _ref.apply(this, arguments);
                };
            }());
        } catch (e) {}
    }, []);
    var toggleDropdown = function(show) {
        setShowDropdown(show);
        if (!show) {
            var opts = options.map(function(param) {
                var id = param.id, name = param.name;
                return {
                    displayValue: name,
                    value: id
                };
            });
            setModelOptions(opts);
        }
    };
    var onSelectModelDropdown = function(param) {
        var value = param.value, displayValue = param.displayValue;
        try {
            setSelectedModelOption({
                value: value,
                displayValue: displayValue
            });
            var selectedModel = options.filter(function(param) {
                var id = param.id;
                return value === id;
            });
            if (!((selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.length) > 0)) {
                return;
            }
            setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                    name: displayValue,
                    id: value,
                    type: selectedModel[0].type,
                    price: selectedModel[0].price,
                    model_mapping_name: selectedModel[0].model_mapping_name
                })
            }));
            setActiveStage(newPlan_constants/* NewPlanStages.PLAN */.W6.PLAN);
            /**
             * segment track event
             */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                action_name: constants/* SegmentEventActionNames.SELECT_MODEL */.iV.SELECT_MODEL,
                button_name: "select_".concat(displayValue, "_model"),
                field_selected: constants/* SegmentEventFieldTypes.DROPDOWN */.OX.DROPDOWN
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        } catch (e) {}
    };
    var ref9 = getLabels(partnerId), label1 = ref9.label1, label2 = ref9.label2;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(mobileModels_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                    src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileModelContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IMEIValidationContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(imeiModelScreen, {})
                            })
                        }),
                        permissionsMap[utils_constants/* Permissions.MANUAL_PURCHASE_FLOW */.Pl.MANUAL_PURCHASE_FLOW] && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(widgets_HorizontalDivider, {
                                    text: "OR"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectModelText, {
                                    children: label1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectModelDropdown, {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                                        className: "mobileModalDropdown",
                                        show: showDropdown,
                                        value: selectedModelOption,
                                        label: label2,
                                        options: modelOptions,
                                        onChange: onSelectModelDropdown,
                                        toggleDropdown: toggleDropdown,
                                        hideClose: true,
                                        hideHeader: true,
                                        showSearchBar: true
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                    handleSnakbarComplete: function() {
                        return setSnackbar({
                            type: "",
                            message: ""
                        });
                    }
                }))
            ]
        })
    });
}
/* harmony default export */ var mobileModels = (MobileModel);

// EXTERNAL MODULE: ./components/newPlan/plans/header/index.tsx + 1 modules
var plans_header = __webpack_require__(9994);
;// CONCATENATED MODULE: ./components/newPlan/plans/selectPlan/planDetailsCard/planDetails/styles.ts

function planDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    planDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 20px;\n    flex-direction: column;\n    background: #ffffff;\n    border: 1px solid #e7e7f0;\n    border-radius: 12px;\n"
    ]);
    planDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    color: #040222;\n    margin-bottom: 20px;\n"
    ]);
    planDetails_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    planDetails_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n"
    ]);
    planDetails_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 3;\n    justify-content: center;\n"
    ]);
    planDetails_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 22px;\n    display: flex;\n    color: #040222;\n"
    ]);
    planDetails_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 6px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: #5b5675;\n"
    ]);
    planDetails_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid rgba(91, 86, 117, 0.1);\n    margin: 15px 0;\n"
    ]);
    planDetails_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid rgba(91, 86, 117, 0.1);\n    margin: 8px 0;\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    color: #5b5675;\n    margin-top: 24px;\n    margin-bottom: 20px;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    color: #040222;\n    margin-left: 10px;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

var planDetails_styles_Wrapper = styled_components_browser_esm["default"].div(planDetails_styles_templateObject());
var PlanCoverWrapper = styled_components_browser_esm["default"].div(planDetails_styles_templateObject1());
var PlanCoverTitle = styled_components_browser_esm["default"].div(planDetails_styles_templateObject2());
var CoverDetailsWrapper = styled_components_browser_esm["default"].div(planDetails_styles_templateObject3());
var styles_IconFlex = styled_components_browser_esm["default"].div(planDetails_styles_templateObject4());
var TitleFlex = styled_components_browser_esm["default"].div(planDetails_styles_templateObject5());
var planDetails_styles_Title = styled_components_browser_esm["default"].div(planDetails_styles_templateObject6());
var SubTitle = styled_components_browser_esm["default"].div(planDetails_styles_templateObject7());
var styles_Hr = styled_components_browser_esm["default"].div(planDetails_styles_templateObject8());
var Hr1 = styled_components_browser_esm["default"].div(styles_templateObject9());
var MoreReason = styled_components_browser_esm["default"].div(styles_templateObject10());
var MoreReasonFlex = styled_components_browser_esm["default"].div(styles_templateObject11());
var MoreReasonIconFlex = styled_components_browser_esm["default"].div(styles_templateObject12());
var MoreReasonText = styled_components_browser_esm["default"].div(styles_templateObject13());

;// CONCATENATED MODULE: ./components/newPlan/plans/selectPlan/planDetailsCard/planDetails/index.tsx




function PlanDetails(param) {
    var plans = param.plans;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(planDetails_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PlanCoverWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PlanCoverTitle, {
                        children: "Your ACKO protection plan covers"
                    }),
                    plans.map(function(plan, index) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CoverDetailsWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_IconFlex, {
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                width: "40px",
                                                height: "40px",
                                                alt: "",
                                                src: (0,generics/* getImageBasePath */.m4)(plan.icon)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TitleFlex, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetails_styles_Title, {
                                                    children: plan.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubTitle, {
                                                    children: plan.subTitle
                                                })
                                            ]
                                        })
                                    ]
                                }, plan.title),
                                index !== plans.length - 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Hr, {})
                            ]
                        });
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MoreReason, {
                children: "More reasons to love ACKO"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MoreReasonFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MoreReasonIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "40px",
                            height: "40px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/checkClaim.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MoreReasonText, {
                        children: "Same day claim approvals"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr1, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MoreReasonFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MoreReasonIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "40px",
                            height: "40px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/pickupDrop.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MoreReasonText, {
                        children: "Free pickup and drop"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr1, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MoreReasonFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MoreReasonIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "40px",
                            height: "40px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/serviceNetwork.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MoreReasonText, {
                        children: "Real time claim tracking"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var planDetails = (PlanDetails);

;// CONCATENATED MODULE: ./components/newPlan/plans/selectPlan/planDetailsCard/styles.ts

function planDetailsCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #e7e7f0;\n    border-radius: 16px;\n    padding: 20px;\n    margin: 8px 0;\n"
    ]);
    planDetailsCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-bottom: 8px;\n"
    ]);
    planDetailsCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin: 8px 0;\n"
    ]);
    planDetailsCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: self-start;\n"
    ]);
    planDetailsCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 10;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    planDetailsCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 15px;\n    color: #1c73e8;\n    margin-top: 8px;\n"
    ]);
    planDetailsCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% + 40px);\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-top: 16px;\n    transform: translateX(-20px);\n"
    ]);
    planDetailsCard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n"
    ]);
    planDetailsCard_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n"
    ]);
    planDetailsCard_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    planDetailsCard_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    planDetailsCard_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: flex-end;\n"
    ]);
    planDetailsCard_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 700;\n    font-size: 22px;\n    line-height: 32px;\n    align-items: center;\n    color: #040222;\n"
    ]);
    planDetailsCard_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function planDetailsCard_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 32px;\n    align-items: center;\n    color: #7a7690;\n    text-decoration: line-through;\n    margin-right: 4px;\n"
    ]);
    planDetailsCard_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    align-items: center;\n    color: #5b5675;\n    margin-left: 4px;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 16px;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-bottom: 8px;\n\n    span {\n        color: #e53935;\n    }\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 12px;\n"
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    padding: 12px 16px;\n    border: 1px solid\n        ",
        ";\n    border-radius: 8px;\n    background: ",
        ";\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: ",
        ";\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n        border-color: #1c73e8;\n    }\n"
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n    margin-top: 4px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}

var CardWrapper = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject());
var PlanTitle = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject1());
var BenefitFlex = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject2());
var GreenTickFlex = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject3());
var BenefitText = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject4());
var SeeDetails = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject5());
var planDetailsCard_styles_Hr = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject6());
var BottomFlex = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject7());
var PriceWrapper = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject8());
var PriceDivFlex = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject9());
var GSTText = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject10());
var BuyFlex = (0,building_blocks_ui_common_dist.styled)(PriceWrapper)(planDetailsCard_styles_templateObject11());
var PriceFlex = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject12());
var StrikedPriceFlex = building_blocks_ui_common_dist.styled.div(planDetailsCard_styles_templateObject13());
var SlashYear = building_blocks_ui_common_dist.styled.div(styles_templateObject14());
var PaymentModeSection = building_blocks_ui_common_dist.styled.div(styles_templateObject15());
var PaymentModeLabel = building_blocks_ui_common_dist.styled.div(styles_templateObject16());
var PaymentModeOptions = building_blocks_ui_common_dist.styled.div(styles_templateObject17());
var PaymentModeButton = building_blocks_ui_common_dist.styled.button(styles_templateObject18(), function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "#1c73e8" : "#e7e7f0";
}, function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "#f0f7ff" : "#ffffff";
}, function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "#1c73e8" : "#040222";
});
var BuyFlexWrapper = building_blocks_ui_common_dist.styled.div(_templateObject19());
var HelperText = building_blocks_ui_common_dist.styled.div(_templateObject20());

;// CONCATENATED MODULE: ./components/newPlan/plans/selectPlan/planDetailsCard/index.tsx











function PlanDetailsCard(param) {
    var planId = param.planId, name = param.name, benefits = param.benefits, premium = param.premium, planCategory = param.planCategory, programId = param.programId, onClick = param.onClick, discountedAmount = param.discountedAmount, eligible = param.eligible, reason = param.reason, productCode = param.productCode, _emiEnabled = param.emiEnabled, emiEnabled = _emiEnabled === void 0 ? false : _emiEnabled;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref = (0,compat_module.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,compat_module.useState)(null), selectedPaymentMode = ref1[0], setSelectedPaymentMode = ref1[1];
    var partner = (0,useFetchParams/* useFetchParams */.u)().partner;
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PlanTitle, {
                children: name
            }),
            (benefits || []).map(function(benefit) {
                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(BenefitFlex, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GreenTickFlex, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: "20px",
                                height: "20px",
                                alt: "",
                                src: (0,generics/* getImageBasePath */.m4)("/icons/greenTick.svg")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BenefitText, {
                            children: benefit
                        })
                    ]
                }, benefit);
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SeeDetails, {
                onClick: function() {
                    return setShowModal(true);
                },
                children: "See Details"
            }),
            emiEnabled && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaymentModeSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaymentModeLabel, {
                        children: [
                            "Choose payment mode ",
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaymentModeOptions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaymentModeButton, {
                                isSelected: selectedPaymentMode === "FULL",
                                onClick: function() {
                                    return setSelectedPaymentMode("FULL");
                                },
                                children: "Pay in full"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaymentModeButton, {
                                isSelected: selectedPaymentMode === "EMI",
                                onClick: function() {
                                    return setSelectedPaymentMode("EMI");
                                },
                                children: "Pay in EMI"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetailsCard_styles_Hr, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BottomFlex, {
                children: eligible ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PriceWrapper, {
                            children: discountedAmount || discountedAmount === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PriceDivFlex, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        style: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StrikedPriceFlex, {
                                                children: [
                                                    "₹",
                                                    premium
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PriceFlex, {
                                                children: [
                                                    "₹",
                                                    discountedAmount
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GSTText, {
                                        children: "(incl 18% GST)"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PriceDivFlex, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        style: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PriceFlex, {
                                                children: [
                                                    "₹",
                                                    premium
                                                ]
                                            }),
                                            partner !== utils_constants/* Partners.HERO_VIDA */.wV.HERO_VIDA && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SlashYear, {
                                                children: "/ year"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GSTText, {
                                        children: "(incl 18% GST)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(BuyFlexWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BuyFlex, {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                        size: "small",
                                        disabled: emiEnabled && !selectedPaymentMode,
                                        onClick: function() {
                                            return onClick(planId, name, premium, planCategory, programId, emiEnabled, emiEnabled ? selectedPaymentMode : "FULL", productCode);
                                        },
                                        children: "Select"
                                    })
                                }),
                                emiEnabled && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HelperText, {
                                    children: "Pick a payment mode to continue"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PriceWrapper, {
                    children: reason
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                show: showModal,
                onHide: function() {
                    return setShowModal(false);
                },
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetails, {
                    plans: (0,generics/* getCoverage */.El)(planCategory || "")
                })
            })
        ]
    });
}
/* harmony default export */ var planDetailsCard = (PlanDetailsCard);

;// CONCATENATED MODULE: ./components/newPlan/plans/selectPlan/styles.ts

function selectPlan_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 32px;\n    margin-bottom: 16px;\n"
    ]);
    selectPlan_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function selectPlan_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-bottom: 16px;\n"
    ]);
    selectPlan_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var selectPlan_styles_Wrapper = building_blocks_ui_common_dist.styled.div(selectPlan_styles_templateObject());
var SelectPlanText = building_blocks_ui_common_dist.styled.div(selectPlan_styles_templateObject1());

;// CONCATENATED MODULE: ./components/newPlan/plans/selectPlan/index.tsx











function SelectPlan(param) {
    var plans = param.plans;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref.planDetails, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, permissions = ref.permissions, userDetails = ref.userDetails;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var onSelect = function(planId, planName, premium, planCategory, programId, emiEnabled, paymentMode, productCode) {
        if (permissions.purchase_journey === "v0") {
            setActiveStage(newPlan_constants/* NewPlanStages.IMEI */.W6.IMEI);
        } else {
            setActiveStage(newPlan_constants/* NewPlanStages.CUSTOMER_DEVICE_DETAILS */.W6.CUSTOMER_DEVICE_DETAILS);
        }
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            plan: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.plan), {
                plan_id: planId,
                plan_name: planName,
                purchase_date: new Date().toISOString(),
                premium: premium,
                plan_category: planCategory,
                program_id: programId
            }), productCode !== undefined && {
                product_code: productCode
            }), {
                payment_mode: paymentMode,
                emi_enabled: emiEnabled,
                emi_selected: paymentMode === "EMI"
            })
        }));
        /**
         * Segment event
         */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.SELECT_PLAN */.iV.SELECT_PLAN,
            button_name: constants/* SegmentEventButtonNames.SELECT_PLAN */.A3.SELECT_PLAN
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(selectPlan_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectPlanText, {
                children: "Select your plan"
            }),
            plans.map(function(param) {
                var plan_id = param.plan_id, plan_name = param.plan_name, premium = param.premium, plan_category = param.plan_category, program_id = param.program_id, benefits = param.benefits, discounted_amount = param.discounted_amount, reason = param.reason, eligible = param.eligible, product_code = param.product_code, emi_enabled = param.emi_enabled;
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetailsCard, {
                    planId: plan_id,
                    name: plan_name,
                    benefits: benefits,
                    premium: premium,
                    planCategory: plan_category,
                    programId: program_id,
                    onClick: onSelect,
                    discountedAmount: discounted_amount,
                    reason: reason,
                    eligible: eligible !== null && eligible !== void 0 ? eligible : true,
                    productCode: product_code,
                    emiEnabled: emi_enabled
                }, plan_id);
            })
        ]
    });
}
/* harmony default export */ var selectPlan = (SelectPlan);

;// CONCATENATED MODULE: ./components/newPlan/plans/styles.ts

function plans_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    plans_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var plans_styles_Wrapper = building_blocks_ui_common_dist.styled.div(plans_styles_templateObject());

;// CONCATENATED MODULE: ./components/newPlan/plans/index.tsx














function Plans() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, planDetails = ref.planDetails, permissions = ref.permissions;
    var ref1 = (0,compat_module.useState)(false), showError = ref1[0], setShowError = ref1[1];
    var ref2 = (0,compat_module.useState)([]), plans = ref2[0], setPlans = ref2[1];
    var ref3 = (0,compat_module.useState)(true), isLoading = ref3[0], setIsLoading = ref3[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_PLAN */.g0.VIEW_PLAN,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    (0,compat_module.useEffect)(function() {
        if (planDetails.device.is_device_verified_in_model_page) {
            __webpack_require__.e(/* import() */ 683).then(__webpack_require__.bind(__webpack_require__, 2683)).then(function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                    var ref, status, plans;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    req.getEligiblePLans(partnerId, planDetails.device.id, planDetails.device.activation_date, planDetails.device.serial_number, permissions.group)
                                ];
                            case 1:
                                ref = _state.sent(), status = ref.status, plans = ref.plans;
                                if (status && plans.length > 0) {
                                    setPlans(plans);
                                    setShowError(false);
                                } else {
                                    setShowError(true);
                                }
                                setIsLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(req) {
                    return _ref.apply(this, arguments);
                };
            }());
        } else {
            __webpack_require__.e(/* import() */ 683).then(__webpack_require__.bind(__webpack_require__, 2683)).then(function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                    var ref, status, plans;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    req.getModelPlans(partnerId, planDetails.device.id, permissions.group)
                                ];
                            case 1:
                                ref = _state.sent(), status = ref.status, plans = ref.plans;
                                if (status) {
                                    setPlans(plans);
                                    setShowError(false);
                                } else {
                                    setShowError(true);
                                }
                                setIsLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(req) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, []);
    if (showError) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            hideHeader: true,
            showEditDeviceHeader: true,
            errorMessage: "No Plans are eligible for this model"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(plans_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(plans_header/* default */.Z, {}),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
            }) : plans.length === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
                hideHeader: true,
                errorMessage: "Sorry no plan available for this model now"
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(selectPlan, {
                plans: plans
            })
        ]
    });
}
/* harmony default export */ var plans = (Plans);

;// CONCATENATED MODULE: ./library/checkbox/styles.ts

function checkbox_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 0;\n    clip: rect(0 0 0 0);\n    clippath: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"
    ]);
    checkbox_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function checkbox_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fill: none;\n    stroke: white;\n    stroke-width: 2px;\n"
    ]);
    checkbox_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function checkbox_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n    width: ",
        ";\n    height: ",
        ";\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 5px;\n    transition: all 150ms;\n    ",
        ":focus + & {\n        box-shadow: 0 0 0 3px pink;\n    }\n    ",
        " {\n        visibility: ",
        ";\n    }\n    cursor: pointer;\n"
    ]);
    checkbox_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var HiddenCheckbox = building_blocks_ui_common_dist.styled.input.attrs({
    type: "checkbox"
})(checkbox_styles_templateObject());
var Icon = building_blocks_ui_common_dist.styled.svg(checkbox_styles_templateObject1());
var StyledCheckbox = building_blocks_ui_common_dist.styled.div(checkbox_styles_templateObject2(), function(props) {
    return props.width || "16px";
}, function(props) {
    return props.height || "16px";
}, function(props) {
    return props.checked ? props.color ? props.color : "#7C47E1" : "#ffffff";
}, function(props) {
    return props.checkbox ? "#ffffff" : "#C8D0DB";
}, HiddenCheckbox, Icon, function(props) {
    return props.checked ? "visible" : "hidden";
});

;// CONCATENATED MODULE: ./library/checkbox/index.tsx
/**
 * types
 */ 
/**
 * styles
 */ 
function Checkbox(props) {
    var isSelected = props.isSelected, onSelectHandler = props.onSelectHandler, color = props.color, height = props.height, width = props.width;
    var onChangeHandler = function() {
        onSelectHandler === null || onSelectHandler === void 0 ? void 0 : onSelectHandler();
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        onClick: onChangeHandler,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HiddenCheckbox, {
                checked: isSelected,
                onChange: onChangeHandler
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StyledCheckbox, {
                checked: isSelected,
                color: color,
                width: width,
                height: height,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon, {
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("polyline", {
                        points: "20 6 9 17 4 12"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var library_checkbox = (Checkbox);

;// CONCATENATED MODULE: ./components/newPlan/scanImei/utils.ts

var scanImei_utils_getLabels = function(modelType) {
    if (modelType === "mobile" || modelType === "tablet") {
        return {
            title: "Enter IMEI number",
            label: "IMEI number",
            confirmLabel: "Confirm IMEI number",
            verifyLabel: "I have verified the IMEI number for plan issuance"
        };
    }
    return {
        title: "Appliance Serial Number",
        label: "Serial number",
        confirmLabel: "Confirm serial number",
        verifyLabel: "I have verified the serial number"
    };
};
var utils_isValidIMEI = function(imei, partnerId) {
    if (partnerId === utils_constants/* Partners.HERO_VIDA */.wV.HERO_VIDA) {
        return true;
    }
    if (partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
        return imei.length >= 8 && imei.length <= 20;
    }
    if ((imei === null || imei === void 0 ? void 0 : imei.length) === 15 && /^[0-9]+$/.test(imei)) return true;
    return false;
};

// EXTERNAL MODULE: ./components/newPlan/documentUpload/apis.ts
var apis = __webpack_require__(9917);
;// CONCATENATED MODULE: ./components/newPlan/documentUpload/utils.ts






var isEWPlan = function(planId) {
    try {
        return planId === null || planId === void 0 ? void 0 : planId.includes("_ew");
    } catch (e) {
        return false;
    }
};
var documentUpload_utils_getLabels = function(partnerId) {
    if (partnerId.toLowerCase() === "xiaomi") {
        return {
            headerText: "Upload Documents"
        };
    }
    return {
        headerText: "Upload Purchase Documents"
    };
};
var fetchDocumentList = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, planId, programId) {
        var ref, statusCode, data, errorMessage, reHydratedData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,apis.fetchDocumentsToBeUploaded)(partnerId, planId, programId)
                    ];
                case 1:
                    ref = _state.sent(), statusCode = ref.statusCode, data = ref.data, errorMessage = ref.errorMessage;
                    reHydratedData = data.map(function(docs) {
                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, docs), {
                            name: "",
                            url: "",
                            documentText: docs.document_text,
                            documentHelperText: docs.document_helper_text,
                            segmentEvent: docs.segment_event,
                            warningNote: docs.warning_note
                        });
                    });
                    if (statusCode === 200) {
                        return [
                            2,
                            reHydratedData
                        ];
                    }
                    console.error(errorMessage);
                    return [
                        2,
                        []
                    ];
            }
        });
    });
    return function fetchDocumentList(partnerId, planId, programId) {
        return _ref.apply(this, arguments);
    };
}();
var getDocumentList = function(partnerId, category, ew) {
    if (partnerId.toLowerCase() === "xiaomi") {
        // ew
        if (ew) {
            // television
            if (category.toLowerCase() === "television") {
                return [
                    {
                        id: "invoice",
                        documentText: "Upload Invoice",
                        documentHelperText: "Upload Invoice",
                        name: "",
                        url: "",
                        mandatory: true,
                        segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_INVOICE,
                        type: "INVOICE"
                    }, 
                ];
            }
            // mobile
            return [
                {
                    id: "invoice",
                    documentText: "Upload Service Order",
                    documentHelperText: "Upload Service Order",
                    name: "",
                    url: "",
                    mandatory: true,
                    segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_INVOICE,
                    type: "INVOICE"
                },
                {
                    id: "imei",
                    documentText: "Upload Service Record",
                    documentHelperText: "Upload Service Record",
                    name: "",
                    url: "",
                    mandatory: true,
                    segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_BOX_IMAGE,
                    type: "IMEI_IMAGE"
                }, 
            ];
        }
    }
    // default
    // Oppo all models
    return [
        {
            id: "invoice",
            documentText: "Upload Invoice",
            documentHelperText: "Upload file",
            mandatory: true,
            name: "",
            url: "",
            segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_INVOICE,
            warningNote: "Date of invoice must be today",
            type: "INVOICE"
        },
        {
            id: "imei",
            documentText: "Upload Box image with IMEI visible",
            documentHelperText: "Upload file",
            name: "",
            url: "",
            mandatory: true,
            segmentEvent: SegmentTrackEvents.TAP_CTA_UPLOAD_BOX_IMAGE,
            type: "IMEI_IMAGE"
        }, 
    ];
};
function findDocumentById(documents, id) {
    return documents.find(function(doc) {
        return doc.id === id;
    });
}
var getDocumentUploaderStatusLoaders = function(partnerId, category, ew) {
    return getDocumentList(partnerId, category, ew).map(function(doc) {
        return doc.id;
    });
};

;// CONCATENATED MODULE: ./components/newPlan/scanImei/styles.ts

function scanImei_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 12px;\n"
    ]);
    scanImei_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n"
    ]);
    scanImei_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n"
    ]);
    scanImei_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 5;\n    align-items: center;\n    margin-top: 8px;\n    width: 100%;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n"
    ]);
    scanImei_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    align-items: center;\n    color: #5b5675;\n    justify-content: center;\n"
    ]);
    scanImei_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 32px;\n"
    ]);
    scanImei_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 5px;\n"
    ]);
    scanImei_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 2px;\n"
    ]);
    scanImei_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-left: 10px;\n"
    ]);
    scanImei_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 25px 0;\n"
    ]);
    scanImei_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function scanImei_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    padding-top: 8px;\n    font-size: 12px;\n    color: #666;\n    font-style: italic;\n"
    ]);
    scanImei_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var scanImei_styles_Wrapper = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject());
var ScanIMEINumber = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject1());
var SplitFlex = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject2());
var scanImei_styles_Hr = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject3());
var OrText = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject4());
var scanImei_styles_InputWrapper = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject5());
var VerifiedIMEI = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject6());
var CheckBoxFlex = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject7());
var ConfirmationText = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject8());
var styles_ButtonWrapper = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject9());
var LoaderTextWrapper = building_blocks_ui_common_dist.styled.div(scanImei_styles_templateObject10());

;// CONCATENATED MODULE: ./components/newPlan/scanImei/index.tsx
























function ScanIMEI() {
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, dealerType = ref.dealerType, planDetails = ref.planDetails, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var phone = (planDetails === null || planDetails === void 0 ? void 0 : planDetails.customer).phone;
    var _device = planDetails.device, serial_number = _device.serial_number, is_device_verified = _device.is_device_verified;
    var ref1 = scanImei_utils_getLabels(planDetails.device.type), title = ref1.title, label = ref1.label, verifyLabel = ref1.verifyLabel;
    var ref2 = (0,compat_module.useState)(serial_number || ""), imei = ref2[0], setImei = ref2[1];
    // const [confirmIMEI, setConfirmIMEI] = useState(serial_number || '');
    // const [showConfirmIMEI, setShowConfirmIMEI] = useState(false);
    var ref3 = (0,compat_module.useState)(is_device_verified), isDeviceVerified = ref3[0], setIsDeviceVerified = ref3[1];
    var ref4 = (0,compat_module.useState)(phone || ""), customerPhoneNumber = ref4[0], setCustomerPhoneNumber = ref4[1];
    var ref5 = (0,compat_module.useState)(false), isChecked = ref5[0], setIsChecked = ref5[1];
    var ref6 = (0,compat_module.useState)(true), isContinueButtonDisabled = ref6[0], setIsContinueButtonDisabled = ref6[1];
    var ref7 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref7[0], setSnackbar = ref7[1];
    var ref8 = (0,compat_module.useState)({
        serial_number: "",
        confirm_serial_number: "",
        phone: ""
    }), validationErr = ref8[0], setValidationErr = ref8[1];
    var ref9 = (0,compat_module.useState)(false), onClickSerialNumber = ref9[0], setOnClickSerialNumber = ref9[1];
    var ref10 = (0,compat_module.useState)(false), isVerifyingDevice = ref10[0], setIsVerifyingDevice = ref10[1];
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentViewEvents.VIEW_SERIAL_NUMBER_SCAN */.od.VIEW_SERIAL_NUMBER_SCAN, {
        page: constants/* SegmentPages.NEW_PLAN_SERIAL_NUMBER */.IT.NEW_PLAN_SERIAL_NUMBER,
        product: "pos",
        journey: "buy",
        platform: "mweb",
        partner: partnerId,
        type: dealerType
    });
    (0,compat_module.useEffect)(function() {
        if (onClickSerialNumber) {
            var ref;
            /**
             * Segment event
             */ (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                page_url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "",
                button_name: constants/* SegmentEventButtonNames.CLICK_SERIAL_NUMBER */.A3.CLICK_SERIAL_NUMBER,
                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                action_name: constants/* SegmentEventActionNames.CLICK_SERIAL_NUMBER */.iV.CLICK_SERIAL_NUMBER,
                product: constants/* PRODUCT */.c5,
                sub_product: constants/* SUB_PRODUCT_NAME */.tM,
                platform: isMobile ? "mweb" : "web",
                device: navigator.userAgent || "",
                partner: partnerId,
                field_selected: constants/* SegmentEventFieldTypes.TEXT */.OX.TEXT,
                plan_id: planDetails.plan.plan_id,
                device_model: planDetails.device.name,
                category: planDetails.device.type
            });
        }
    }, [
        onClickSerialNumber
    ]);
    // useEffect(() => {
    //     if (onClickConfirmSerialNumber) {
    //         /**
    //          * Segment event
    //          */
    //         trackEvent(SegmentTrackEvents.TAP_LBL_CONFIRM_SERIAL_NUMBER, {
    //             page: SegmentPages.NEW_PLAN_SERIAL_NUMBER,
    //             partner: partnerId,
    //             product: 'pos',
    //             journey: 'buy',
    //             platform: 'mweb',
    //             type: dealerType,
    //             plan_id: planDetails.plan.plan_id,
    //             device_model: planDetails.device.name,
    //             category: planDetails.device.type,
    //         });
    //     }
    // }, [onClickConfirmSerialNumber]);
    (0,compat_module.useEffect)(function() {
        setImei(serial_number);
        setIsDeviceVerified(partnerId === utils_constants/* Partners.HERO_VIDA */.wV.HERO_VIDA ? true : is_device_verified);
    }, [
        serial_number,
        is_device_verified
    ]);
    (0,compat_module.useEffect)(function() {
        if (partnerId === utils_constants/* Partners.HERO_VIDA */.wV.HERO_VIDA) {
            setIsDeviceVerified(true);
        }
    }, [
        partnerId
    ]);
    (0,compat_module.useEffect)(function() {
        if (!((0,validation/* inputRegexValidation */.xz)(imei) && (0,validation/* inputRegexValidation */.xz)(customerPhoneNumber) && (0,validation/* phoneNumberValidation */.q$)(customerPhoneNumber) && imei && utils_isValidIMEI(imei, partnerId) && isChecked && isDeviceVerified)) {
            if (planDetails.device.type === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE) {
                if (utils_isValidIMEI(imei)) {
                    setIsContinueButtonDisabled(false);
                } else {
                    setIsContinueButtonDisabled(true);
                }
            }
            setIsContinueButtonDisabled(true);
        } else {
            setIsContinueButtonDisabled(false);
        }
    }, [
        imei,
        isChecked,
        isDeviceVerified,
        customerPhoneNumber
    ]);
    (0,compat_module.useEffect)(function() {
        if (!isContinueButtonDisabled) {
            setValidationErr({
                serial_number: "",
                confirm_serial_number: "",
                phone: ""
            });
        }
    }, [
        isContinueButtonDisabled
    ]);
    (0,compat_module.useEffect)(function() {
        if (customerPhoneNumber.length > 0) {
            if (!(0,validation/* phoneNumberValidation */.q$)(customerPhoneNumber)) {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    phone: "Please enter a valid phone number"
                }));
            } else {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    phone: ""
                }));
            }
        } else {
            setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                phone: ""
            }));
        }
    }, [
        customerPhoneNumber
    ]);
    (0,compat_module.useEffect)(function() {
        var validationErrCopy = (0,src_object_spread/* default */.Z)({}, validationErr);
        if (imei.length === 0) {
            return;
        }
        if (!(0,validation/* inputRegexValidation */.xz)(imei)) {
            if (partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
                validationErrCopy["serial_number"] = "Please enter a valid serial number";
            } else {
                validationErrCopy["serial_number"] = planDetails.device.type === "mobile" || planDetails.device.type === "tablet" ? "Please enter a valid 15 digit IMEI number" : "Please enter a valid serial number";
            }
            setValidationErr(validationErrCopy);
            setIsDeviceVerified(false);
            // setShowConfirmIMEI(false);
            return;
        }
        if (partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
            if (!((imei === null || imei === void 0 ? void 0 : imei.length) >= 8 && (imei === null || imei === void 0 ? void 0 : imei.length) <= 20)) {
                validationErrCopy["serial_number"] = "Please enter a valid serial number";
                setIsDeviceVerified(false);
            // setShowConfirmIMEI(false);
            } else {
                validationErrCopy["serial_number"] = "";
            }
        } else if (!utils_isValidIMEI(imei)) {
            validationErrCopy["serial_number"] = planDetails.device.type === "mobile" || planDetails.device.type === "tablet" ? "Please enter a valid 15 digit IMEI number" : "Please enter a valid serial number";
            setIsDeviceVerified(false);
        } else {
            validationErrCopy["serial_number"] = "";
        }
        setValidationErr(validationErrCopy);
    }, [
        imei
    ]);
    var onChangeSerialNumber = function(e) {
        setImei(e.target.value);
        setIsDeviceVerified(false);
    };
    var onBlurSerialNumber = function() {
        if (planDetails.device.type === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE || partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
            if (utils_isValidIMEI(imei) || partnerId === utils_constants/* Partners.REALME */.wV.REALME && imei.length >= 8 && imei.length <= 20) {
                __webpack_require__.e(/* import() */ 509).then(__webpack_require__.bind(__webpack_require__, 8509)).then(function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                        var ref, ref1, status, statusCode, errMsg, ref2, ref3;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setIsVerifyingDevice(true);
                                    return [
                                        4,
                                        req.verifyDevice(partnerId, planDetails.device.type, imei, isEWPlan((ref = planDetails.plan.plan_id) === null || ref === void 0 ? void 0 : ref.toLowerCase()), planDetails.device.model_mapping_name, planDetails.plan.plan_id, planDetails.plan.program_id)
                                    ];
                                case 1:
                                    ref1 = _state.sent(), status = ref1.status, statusCode = ref1.statusCode, errMsg = ref1.errMsg;
                                    if (statusCode === 401) {
                                        router.push("/login");
                                        setIsVerifyingDevice(false);
                                        setSnackbar({
                                            type: "failure",
                                            message: "Token expired. Redirecting to login page."
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    setIsDeviceVerified(status);
                                    setIsVerifyingDevice(false);
                                    if (!status) {
                                        ;
                                        setSnackbar({
                                            type: "failure",
                                            message: errMsg || (partnerId === utils_constants/* Partners.REALME */.wV.REALME || (planDetails === null || planDetails === void 0 ? void 0 : (ref2 = planDetails.device) === null || ref2 === void 0 ? void 0 : ref2.type) === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE ? "Invalid serial number. Please check the serial number" : "Invalid IMEI. Please check the imei value")
                                        });
                                        setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                                            serial_number: errMsg || (partnerId === utils_constants/* Partners.REALME */.wV.REALME || (planDetails === null || planDetails === void 0 ? void 0 : (ref3 = planDetails.device) === null || ref3 === void 0 ? void 0 : ref3.type) === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE ? "Please enter a valid serial number" : "Please enter a valid IMEI number")
                                        }));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(req) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    };
    var onSubmit = function() {
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            customer: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.customer), {
                phone: customerPhoneNumber
            }),
            device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                serial_number: imei,
                is_device_verified: isDeviceVerified
            })
        }));
        setActiveStage(newPlan_constants/* NewPlanStages.DOCUMENT_UPLOAD */.W6.DOCUMENT_UPLOAD);
        /**
         * Segment event
         */ (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentTrackEvents.TAP_CONTINUE_SERIAL_NUMBER_SCAN_PAGE */.Jk.TAP_CONTINUE_SERIAL_NUMBER_SCAN_PAGE, {
            page: constants/* SegmentPages.NEW_PLAN_SERIAL_NUMBER */.IT.NEW_PLAN_SERIAL_NUMBER,
            partner: partnerId,
            product: "pos",
            journey: "buy",
            platform: "mweb",
            type: dealerType,
            plan_id: planDetails.plan.plan_id,
            device_model: planDetails.device.name,
            category: planDetails.device.type
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(scanImei_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ScanIMEINumber, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(scanImei_styles_InputWrapper, {
                onClick: function() {
                    return setOnClickSerialNumber(true);
                },
                onBlur: onBlurSerialNumber,
                children: [
                    isDeviceVerified ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                        className: "",
                        labelText: label,
                        name: label,
                        type: "text",
                        value: imei,
                        onChange: onChangeSerialNumber,
                        errMsg: validationErr.serial_number,
                        hasError: validationErr.serial_number.length > 0,
                        disableCopy: true,
                        disablePaste: true,
                        leftElement: isDeviceVerified ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(VerifiedIMEI, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: "16px",
                                height: "16px",
                                alt: "",
                                src: (0,generics/* getImageBasePath */.m4)("/icons/greenTickFill.svg")
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                        className: "",
                        labelText: label,
                        name: label,
                        type: "text",
                        value: imei,
                        onChange: function(e) {
                            return setImei(e.target.value);
                        },
                        errMsg: validationErr.serial_number,
                        hasError: validationErr.serial_number.length > 0,
                        disableCopy: true,
                        disablePaste: true,
                        rightElement: isVerifyingDevice ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: (0,generics/* getImageBasePath */.m4)("/gif/greenCircleLoader.gif"),
                            alt: "Loading",
                            width: 20,
                            height: 20
                        }) : null
                    }),
                    isVerifyingDevice && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LoaderTextWrapper, {
                        children: "Verifying the IMEI number..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(scanImei_styles_InputWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Enter customer's mobile number",
                    name: "phone_number",
                    type: "text",
                    leftElement: "+91",
                    value: customerPhoneNumber,
                    onChange: function(e) {
                        return setCustomerPhoneNumber(e.target.value);
                    },
                    errMsg: validationErr.phone,
                    hasError: validationErr.phone.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(scanImei_styles_InputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CheckBoxFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_checkbox, {
                            isSelected: isChecked,
                            onSelectHandler: function() {
                                return setIsChecked(function(s) {
                                    return !s;
                                });
                            },
                            color: "#0FA457"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ConfirmationText, {
                        children: verifyLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    disabled: isContinueButtonDisabled,
                    onClick: onSubmit,
                    children: "Continue"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var scanImei = (ScanIMEI);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.calendar/dist/index.js
var building_blocks_ui_calendar_dist = __webpack_require__(8836);
var building_blocks_ui_calendar_dist_default = /*#__PURE__*/__webpack_require__.n(building_blocks_ui_calendar_dist);
;// CONCATENATED MODULE: ./components/newPlan/documentUpload/header/styles.ts

function header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 12px;\n"
    ]);
    header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    margin-left: 5px;\n"
    ]);
    header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 10;\n    align-items: center;\n"
    ]);
    header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n"
    ]);
    header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% + 40px);\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-top: 10px;\n    transform: translateX(-20px);\n"
    ]);
    header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var HeaderWrapper = building_blocks_ui_common_dist.styled.div(header_styles_templateObject());
var PhoneIconFlex = building_blocks_ui_common_dist.styled.div(header_styles_templateObject1());
var ModelNameFlex = building_blocks_ui_common_dist.styled.div(header_styles_templateObject2());
var ModelName = building_blocks_ui_common_dist.styled.div(header_styles_templateObject3());
var header_styles_Hr = building_blocks_ui_common_dist.styled.div(header_styles_templateObject4());

;// CONCATENATED MODULE: ./components/newPlan/documentUpload/header/index.tsx






function PlansHeader() {
    var planDetails = (0,compat_module.useContext)(context/* MPosContext */.w).planDetails;
    var device = planDetails.device;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(HeaderWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PhoneIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "11px",
                            height: "16px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/phone.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModelNameFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModelName, {
                            children: device.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header_styles_Hr, {})
        ]
    });
}
/* harmony default export */ var documentUpload_header = (PlansHeader);

;// CONCATENATED MODULE: ./widgets/documentUpload/styles.ts

function documentUpload_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n"
    ]);
    documentUpload_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    documentUpload_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    documentUpload_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #d83d37;\n"
    ]);
    documentUpload_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 8px;\n    cursor: pointer;\n"
    ]);
    documentUpload_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 10px;\n    border: 1px dashed #0fa457;\n    border-radius: 8px;\n    ",
        "\n"
    ]);
    documentUpload_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n"
    ]);
    documentUpload_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 8;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-left: 5px;\n"
    ]);
    documentUpload_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n"
    ]);
    documentUpload_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var documentUpload_styles_Wrapper = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject());
var styles_TitleFlex = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject1());
var documentUpload_styles_Title = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject2());
var MandatorySign = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject3());
var FileUploadInput = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject4());
var FileUploadWrapper = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject5(), function(props) {
    return props.isUploaded && "background: #F8F7FC;\n        border: none;\n";
});
var PlusIconFlex = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject6());
var UploadLabel = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject7());
var styles_DeleteIconFlex = building_blocks_ui_common_dist.styled.div(documentUpload_styles_templateObject8());

;// CONCATENATED MODULE: ./widgets/documentUpload/index.tsx





function DocumentUpload(param) {
    var id = param.id, title = param.title, label = param.label, documentName = param.documentName, uploadStatus = param.uploadStatus, isMandatory = param.isMandatory, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onSelect = param.onSelect, onDelete = param.onDelete;
    var hiddenFileInput = (0,compat_module.useRef)(null);
    var handleClick = function() {
        var ref;
        if (disabled) return;
        hiddenFileInput === null || hiddenFileInput === void 0 ? void 0 : (ref = hiddenFileInput.current) === null || ref === void 0 ? void 0 : ref.click();
    };
    var handleChange = function(event) {
        if (disabled) return;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(id, event.target.files[0]);
    };
    var getUploadStatusIcon = function() {
        if (uploadStatus === "") {
            return "/icons/greenPlus.svg";
        }
        if (uploadStatus === "uploading") {
            return "/gif/greenCircleLoader.gif";
        }
        if (uploadStatus === "uploaded") {
            return "/icons/greenTickFill.svg";
        }
        if (uploadStatus === "failed") {
            return "/icons/failed.svg";
        }
        return "/icons/trash.svg";
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(documentUpload_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_TitleFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(documentUpload_styles_Title, {
                        children: title
                    }),
                    isMandatory && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MandatorySign, {
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FileUploadInput, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FileUploadWrapper, {
                        isUploaded: uploadStatus === "uploaded",
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PlusIconFlex, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    width: "24px",
                                    height: "24px",
                                    alt: "",
                                    src: (0,generics/* getImageBasePath */.m4)(getUploadStatusIcon())
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(UploadLabel, {
                                children: uploadStatus ? "".concat(documentName.substring(0, 20), "...") : label
                            }),
                            uploadStatus === "uploaded" && !disabled && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_DeleteIconFlex, {
                                onClick: function(e) {
                                    return onDelete(e, id);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    width: "20px",
                                    height: "20px",
                                    alt: "",
                                    src: (0,generics/* getImageBasePath */.m4)("/icons/trash.svg")
                                })
                            })
                        ]
                    }),
                    !disabled && (uploadStatus === "" || uploadStatus === "failed") && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                        type: "file",
                        ref: hiddenFileInput,
                        onChange: handleChange,
                        style: {
                            display: "none"
                        }
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var documentUpload = (DocumentUpload);

// EXTERNAL MODULE: ./utils/api/urls.ts
var urls = __webpack_require__(816);
;// CONCATENATED MODULE: ./components/newPlan/documentUpload/styles.ts

function newPlan_documentUpload_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    newPlan_documentUpload_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 32px;\n"
    ]);
    newPlan_documentUpload_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: #5b5675;\n    margin-top: 6px;\n"
    ]);
    newPlan_documentUpload_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 26px;\n"
    ]);
    newPlan_documentUpload_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n"
    ]);
    newPlan_documentUpload_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #e0e0e8;\n    border-radius: 8px;\n"
    ]);
    newPlan_documentUpload_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    line-height: ",
        ";\n    position: absolute;\n    left: 28px;\n    top: 52%;\n    transform: translateY(-50%);\n    color: ",
        ";\n    background-color: ",
        ";\n    transition: all 0.15s ease-out 0s;\n    pointer-events: none;\n    font-family: ",
        ";\n    &.shiftRight {\n        left: ",
        ";\n    }\n    padding: 0 ",
        ";\n"
    ]);
    newPlan_documentUpload_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 4;\n    align-items: center;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    newPlan_documentUpload_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function newPlan_documentUpload_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    align-items: center;\n"
    ]);
    newPlan_documentUpload_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function documentUpload_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    &::after {\n        content: ",
        ";\n        position: absolute;\n        pointer-events: none;\n        bottom: 0;\n        left: 10px;\n        top: -48px;\n        margin: auto;\n        background: white;\n        padding: 2px 6px;\n        height: max-content;\n        color: #5b5675;\n        font-size: 14px;\n    }\n"
    ]);
    documentUpload_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var newPlan_documentUpload_styles_Wrapper = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject());
var newPlan_documentUpload_styles_Title = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject1());
var WarningNote = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject2());
var DocumentUploadWrapper = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject3());
var SubmitButtonWrapper = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject4());
var CalendarInputWrapper = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject5());
var InputLabel = building_blocks_ui_common_dist.styled.label(newPlan_documentUpload_styles_templateObject6(), function(props) {
    return props.theme.typography.lineHeights.C1;
}, function(props) {
    return props.colors.neutral.n400;
}, function(props) {
    return props.colors.primary.n0;
}, function(props) {
    return props.theme.typography.fonts.family.family;
}, function(props) {
    return props.theme.spacing[9];
}, function(props) {
    return props.theme.spacing[1];
});
var LabelText = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject7());
var CalendarIcon = building_blocks_ui_common_dist.styled.div(newPlan_documentUpload_styles_templateObject8());
var PurchaseDateWrapper = (0,building_blocks_ui_common_dist.styled)(DocumentUploadWrapper)(documentUpload_styles_templateObject9(), function(props) {
    return "'".concat(props.content, "'");
});

// EXTERNAL MODULE: ./utils/api/services.ts + 1 modules
var services = __webpack_require__(1349);
// EXTERNAL MODULE: ./hooks/usePermissionHook.ts
var usePermissionHook = __webpack_require__(7664);
;// CONCATENATED MODULE: ./components/newPlan/documentUpload/index.tsx






























var WarrantyOptions = [
    {
        value: "1",
        displayValue: "1 year"
    }, 
];
function documentUpload_DocumentUpload() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,compat_module.useContext)(context/* MPosContext */.w), dealerType = ref2.dealerType, partnerId = ref2.partnerId, planDetails = ref2.planDetails, setPlanDetails = ref2.setPlanDetails, setActiveStage = ref2.setActiveStage, permissions = ref2.permissions, setGstDetailsValid = ref2.setGstDetailsValid, userDetails = ref2.userDetails;
    var ewPlan = isEWPlan((ref = planDetails.plan.plan_id) === null || ref === void 0 ? void 0 : ref.toLowerCase());
    var ref3 = (0,compat_module.useState)(true), isIssuePlanButtonDisabled = ref3[0], setIsIssuePlanButtonDisabled = ref3[1];
    var ref4 = (0,compat_module.useState)(false), isLoading = ref4[0], setIsLoading = ref4[1];
    var ref5 = (0,compat_module.useState)(true), pageLoading = ref5[0], setPageLoading = ref5[1];
    var ref6 = (0,compat_module.useState)({
        value: "",
        displayValue: ""
    }), selectedWarranty = ref6[0], setSelectedWarranty = ref6[1];
    var ref7 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref7[0], setSnackbar = ref7[1];
    var ref8 = (0,compat_module.useState)({}), documentUploadStatus = ref8[0], setDocumentUploadStatus = ref8[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var getPartnerIdFromPermission = (0,usePermissionHook/* default */.Z)().getPartnerIdFromPermission;
    var headerText = documentUpload_utils_getLabels(partnerId).headerText;
    var ref9 = (0,compat_module.useState)([]), documentList = ref9[0], setDocumentList = ref9[1];
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentViewEvents.VIEW_UPLOAD_DOCUMENTS */.od.VIEW_UPLOAD_DOCUMENTS, {
        page: constants/* SegmentPages.NEW_PLAN_DOCUMENT_UPLOAD */.IT.NEW_PLAN_DOCUMENT_UPLOAD,
        product: "pos",
        journey: "buy",
        platform: "mweb",
        partner: partnerId,
        type: dealerType,
        plan_id: planDetails.plan.plan_id,
        category: planDetails.device.type,
        device_model: planDetails.device.name,
        serial_numbers: [
            planDetails.device.serial_number
        ]
    });
    var fetchDocuments = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var documentList, uploadStatus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPageLoading(true);
                        return [
                            4,
                            fetchDocumentList(partnerId, planDetails.plan.plan_id, planDetails.plan.program_id)
                        ];
                    case 1:
                        documentList = _state.sent();
                        console.log("Client ", documentList);
                        setDocumentList(documentList);
                        uploadStatus = {};
                        documentList.forEach(function(document) {
                            uploadStatus = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, uploadStatus), (0,_define_property/* default */.Z)({}, document.id, ""));
                        });
                        setDocumentUploadStatus((0,src_object_spread/* default */.Z)({}, uploadStatus));
                        setPageLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchDocuments() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,compat_module.useEffect)(function() {
        fetchDocuments();
    }, []);
    (0,compat_module.useEffect)(function() {
        var ref;
        if (pageLoading) {
            return;
        }
        if (planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.manufacturer_warranty) {
            var ref1;
            var value = "";
            var displayValue = "";
            var years = (planDetails === null || planDetails === void 0 ? void 0 : (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.manufacturer_warranty).years;
            if (years > 0) {
                value = years === null || years === void 0 ? void 0 : years.toString();
                displayValue = "".concat(years === null || years === void 0 ? void 0 : years.toString(), " ").concat(years > 1 ? "years" : "year");
            }
            setSelectedWarranty({
                value: value,
                displayValue: displayValue
            });
        }
        if (planDetails === null || planDetails === void 0 ? void 0 : planDetails.document_urls) {
            var filledDocumentList = documentList.map(function(doc) {
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, doc), {
                    url: planDetails.document_urls[doc.id] || "",
                    name: planDetails.document_names[doc.id] || ""
                });
            });
            setDocumentList((0,_to_consumable_array/* default */.Z)(filledDocumentList));
        }
    }, [
        planDetails,
        pageLoading
    ]);
    (0,compat_module.useEffect)(function() {
        if (pageLoading) {
            return;
        }
        var requiredDocumentList = documentList.map(function(doc) {
            return doc.id;
        });
        var areAllDocumentsUploaded = requiredDocumentList.every(function(documentId) {
            return !!planDetails.document_urls[documentId];
        });
        if (!areAllDocumentsUploaded) {
            setIsIssuePlanButtonDisabled(true);
            return;
        }
        if (ewPlan) {
            var ref, ref1;
            if (((ref = planDetails.device.manufacturer_warranty) === null || ref === void 0 ? void 0 : ref.years) && ((ref1 = planDetails.device.purchase_date) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                setIsIssuePlanButtonDisabled(false);
            } else {
                setIsIssuePlanButtonDisabled(true);
            }
        } else {
            setIsIssuePlanButtonDisabled(false);
        }
    }, [
        JSON.stringify(planDetails),
        pageLoading
    ]);
    console.log("Upload status", documentUploadStatus);
    (0,compat_module.useEffect)(function() {
        if (pageLoading) {
            return;
        }
        if (planDetails.document_urls) {
            var requiredDocumentList = documentList.map(function(doc) {
                return doc.id;
            });
            console.log(requiredDocumentList);
            setDocumentUploadStatus(function(prevStatus) {
                var updatedStatus = requiredDocumentList.reduce(function(acc, documentId) {
                    var isUploaded = !!planDetails.document_urls[documentId];
                    acc[documentId] = isUploaded ? "uploaded" : "";
                    return acc;
                }, (0,src_object_spread/* default */.Z)({}, prevStatus));
                return updatedStatus;
            });
        }
    }, [
        JSON.stringify(planDetails.document_urls),
        pageLoading
    ]);
    var onSelectFile = function(id, file) {
        /**
         * Segment event
         */ var document = findDocumentById(documentList, id);
        if (document) {
            var eventName = document.segmentEvent;
            (0,building_blocks_ui_acko_analytics_dist.trackEvent)(eventName, {
                page: constants/* SegmentPages.NEW_PLAN_DOCUMENT_UPLOAD */.IT.NEW_PLAN_DOCUMENT_UPLOAD,
                partner: partnerId,
                product: "pos",
                journey: "buy",
                platform: "mweb",
                type: dealerType,
                plan_id: planDetails.plan.plan_id,
                device_model: planDetails.device.name,
                category: planDetails.device.type,
                serial_numbers: [
                    planDetails.device.serial_number
                ]
            });
            setDocumentList(function(documentList) {
                return documentList.map(function(document) {
                    if (document.id === id) {
                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, document), {
                            name: file.name
                        });
                    }
                    return (0,src_object_spread/* default */.Z)({}, document);
                });
            });
            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1349)).then(function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                    var documentType, ref, status, data, statusCode, url;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                documentType = document === null || document === void 0 ? void 0 : document.type;
                                setDocumentUploadStatus(function(documentUploadStatus) {
                                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, documentUploadStatus), (0,_define_property/* default */.Z)({}, id, "uploading"));
                                });
                                return [
                                    4,
                                    req.uploadDocument("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/").concat(urls/* newPlanUrls.documentUpload */.Q2.documentUpload), file, documentType, userDetails.user_id, function() {})
                                ];
                            case 1:
                                ref = _state.sent(), status = ref.status, data = ref.data, statusCode = ref.statusCode;
                                if (statusCode === 401) {
                                    router.push("/login");
                                    setSnackbar({
                                        type: "failure",
                                        message: "Token expired. Redirecting to login page."
                                    });
                                    return [
                                        2
                                    ];
                                }
                                if (status && (data === null || data === void 0 ? void 0 : data.url)) {
                                    url = data.url;
                                    setDocumentList(function(documentList) {
                                        return documentList.map(function(document) {
                                            if (document.id === id) {
                                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, document), {
                                                    url: url
                                                });
                                            }
                                            return (0,src_object_spread/* default */.Z)({}, document);
                                        });
                                    });
                                    setDocumentUploadStatus(function(documentUploadStatus) {
                                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, documentUploadStatus), (0,_define_property/* default */.Z)({}, id, "uploaded"));
                                    });
                                    setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                                        document_urls: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.document_urls), (0,_define_property/* default */.Z)({}, id, url)),
                                        document_names: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.document_names), (0,_define_property/* default */.Z)({}, id, file.name))
                                    }));
                                    return [
                                        2
                                    ];
                                }
                                setDocumentUploadStatus(function(documentUploadStatus) {
                                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, documentUploadStatus), (0,_define_property/* default */.Z)({}, id, "failed"));
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(req) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    };
    var onDelete = function(e, id) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            document_names: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.document_names), (0,_define_property/* default */.Z)({}, id, ""))
        }));
        setDocumentUploadStatus(function(documentUploadStatus) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, documentUploadStatus), (0,_define_property/* default */.Z)({}, id, ""));
        });
        setDocumentList(function(documentList) {
            return documentList.map(function(document) {
                if (document.id === id) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, document), {
                        name: "",
                        url: ""
                    });
                }
                return (0,src_object_spread/* default */.Z)({}, document);
            });
        });
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            document_urls: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.document_urls), (0,_define_property/* default */.Z)({}, id, "")),
            document_names: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.document_names), (0,_define_property/* default */.Z)({}, id, ""))
        }));
    };
    var onDateSelect = function(date) {
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                purchase_date: date.toISOString()
            })
        }));
    };
    var onChangeWarranty = function(param) {
        var value = param.value, displayValue = param.displayValue;
        setSelectedWarranty({
            value: value,
            displayValue: displayValue
        });
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                manufacturer_warranty: {
                    years: Number(value),
                    months: 0,
                    days: 0
                }
            })
        }));
    };
    var handleSnakbarComplete = function() {
        setSnackbar({
            type: "",
            message: ""
        });
    };
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var gstValidationResponse, _data, required, valid;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        /**
         * Segment event
         */ (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentTrackEvents.TAP_CONTINUE_UPLOAD_DOCUMENTS_PAGE */.Jk.TAP_CONTINUE_UPLOAD_DOCUMENTS_PAGE, {
                            page: constants/* SegmentPages.NEW_PLAN_SERIAL_NUMBER */.IT.NEW_PLAN_SERIAL_NUMBER,
                            partner: partnerId,
                            product: "pos",
                            journey: "buy",
                            platform: "mweb",
                            type: dealerType,
                            plan_id: planDetails.plan.plan_id,
                            device_model: planDetails.device.name,
                            category: planDetails.device.type,
                            serial_numbers: [
                                planDetails.device.serial_number
                            ]
                        });
                        setIsLoading(true);
                        setIsIssuePlanButtonDisabled(true);
                        return [
                            4,
                            (0,services.callValidateGSTDetails)(getPartnerIdFromPermission(), permissions.group, false)
                        ];
                    case 1:
                        gstValidationResponse = _state.sent();
                        if (!gstValidationResponse.is_error) {
                            if (gstValidationResponse.data) {
                                _data = gstValidationResponse.data, required = _data.required, valid = _data.valid;
                                if (required && !valid) {
                                    setGstDetailsValid(false);
                                    return [
                                        2
                                    ];
                                }
                                setGstDetailsValid(true);
                            }
                        }
                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9917)).then(function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                                var orderDetails, ref, status, data, statusCode, errorMessage, ref1, ref2, order_ekey;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            orderDetails = {
                                                customer: {
                                                    phone: planDetails.customer.phone,
                                                    email: planDetails.customer.email,
                                                    name: planDetails.customer.name
                                                },
                                                device: {
                                                    model_id: planDetails.device.id,
                                                    name: planDetails.device.name,
                                                    category: planDetails.device.type,
                                                    serial_number: planDetails.device.serial_number,
                                                    purchase_date: (0,date/* getYYYY_MM_DD */.a6)(new Date(planDetails.device.purchase_date || new Date())) || (0,date/* getYYYY_MM_DD */.a6)(new Date()),
                                                    delivery_date: (0,date/* getYYYY_MM_DD */.a6)(new Date()),
                                                    price: planDetails.device.price,
                                                    brand: planDetails.device.brand,
                                                    manufacturer_warranty: planDetails.device.manufacturer_warranty,
                                                    promoter_id: planDetails.device.promoter_id
                                                },
                                                document_urls: planDetails.document_urls,
                                                plan: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                    partner: partnerId,
                                                    plan_id: planDetails.plan.plan_id,
                                                    plan_name: planDetails.plan.plan_name,
                                                    premium: planDetails.plan.premium,
                                                    promo_name: planDetails.plan.promo_name,
                                                    insurance_program_id: planDetails.plan.program_id,
                                                    insurance_order_id: (0,generics/* uuid */.Vj)(10),
                                                    insurance_program_name: "ACKO INSURANCE",
                                                    plan_purchase_date: (0,date/* getYYYY_MM_DD */.a6)(new Date()),
                                                    plan_category: planDetails.plan.plan_category
                                                }, planDetails.plan.product_code && {
                                                    product_code: planDetails.plan.product_code
                                                }), {
                                                    emi_enabled: planDetails.plan.emi_enabled,
                                                    payment_mode: planDetails.plan.payment_mode,
                                                    emi_selected: planDetails.plan.emi_selected
                                                }),
                                                order_communication: false,
                                                policy_communication: false
                                            };
                                            return [
                                                4,
                                                req.postOrderDetails(orderDetails, partnerId, permissions.group)
                                            ];
                                        case 1:
                                            ref = _state.sent(), status = ref.status, data = ref.data, statusCode = ref.statusCode, errorMessage = ref.errorMessage;
                                            if (statusCode === 401) {
                                                router.push("/login");
                                                setSnackbar({
                                                    type: "failure",
                                                    message: "Token expired. Redirecting to login page."
                                                });
                                                return [
                                                    2
                                                ];
                                            }
                                            if (statusCode === 409) {
                                                ;
                                                setSnackbar({
                                                    type: "failure",
                                                    message: errorMessage || "Policy is already exist for this ".concat((planDetails === null || planDetails === void 0 ? void 0 : (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.type) === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE || (planDetails === null || planDetails === void 0 ? void 0 : (ref2 = planDetails.device) === null || ref2 === void 0 ? void 0 : ref2.type) === newPlan_constants/* DeviceCategory.TABLET */.I_.TABLET ? "IMEI" : "Serial", "  number")
                                                });
                                                setIsLoading(false);
                                                return [
                                                    2
                                                ];
                                            }
                                            if (status && data) {
                                                order_ekey = data.order_ekey;
                                                setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                                                    order_ekey: order_ekey
                                                }));
                                                if (permissions.purchase_journey === "v0") {
                                                    setActiveStage(newPlan_constants/* NewPlanStages.CUSTOMER_LINK */.W6.CUSTOMER_LINK);
                                                } else {
                                                    setActiveStage(newPlan_constants/* NewPlanStages.SUMMARY */.W6.SUMMARY);
                                                }
                                                setIsLoading(false);
                                                return [
                                                    2
                                                ];
                                            }
                                            setSnackbar({
                                                type: "failure",
                                                message: errorMessage || "Oops. Something went wrong."
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(req) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        setIsIssuePlanButtonDisabled(false);
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    if (pageLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(newPlan_documentUpload_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(documentUpload_header, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_documentUpload_styles_Title, {
                children: headerText
            }),
            documentList.map(function(document) {
                console.log(document);
                console.log(documentUploadStatus[document.id]);
                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DocumentUploadWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(documentUpload, {
                            id: document.id,
                            title: document.documentText,
                            label: document.documentHelperText,
                            documentName: (planDetails === null || planDetails === void 0 ? void 0 : planDetails.document_names[document.id]) || "",
                            uploadStatus: documentUploadStatus[document.id],
                            isMandatory: document.mandatory,
                            onSelect: onSelectFile,
                            onDelete: onDelete
                        }),
                        !ewPlan && document.warningNote && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WarningNote, {
                            children: "Date of invoice must be today"
                        })
                    ]
                }, document.id);
            }),
            ewPlan && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DocumentUploadWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                            title: "Purchase date of the device",
                            defaultDate: (planDetails === null || planDetails === void 0 ? void 0 : (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.purchase_date) ? new Date(planDetails.device.purchase_date) : undefined,
                            onSelect: function(date) {
                                onDateSelect(date);
                            },
                            enableWindow: {
                                start: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
                                current: new Date(),
                                end: new Date()
                            },
                            isDesktop: !isMobile
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WarningNote, {
                        children: "Please ensure the date of purchase matches with date of purchase mentioned in the invoice, discrepancy may lead issue in Claims process."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DocumentUploadWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                            value: selectedWarranty,
                            heading: "Manufacturer’s warranty",
                            label: "Manufacturer’s warranty",
                            options: WarrantyOptions,
                            onChange: onChangeWarranty
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubmitButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    disabled: isIssuePlanButtonDisabled,
                    loading: isLoading,
                    onClick: onSubmit,
                    children: "Continue"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: handleSnakbarComplete
            }))
        ]
    });
}
/* harmony default export */ var newPlan_documentUpload = (documentUpload_DocumentUpload);

;// CONCATENATED MODULE: ./components/newPlan/customerLink/styles.ts

function customerLink_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 50px;\n"
    ]);
    customerLink_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    customerLink_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n"
    ]);
    customerLink_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 8px;\n"
    ]);
    customerLink_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    customerLink_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-left: 5px;\n"
    ]);
    customerLink_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    background: #ffffff;\n    border: 1px solid #e7e7f0;\n    border-radius: 8px;\n    margin-top: 16px;\n    padding: 12px;\n    word-break: break-all;\n"
    ]);
    customerLink_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n"
    ]);
    customerLink_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 6;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #1b73e8;\n"
    ]);
    customerLink_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n"
    ]);
    customerLink_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var customerLink_styles_Wrapper = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject());
var ShareLinkImage = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject1());
var customerLink_styles_Text = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject2());
var PhoneNumberWrapper = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject3());
var PhoneNumber = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject4());
var EditIcon = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject5());
var LinkWrapper = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject6());
var CopyLink = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject7());
var Link = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject8());
var SendButtonWrapper = building_blocks_ui_common_dist.styled.div(customerLink_styles_templateObject9());

;// CONCATENATED MODULE: ./components/newPlan/customerLink/index.tsx

















function CustomerLink() {
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, dealerType = ref.dealerType, planDetails = ref.planDetails, setActiveStage = ref.setActiveStage;
    var customer = planDetails.customer;
    var ref1 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref1[0], setSnackbar = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isBtnLoading = ref2[0], setIsBtnLoading = ref2[1];
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentViewEvents.VIEW_CUSTOMER_LINK_SHARE */.od.VIEW_CUSTOMER_LINK_SHARE, {
        page: constants/* SegmentPages.NEW_PLAN_SEND_LINK_TO_CUSTOMER */.IT.NEW_PLAN_SEND_LINK_TO_CUSTOMER,
        product: "pos",
        journey: "buy",
        platform: "mweb",
        partner: partnerId,
        type: dealerType,
        plan_id: planDetails.plan.plan_id,
        category: planDetails.device.type,
        serial_numbers: [
            planDetails.device.serial_number
        ],
        device_model: planDetails.device.name
    });
    var linkText = function() {
        if (window !== undefined) {
            var domain = "https://www.acko.com";
            if (window.location.origin.includes("pos-dev")) {
                domain = "https://sandbox2.acko.com";
            } else if (window.location.origin.includes("pos.ackodev.com")) {
                domain = "https://www.ackodev.com";
            }
            return "".concat(domain, "/mpos/partner/").concat(partnerId, "?order_ekey=").concat(planDetails.order_ekey, "&phone=").concat(customer.phone);
        }
        return "https://www.acko.com/mpos/partner/".concat(partnerId, "?order_ekey=").concat(planDetails.order_ekey, "&phone=").concat(customer.phone);
    };
    var sendLink = function() {
        __webpack_require__.e(/* import() */ 70).then(__webpack_require__.bind(__webpack_require__, 6070)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, statusCode, errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsBtnLoading(true);
                            return [
                                4,
                                req.sendLinkToCustomer(planDetails.order_ekey, partnerId)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, statusCode = ref.statusCode, errorMessage = ref.errorMessage;
                            setIsBtnLoading(false);
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status) {
                                setActiveStage(newPlan_constants/* NewPlanStages.CONGRATULATION */.W6.CONGRATULATION);
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: errorMessage || "Oops. Something went wrong"
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
        /**
         * Segment event
         */ (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentTrackEvents.TAP_BTN_SEND_TO_CUSTOMER */.Jk.TAP_BTN_SEND_TO_CUSTOMER, {
            page: constants/* SegmentPages.NEW_PLAN_SEND_LINK_TO_CUSTOMER */.IT.NEW_PLAN_SEND_LINK_TO_CUSTOMER,
            partner: partnerId,
            product: "pos",
            journey: "buy",
            platform: "mweb",
            type: dealerType,
            plan_id: planDetails.plan.plan_id,
            device_model: planDetails.device.name,
            category: planDetails.device.type,
            serial_numbers: [
                planDetails.device.serial_number
            ]
        });
    };
    var onCopyLink = function() {
        try {
            navigator.clipboard.writeText(linkText());
            setSnackbar({
                type: "success",
                message: "Link copied to clipboard"
            });
        } catch (e) {}
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(customerLink_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ShareLinkImage, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "120px",
                    height: "120px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/shareEmail.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerLink_styles_Text, {
                children: "Send link to the customer mobile"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PhoneNumberWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PhoneNumber, {
                        children: customer.phone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EditIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "20px",
                            height: "20px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/blueEdit.svg"),
                            onClick: function() {
                                return setActiveStage(newPlan_constants/* NewPlanStages.IMEI */.W6.IMEI);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LinkWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Link, {
                        children: [
                            linkText().substring(0, 36),
                            "..."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CopyLink, {
                        onClick: onCopyLink,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: (0,generics/* getImageBasePath */.m4)("/icons/copy.svg"),
                            width: 20,
                            height: 20,
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SendButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    loading: isBtnLoading,
                    onClick: sendLink,
                    children: "Send to customer"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var customerLink = (CustomerLink);

;// CONCATENATED MODULE: ./widgets/congratulations/styles.ts

function congratulations_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-self: center;\n    max-width: 300px;\n    margin: auto;\n"
    ]);
    congratulations_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function congratulations_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n"
    ]);
    congratulations_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function congratulations_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin-top: 16px;\n"
    ]);
    congratulations_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function congratulations_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    color: #5b5675;\n    margin-top: 8px;\n"
    ]);
    congratulations_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function congratulations_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    congratulations_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var congratulations_styles_Wrapper = building_blocks_ui_common_dist.styled.div(congratulations_styles_templateObject());
var CongratulationImage = building_blocks_ui_common_dist.styled.div(congratulations_styles_templateObject1());
var congratulations_styles_Text = building_blocks_ui_common_dist.styled.div(congratulations_styles_templateObject2());
var Description = building_blocks_ui_common_dist.styled.div(congratulations_styles_templateObject3());
var GoHomeButtonWrapper = building_blocks_ui_common_dist.styled.div(congratulations_styles_templateObject4());

;// CONCATENATED MODULE: ./widgets/congratulations/index.tsx













function Congratulations(param) {
    var message = param.message;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, partnerId = ref.partnerId, userDetails = ref.userDetails;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    (0,compat_module.useEffect)(function() {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
            page_type: constants/* SegmentEventPageTypes.CONGRATULATIONS_PAGE */.s9.CONGRATULATIONS_PAGE,
            view_name: constants/* SegmentEventPages.VIEW_CONGRATULATIONS_PAGE */.g0.VIEW_CONGRATULATIONS_PAGE
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    }, []);
    var goHome = function() {
        setActiveStage(newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL);
        /**
         * Segment event
         */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.CLICK_GO_HOME_BUTTON */.iV.CLICK_GO_HOME_BUTTON,
            button_name: constants/* SegmentEventButtonNames.GO_HOME_BUTTON */.A3.GO_HOME_BUTTON
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        setPlanDetails(newPlan_constants/* policyDetailsInitState */.c8);
        router.push("".concat(lob, "/").concat(partnerId, "/dashboard"));
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(congratulations_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CongratulationImage, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "120px",
                    height: "120px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/congratulation.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(congratulations_styles_Text, {
                children: "Congratulations!"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Description, {
                children: message
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GoHomeButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: goHome,
                    children: "Go Home"
                })
            })
        ]
    });
}
/* harmony default export */ var congratulations = (Congratulations);

;// CONCATENATED MODULE: ./components/newPlan/styles.ts

function newPlan_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    newPlan_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function newPlan_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    newPlan_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function newPlan_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    newPlan_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function newPlan_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    newPlan_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function newPlan_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n"
    ]);
    newPlan_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var newPlan_styles_Wrapper = building_blocks_ui_common_dist.styled.div(newPlan_styles_templateObject());
var newPlan_styles_Header = building_blocks_ui_common_dist.styled.div(newPlan_styles_templateObject1());
var newPlan_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(newPlan_styles_templateObject2());
var styles_SelectModelText = building_blocks_ui_common_dist.styled.div(newPlan_styles_templateObject3());
var styles_SelectModelDropdown = building_blocks_ui_common_dist.styled.div(newPlan_styles_templateObject4());

;// CONCATENATED MODULE: ./components/newPlan/customerDeviceDetails/utils.ts

var customerDeviceDetails_utils_getLabels = function(modelType) {
    if (modelType === utils_constants/* Device.MOBILE */.AS.MOBILE || modelType === utils_constants/* Device.TABLET */.AS.TABLET) {
        return {
            customer: {
                title: "Enter Customer Details",
                nameLabel: "Full Name",
                mobileLabel: "Mobile Number",
                emailLabel: "Email"
            },
            device: {
                title: "Enter Device Details",
                imeilabel: "IMEI number",
                verifyLabel: "I have verified the IMEI number for plan issuance"
            },
            promoter: {
                title: "Enter Promoter Id",
                promoterIdLabel: "Promoter Id"
            }
        };
    }
    return {
        customer: {
            title: "Customer",
            nameLabel: "Full Name",
            mobileLabel: "Mobile Number",
            emailLabel: "Email"
        },
        device: {
            title: "Device",
            imeilabel: "Serial Number",
            verifyLabel: "I have verified the serial number"
        },
        promoter: {
            title: "Enter Promoter Id",
            promoterIdLabel: "Promoter Id"
        }
    };
};
var customerDeviceDetails_utils_isValidIMEI = function(imei, partnerId) {
    if (partnerId === utils_constants/* Partners.HERO_VIDA */.wV.HERO_VIDA) {
        return true;
    }
    if (partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
        return imei.length >= 8 && imei.length <= 20;
    }
    if (partnerId === utils_constants/* Partners.XIAOMI */.wV.XIAOMI) {
        if (imei.trim().length === 0) {
            return false;
        }
        var mobileValidation = (imei === null || imei === void 0 ? void 0 : imei.length) === 15 && /^[0-9]+$/.test(imei);
        var televisionValidation = /^[A-Za-z0-9]{5}\/[A-Za-z0-9]{12,13}$/.test(imei);
        return mobileValidation || televisionValidation;
    }
    if ((imei === null || imei === void 0 ? void 0 : imei.length) === 15 && /^[0-9]+$/.test(imei)) return true;
    return false;
};
var utils_isEWPlan = function(planId) {
    try {
        return planId === null || planId === void 0 ? void 0 : planId.includes("_ew");
    } catch (e) {
        return false;
    }
};

;// CONCATENATED MODULE: ./components/newPlan/customerDeviceDetails/styles.ts

function customerDeviceDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 12px;\n"
    ]);
    customerDeviceDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 24px;\n"
    ]);
    customerDeviceDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n"
    ]);
    customerDeviceDetails_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 5;\n    align-items: center;\n    margin-top: 8px;\n    width: 100%;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n"
    ]);
    customerDeviceDetails_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    align-items: center;\n    color: #5b5675;\n    justify-content: center;\n"
    ]);
    customerDeviceDetails_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 32px;\n"
    ]);
    customerDeviceDetails_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 5px;\n"
    ]);
    customerDeviceDetails_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 2px;\n"
    ]);
    customerDeviceDetails_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-left: 10px;\n"
    ]);
    customerDeviceDetails_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 25px 0;\n"
    ]);
    customerDeviceDetails_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function customerDeviceDetails_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    padding-top: 8px;\n    font-size: 12px;\n    color: #666;\n    font-style: italic;\n"
    ]);
    customerDeviceDetails_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var customerDeviceDetails_styles_Wrapper = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject());
var styles_EnterMoreDetails = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject1());
var styles_SplitFlex = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject2());
var customerDeviceDetails_styles_Hr = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject3());
var styles_OrText = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject4());
var customerDeviceDetails_styles_InputWrapper = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject5());
var styles_VerifiedIMEI = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject6());
var styles_CheckBoxFlex = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject7());
var styles_ConfirmationText = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject8());
var customerDeviceDetails_styles_ButtonWrapper = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject9());
var styles_LoaderTextWrapper = building_blocks_ui_common_dist.styled.div(customerDeviceDetails_styles_templateObject10());

;// CONCATENATED MODULE: ./components/newPlan/customerDeviceDetails/index.tsx
























var CustomerDeviceDetails = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, planDetails = ref.planDetails, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, metaData = ref.metaData, permissions = ref.permissions;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref1 = customerDeviceDetails_utils_getLabels(planDetails.device.type), customer = ref1.customer, device = ref1.device, promoter = ref1.promoter;
    var promoter_id_visibility = metaData.promoter_id_visibility;
    var ref2 = (planDetails === null || planDetails === void 0 ? void 0 : planDetails.device) || {}, is_device_verified_in_model_page = ref2.is_device_verified_in_model_page, model_name = ref2.name, model_serial_number = ref2.serial_number, model_activation_date = ref2.activation_date, show_activation_date = ref2.show_activation_date;
    // state
    var ref3 = (0,compat_module.useState)(planDetails.device.serial_number || ""), serialNumber = ref3[0], setSerialNumber = ref3[1];
    var ref4 = (0,compat_module.useState)(planDetails.customer.name || ""), customerName = ref4[0], setCustomerName = ref4[1];
    var ref5 = (0,compat_module.useState)(planDetails.customer.phone || ""), customerPhone = ref5[0], setCustomerPhone = ref5[1];
    var ref6 = (0,compat_module.useState)(planDetails.device.promoter_id || ""), promoterId = ref6[0], setPromoterId = ref6[1];
    var ref7 = (0,compat_module.useState)(false), isChecked = ref7[0], setIsChecked = ref7[1];
    var ref8 = (0,compat_module.useState)(false), onClickSerialNumber = ref8[0], setOnClickSerialNumber = ref8[1];
    var ref9 = (0,compat_module.useState)(planDetails.device.is_device_verified), isDeviceVerified = ref9[0], setIsDeviceVerified = ref9[1];
    var ref10 = (0,compat_module.useState)(planDetails.customer.email || ""), customerEmail = ref10[0], setCustomerEmail = ref10[1];
    var ref11 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref11[0], setSnackbar = ref11[1];
    var ref12 = (0,compat_module.useState)({
        customer_name: "",
        phone: "",
        email: "",
        serial_number: "",
        confirm_serial_number: ""
    }), validationErr = ref12[0], setValidationErr = ref12[1];
    var ref13 = (0,compat_module.useState)(true), isContinueButtonDisabled = ref13[0], setIsContinueButtonDisabled = ref13[1];
    var ref14 = (0,compat_module.useState)(false), isVerifyingDevice = ref14[0], setIsVerifyingDevice = ref14[1];
    var group = permissions.group;
    (0,compat_module.useEffect)(function() {
        if (onClickSerialNumber) {
            var ref;
            /**
             * Segment event
             */ (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                page_url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "",
                button_name: constants/* SegmentEventButtonNames.CLICK_SERIAL_NUMBER */.A3.CLICK_SERIAL_NUMBER,
                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                action_name: constants/* SegmentEventActionNames.CLICK_SERIAL_NUMBER */.iV.CLICK_SERIAL_NUMBER,
                product: constants/* PRODUCT */.c5,
                sub_product: constants/* SUB_PRODUCT_NAME */.tM,
                platform: isMobile ? "mweb" : "web",
                device: navigator.userAgent || "",
                partner: partnerId,
                field_selected: constants/* SegmentEventFieldTypes.TEXT */.OX.TEXT,
                plan_id: planDetails.plan.plan_id,
                device_model: planDetails.device.name,
                category: planDetails.device.type
            });
        }
    }, [
        onClickSerialNumber
    ]);
    (0,compat_module.useEffect)(function() {
        var ref;
        var shouldValidateSerialNumber = !(planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.is_device_verified_in_model_page);
        var basicInputsValid = (0,validation/* inputRegexValidation */.xz)(serialNumber) && (0,validation/* inputRegexValidation */.xz)(customerName) && (0,validation/* inputRegexValidation */.xz)(customerPhone) && (0,validation/* phoneNumberValidation */.q$)(customerPhone) && isChecked;
        var shouldEnable = false;
        if (shouldValidateSerialNumber) {
            var imeiValid = Boolean(serialNumber) && customerDeviceDetails_utils_isValidIMEI(serialNumber, partnerId);
            var baseValid = basicInputsValid && Boolean(serialNumber) && imeiValid && isDeviceVerified;
            if (baseValid) {
                if ((customerEmail !== null && customerEmail !== void 0 ? customerEmail : "").length === 0) {
                    shouldEnable = true;
                } else {
                    shouldEnable = !!(0,validation/* emailValidation */.D6)(customerEmail);
                }
            } else {
                shouldEnable = false;
            }
        } else {
            var baseValid1 = basicInputsValid;
            if (!baseValid1) {
                shouldEnable = false;
            } else {
                if ((customerEmail !== null && customerEmail !== void 0 ? customerEmail : "").length === 0) {
                    shouldEnable = true;
                } else {
                    shouldEnable = !!(0,validation/* emailValidation */.D6)(customerEmail);
                }
            }
        }
        if (promoter_id_visibility && (promoterId !== null && promoterId !== void 0 ? promoterId : "").length === 0) {
            shouldEnable = false;
        }
        setIsContinueButtonDisabled(!shouldEnable);
    }, [
        serialNumber,
        isChecked,
        isDeviceVerified,
        customerPhone,
        customerName,
        customerEmail,
        promoterId, 
    ]);
    (0,compat_module.useEffect)(function() {
        if (!isContinueButtonDisabled) {
            setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                serial_number: "",
                confirm_serial_number: "",
                phone: ""
            }));
        }
    }, [
        isContinueButtonDisabled
    ]);
    (0,compat_module.useEffect)(function() {
        if (customerEmail.length > 0) {
            if (!(0,validation/* emailValidation */.D6)(customerEmail)) {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    email: "Enter valid email address"
                }));
            } else {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    email: ""
                }));
            }
        } else {
            setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                email: ""
            }));
        }
    }, [
        customerEmail
    ]);
    (0,compat_module.useEffect)(function() {
        if (customerPhone.length > 0) {
            if (!(0,validation/* phoneNumberValidation */.q$)(customerPhone)) {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    phone: "Please enter a valid phone number"
                }));
            } else {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    phone: ""
                }));
            }
        } else {
            setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                phone: ""
            }));
        }
    }, [
        customerPhone
    ]);
    (0,compat_module.useEffect)(function() {
        var validationErrCopy = (0,src_object_spread/* default */.Z)({}, validationErr);
        if (serialNumber.length === 0) {
            return;
        }
        if (!(0,validation/* inputRegexValidation */.xz)(serialNumber)) {
            if (partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
                validationErrCopy["serial_number"] = "Please enter a valid serial number";
            } else {
                validationErrCopy["serial_number"] = planDetails.device.type === "mobile" || planDetails.device.type === "tablet" ? "Please enter a valid 15 digit IMEI number" : "Please enter a valid serial number";
            }
            setValidationErr(validationErrCopy);
            setIsDeviceVerified(false);
            return;
        }
        if (partnerId === utils_constants/* Partners.REALME */.wV.REALME) {
            if (!((serialNumber === null || serialNumber === void 0 ? void 0 : serialNumber.length) >= 8 && (serialNumber === null || serialNumber === void 0 ? void 0 : serialNumber.length) <= 20)) {
                validationErrCopy["serial_number"] = "Please enter a valid serial number";
                setIsDeviceVerified(false);
            } else {
                validationErrCopy["serial_number"] = "";
            }
        } else if (!customerDeviceDetails_utils_isValidIMEI(serialNumber, partnerId)) {
            validationErrCopy["serial_number"] = planDetails.device.type === "mobile" || planDetails.device.type === "tablet" ? "Please enter a valid 15 digit IMEI number" : "Please enter a valid serial number";
            setIsDeviceVerified(false);
        // setShowConfirmIMEI(false);
        } else {
            validationErrCopy["serial_number"] = "";
        }
        setValidationErr(validationErrCopy);
    }, [
        serialNumber
    ]);
    var onChangeSerialNumber = function(e) {
        setSerialNumber(e.target.value);
        setIsDeviceVerified(false);
    };
    (0,compat_module.useEffect)(function() {
        var ref;
        if (planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.is_device_verified_in_model_page) {
            return;
        }
        var passesOuter = customerDeviceDetails_utils_isValidIMEI(serialNumber, partnerId) || partnerId === utils_constants/* Partners.REALME */.wV.REALME && serialNumber.length >= 8 && serialNumber.length <= 20;
        var passesInner = customerDeviceDetails_utils_isValidIMEI(serialNumber) || partnerId === utils_constants/* Partners.REALME */.wV.REALME && serialNumber.length >= 8 && serialNumber.length <= 20;
        if (!passesOuter || !passesInner) {
            return;
        }
        setIsDeviceVerified(false);
        setIsVerifyingDevice(true);
        var cancelled = false;
        __webpack_require__.e(/* import() */ 206).then(__webpack_require__.bind(__webpack_require__, 5206)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, ref1, status, statusCode, errMsg, ref2, isRealmeOrMobile;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                ,
                                2,
                                3
                            ]);
                            return [
                                4,
                                req.verifyDevice(partnerId, planDetails.device.type, serialNumber, utils_isEWPlan((ref = planDetails.plan.plan_id) === null || ref === void 0 ? void 0 : ref.toLowerCase()), planDetails.device.model_mapping_name, planDetails.plan.plan_id, planDetails.plan.program_id, group)
                            ];
                        case 1:
                            ref1 = _state.sent(), status = ref1.status, statusCode = ref1.statusCode, errMsg = ref1.errMsg;
                            if (cancelled) {
                                return [
                                    2
                                ];
                            }
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                setIsDeviceVerified(false);
                                return [
                                    2
                                ];
                            }
                            setIsDeviceVerified(status);
                            if (!status) {
                                ;
                                isRealmeOrMobile = partnerId === utils_constants/* Partners.REALME */.wV.REALME || (planDetails === null || planDetails === void 0 ? void 0 : (ref2 = planDetails.device) === null || ref2 === void 0 ? void 0 : ref2.type) === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE;
                                setSnackbar({
                                    type: "failure",
                                    message: errMsg || (isRealmeOrMobile ? "Invalid serial number. Please check the serial number" : "Invalid IMEI. Please check the imei value")
                                });
                                setValidationErr(function(prev) {
                                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
                                        serial_number: errMsg || (isRealmeOrMobile ? "Please enter a valid serial number" : "Please enter a valid IMEI number")
                                    });
                                });
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            if (!cancelled) {
                                setIsVerifyingDevice(false);
                            }
                            return [
                                7
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            cancelled = true;
        };
    }, [
        serialNumber,
        partnerId,
        planDetails.device.type,
        planDetails.device.model_mapping_name,
        planDetails.device.is_device_verified_in_model_page,
        planDetails.plan.plan_id,
        planDetails.plan.program_id, 
    ]);
    var onSubmit = function() {
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            customer: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.customer), {
                phone: customerPhone,
                name: customerName,
                email: customerEmail
            }),
            device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                serial_number: serialNumber,
                is_device_verified: isDeviceVerified,
                promoter_id: promoter_id_visibility ? promoterId : ""
            })
        }));
        setActiveStage(newPlan_constants/* NewPlanStages.DOCUMENT_UPLOAD */.W6.DOCUMENT_UPLOAD);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(plans_header/* default */.Z, {}),
            promoter_id_visibility && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(customerDeviceDetails_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_EnterMoreDetails, {
                        children: promoter === null || promoter === void 0 ? void 0 : promoter.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDeviceDetails_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            className: "",
                            name: promoter.promoterIdLabel,
                            labelText: promoter.promoterIdLabel,
                            type: "text",
                            value: promoterId,
                            onChange: function(e) {
                                return setPromoterId(e.target.value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(customerDeviceDetails_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_EnterMoreDetails, {
                        children: customer.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDeviceDetails_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            className: "",
                            name: customer.nameLabel,
                            labelText: customer.nameLabel,
                            type: "text",
                            value: customerName,
                            onChange: function(e) {
                                return setCustomerName(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDeviceDetails_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            className: "",
                            name: customer.mobileLabel,
                            labelText: customer.mobileLabel,
                            type: "text",
                            value: customerPhone,
                            onChange: function(e) {
                                return setCustomerPhone(e.target.value);
                            },
                            leftElement: "+91",
                            errMsg: validationErr.phone,
                            hasError: validationErr.phone.length > 0
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDeviceDetails_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            className: "",
                            name: customer.emailLabel,
                            labelText: customer.emailLabel,
                            type: "text",
                            value: customerEmail,
                            onChange: function(e) {
                                return setCustomerEmail(e.target.value);
                            },
                            errMsg: validationErr.email,
                            hasError: validationErr.email.length > 0
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_SplitFlex, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(customerDeviceDetails_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_EnterMoreDetails, {
                        children: device.title
                    }),
                    is_device_verified_in_model_page ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_modelDetails, {
                        showActivationDate: show_activation_date,
                        modelName: model_name,
                        activationDate: model_activation_date,
                        imei: model_serial_number
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDeviceDetails_styles_InputWrapper, {
                                onClick: function() {
                                    return setOnClickSerialNumber(true);
                                },
                                children: isDeviceVerified ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                    className: "",
                                    labelText: device.imeilabel,
                                    name: device.imeilabel,
                                    type: "text",
                                    value: serialNumber,
                                    onChange: onChangeSerialNumber,
                                    errMsg: validationErr.serial_number,
                                    hasError: validationErr.serial_number.length > 0,
                                    disableCopy: true,
                                    disablePaste: true,
                                    leftElement: isDeviceVerified ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_VerifiedIMEI, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                            width: "16px",
                                            height: "16px",
                                            alt: "",
                                            src: (0,generics/* getImageBasePath */.m4)("/icons/greenTickFill.svg")
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                    className: "",
                                    labelText: device.imeilabel,
                                    name: device.imeilabel,
                                    type: "text",
                                    value: serialNumber,
                                    onChange: onChangeSerialNumber,
                                    errMsg: validationErr.serial_number,
                                    hasError: validationErr.serial_number.length > 0,
                                    disableCopy: true,
                                    disablePaste: true,
                                    rightElement: isVerifyingDevice ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                        src: (0,generics/* getImageBasePath */.m4)("/gif/greenCircleLoader.gif"),
                                        alt: "Loading",
                                        width: 20,
                                        height: 20
                                    }) : null
                                })
                            }),
                            isVerifyingDevice && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LoaderTextWrapper, {
                                children: "Verifying the IMEI number..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(customerDeviceDetails_styles_InputWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CheckBoxFlex, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_checkbox, {
                                    isSelected: isChecked,
                                    onSelectHandler: function() {
                                        return setIsChecked(function(s) {
                                            return !s;
                                        });
                                    },
                                    color: "#0FA457"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ConfirmationText, {
                                children: device.verifyLabel
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDeviceDetails_styles_ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    disabled: isContinueButtonDisabled,
                    onClick: onSubmit,
                    children: "Continue"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var customerDeviceDetails = (CustomerDeviceDetails);

;// CONCATENATED MODULE: ./components/orderSummary/styles.ts

function orderSummary_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 12px;\n    width: 100%;\n"
    ]);
    orderSummary_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 600px;\n    /* margin: 0 auto; */\n    padding: 20px;\n    /* border: 1px solid #ddd; */\n    border-radius: 8px;\n    background-color: #fff;\n"
    ]);
    orderSummary_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n"
    ]);
    orderSummary_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1rem;\n    margin-bottom: 16px;\n"
    ]);
    orderSummary_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    orderSummary_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n\n    &:last-child {\n        border-bottom: none;\n    }\n"
    ]);
    orderSummary_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 45%;\n    padding: 12px 0;\n    border-right: 2px solid rgb(170 166 166);\n"
    ]);
    orderSummary_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    color: #000000;\n"
    ]);
    orderSummary_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 60%;\n    max-width: 300px;\n    margin-left: 16px;\n    text-align: left;\n    padding: 12px 0;\n    word-break: break-word;\n"
    ]);
    orderSummary_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    color: #000000;\n"
    ]);
    orderSummary_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #007bff;\n    text-decoration: none;\n\n    &:hover {\n        text-decoration: underline;\n    }\n"
    ]);
    orderSummary_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n"
    ]);
    orderSummary_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #5e5ce6;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 12px 20px;\n    margin: 20px 0;\n    font-size: 1rem;\n    cursor: pointer;\n\n    &:hover {\n        background-color: #4d4bd1;\n    }\n"
    ]);
    orderSummary_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 8px 0;\n"
    ]);
    orderSummary_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    background-color: #fef9e7;\n    border-radius: 50%;\n    margin-bottom: 16px;\n"
    ]);
    orderSummary_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    font-weight: 600;\n    color: #040222;\n    margin: 0 0 12px 0;\n"
    ]);
    orderSummary_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 400;\n    color: #5b5675;\n    line-height: 22px;\n    margin: 0 0 24px 0;\n    padding: 0 8px;\n"
    ]);
    orderSummary_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 12px;\n    width: 100%;\n"
    ]);
    orderSummary_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function orderSummary_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    padding: 12px 24px;\n    border: 1px solid #e7e7f0;\n    border-radius: 8px;\n    background: #ffffff;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n        background: #f5f5f5;\n    }\n"
    ]);
    orderSummary_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    padding: 12px 24px;\n    border: none;\n    border-radius: 8px;\n    background: #00a676;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n        background: #008f64;\n    }\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}

var orderSummary_styles_Wrapper = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject());
var Container = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject1());
var Section = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject2());
var orderSummary_styles_Title = building_blocks_ui_common_dist.styled.h2(orderSummary_styles_templateObject3());
var Details = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject4());
var Row = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject5());
var LabelContainer = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject6());
var Label = building_blocks_ui_common_dist.styled.span(orderSummary_styles_templateObject7());
var ValueContainer = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject8());
var Value = building_blocks_ui_common_dist.styled.span(orderSummary_styles_templateObject9());
var styles_Link = building_blocks_ui_common_dist.styled.a(orderSummary_styles_templateObject10());
var ButtonContainer = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject11());
var Button = building_blocks_ui_common_dist.styled.button(orderSummary_styles_templateObject12());
var EmiConfirmationWrapper = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject13());
var EmiWarningIcon = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject14());
var EmiConfirmationTitle = building_blocks_ui_common_dist.styled.h3(orderSummary_styles_templateObject15());
var EmiConfirmationText = building_blocks_ui_common_dist.styled.p(orderSummary_styles_templateObject16());
var EmiConfirmationButtons = building_blocks_ui_common_dist.styled.div(orderSummary_styles_templateObject17());
var EmiCancelButton = building_blocks_ui_common_dist.styled.button(orderSummary_styles_templateObject18());
var EmiConfirmButton = building_blocks_ui_common_dist.styled.button(styles_templateObject19());

// EXTERNAL MODULE: ./components/orderSummary/types.ts
var types = __webpack_require__(9985);
;// CONCATENATED MODULE: ./components/orderSummary/index.tsx






















var WarningIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size, _color = param.color, color = _color === void 0 ? "#F5A623" : _color;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
            d: "M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
            stroke: color,
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var OrderSummary = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var router = (0,next_router.useRouter)();
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref11 = (0,compat_module.useState)(true), isLoading = ref11[0], setIsLoading = ref11[1];
    var ref12 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref12.partnerId, planDetails = ref12.planDetails, permissions = ref12.permissions;
    var ref13 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref13[0], setSnackbar = ref13[1];
    var ref14 = (0,compat_module.useState)(null), orderDetails = ref14[0], setOrderDetails = ref14[1];
    var ref15 = (0,compat_module.useState)(""), errorMessage = ref15[0], setErrorMessage = ref15[1];
    var ref16 = (0,compat_module.useState)([]), paymentOptions = ref16[0], setPaymentOptions = ref16[1];
    var ref17 = (0,compat_module.useContext)(context/* MPosContext */.w), metaData = ref17.metaData, setActiveStage = ref17.setActiveStage;
    var promoter_id_visibility = metaData.promoter_id_visibility;
    var ref18 = (0,compat_module.useState)({}), buttonLoader = ref18[0], setButtonLoaders = ref18[1];
    var ref19 = (0,compat_module.useState)(false), showEmiConfirmation = ref19[0], setShowEmiConfirmation = ref19[1];
    var ref20 = (0,compat_module.useState)(null), pendingPaymentType = ref20[0], setPendingPaymentType = ref20[1];
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    var getOrders = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4477)).then(function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                        var ref, ref1, status, data, statusCode;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        req.getOrderByOrderEkey(partnerId, planDetails.order_ekey)
                                    ];
                                case 1:
                                    ref1 = _state.sent(), status = ref1.status, data = ref1.data, statusCode = ref1.statusCode;
                                    if (statusCode === 401) {
                                        router.push("/login");
                                        setSnackbar({
                                            type: "failure",
                                            message: "Token expired. Redirecting to login page."
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    return [
                                        4,
                                        getAllPaymentOptions()
                                    ];
                                case 2:
                                    _state.sent();
                                    setIsLoading(false);
                                    if (status && (data === null || data === void 0 ? void 0 : (ref = data.recent_orders) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                        setOrderDetails(data.recent_orders[0]);
                                        setErrorMessage("");
                                    } else {
                                        setErrorMessage("Oops. something went wrong.");
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(req) {
                        return _ref.apply(this, arguments);
                    };
                }());
                return [
                    2
                ];
            });
        });
        return function getOrders() {
            return _ref.apply(this, arguments);
        };
    }();
    var getAllPaymentOptions = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4477)).then(function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                        var ref, data, errorMessage, statusCode;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        req.getAllPaymentOptions(partnerId, permissions.group)
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, errorMessage = ref.errorMessage, statusCode = ref.statusCode;
                                    if (statusCode === 400) {
                                        setSnackbar({
                                            type: "failure",
                                            message: errorMessage || ""
                                        });
                                    }
                                    if (statusCode === 401) {
                                        router.push("/login");
                                        setSnackbar({
                                            type: "failure",
                                            message: "Token expired. Redirecting to login page."
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    setPaymentOptions((0,_to_consumable_array/* default */.Z)(data));
                                    data.forEach(function(paymentOption) {
                                        setButtonLoaders(function(buttonLoader) {
                                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoader), (0,_define_property/* default */.Z)({}, paymentOption.type, false));
                                        });
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(req) {
                        return _ref.apply(this, arguments);
                    };
                }());
                return [
                    2
                ];
            });
        });
        return function getAllPaymentOptions() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,compat_module.useEffect)(function() {
        getOrders();
    }, []);
    var onPayNow = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(type) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setButtonLoaders(function(buttonLoader) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoader), (0,_define_property/* default */.Z)({}, type, true));
                });
                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4477)).then(function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                        var ref, data, status, statusCode;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        req.dealerPayment(partnerId, planDetails.order_ekey)
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, status = ref.status, statusCode = ref.statusCode;
                                    if (statusCode === 401) {
                                        router.push("/login");
                                        setSnackbar({
                                            type: "failure",
                                            message: "Token expired. Redirecting to login page."
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    if (status && data) {
                                        if (status && (data === null || data === void 0 ? void 0 : data.payment_gateway_url)) {
                                            window.location.href = "".concat(data.payment_gateway_url, "?id=").concat(data === null || data === void 0 ? void 0 : data.payment_order_ekey, "&redirect_source=pos_dealer");
                                        }
                                        return [
                                            2
                                        ];
                                    }
                                    setSnackbar({
                                        type: "failure",
                                        message: "Oops. Something went wrong."
                                    });
                                    setButtonLoaders(function(buttonLoader) {
                                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoader), (0,_define_property/* default */.Z)({}, type, false));
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(req) {
                        return _ref.apply(this, arguments);
                    };
                }());
                return [
                    2
                ];
            });
        });
        return function onPayNow(type) {
            return _ref.apply(this, arguments);
        };
    }();
    var customerPayment = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setActiveStage(newPlan_constants/* NewPlanStages.CUSTOMER_LINK */.W6.CUSTOMER_LINK);
                return [
                    2
                ];
            });
        });
        return function customerPayment() {
            return _ref.apply(this, arguments);
        };
    }();
    var walletPayment = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                router.push("/".concat(lob, "/").concat(partnerId, "/payment-mode"));
                return [
                    2
                ];
            });
        });
        return function walletPayment() {
            return _ref.apply(this, arguments);
        };
    }();
    var paymentButtonHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(type) {
            var ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ((orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.plan) === null || ref === void 0 ? void 0 : ref.emi_enabled) && (orderDetails === null || orderDetails === void 0 ? void 0 : (ref1 = orderDetails.plan) === null || ref1 === void 0 ? void 0 : ref1.emi_selected)) {
                            setPendingPaymentType(type);
                            setShowEmiConfirmation(true);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            executePayment(type)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function paymentButtonHandler(type) {
            return _ref.apply(this, arguments);
        };
    }();
    var executePayment = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(type) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(type === types/* PaymentOptionType.DEALER_PAYMENT */.G.DEALER_PAYMENT)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onPayNow(type)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!(type === types/* PaymentOptionType.CUSTOMER_PAYMENT */.G.CUSTOMER_PAYMENT)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            customerPayment()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!(type === types/* PaymentOptionType.DEALER_WALLET_PAYMENT */.G.DEALER_WALLET_PAYMENT)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            walletPayment()
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function executePayment(type) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEmiConfirmation = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowEmiConfirmation(false);
                        if (!pendingPaymentType) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executePayment(pendingPaymentType)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setPendingPaymentType(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEmiConfirmation() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEmiCancel = function() {
        setShowEmiConfirmation(false);
        setPendingPaymentType(null);
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (errorMessage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(plans_header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(orderSummary_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Section, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(orderSummary_styles_Title, {
                                        children: "Plan summary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Details, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "IMEI"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value, {
                                                            children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.device.serial_number
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Plan Name"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Value, {
                                                            children: [
                                                                orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.plan) === null || ref === void 0 ? void 0 : ref.partner,
                                                                " ",
                                                                orderDetails === null || orderDetails === void 0 ? void 0 : (ref1 = orderDetails.device) === null || ref1 === void 0 ? void 0 : ref1.category,
                                                                " ",
                                                                orderDetails === null || orderDetails === void 0 ? void 0 : (ref2 = orderDetails.plan) === null || ref2 === void 0 ? void 0 : ref2.plan_category
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "What’s covered"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Value, {
                                                            children: [
                                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.plan.plan_category,
                                                                " "
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Plan price (inc GST)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Value, {
                                                            children: [
                                                                "Rs ",
                                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.plan.premium
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            (orderDetails === null || orderDetails === void 0 ? void 0 : (ref3 = orderDetails.plan) === null || ref3 === void 0 ? void 0 : ref3.commission_amount) && (orderDetails === null || orderDetails === void 0 ? void 0 : (ref4 = orderDetails.plan) === null || ref4 === void 0 ? void 0 : ref4.commission_amount) !== 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Dealer Share (inc GST)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Value, {
                                                            children: [
                                                                "Rs",
                                                                " ",
                                                                orderDetails.plan.commission_amount
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : null,
                                            (orderDetails === null || orderDetails === void 0 ? void 0 : (ref5 = orderDetails.plan) === null || ref5 === void 0 ? void 0 : ref5.emi_enabled) === true && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Payment Mode"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value, {
                                                            children: orderDetails === null || orderDetails === void 0 ? void 0 : (ref6 = orderDetails.plan) === null || ref6 === void 0 ? void 0 : ref6.payment_mode
                                                        })
                                                    })
                                                ]
                                            }),
                                            (orderDetails === null || orderDetails === void 0 ? void 0 : (ref7 = orderDetails.plan) === null || ref7 === void 0 ? void 0 : ref7.discount_amount) && (orderDetails === null || orderDetails === void 0 ? void 0 : (ref8 = orderDetails.plan) === null || ref8 === void 0 ? void 0 : ref8.discount_amount) !== 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Discount (inc GST)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Value, {
                                                            children: [
                                                                "Rs",
                                                                " ",
                                                                orderDetails === null || orderDetails === void 0 ? void 0 : (ref9 = orderDetails.plan) === null || ref9 === void 0 ? void 0 : ref9.discount_amount
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Settle to Acko"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Value, {
                                                            children: [
                                                                "Rs ",
                                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.plan.settle_with_acko
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Section, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(orderSummary_styles_Title, {
                                        children: "Customer details"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Details, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Name"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value, {
                                                            children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.customer.name
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Mobile"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value, {
                                                            children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.customer.phone
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                            children: "Email"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value, {
                                                            children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.customer.email) || "NA"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            promoter_id_visibility && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Section, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(orderSummary_styles_Title, {
                                        children: "Promoter details"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Details, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Row, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelContainer, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Label, {
                                                        children: "Promoter Id"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueContainer, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value, {
                                                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.device.promoter_id
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonContainer, {
                                children: paymentOptions.map(function(paymentOptions) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                        loading: buttonLoader[paymentOptions.type],
                                        disabled: !paymentOptions.applicable,
                                        onClick: function() {
                                            return paymentButtonHandler(paymentOptions.type);
                                        },
                                        children: paymentOptions.name
                                    }, paymentOptions.type);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                        header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                        show: showEmiConfirmation,
                        onHide: handleEmiCancel,
                        padding: "20px",
                        wrapperStyles: "border-radius: 16px;",
                        showOverlayBackground: true,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(EmiConfirmationWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EmiWarningIcon, {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WarningIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EmiConfirmationTitle, {
                                    children: "Confirm EMI settlement"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(EmiConfirmationText, {
                                    children: [
                                        "Settle ₹",
                                        orderDetails === null || orderDetails === void 0 ? void 0 : (ref10 = orderDetails.plan) === null || ref10 === void 0 ? void 0 : ref10.settle_with_acko,
                                        " to ACKO via EMI. Dealer share will be processed separately post-collection."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(EmiConfirmationButtons, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EmiCancelButton, {
                                            onClick: handleEmiCancel,
                                            children: "No"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EmiConfirmButton, {
                                            onClick: handleEmiConfirmation,
                                            children: "Yes, continue"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                        handleSnakbarComplete: function() {
                            return setSnackbar({
                                type: "",
                                message: ""
                            });
                        }
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var orderSummary = (OrderSummary);

// EXTERNAL MODULE: ./components/dashboard/gstDetailsUpdateModal/index.tsx + 1 modules
var gstDetailsUpdateModal = __webpack_require__(1716);
;// CONCATENATED MODULE: ./components/newPlan/index.tsx





















function NewPlan() {
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), stage = ref.activeStage, partnerId = ref.partnerId, setActiveStage = ref.setActiveStage, permissions = ref.permissions, gstDetailsValid = ref.gstDetailsValid, setPlanDetails = ref.setPlanDetails;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var onBack = function() {
        switch(stage){
            case newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL:
                router.push("/".concat(lob, "/").concat(partnerId, "/dashboard"));
                return;
            case newPlan_constants/* NewPlanStages.PLAN */.W6.PLAN:
                setPlanDetails((0,src_object_spread/* default */.Z)({}, newPlan_constants/* policyDetailsInitState */.c8));
                setActiveStage(newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL);
                return;
            case newPlan_constants/* NewPlanStages.IMEI */.W6.IMEI:
                setActiveStage(newPlan_constants/* NewPlanStages.PLAN */.W6.PLAN);
                return;
            case newPlan_constants/* NewPlanStages.DOCUMENT_UPLOAD */.W6.DOCUMENT_UPLOAD:
                if (permissions.purchase_journey === "v0") {
                    setActiveStage(newPlan_constants/* NewPlanStages.IMEI */.W6.IMEI);
                } else {
                    setActiveStage(newPlan_constants/* NewPlanStages.CUSTOMER_DEVICE_DETAILS */.W6.CUSTOMER_DEVICE_DETAILS);
                }
                return;
            case newPlan_constants/* NewPlanStages.CUSTOMER_DEVICE_DETAILS */.W6.CUSTOMER_DEVICE_DETAILS:
                setActiveStage(newPlan_constants/* NewPlanStages.PLAN */.W6.PLAN);
                return;
            case newPlan_constants/* NewPlanStages.CUSTOMER_LINK */.W6.CUSTOMER_LINK:
                setActiveStage(newPlan_constants/* NewPlanStages.DOCUMENT_UPLOAD */.W6.DOCUMENT_UPLOAD);
                return;
            case newPlan_constants/* NewPlanStages.SUMMARY */.W6.SUMMARY:
                setActiveStage(newPlan_constants/* NewPlanStages.DOCUMENT_UPLOAD */.W6.DOCUMENT_UPLOAD);
                return;
            case newPlan_constants/* NewPlanStages.CONGRATULATION */.W6.CONGRATULATION:
                router.push("/".concat(lob, "/").concat(partnerId, "/dashboard"));
                return;
            default:
                setActiveStage(newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL);
        }
    };
    var activeNewPlanStage = function() {
        switch(stage){
            case newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(mobileModels, {});
            case newPlan_constants/* NewPlanStages.PLAN */.W6.PLAN:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(plans, {});
            case newPlan_constants/* NewPlanStages.CUSTOMER_DEVICE_DETAILS */.W6.CUSTOMER_DEVICE_DETAILS:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDeviceDetails, {});
            case newPlan_constants/* NewPlanStages.IMEI */.W6.IMEI:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(scanImei, {});
            case newPlan_constants/* NewPlanStages.DOCUMENT_UPLOAD */.W6.DOCUMENT_UPLOAD:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_documentUpload, {});
            case newPlan_constants/* NewPlanStages.CUSTOMER_LINK */.W6.CUSTOMER_LINK:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerLink, {});
            case newPlan_constants/* NewPlanStages.SUMMARY */.W6.SUMMARY:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(orderSummary, {});
            case newPlan_constants/* NewPlanStages.CONGRATULATION */.W6.CONGRATULATION:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(congratulations, {
                    message: "Plan details shared with customer, waiting for customer to pay"
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(mobileModels, {});
        }
    };
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(newPlan_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_styles_Header, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_styles_BackArrowIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "10px",
                        height: "24px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                        onClick: onBack
                    })
                })
            }),
            activeNewPlanStage(),
            !gstDetailsValid && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                show: true,
                urlhash: "",
                onHide: function() {},
                padding: "20px",
                maxWidth: "500px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                hideCloseButton: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstDetailsUpdateModal/* default */.Z, {})
            })
        ]
    });
}
/* harmony default export */ var newPlan = (NewPlan);

;// CONCATENATED MODULE: ./components/payment/styles.ts

function payment_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    payment_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function payment_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 20px;\n    padding-bottom: 0px;\n"
    ]);
    payment_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function payment_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    padding-bottom: 35px;\n    background: linear-gradient(161.3deg, #fff7e5 -2.04%, #fbe9f6 102.81%);\n"
    ]);
    payment_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function payment_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin: 5px 0;\n"
    ]);
    payment_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function payment_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 12px;\n    flex-direction: column;\n    background: #ffffff;\n    border-radius: 12px;\n    margin-top: 14px;\n"
    ]);
    payment_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function payment_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 10px;\n"
    ]);
    payment_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function payment_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    payment_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function payment_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    text-align: end;\n"
    ]);
    payment_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function payment_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    opacity: 0.1;\n    border: 1px solid #040222;\n    margin-top: 10px;\n"
    ]);
    payment_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function payment_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    background: #ffffff;\n    box-shadow: 0px -6px 12px -2px rgba(54, 53, 76, 0.08);\n    border-radius: 24px 24px 0px 0px;\n    margin-top: -15px;\n"
    ]);
    payment_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function payment_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n"
    ]);
    payment_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function payment_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 24px;\n"
    ]);
    payment_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function payment_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 15px;\n"
    ]);
    payment_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function payment_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 5px;\n"
    ]);
    payment_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function payment_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-left: 10px;\n"
    ]);
    payment_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function payment_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 15px 20px;\n"
    ]);
    payment_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function payment_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 29px;\n    letter-spacing: -0.8px;\n    color: #040222;\n"
    ]);
    payment_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function payment_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 3;\n    align-items: center;\n    margin-left: 10px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    payment_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function payment_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n"
    ]);
    payment_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function payment_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-end;\n"
    ]);
    payment_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}

var payment_styles_Wrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject());
var styles_HeaderWrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject1());
var CustomPlanDetailsWrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject2());
var HeaderTitle = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject3());
var PlanDetailsWrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject4());
var RowWrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject5());
var styles_LabelText = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject6());
var ValueText = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject7());
var payment_styles_Hr = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject8());
var CustomerDetailsFormWrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject9());
var FormTitle = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject10());
var payment_styles_InputWrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject11());
var TncWrapper = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject12());
var CheckboxFlex = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject13());
var TncText = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject14());
var PriceDetailsFlex = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject15());
var Price = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject16());
var Tax = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject17());
var styles_Hr1 = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject18());
var PayNowButton = building_blocks_ui_common_dist.styled.div(payment_styles_templateObject19());

;// CONCATENATED MODULE: ./components/payment/index.tsx









// import Checkbox from 'library/checkbox';










function Payment() {
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var order_ekey = router.query.order_ekey;
    var partnerId = (0,compat_module.useContext)(context/* MPosContext */.w).partnerId;
    var ref5 = (0,compat_module.useState)(null), orderDetails = ref5[0], setOrderDetails = ref5[1];
    var ref6 = (0,compat_module.useState)(true), isLoading = ref6[0], setIsLoading = ref6[1];
    // const [isCheckboxSelected, setIsCheckboxSelected] = useState(true);
    var ref7 = (0,compat_module.useState)(""), errorMessage = ref7[0], setErrorMessage = ref7[1];
    var ref8 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref8[0], setSnackbar = ref8[1];
    var ref9 = (0,compat_module.useState)(false), isBtnLoading = ref9[0], setIsBtnLoading = ref9[1];
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_PAYMENT_PAGE */.g0.VIEW_PAYMENT_PAGE,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    (0,compat_module.useEffect)(function() {
        __webpack_require__.e(/* import() */ 355).then(__webpack_require__.bind(__webpack_require__, 7355)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, ref1, status, data, statusCode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getCustomerPlanDetails(partnerId, order_ekey)
                            ];
                        case 1:
                            ref1 = _state.sent(), status = ref1.status, data = ref1.data, statusCode = ref1.statusCode;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            setIsLoading(false);
                            if (status && (data === null || data === void 0 ? void 0 : (ref = data.recent_orders) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                setOrderDetails(data.recent_orders[0]);
                                setErrorMessage("");
                            } else {
                                setErrorMessage("Oops. something went wrong.");
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    }, []);
    var onPayNow = function() {
        setIsBtnLoading(true);
        (0,services.dealerPayment)(partnerId, order_ekey).then(function(param) {
            var data = param.data, status = param.status, statusCode = param.statusCode;
            setIsBtnLoading(false);
            if (statusCode === 401) {
                router.push("/login");
                setSnackbar({
                    type: "failure",
                    message: "Token expired. Redirecting to login page."
                });
                return;
            }
            if (status && data) {
                if (status && (data === null || data === void 0 ? void 0 : data.payment_gateway_url)) {
                    window.location.href = "".concat(data.payment_gateway_url, "?id=").concat(data === null || data === void 0 ? void 0 : data.payment_order_ekey, "&redirect_source=pos_dealer");
                }
                return;
            }
            setSnackbar({
                type: "failure",
                message: "Oops. Something went wrong."
            });
        });
    };
    // const onClickTnc = () => {
    //     window.open(getTncLink(), '_blank');
    // };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {});
    }
    if (errorMessage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(payment_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_HeaderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomPlanDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HeaderTitle, {
                        children: "Confirm and pay for your customer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PlanDetailsWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "Device model"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.device.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "Serial number"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.device.serial_number
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "Plan Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: (0,generics/* getPlanName */.s0)((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.plan.plan_name) || "")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "What’s covered"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: (0,generics/* whatsCoverText */.oX)((orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.plan) === null || ref === void 0 ? void 0 : (ref1 = ref.plan_category) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || (orderDetails === null || orderDetails === void 0 ? void 0 : (ref2 = orderDetails.plan) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.plan_id) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || "")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerDetailsFormWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FormTitle, {
                        children: "Please find your customer's details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "name",
                            type: "text",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.customer.name) || "",
                            onChange: function() {},
                            labelText: "Full name",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "email",
                            type: "text",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : (ref4 = orderDetails.customer) === null || ref4 === void 0 ? void 0 : ref4.email) || "",
                            onChange: function() {},
                            labelText: "Email address",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "mobile",
                            type: "text",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.customer.phone) || "",
                            onChange: function() {},
                            labelText: "Mobile number",
                            disabled: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Hr1, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PriceDetailsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Price, {
                        children: [
                            "₹",
                            orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.plan.premium
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Tax, {
                        children: "(incl 18% GST)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PayNowButton, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                            loading: isBtnLoading,
                            size: "small",
                            // disabled={!isCheckboxSelected}
                            onClick: onPayNow,
                            children: "Pay now"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var payment = (Payment);

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.search-input/dist/index.js
var building_blocks_ui_search_input_dist = __webpack_require__(8210);
var building_blocks_ui_search_input_dist_default = /*#__PURE__*/__webpack_require__.n(building_blocks_ui_search_input_dist);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(8533);
;// CONCATENATED MODULE: ./components/transactions/detailsCard/styles.ts

function detailsCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #e7e7f0;\n    border-radius: 12px;\n    margin-top: 20px;\n    padding: 20px;\n"
    ]);
    detailsCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    detailsCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 2;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 19px;\n    color: #040222;\n"
    ]);
    detailsCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 19px;\n    color: #040222;\n"
    ]);
    detailsCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 15px;\n    color: #5b5675;\n    margin-top: 8px;\n"
    ]);
    detailsCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 15px;\n    color: #5b5675;\n    margin-top: 8px;\n"
    ]);
    detailsCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-top: 20px;\n"
    ]);
    detailsCard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    detailsCard_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 24px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    detailsCard_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function detailsCard_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 6px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    color: #040222;\n"
    ]);
    detailsCard_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var detailsCard_styles_Wrapper = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject());
var PlanDetailsFlex = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject1());
var PlanName = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject2());
var Premium = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject3());
var DeviceName = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject4());
var IMEI = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject5());
var detailsCard_styles_Hr = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject6());
var PaidBy = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject7());
var styles_Label = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject8());
var styles_Value = building_blocks_ui_common_dist.styled.div(detailsCard_styles_templateObject9());

;// CONCATENATED MODULE: ./components/transactions/detailsCard/index.tsx



function TransactionDetailsCard(param) {
    var planName = param.planName, premium = param.premium, deviceName = param.deviceName, serialNumber = param.serialNumber, paidBy = param.paidBy, customerMobileNumber = param.customerMobileNumber, paidOn = param.paidOn, deviceType = param.deviceType;
    var getLabel = function() {
        if (deviceType === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE || deviceType === newPlan_constants/* DeviceCategory.TABLET */.I_.TABLET) {
            return "IMEI";
        }
        return "Serial number";
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(detailsCard_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PlanDetailsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PlanName, {
                        children: planName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Premium, {
                        children: [
                            "₹",
                            premium
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DeviceName, {
                children: deviceName
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(IMEI, {
                children: [
                    getLabel(),
                    ": ",
                    serialNumber
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsCard_styles_Hr, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaidBy, {
                children: [
                    "Paid by ",
                    paidBy
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Label, {
                children: "Customer mobile number"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value, {
                children: customerMobileNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Label, {
                children: "Paid On"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value, {
                children: paidOn
            })
        ]
    });
}
/* harmony default export */ var detailsCard = (TransactionDetailsCard);

;// CONCATENATED MODULE: ./components/transactions/itemCard/styles.ts

function itemCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px;\n    width: 100%;\n"
    ]);
    itemCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    itemCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n"
    ]);
    itemCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    itemCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n    ",
        "\n"
    ]);
    itemCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    margin-top: 4px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    itemCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n    justify-content: flex-end;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    itemCard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 2px 6px;\n    border-radius: 4px;\n"
    ]);
    itemCard_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var itemCard_styles_Wrapper = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject());
var DivFlex = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject1());
var RowFlex = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject2());
var Value1 = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject3());
var Value2 = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject4(), function(props) {
    return props.label && "font-weight: 400;\n        font-size: 14px;\n    ";
});
var Value3 = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject5());
var Value4 = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject6());
var Value4BackgroundText = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject7(), function(props) {
    return props.background;
}, function(props) {
    return props.color;
});

;// CONCATENATED MODULE: ./components/transactions/itemCard/index.tsx


function TransactionItemCard(param) {
    var value1 = param.value1, value2 = param.value2, value3 = param.value3, value4 = param.value4;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(itemCard_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DivFlex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowFlex, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value1, {
                            children: value1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value2, {
                            children: value2
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowFlex, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value3, {
                            children: value3
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value4, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value4BackgroundText, {
                                children: value4
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var itemCard = (TransactionItemCard);

;// CONCATENATED MODULE: ./components/transactions/styles.ts

function transactions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 20px;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    transactions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    transactions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    transactions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    transactions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n    width: 100%;\n"
    ]);
    transactions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 15px;\n    cursor: pointer;\n"
    ]);
    transactions_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n"
    ]);
    transactions_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    transactions_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var transactions_styles_Wrapper = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject());
var transactions_styles_Header = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject1());
var transactions_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject2());
var TransactionText = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject3());
var TransactionSearchFlex = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject4());
var TransactionCard = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject5());
var transactions_styles_Hr = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject6());
var NoResult = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject7());

;// CONCATENATED MODULE: ./components/transactions/index.tsx


















function Transactions() {
    var getTransactions = function getTransactions() {
        __webpack_require__.e(/* import() */ 37).then(__webpack_require__.bind(__webpack_require__, 5037)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var isSearchCall, ref, status, data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            isSearchCall = (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 2;
                            return [
                                4,
                                req.getTransactions(partnerId, isSearchCall ? searchResultPage : page, searchValue)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            setIsLoading(false);
                            if (status && (data === null || data === void 0 ? void 0 : data.transactions)) {
                                if (isSearchCall) {
                                    setSearchResultTransactions(data.transactions || []);
                                } else {
                                    setTransactions(function(transactions) {
                                        return transactions.concat(data.transactions || []);
                                    });
                                }
                                if ((data === null || data === void 0 ? void 0 : data.transactions.length) > 9) {
                                    if (isSearchCall) {
                                        setSearchResultPage(function(page) {
                                            return page + 1;
                                        });
                                    } else {
                                        setPage(function(page) {
                                            return page + 1;
                                        });
                                    }
                                    setHasMore(true);
                                } else {
                                    setHasMore(false);
                                }
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,compat_module.useContext)(context/* MPosContext */.w), setShowHamburger = ref7.setShowHamburger, partnerId = ref7.partnerId;
    var ref8 = (0,compat_module.useState)(""), searchValue = ref8[0], setSearchValue = ref8[1];
    var ref9 = (0,compat_module.useState)([]), transactions = ref9[0], setTransactions = ref9[1];
    var ref10 = (0,compat_module.useState)([]), searchResultTransactions = ref10[0], setSearchResultTransactions = ref10[1];
    var ref11 = (0,compat_module.useState)({}), selectedTransaction = ref11[0], setSelectedTransaction = ref11[1];
    var ref12 = (0,compat_module.useState)(0), page = ref12[0], setPage = ref12[1];
    var ref13 = (0,compat_module.useState)(0), searchResultPage = ref13[0], setSearchResultPage = ref13[1];
    var ref14 = (0,compat_module.useState)(true), hasMore = ref14[0], setHasMore = ref14[1];
    var ref15 = (0,compat_module.useState)(false), showTransaction = ref15[0], setShowTransaction = ref15[1];
    var ref16 = (0,compat_module.useState)(true), isLoading = ref16[0], setIsLoading = ref16[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_MY_TRANSACTIONS */.g0.VIEW_MY_TRANSACTIONS,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    (0,compat_module.useEffect)(function() {
        getTransactions();
    }, []);
    (0,compat_module.useEffect)(function() {
        var timeout;
        if (searchValue.length > 2) {
            timeout = setTimeout(function() {
                getTransactions();
                setSearchResultPage(0);
                setIsLoading(true);
            }, 1000);
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchValue
    ]);
    var onBack = function() {
        if (showTransaction) {
            setShowTransaction(false);
        } else {
            setShowHamburger(true);
        }
    };
    var getTransactionList = function() {
        var isSearchCall = (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 2;
        if (isSearchCall) return searchResultTransactions;
        return transactions;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(transactions_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions_styles_Header, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions_styles_BackArrowIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "10px",
                        height: "24px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                        onClick: onBack
                    })
                })
            }),
            showTransaction ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsCard, {
                planName: (0,generics/* getPlanName */.s0)(selectedTransaction === null || selectedTransaction === void 0 ? void 0 : (ref = selectedTransaction.plan) === null || ref === void 0 ? void 0 : ref.plan_name),
                premium: selectedTransaction === null || selectedTransaction === void 0 ? void 0 : (ref1 = selectedTransaction.plan) === null || ref1 === void 0 ? void 0 : ref1.premium,
                deviceName: selectedTransaction === null || selectedTransaction === void 0 ? void 0 : (ref2 = selectedTransaction.device) === null || ref2 === void 0 ? void 0 : ref2.name,
                serialNumber: selectedTransaction === null || selectedTransaction === void 0 ? void 0 : (ref3 = selectedTransaction.device) === null || ref3 === void 0 ? void 0 : ref3.serial_number,
                paidBy: selectedTransaction === null || selectedTransaction === void 0 ? void 0 : (ref4 = selectedTransaction.payment_details) === null || ref4 === void 0 ? void 0 : ref4.user_name,
                customerMobileNumber: selectedTransaction === null || selectedTransaction === void 0 ? void 0 : (ref5 = selectedTransaction.customer) === null || ref5 === void 0 ? void 0 : ref5.phone,
                paidOn: (0,date/* getDD_Month_Time */.Se)(new Date(selectedTransaction === null || selectedTransaction === void 0 ? void 0 : (ref6 = selectedTransaction.payment_details) === null || ref6 === void 0 ? void 0 : ref6.timestamp)),
                deviceType: selectedTransaction.device.category
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TransactionText, {
                        children: "My transactions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TransactionSearchFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_search_input_dist_default()), {
                                className: "",
                                placeholder: "Search by name, mobile number, serial-number",
                                handleChange: function(vaue) {
                                    return setSearchValue(vaue);
                                }
                            })
                        })
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                        style: {
                            width: "60px"
                        },
                        src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
                    }) : getTransactionList().length === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NoResult, {
                        children: "No transactions"
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                        dataLength: getTransactionList().length,
                        next: getTransactions,
                        hasMore: hasMore,
                        loader: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                        children: getTransactionList().map(function(transaction) {
                            var ref, ref1, ref2, ref3, ref4;
                            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TransactionCard, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            style: {
                                                width: "100%"
                                            },
                                            onClick: function() {
                                                setSelectedTransaction(transaction), setShowTransaction(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(itemCard, {
                                                value1: (transaction === null || transaction === void 0 ? void 0 : (ref = transaction.customer) === null || ref === void 0 ? void 0 : ref.name) || (transaction === null || transaction === void 0 ? void 0 : (ref1 = transaction.customer) === null || ref1 === void 0 ? void 0 : ref1.phone),
                                                value2: "₹".concat(transaction === null || transaction === void 0 ? void 0 : (ref2 = transaction.plan) === null || ref2 === void 0 ? void 0 : ref2.premium),
                                                value3: transaction === null || transaction === void 0 ? void 0 : (ref3 = transaction.device) === null || ref3 === void 0 ? void 0 : ref3.name,
                                                value4: transaction === null || transaction === void 0 ? void 0 : (ref4 = transaction.device) === null || ref4 === void 0 ? void 0 : ref4.purchase_date
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions_styles_Hr, {})
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var transactions = (Transactions);

;// CONCATENATED MODULE: ./components/contactUs/styles.ts

function contactUs_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    contactUs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    contactUs_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    contactUs_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    contactUs_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n    margin-bottom: 20px;\n"
    ]);
    contactUs_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin: 20px 0;\n"
    ]);
    contactUs_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    contactUs_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 3;\n    justify-content: flex-end;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 150%;\n    color: #1b73e8;\n"
    ]);
    contactUs_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function contactUs_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border: 1px solid #e7e7f0;\n"
    ]);
    contactUs_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var contactUs_styles_Wrapper = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject());
var contactUs_styles_Header = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject1());
var contactUs_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject2());
var ContactUsTitle = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject3());
var contactUs_styles_Text = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject4());
var ContactFlex = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject5());
var contactUs_styles_Label = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject6());
var contactUs_styles_Value = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject7());
var contactUs_styles_Hr = building_blocks_ui_common_dist.styled.div(contactUs_styles_templateObject8());

;// CONCATENATED MODULE: ./components/contactUs/index.tsx







function ContactUs() {
    var setShowHamburger = (0,compat_module.useContext)(context/* MPosContext */.w).setShowHamburger;
    var onBack = function() {
        setShowHamburger(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(contactUs_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs_styles_Header, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs_styles_BackArrowIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "10px",
                        height: "24px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                        onClick: onBack
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ContactUsTitle, {
                children: "Contact us"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs_styles_Text, {
                children: "We’re here to help you - all day, from 8 AM to 10 PM. Choose one to talk with our in-house team:"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ContactFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs_styles_Label, {
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs_styles_Value, {
                        children: "mpossupport@acko.com"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var contactUs = (ContactUs);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/constants.ts
var NewPlanStages;
(function(NewPlanStages) {
    NewPlanStages["MODEL"] = "model";
    NewPlanStages["PLAN"] = "plan";
    NewPlanStages["VEHICLE_DETAILS"] = "vehicle_details";
    NewPlanStages["USER_DETAILS"] = "user_details";
    NewPlanStages["CUSTOMER_LINK"] = "customer_link";
    NewPlanStages["CONGRATULATION"] = "congratulation";
    NewPlanStages["REVIEW_DETAILS"] = "review_details";
    NewPlanStages["IMEI"] = "imei";
})(NewPlanStages || (NewPlanStages = {}));
var popularModels = [
    {
        id: "find_x2",
        name: "Find X2",
        image: "/assets/findx2.svg"
    },
    {
        id: "regno7_pro_5g",
        name: "Regno7 Pro 5G",
        image: "/assets/findx2.svg"
    },
    {
        id: "regno6_pro_5g",
        name: "Regno6 Pro 5G",
        image: "/assets/findx2.svg"
    },
    {
        id: "f21_pro_5g",
        name: "F21 Pro 5G",
        image: "/assets/findx2.svg"
    }, 
];
var DeviceCategory;
(function(DeviceCategory) {
    DeviceCategory["MOBILE"] = "mobile";
})(DeviceCategory || (DeviceCategory = {}));
var policyDetailsInitState = {
    customer: {
        name: "",
        phone: "",
        email: "",
        pincode: ""
    },
    device: {
        id: "",
        name: "",
        type: DeviceCategory.MOBILE,
        serial_number: "",
        purchase_date: "",
        delivery_date: "",
        price: null,
        brand: ""
    },
    document_urls: {
        invoice: "",
        imei: ""
    },
    document_names: {
        invoice: "",
        imei: ""
    },
    plan: {
        partner: "",
        plan_id: "",
        plan_name: "",
        purchase_date: "",
        program_id: "",
        premium: null,
        promo_name: "",
        plan_category: ""
    },
    policy_communication: true,
    order_communication: true,
    order_ekey: ""
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/utils.ts

var getVehicleLabels = function(purchaseJourney) {
    var isV1 = purchaseJourney === utils_constants/* PurchaseJourney.V1 */.PE.V1;
    if (isV1) {
        return {
            label1: "Vehicle Validation",
            label2: "Select Model",
            placeholder: "Search vehicle model"
        };
    }
    return {
        label1: "Select vehicle",
        label2: "Search vehicle",
        placeholder: "Search vehicle model"
    };
};
var mobileModels_utils_getLabels = function(partner, purchaseJourney) {
    var ref = getVehicleLabels(purchaseJourney), label1 = ref.label1, label2 = ref.label2, placeholder = ref.placeholder;
    switch(partner){
        default:
            return {
                label1: label1,
                label2: label2,
                placeholder: placeholder
            };
    }
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/styles.ts

function newPlan_mobileModels_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    newPlan_mobileModels_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function newPlan_mobileModels_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    newPlan_mobileModels_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function newPlan_mobileModels_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    newPlan_mobileModels_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function newPlan_mobileModels_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    newPlan_mobileModels_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function newPlan_mobileModels_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 24px;\n    padding-bottom: 50px;\n"
    ]);
    newPlan_mobileModels_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function newPlan_mobileModels_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #040222;\n    border-radius: 8px;\n    padding: 10px;\n"
    ]);
    newPlan_mobileModels_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var newPlan_mobileModels_styles_Wrapper = building_blocks_ui_common_dist.styled.div(newPlan_mobileModels_styles_templateObject());
var newPlan_mobileModels_styles_Header = building_blocks_ui_common_dist.styled.div(newPlan_mobileModels_styles_templateObject1());
var newPlan_mobileModels_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(newPlan_mobileModels_styles_templateObject2());
var mobileModels_styles_SelectModelText = building_blocks_ui_common_dist.styled.div(newPlan_mobileModels_styles_templateObject3());
var mobileModels_styles_SelectModelDropdown = building_blocks_ui_common_dist.styled.div(newPlan_mobileModels_styles_templateObject4());
var styles_SearchInput = building_blocks_ui_common_dist.styled.input(newPlan_mobileModels_styles_templateObject5());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/styles.ts

function vehicleValidationScreen_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    vehicleValidationScreen_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 10px;\n"
    ]);
    vehicleValidationScreen_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #666666;\n    margin-top: 5px;\n"
    ]);
    vehicleValidationScreen_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 10px;\n    flex-direction: column;\n"
    ]);
    vehicleValidationScreen_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n"
    ]);
    vehicleValidationScreen_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 25px;\n    margin-bottom: 10px;\n"
    ]);
    vehicleValidationScreen_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    margin-top: 10px;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    background: rgb(247, 199, 187);\n"
    ]);
    vehicleValidationScreen_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 12px;\n    align-items: flex-end;\n    width: 100%;\n"
    ]);
    vehicleValidationScreen_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n"
    ]);
    vehicleValidationScreen_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px 16px;\n    background-color: #40a7a3;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background-color 0.2s ease;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover:not(:disabled) {\n        background-color: #358a87;\n    }\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n    }\n"
    ]);
    vehicleValidationScreen_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function vehicleValidationScreen_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n    padding: 15px;\n    border-radius: 14px;\n    background: #ffffff;\n    border: 1px solid #e3e4f2;\n    box-shadow: 0 2px 10px rgba(4, 2, 34, 0.08);\n"
    ]);
    vehicleValidationScreen_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var vehicleValidationScreen_styles_Wrapper = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject());
var VinNumberHeading = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject1());
var VinNumberText = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject2());
var vehicleValidationScreen_styles_InputWrapper = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject3());
var vehicleValidationScreen_styles_EnterMoreDetails = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject4());
var vehicleValidationScreen_styles_ButtonWrapper = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject5());
var ManualFlowMessage = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject6());
var styles_InputAndScanWrapper = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject7());
var styles_InputContainer = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject8());
var styles_ScanButton = building_blocks_ui_common_dist.styled.button(vehicleValidationScreen_styles_templateObject9());
var InputCard = building_blocks_ui_common_dist.styled.div(vehicleValidationScreen_styles_templateObject10());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/DetailsCard/styles.ts

function DetailsCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n    padding: 15px;\n    border-radius: 14px;\n    background: #ffffff;\n    border: 1px solid #e3e4f2;\n    box-shadow: -5px 0 1px -2px #00c951;\n"
    ]);
    DetailsCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 20px;\n"
    ]);
    DetailsCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-left: 10px;\n"
    ]);
    DetailsCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n"
    ]);
    DetailsCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #008236;\n"
    ]);
    DetailsCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 25px;\n    margin-bottom: 10px;\n"
    ]);
    DetailsCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 15px;\n"
    ]);
    DetailsCard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #666666;\n    flex-shrink: 0;\n"
    ]);
    DetailsCard_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-left: 8px;\n"
    ]);
    DetailsCard_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n    margin: 8px 0 12px;\n"
    ]);
    DetailsCard_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 15px;\n"
    ]);
    DetailsCard_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    min-height: 20px;\n"
    ]);
    DetailsCard_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-left: 8px;\n    flex: 1;\n    min-width: 0;\n"
    ]);
    DetailsCard_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    word-break: break-word;\n"
    ]);
    DetailsCard_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border: none;\n    border-bottom: 1px solid #c8c8d0;\n    outline: none;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    padding: 0 0 2px 0;\n    background: transparent;\n\n    &:focus {\n        border-bottom-color: #040222;\n    }\n\n    &::placeholder {\n        color: #999999;\n        font-weight: 400;\n    }\n"
    ]);
    DetailsCard_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    flex-shrink: 0;\n    padding-left: 12px;\n"
    ]);
    DetailsCard_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    DetailsCard_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function DetailsCard_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    line-height: 16px;\n    color: #d32f2f;\n    margin-top: 4px;\n    margin-left: 8px;\n"
    ]);
    DetailsCard_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}

var DetailsCard = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject());
var DetailsCardHeader = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject1());
var DetailsCardTitle = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject2());
var DetailsCardTitleText = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject3());
var TitleSubText = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject4());
var DetailsCard_styles_ButtonWrapper = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject5());
var CardRow = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject6());
var CardRowLabel = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject7());
var CardRowValueText = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject8());
var SectionHeading = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject9());
var EditableRow = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject10());
var EditableRowContent = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject11());
var EditableRowMiddle = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject12());
var EditableRowValueText = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject13());
var UnderlineInput = building_blocks_ui_common_dist.styled.input(DetailsCard_styles_templateObject14());
var RowActions = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject15());
var ActionIcon = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject16());
var FieldError = building_blocks_ui_common_dist.styled.div(DetailsCard_styles_templateObject17());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/DetailsCard/EditableFieldRow.tsx




var getDisplayValue = function(value) {
    return value && value.trim().length ? value : "-";
};
function EditableFieldRow(param) {
    var label = param.label, value = param.value, isEditing = param.isEditing, _inputType = param.inputType, inputType = _inputType === void 0 ? "text" : _inputType, placeholder = param.placeholder, error = param.error, onChange = param.onChange, onEdit = param.onEdit, onSave = param.onSave, onFocus = param.onFocus;
    var handleKeyDown = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            onSave();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(EditableRow, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(EditableRowContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "".concat(label, ":")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EditableRowMiddle, {
                        children: isEditing ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(UnderlineInput, {
                            name: label,
                            type: inputType,
                            value: value,
                            placeholder: placeholder,
                            onChange: function(e) {
                                return onChange(e.target.value);
                            },
                            onFocus: onFocus,
                            onKeyDown: handleKeyDown,
                            autoFocus: true
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EditableRowValueText, {
                            children: getDisplayValue(value)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RowActions, {
                        children: isEditing ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ActionIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: 20,
                                height: 20,
                                alt: "Save ".concat(label),
                                src: (0,generics/* getImageBasePath */.m4)("/icons/greenTickFill.svg"),
                                onClick: onSave
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ActionIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: 20,
                                height: 20,
                                alt: "Edit ".concat(label),
                                src: (0,generics/* getImageBasePath */.m4)("/icons/blueEdit.svg"),
                                onClick: onEdit
                            })
                        })
                    })
                ]
            }),
            error.length > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FieldError, {
                children: error
            })
        ]
    });
}
/* harmony default export */ var DetailsCard_EditableFieldRow = (EditableFieldRow);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/DetailsCard/DetailsCard.tsx






var DetailsCard_getDisplayValue = function(value) {
    return value && value.trim().length ? value : "-";
};
function DetailsCard_DetailsCard(param) {
    var isButtonDisabled = param.isButtonDisabled, onSubmit = param.onSubmit, isLoading = param.isLoading, vehicleDetails = param.vehicleDetails, customerDetails = param.customerDetails, modelDetails = param.modelDetails, editingFields = param.editingFields, fieldErrors = param.fieldErrors, onCustomerFieldChange = param.onCustomerFieldChange, onVehicleFieldChange = param.onVehicleFieldChange, onEditField = param.onEditField, onSaveField = param.onSaveField, onFieldFocus = param.onFieldFocus;
    var isEditing = function(field) {
        return editingFields.has(field);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DetailsCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DetailsCardHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)("/icons/greenTick.svg"),
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DetailsCardTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCardTitleText, {
                                children: "Vehicle Validated Successfully"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TitleSubText, {
                                children: "Eligible for Extended Warranty"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SectionHeading, {
                children: "Vehicle details"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "VIN Number:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.asset_number)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "Vehicle Model:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(modelDetails === null || modelDetails === void 0 ? void 0 : modelDetails.name)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "Purchase/Sale Date:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.purchase_date)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "Registration No. (Optional):"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.registration_number)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "Motor Number:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.motor_number)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "Battery No. 1:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.bin)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "Battery No. 2:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.bin2)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCard_EditableFieldRow, {
                label: "RTO Code",
                value: vehicleDetails.rto_code,
                isEditing: isEditing("rto_code"),
                placeholder: "Enter RTO code",
                error: fieldErrors.rto_code,
                onChange: function(value) {
                    return onVehicleFieldChange("rto_code", value);
                },
                onEdit: function() {
                    return onEditField("rto_code");
                },
                onSave: function() {
                    return onSaveField("rto_code");
                },
                onFocus: function() {
                    return onFieldFocus === null || onFieldFocus === void 0 ? void 0 : onFieldFocus("rto_code");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCard_EditableFieldRow, {
                label: "Charger Number",
                value: vehicleDetails.charger_number,
                isEditing: isEditing("charger_number"),
                placeholder: "Enter charger number",
                error: fieldErrors.charger_number,
                onChange: function(value) {
                    return onVehicleFieldChange("charger_number", value);
                },
                onEdit: function() {
                    return onEditField("charger_number");
                },
                onSave: function() {
                    return onSaveField("charger_number");
                },
                onFocus: function() {
                    return onFieldFocus === null || onFieldFocus === void 0 ? void 0 : onFieldFocus("charger_number");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SectionHeading, {
                children: "Customer details"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowLabel, {
                        children: "Full Name:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardRowValueText, {
                        children: DetailsCard_getDisplayValue(customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.name)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCard_EditableFieldRow, {
                label: "Mobile No.",
                value: customerDetails.phone,
                isEditing: isEditing("phone"),
                inputType: "number",
                placeholder: "Enter mobile number",
                error: fieldErrors.phone,
                onChange: function(value) {
                    return onCustomerFieldChange("phone", value);
                },
                onEdit: function() {
                    return onEditField("phone");
                },
                onSave: function() {
                    return onSaveField("phone");
                },
                onFocus: function() {
                    return onFieldFocus === null || onFieldFocus === void 0 ? void 0 : onFieldFocus("phone");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCard_EditableFieldRow, {
                label: "Email ID",
                value: customerDetails.email,
                isEditing: isEditing("email"),
                placeholder: "Enter email ID",
                error: fieldErrors.email,
                onChange: function(value) {
                    return onCustomerFieldChange("email", value);
                },
                onEdit: function() {
                    return onEditField("email");
                },
                onSave: function() {
                    return onSaveField("email");
                },
                onFocus: function() {
                    return onFieldFocus === null || onFieldFocus === void 0 ? void 0 : onFieldFocus("email");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCard_EditableFieldRow, {
                label: "Address",
                value: customerDetails.address,
                isEditing: isEditing("address"),
                placeholder: "Enter address",
                error: fieldErrors.address,
                onChange: function(value) {
                    return onCustomerFieldChange("address", value);
                },
                onEdit: function() {
                    return onEditField("address");
                },
                onSave: function() {
                    return onSaveField("address");
                },
                onFocus: function() {
                    return onFieldFocus === null || onFieldFocus === void 0 ? void 0 : onFieldFocus("address");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCard_EditableFieldRow, {
                label: "Pin Code",
                value: customerDetails.pincode,
                isEditing: isEditing("pincode"),
                inputType: "number",
                placeholder: "Enter pin code",
                error: fieldErrors.pincode,
                onChange: function(value) {
                    return onCustomerFieldChange("pincode", value);
                },
                onEdit: function() {
                    return onEditField("pincode");
                },
                onSave: function() {
                    return onSaveField("pincode");
                },
                onFocus: function() {
                    return onFieldFocus === null || onFieldFocus === void 0 ? void 0 : onFieldFocus("pincode");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DetailsCard_styles_ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    disabled: isButtonDisabled,
                    onClick: onSubmit,
                    loading: isLoading,
                    children: "Continue to plan selection"
                })
            })
        ]
    });
}
/* harmony default export */ var vehicleValidationScreen_DetailsCard_DetailsCard = (DetailsCard_DetailsCard);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/DetailsCard/index.ts

/* harmony default export */ var vehicleValidationScreen_DetailsCard = (vehicleValidationScreen_DetailsCard_DetailsCard);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/utils.ts
var VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;
var isValidVinNumber = function(vin) {
    if (!vin) {
        return false;
    }
    var normalizedVin = vin.trim().toUpperCase();
    return VIN_REGEX.test(normalizedVin);
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/api.ts





var validateVinNumber = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, vin_number, group) {
        var data, error, ref, ref1, ref2, ref3, message;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "GET",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/asset-details?serial_number=").concat(vin_number, "&group_name=").concat(group)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            message: data === null || data === void 0 ? void 0 : data.message,
                            isValid: data === null || data === void 0 ? void 0 : data.is_valid,
                            assetDetails: data === null || data === void 0 ? void 0 : data.asset_details,
                            customerDetails: data === null || data === void 0 ? void 0 : data.customer_details,
                            errorCode: data === null || data === void 0 ? void 0 : data.errorCode,
                            modelDetails: data === null || data === void 0 ? void 0 : data.model_details
                        }
                    ];
                case 2:
                    error = _state.sent();
                    message = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
                    return [
                        2,
                        {
                            isValid: false,
                            message: message,
                            errorCode: error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.errorCode
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function validateVinNumber(partnerId, vin_number, group) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/customerDetails/helpers.ts

var getFieldActionName = function(fieldName) {
    switch(fieldName){
        case "name":
            return constants/* SegmentEventActionNames.ENTER_NAME */.iV.ENTER_NAME;
        case "mobile":
            return constants/* SegmentEventActionNames.ENTER_MOBILE_NUMBER */.iV.ENTER_MOBILE_NUMBER;
        case "email":
            return constants/* SegmentEventActionNames.ENTER_EMAIL */.iV.ENTER_EMAIL;
        case "address":
            return constants/* SegmentEventActionNames.ENTER_ADDRESS */.iV.ENTER_ADDRESS;
        case "pincode":
            return constants/* SegmentEventActionNames.ENTER_PINCODE */.iV.ENTER_PINCODE;
        default:
            return constants/* SegmentEventActionNames.ENTER_VALUE */.iV.ENTER_VALUE;
    }
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/constants.ts
var MANUAL_FLOW_MESSAGE = "System was unable to fetch all the information, please continue by selecting the model from the dropdown below";
var MANUAL_FLOW_UNAVAILABLE_MESSAGE = "System was unable to fetch vehicle information. Please verify the VIN number and try again.";
var getManualFlowMessage = function(isManualFlowEnabled) {
    return isManualFlowEnabled ? MANUAL_FLOW_MESSAGE : MANUAL_FLOW_UNAVAILABLE_MESSAGE;
};
var SERVICE_UNAVAILABLE_ERROR_CODE = "ERR003";
var DETAILS_NOT_FOUND_ERROR_CODE = "ERR003";
var VALIDATION_SERVICE_UNAVAILABLE_ERROR_CODE = "ERR005";
var getErrorMessage = function(errorCode) {
    switch(errorCode){
        case SERVICE_UNAVAILABLE_ERROR_CODE:
            return "Service unavailable";
        case DETAILS_NOT_FOUND_ERROR_CODE:
            return "Details not found";
        case VALIDATION_SERVICE_UNAVAILABLE_ERROR_CODE:
            return "Validation service unavailable";
        default:
            return "Vin Validation failed";
    }
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/validators.ts
var isFieldBlank = function(value) {
    return !value || !value.trim().length;
};
var validateField = function(field, value) {
    var trimmedValue = (value === null || value === void 0 ? void 0 : value.trim()) || "";
    switch(field){
        case "phone":
            return /^[6-9]\d{9}$/i.test(trimmedValue) ? "" : "Please enter valid mobile number";
        case "email":
            if (!trimmedValue) return "";
            return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(trimmedValue) ? "" : "Please enter valid email";
        case "address":
            return trimmedValue.length >= 4 ? "" : "Please enter valid address";
        case "pincode":
            return /^[1-9][0-9]{5}$/i.test(trimmedValue) ? "" : "Please enter valid pincode";
        case "rto_code":
            return /^[A-Za-z]{2}[0-9]{2}$/i.test(trimmedValue) ? "" : "Please enter valid rto";
        case "charger_number":
            return "";
        default:
            return "";
    }
};
var validateEditableFields = function(customerDetails, vehicleDetails) {
    return {
        phone: validateField("phone", customerDetails.phone),
        email: validateField("email", customerDetails.email),
        address: validateField("address", customerDetails.address),
        pincode: validateField("pincode", customerDetails.pincode),
        rto_code: validateField("rto_code", vehicleDetails.rto_code),
        charger_number: validateField("charger_number", vehicleDetails.charger_number)
    };
};
var areRequiredEditableFieldsComplete = function(customerDetails, vehicleDetails) {
    return ![
        customerDetails.phone,
        customerDetails.address,
        customerDetails.pincode,
        vehicleDetails.rto_code, 
    ].some(isFieldBlank);
};
var hasEditableFieldErrors = function(errors) {
    return Object.values(errors).some(function(error) {
        return error.length > 0;
    });
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/vehicleValidationScreen/VehicleValidationScreen.tsx













// components

// utils






// constants





var INITIAL_FIELD_ERRORS = {
    phone: "",
    email: "",
    address: "",
    pincode: "",
    rto_code: "",
    charger_number: ""
};
var getEmptyVehicleDetails = function() {
    return {
        asset_number: "",
        name: "",
        purchase_date: "",
        motor_number: "",
        charger_number: "",
        bin: "",
        bin2: "",
        rto_code: "",
        registration_number: ""
    };
};
var getEmptyCustomerDetails = function() {
    return {
        name: "",
        phone: "",
        email: "",
        address: "",
        pincode: ""
    };
};
var VehicleValidationScreen = function(param) {
    var setSelectedModelOption = param.setSelectedModelOption;
    var ref;
    var ref1 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref1.partnerId, dealerType = ref1.dealerType, setPlanDetails = ref1.setPlanDetails, planDetails = ref1.planDetails, setActiveStage = ref1.setActiveStage, userDetails = ref1.userDetails, permissions = ref1.permissions, permissionsMap = ref1.permissionsMap, metaData = ref1.metaData;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref2 = (0,compat_module.useState)(false), onClickVinNumber = ref2[0], setOnClickVinNumber = ref2[1];
    var ref3 = (0,compat_module.useState)(true), isVinValidateDisabled = ref3[0], setIsVinValidateDisabled = ref3[1];
    var ref4 = (0,compat_module.useState)(true), isDetailsContinueDisabled = ref4[0], setIsDetailsContinueDisabled = ref4[1];
    var ref5 = (0,compat_module.useState)(""), vin = ref5[0], setVin = ref5[1];
    var ref6 = (0,compat_module.useState)(false), isScannerOpen = ref6[0], setIsScannerOpen = ref6[1];
    var ref7 = (0,compat_module.useState)(false), cameraSupported = ref7[0], setCameraSupported = ref7[1];
    var ref8 = (0,compat_module.useState)({
        isVinNumberValidationLoading: false,
        submitButtonLoaders: false
    }), buttonLoaders = ref8[0], setButtonLoaders = ref8[1];
    var ref9 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref9[0], setSnackbar = ref9[1];
    var ref10 = (0,compat_module.useState)({
        description: "",
        id: "",
        name: "",
        price: 0,
        type: "",
        brand: ""
    }), modelDetails = ref10[0], setModelDetails = ref10[1];
    var ref11 = (0,compat_module.useState)(false), isVinNumberVerified = ref11[0], setIsVinNumberVerified = ref11[1];
    var ref12 = (0,compat_module.useState)({
        asset_number: "",
        name: "",
        purchase_date: "",
        motor_number: "",
        charger_number: "",
        bin: "",
        bin2: "",
        rto_code: "",
        registration_number: ""
    }), vehicleDetails = ref12[0], setVehicleDetails = ref12[1];
    var ref13 = (0,compat_module.useState)({
        name: "",
        phone: "",
        email: "",
        address: "",
        pincode: ""
    }), customerDetails = ref13[0], setCustomerDetails = ref13[1];
    var ref14 = (0,compat_module.useState)(new Set()), editingFields = ref14[0], setEditingFields = ref14[1];
    var ref15 = (0,compat_module.useState)(INITIAL_FIELD_ERRORS), fieldErrors = ref15[0], setFieldErrors = ref15[1];
    var group = permissions.group;
    (0,compat_module.useEffect)(function() {
        if (onClickVinNumber) {
            var ref;
            (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                page_url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "",
                button_name: constants/* SegmentEventButtonNames.CLICK_VIN_NUMBER */.A3.CLICK_VIN_NUMBER,
                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                action_name: constants/* SegmentEventActionNames.CLICK_VIN_NUMBER */.iV.CLICK_VIN_NUMBER,
                product: constants/* PRODUCT */.c5,
                sub_product: constants/* SUB_PRODUCT_NAME */.tM,
                platform: isMobile ? "mweb" : "web",
                device: navigator.userAgent || "",
                partner: partnerId,
                field_selected: constants/* SegmentEventFieldTypes.TEXT */.OX.TEXT,
                plan_id: planDetails.plan.plan_id,
                device_model: planDetails.device.name,
                category: planDetails.device.type
            });
        }
    }, [
        onClickVinNumber
    ]); // we can remove this check
    var ref16 = (0,compat_module.useState)({
        vin_number: ""
    }), validationErr = ref16[0], setValidationErr = ref16[1];
    var resetEditableFieldState = function() {
        setEditingFields(new Set());
        setFieldErrors(INITIAL_FIELD_ERRORS);
        setIsDetailsContinueDisabled(true);
    };
    var updateDetailsContinueState = function(nextCustomerDetails, nextVehicleDetails) {
        var errors = validateEditableFields(nextCustomerDetails, nextVehicleDetails);
        setFieldErrors(errors);
        setIsDetailsContinueDisabled(!areRequiredEditableFieldsComplete(nextCustomerDetails, nextVehicleDetails) || hasEditableFieldErrors(errors));
    };
    var handleCustomerFieldChange = function(field, value) {
        var nextCustomerDetails = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, customerDetails), (0,_define_property/* default */.Z)({}, field, value));
        setCustomerDetails(nextCustomerDetails);
        var fieldKey = field;
        var fieldError = validateField(fieldKey, value);
        var nextErrors = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldErrors), (0,_define_property/* default */.Z)({}, fieldKey, fieldError));
        setFieldErrors(nextErrors);
        setIsDetailsContinueDisabled(!areRequiredEditableFieldsComplete(nextCustomerDetails, vehicleDetails) || hasEditableFieldErrors(nextErrors));
    };
    var handleVehicleFieldChange = function(field, value) {
        var nextVehicleDetails = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, vehicleDetails), (0,_define_property/* default */.Z)({}, field, value));
        setVehicleDetails(nextVehicleDetails);
        var fieldError = validateField(field, value);
        var nextErrors = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldErrors), (0,_define_property/* default */.Z)({}, field, fieldError));
        setFieldErrors(nextErrors);
        setIsDetailsContinueDisabled(!areRequiredEditableFieldsComplete(customerDetails, nextVehicleDetails) || hasEditableFieldErrors(nextErrors));
    };
    var handleEditField = function(field) {
        setEditingFields(function(currentFields) {
            return new Set(currentFields).add(field);
        });
    };
    var getEditableFieldValue = function(field) {
        if (field === "rto_code" || field === "charger_number") {
            return vehicleDetails[field] || "";
        }
        return customerDetails[field] || "";
    };
    var handleSaveField = function(field) {
        var fieldValue = getEditableFieldValue(field);
        var fieldError = validateField(field, fieldValue);
        var nextErrors = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldErrors), (0,_define_property/* default */.Z)({}, field, fieldError));
        setFieldErrors(nextErrors);
        setIsDetailsContinueDisabled(!areRequiredEditableFieldsComplete(customerDetails, vehicleDetails) || hasEditableFieldErrors(nextErrors));
        if (fieldError.length > 0) {
            return;
        }
        setEditingFields(function(currentFields) {
            var nextFields = new Set(currentFields);
            nextFields.delete(field);
            return nextFields;
        });
    };
    var getEditableFieldActionName = function(field) {
        if (field === "phone") {
            return getFieldActionName("mobile");
        }
        return getFieldActionName(field);
    };
    var handleEditableFieldFocus = function(field) {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.ENTER_TEXT */.Qy.ENTER_TEXT,
            action_name: getEditableFieldActionName(field)
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    var validateVinHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var vinNumber, response, ref, nextVehicleDetails, ref1, nextCustomerDetails, nextModelDetails, errorMessage, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // segment events
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActionNames.CLICK_VALIDATE_VIN_NUMBER_BUTTON */.iV.CLICK_VALIDATE_VIN_NUMBER_BUTTON
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                isVinNumberValidationLoading: true
                            });
                        });
                        setVin(vin);
                        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                            device: {},
                            customer: {},
                            showManualFlow: false
                        }));
                        setSelectedModelOption({
                            displayValue: "",
                            value: ""
                        });
                        resetEditableFieldState();
                        setIsVinNumberVerified(false);
                        setVehicleDetails(getEmptyVehicleDetails());
                        setCustomerDetails(getEmptyCustomerDetails());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        vinNumber = vin.trim();
                        return [
                            4,
                            validateVinNumber(partnerId, vinNumber, group)
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.isValid) {
                            setIsVinNumberVerified(true);
                            ;
                            nextVehicleDetails = (ref = response === null || response === void 0 ? void 0 : response.assetDetails) !== null && ref !== void 0 ? ref : getEmptyVehicleDetails();
                            ;
                            nextCustomerDetails = (ref1 = response === null || response === void 0 ? void 0 : response.customerDetails) !== null && ref1 !== void 0 ? ref1 : getEmptyCustomerDetails();
                            nextModelDetails = response === null || response === void 0 ? void 0 : response.modelDetails;
                            setVehicleDetails(nextVehicleDetails);
                            setCustomerDetails(nextCustomerDetails);
                            if (nextModelDetails) {
                                setModelDetails(nextModelDetails);
                            }
                            updateDetailsContinueState(nextCustomerDetails, nextVehicleDetails);
                            setSnackbar({
                                type: "success",
                                message: response === null || response === void 0 ? void 0 : response.message
                            });
                            setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                                showManualFlow: false
                            }));
                        } else {
                            if ((response === null || response === void 0 ? void 0 : response.errorCode) === VALIDATION_SERVICE_UNAVAILABLE_ERROR_CODE || SERVICE_UNAVAILABLE_ERROR_CODE || DETAILS_NOT_FOUND_ERROR_CODE) {
                                errorMessage = getErrorMessage(response === null || response === void 0 ? void 0 : response.errorCode);
                                // segment events
                                (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                                    message: errorMessage
                                }, {
                                    userDetails: userDetails,
                                    isMobile: isMobile
                                });
                                setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                                    showManualFlow: true
                                }));
                            }
                            setIsVinNumberVerified(false);
                            setValidationErr(function(validationErr) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                                    vin_number: response === null || response === void 0 ? void 0 : response.message
                                });
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        // segment events
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                            message: utils_constants/* ERROR_MESSAGES.VIN_VALIDATION_FAILED_MESSAGE */.RZ.VIN_VALIDATION_FAILED_MESSAGE
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                            showManualFlow: true
                        }));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                isVinNumberValidationLoading: false
                            });
                        });
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function validateVinHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                submitButtonLoaders: true
                            });
                        });
                        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                            device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails === null || planDetails === void 0 ? void 0 : planDetails.device), {
                                vin_number: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.asset_number,
                                name: modelDetails === null || modelDetails === void 0 ? void 0 : modelDetails.name,
                                invoice_date: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.purchase_date,
                                motor_number: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.motor_number,
                                charger_number: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.charger_number,
                                bin_number: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.bin,
                                bin2_number: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.bin2,
                                rto_code: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.rto_code,
                                registration_number: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.registration_number,
                                type: modelDetails === null || modelDetails === void 0 ? void 0 : modelDetails.type,
                                price: modelDetails === null || modelDetails === void 0 ? void 0 : modelDetails.price,
                                id: modelDetails === null || modelDetails === void 0 ? void 0 : modelDetails.id,
                                description: modelDetails === null || modelDetails === void 0 ? void 0 : modelDetails.description,
                                brand: modelDetails === null || modelDetails === void 0 ? void 0 : modelDetails.brand
                            }),
                            customer: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails === null || planDetails === void 0 ? void 0 : planDetails.customer), {
                                name: customerDetails === null || customerDetails === void 0 ? void 0 : (ref = customerDetails.name) === null || ref === void 0 ? void 0 : ref.trim(),
                                phone: customerDetails === null || customerDetails === void 0 ? void 0 : (ref1 = customerDetails.phone) === null || ref1 === void 0 ? void 0 : ref1.trim(),
                                email: customerDetails === null || customerDetails === void 0 ? void 0 : (ref2 = customerDetails.email) === null || ref2 === void 0 ? void 0 : ref2.trim(),
                                address: customerDetails === null || customerDetails === void 0 ? void 0 : (ref3 = customerDetails.address) === null || ref3 === void 0 ? void 0 : ref3.trim(),
                                pincode: customerDetails === null || customerDetails === void 0 ? void 0 : (ref4 = customerDetails.pincode) === null || ref4 === void 0 ? void 0 : ref4.trim()
                            })
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentTrackEvents.TAP_SUBMIT_SERIAL_NUMBER_MODEL_PAGE */.Jk.TAP_SUBMIT_SERIAL_NUMBER_MODEL_PAGE, {
                                page: constants/* SegmentPages.NEW_PLAN_DEVICE_MODELS */.IT.NEW_PLAN_DEVICE_MODELS,
                                partner: partnerId,
                                product: "pos",
                                journey: "buy",
                                platform: "mweb",
                                type: dealerType
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setButtonLoaders(function(buttonLoaders) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buttonLoaders), {
                                submitButtonLoaders: false
                            });
                        });
                        setActiveStage(NewPlanStages.PLAN);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onFocusVinHandler = function() {
        // segment events - should be called when VIN input is focused
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.ENTER_VIN_NUMBER */.iV.ENTER_VIN_NUMBER,
            field_type: constants/* SegmentEventFieldTypes.TEXT */.OX.TEXT
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    (0,compat_module.useEffect)(function() {
        var ref;
        setCameraSupported(typeof navigator !== "undefined" && !!((ref = navigator.mediaDevices) === null || ref === void 0 ? void 0 : ref.getUserMedia));
    }, []);
    var handleVinScanned = function(scannedVin) {
        setVin(scannedVin);
        if (isValidVinNumber(scannedVin)) {
            setIsVinValidateDisabled(false);
        } else {
            setIsVinValidateDisabled(true);
        }
        setValidationErr(function(validationErr) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                vin_number: ""
            });
        });
        setIsScannerOpen(false);
    };
    var onKeyDownVinHandler = function(e) {
        if (e.key === "Enter" && isValidVinNumber(e.target.value)) {
            e.preventDefault();
            validateVinHandler();
        }
    };
    var onChangeVinHandler = function(e) {
        var updatedVin = e.target.value;
        setVin(updatedVin);
        if (isValidVinNumber(updatedVin)) {
            setIsVinValidateDisabled(false);
        } else {
            setIsVinValidateDisabled(true);
        }
        // resetting validation error here
        setValidationErr(function(validationErr) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                vin_number: ""
            });
        });
    };
    var ref17;
    var showManualFlow = (ref17 = planDetails === null || planDetails === void 0 ? void 0 : planDetails.showManualFlow) !== null && ref17 !== void 0 ? ref17 : false;
    var _MANUAL_PURCHASE_FLOW;
    var isManualFlowPermissionEnabled = (_MANUAL_PURCHASE_FLOW = permissionsMap[utils_constants/* Permissions.MANUAL_PURCHASE_FLOW */.Pl.MANUAL_PURCHASE_FLOW]) !== null && _MANUAL_PURCHASE_FLOW !== void 0 ? _MANUAL_PURCHASE_FLOW : false;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(vehicleValidationScreen_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(VinNumberHeading, {
                        children: "Vehicle Validation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(VinNumberText, {
                        children: "Enter Vehicle Vin Number to validate and view details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(InputCard, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(vehicleValidationScreen_styles_InputWrapper, {
                                onClick: function() {
                                    return setOnClickVinNumber(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleValidationScreen_styles_EnterMoreDetails, {
                                        children: "Vehicle VIN Number"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_InputAndScanWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_InputContainer, {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "Vehicle VIN Number",
                                                    placeHolder: "Enter VIN Number",
                                                    type: "text",
                                                    value: vin,
                                                    onChange: onChangeVinHandler,
                                                    onKeyDown: onKeyDownVinHandler,
                                                    onFocus: onFocusVinHandler,
                                                    errMsg: validationErr === null || validationErr === void 0 ? void 0 : validationErr.vin_number,
                                                    hasError: (validationErr === null || validationErr === void 0 ? void 0 : (ref = validationErr.vin_number) === null || ref === void 0 ? void 0 : ref.length) > 0
                                                })
                                            }),
                                            permissionsMap[utils_constants/* Permissions.SCANNER */.Pl.SCANNER] && cameraSupported && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ScanButton, {
                                                type: "button",
                                                onClick: function() {
                                                    return setIsScannerOpen(true);
                                                },
                                                title: "Scan VIN barcode",
                                                children: "\uD83D\uDCF7 Scan"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(VinNumberText, {
                                children: "Find VIN in Vehicle Documents or on the chassis"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleValidationScreen_styles_ButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                    disabled: isVinValidateDisabled,
                                    onClick: validateVinHandler,
                                    loading: buttonLoaders.isVinNumberValidationLoading,
                                    children: "Validate device"
                                })
                            })
                        ]
                    }),
                    showManualFlow && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ManualFlowMessage, {
                        children: getManualFlowMessage(isManualFlowPermissionEnabled)
                    }),
                    !showManualFlow && isVinNumberVerified && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleValidationScreen_DetailsCard, {
                        isButtonDisabled: isDetailsContinueDisabled,
                        onSubmit: onSubmit,
                        isLoading: buttonLoaders.submitButtonLoaders,
                        vehicleDetails: vehicleDetails,
                        customerDetails: customerDetails,
                        modelDetails: modelDetails,
                        editingFields: editingFields,
                        fieldErrors: fieldErrors,
                        onCustomerFieldChange: handleCustomerFieldChange,
                        onVehicleFieldChange: handleVehicleFieldChange,
                        onEditField: handleEditField,
                        onSaveField: handleSaveField,
                        onFieldFocus: handleEditableFieldFocus
                    })
                ]
            }),
            permissionsMap[utils_constants/* Permissions.SCANNER */.Pl.SCANNER] && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImeiScannerModal, {
                isOpen: isScannerOpen,
                onClose: function() {
                    return setIsScannerOpen(false);
                },
                onImeiScanned: handleVinScanned
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var vehicleValidationScreen_VehicleValidationScreen = (VehicleValidationScreen);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/mobileModels/index.tsx












// constants









// components

function mobileModels_MobileModel() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref2.planDetails, setActiveStage = ref2.setActiveStage, setPlanDetails = ref2.setPlanDetails, permissions = ref2.permissions, userDetails = ref2.userDetails, permissionsMap = ref2.permissionsMap;
    var ref3 = (0,compat_module.useState)([]), options = ref3[0], setOptions = ref3[1];
    var ref4 = (0,compat_module.useState)([]), modelOptions = ref4[0], setModelOptions = ref4[1];
    var ref5 = (0,compat_module.useState)(""), search = ref5[0], setSearch = ref5[1];
    var ref6 = (0,compat_module.useState)(false), showDropdown = ref6[0], setShowDropdown = ref6[1];
    var ref7 = (0,compat_module.useState)({
        value: (planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.id) || "",
        displayValue: (planDetails === null || planDetails === void 0 ? void 0 : (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
    }), selectedModelOption = ref7[0], setSelectedModelOption = ref7[1];
    var ref8 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref8[0], setSnackbar = ref8[1];
    var ref9 = (0,compat_module.useState)(true), isLoading = ref9[0], setIsLoading = ref9[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var purchaseJourney = permissions === null || permissions === void 0 ? void 0 : permissions.purchase_journey;
    var showManualFlowForV1 = purchaseJourney === utils_constants/* PurchaseJourney.V1 */.PE.V1 && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.showManualFlow);
    /**
     * view segment hook
     */ (0,compat_module.useEffect)(function() {
        if (true) {
            var view_name = purchaseJourney === utils_constants/* PurchaseJourney.V0 */.PE.V0 || showManualFlowForV1 ? constants/* SegmentEventPages.VIEW_DEVICE_MODEL */.g0.VIEW_DEVICE_MODEL : constants/* SegmentEventPages.VIEW_VEHICLE_VALIDATION_PAGE */.g0.VIEW_VEHICLE_VALIDATION_PAGE;
            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
                page_type: constants/* SegmentEventPageTypes.VEHICLE_VALIDATION_PAGE */.s9.VEHICLE_VALIDATION_PAGE,
                view_name: view_name
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        window,
        showManualFlowForV1,
        purchaseJourney
    ]);
    (0,compat_module.useEffect)(function() {
        var ref, ref1;
        setSelectedModelOption({
            value: (planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.id) || "",
            displayValue: (planDetails === null || planDetails === void 0 ? void 0 : (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
        });
    }, [
        planDetails
    ]);
    (0,compat_module.useEffect)(function() {
        if (showManualFlowForV1 || purchaseJourney === utils_constants/* PurchaseJourney.V0 */.PE.V0) {
            try {
                __webpack_require__.e(/* import() */ 647).then(__webpack_require__.bind(__webpack_require__, 4647)).then(function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                        var ref, models, statusCode, options;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        req.getMobileModels(permissions.partner_id, permissions.group)
                                    ];
                                case 1:
                                    ref = _state.sent(), models = ref.models, statusCode = ref.statusCode;
                                    setIsLoading(false);
                                    if (statusCode === 401) {
                                        router.push("/login");
                                        setSnackbar({
                                            type: "failure",
                                            message: "Token expired. Redirecting to login page."
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    if (models.length > 0) {
                                        setOptions(models);
                                        options = models.map(function(param) {
                                            var id = param.id, name = param.name;
                                            return {
                                                displayValue: name,
                                                value: id
                                            };
                                        });
                                        setModelOptions(options);
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(req) {
                        return _ref.apply(this, arguments);
                    };
                }());
            } catch (e) {}
        } else {
            setIsLoading(false);
        }
    }, [
        showManualFlowForV1,
        purchaseJourney
    ]);
    (0,compat_module.useEffect)(function() {
        if (options.length === 0) return;
        if (search.length > 0) {
            var filteredList = options.filter(function(option) {
                return option.name.toLowerCase().includes(search.toLowerCase());
            });
            var opts = filteredList.map(function(param) {
                var id = param.id, name = param.name;
                return {
                    displayValue: name,
                    value: id
                };
            });
            setModelOptions(opts);
        } else {
            var opts1 = options.map(function(param) {
                var id = param.id, name = param.name;
                return {
                    displayValue: name,
                    value: id
                };
            });
            setModelOptions(opts1);
        }
    }, [
        search
    ]);
    var toggleDropdown = function(show) {
        setShowDropdown(show);
        if (!show) {
            var opts = options.map(function(param) {
                var id = param.id, name = param.name;
                return {
                    displayValue: name,
                    value: id
                };
            });
            setModelOptions(opts);
        }
    };
    var onSelectModelDropdown = function(param) {
        var value = param.value, displayValue = param.displayValue;
        try {
            setSelectedModelOption({
                value: value,
                displayValue: displayValue
            });
            var selectedModel = options.filter(function(param) {
                var id = param.id;
                return value === id;
            });
            if (!((selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.length) > 0)) {
                return;
            }
            setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                    name: displayValue,
                    id: value,
                    type: selectedModel[0].type,
                    price: selectedModel[0].price
                })
            }));
            setActiveStage(NewPlanStages.PLAN);
            // segment Event
            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                action_name: constants/* SegmentEventActionNames.SELECT_MODEL */.iV.SELECT_MODEL,
                button_name: "select_".concat(displayValue, "_model"),
                field_selected: constants/* SegmentEventFieldTypes.DROPDOWN */.OX.DROPDOWN
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        } catch (e) {}
    };
    var ref10 = mobileModels_utils_getLabels(permissions === null || permissions === void 0 ? void 0 : permissions.partner_id, purchaseJourney), label2 = ref10.label2, placeholder = ref10.placeholder;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.ThemeProvider, {
        theme: dist.AckoMainTheme,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                    src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                    children: [
                        purchaseJourney === utils_constants/* PurchaseJourney.V1 */.PE.V1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleValidationScreen_VehicleValidationScreen, {
                            setSelectedModelOption: setSelectedModelOption
                        }),
                        permissionsMap[utils_constants/* Permissions.MANUAL_PURCHASE_FLOW */.Pl.MANUAL_PURCHASE_FLOW] && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                            children: (purchaseJourney === utils_constants/* PurchaseJourney.V0 */.PE.V0 || showManualFlowForV1) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(mobileModels_styles_SelectModelText, {
                                        children: label2
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(mobileModels_styles_SelectModelDropdown, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                                            show: showDropdown,
                                            value: selectedModelOption,
                                            label: placeholder,
                                            options: modelOptions,
                                            onChange: onSelectModelDropdown,
                                            toggleDropdown: toggleDropdown,
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                style: {
                                                    marginBottom: "10px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_search_input_dist_default()), {
                                                    placeholder: placeholder,
                                                    handleChange: function(value) {
                                                        return setSearch(value);
                                                    }
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                    handleSnakbarComplete: function() {
                        return setSnackbar({
                            type: "",
                            message: ""
                        });
                    }
                }))
            ]
        })
    });
}
/* harmony default export */ var newPlan_mobileModels = (mobileModels_MobileModel);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/header/styles.ts

function plans_header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 12px;\n"
    ]);
    plans_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function plans_header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-right: 8px;\n    margin-left: 5px;\n"
    ]);
    plans_header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function plans_header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 6;\n    align-items: center;\n"
    ]);
    plans_header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function plans_header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n"
    ]);
    plans_header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function plans_header_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 2;\n    align-items: center;\n    justify-content: flex-end;\n"
    ]);
    plans_header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #1c73e8;\n    cursor: pointer;\n"
    ]);
    header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% + 40px);\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-top: 10px;\n    transform: translateX(-20px);\n"
    ]);
    header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var header_styles_HeaderWrapper = building_blocks_ui_common_dist.styled.div(plans_header_styles_templateObject());
var styles_PhoneIconFlex = building_blocks_ui_common_dist.styled.div(plans_header_styles_templateObject1());
var styles_ModelNameFlex = building_blocks_ui_common_dist.styled.div(plans_header_styles_templateObject2());
var styles_ModelName = building_blocks_ui_common_dist.styled.div(plans_header_styles_templateObject3());
var EditFlex = building_blocks_ui_common_dist.styled.div(plans_header_styles_templateObject4());
var Edit = building_blocks_ui_common_dist.styled.div(header_styles_templateObject5());
var plans_header_styles_Hr = building_blocks_ui_common_dist.styled.div(header_styles_templateObject6());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/header/index.tsx










function header_PlansHeader() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref.planDetails, setActiveStage = ref.setActiveStage, partnerId = ref.partnerId, userDetails = ref.userDetails;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var device = planDetails.device;
    var _getHeaderImage = function() {
        if (partnerId === "ather") {
            return (0,generics/* getImageBasePath */.m4)("/icons/bike.svg");
        }
        return (0,generics/* getImageBasePath */.m4)("/icons/phone.svg");
    };
    var onEditClick = function() {
        setActiveStage(newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL);
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.CLICK_EDIT_MODEL */.iV.CLICK_EDIT_MODEL,
            button_name: constants/* SegmentEventButtonNames.CLICK_EDIT_MODEL */.A3.CLICK_EDIT_MODEL
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(header_styles_HeaderWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PhoneIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: partnerId === "ather" ? "24px" : "11px",
                            height: partnerId === "ather" ? "24px" : "16px",
                            alt: "",
                            src: _getHeaderImage()
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ModelNameFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ModelName, {
                            children: device.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EditFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Edit, {
                            onClick: onEditClick,
                            children: "Edit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(plans_header_styles_Hr, {})
        ]
    });
}
/* harmony default export */ var newPlan_plans_header = (header_PlansHeader);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/utils.ts


var isManualFlowEnabled = function(purchaseJourney, showManualFlow) {
    var showManualFlowInV1 = purchaseJourney === utils_constants/* PurchaseJourney.V1 */.PE.V1 && showManualFlow;
    return purchaseJourney === utils_constants/* PurchaseJourney.V0 */.PE.V0 || showManualFlowInV1;
};
var getPlanStageBackFromReviewDetails = function(permissions, planDetails) {
    var showManualFlow = isManualFlowEnabled(permissions === null || permissions === void 0 ? void 0 : permissions.purchase_journey, planDetails === null || planDetails === void 0 ? void 0 : planDetails.showManualFlow);
    var planStageBackFromReviewDetails = showManualFlow ? NewPlanStages.USER_DETAILS : NewPlanStages.PLAN;
    return planStageBackFromReviewDetails;
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/selectPlan/planDetailsCard/planDetails/styles.ts

function planDetailsCard_planDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 20px;\n    flex-direction: column;\n    background: #ffffff;\n    border: 1px solid #e7e7f0;\n    border-radius: 12px;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    color: #040222;\n    margin-bottom: 20px;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 3;\n    justify-content: center;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 22px;\n    display: flex;\n    color: #040222;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 6px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: #5b5675;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function planDetailsCard_planDetails_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid rgba(91, 86, 117, 0.1);\n    margin: 15px 0;\n"
    ]);
    planDetailsCard_planDetails_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid rgba(91, 86, 117, 0.1);\n    margin: 8px 0;\n"
    ]);
    planDetails_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 22px;\n    color: #5b5675;\n    margin-top: 24px;\n    margin-bottom: 20px;\n"
    ]);
    planDetails_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    planDetails_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    planDetails_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function planDetails_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    color: #040222;\n    margin-left: 10px;\n"
    ]);
    planDetails_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

var planDetailsCard_planDetails_styles_Wrapper = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject());
var styles_PlanCoverWrapper = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject1());
var styles_PlanCoverTitle = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject2());
var styles_CoverDetailsWrapper = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject3());
var planDetails_styles_IconFlex = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject4());
var planDetails_styles_TitleFlex = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject5());
var planDetailsCard_planDetails_styles_Title = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject6());
var styles_SubTitle = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject7());
var planDetails_styles_Hr = styled_components_browser_esm["default"].div(planDetailsCard_planDetails_styles_templateObject8());
var planDetails_styles_Hr1 = styled_components_browser_esm["default"].div(planDetails_styles_templateObject9());
var styles_MoreReason = styled_components_browser_esm["default"].div(planDetails_styles_templateObject10());
var styles_MoreReasonFlex = styled_components_browser_esm["default"].div(planDetails_styles_templateObject11());
var styles_MoreReasonIconFlex = styled_components_browser_esm["default"].div(planDetails_styles_templateObject12());
var styles_MoreReasonText = styled_components_browser_esm["default"].div(planDetails_styles_templateObject13());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/selectPlan/planDetailsCard/planDetails/index.tsx




function planDetails_PlanDetails(param) {
    var plans = param.plans;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(planDetailsCard_planDetails_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PlanCoverWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PlanCoverTitle, {
                        children: "Your ACKO protection plan covers"
                    }),
                    plans.map(function(plan, index) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CoverDetailsWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetails_styles_IconFlex, {
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                width: "48px",
                                                height: "48px",
                                                alt: "",
                                                src: (0,generics/* getImageBasePath */.m4)(plan.icon)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(planDetails_styles_TitleFlex, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetailsCard_planDetails_styles_Title, {
                                                    children: plan.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_SubTitle, {
                                                    children: plan.subTitle
                                                })
                                            ]
                                        })
                                    ]
                                }, plan.title),
                                index !== plans.length - 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetails_styles_Hr, {})
                            ]
                        });
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MoreReason, {
                children: "More reasons to love ACKO"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_MoreReasonFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MoreReasonIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "48px",
                            height: "48px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/mpos/checkClaim.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MoreReasonText, {
                        children: "Same day claim approvals"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetails_styles_Hr1, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_MoreReasonFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MoreReasonIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "48px",
                            height: "48px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/mpos/pickupDrop.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MoreReasonText, {
                        children: "Free pickup and drop"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetails_styles_Hr1, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_MoreReasonFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MoreReasonIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "48px",
                            height: "48px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/mpos/serviceNetwork.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MoreReasonText, {
                        children: "Real time claim tracking"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var planDetailsCard_planDetails = (planDetails_PlanDetails);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/selectPlan/planDetailsCard/styles.ts

function selectPlan_planDetailsCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #e7e7f0;\n    border-radius: 16px;\n    padding: 20px;\n    margin: 8px 0;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-bottom: 8px;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin: 8px 0;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: self-start;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 10;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 15px;\n    color: #1c73e8;\n    margin-top: 8px;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% + 40px);\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-top: 16px;\n    transform: translateX(-20px);\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: flex-end;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 700;\n    font-size: 22px;\n    line-height: 32px;\n    align-items: center;\n    color: #040222;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function selectPlan_planDetailsCard_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    align-items: center;\n    color: #5b5675;\n    margin-left: 4px;\n"
    ]);
    selectPlan_planDetailsCard_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

var styles_CardWrapper = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject());
var styles_PlanTitle = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject1());
var styles_BenefitFlex = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject2());
var styles_GreenTickFlex = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject3());
var styles_BenefitText = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject4());
var styles_SeeDetails = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject5());
var selectPlan_planDetailsCard_styles_Hr = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject6());
var styles_BottomFlex = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject7());
var styles_PriceWrapper = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject8());
var styles_PriceDivFlex = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject9());
var styles_GSTText = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject10());
var styles_BuyFlex = (0,building_blocks_ui_common_dist.styled)(styles_PriceWrapper)(selectPlan_planDetailsCard_styles_templateObject11());
var styles_PriceFlex = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject12());
var styles_SlashYear = building_blocks_ui_common_dist.styled.div(selectPlan_planDetailsCard_styles_templateObject13());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/selectPlan/planDetailsCard/index.tsx











function planDetailsCard_PlanDetailsCard(param) {
    var planId = param.planId, name = param.name, benefits = param.benefits, premium = param.premium, planCategory = param.planCategory, programId = param.programId, onClick = param.onClick, productCode = param.productCode;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var partner = (0,useFetchParams/* useFetchParams */.u)().partner;
    var ref = (0,compat_module.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CardWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PlanTitle, {
                children: name
            }),
            (benefits || []).map(function(benefit) {
                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_BenefitFlex, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_GreenTickFlex, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: "20px",
                                height: "20px",
                                alt: "",
                                src: (0,generics/* getImageBasePath */.m4)("/icons/greenTick.svg")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_BenefitText, {
                            children: benefit
                        })
                    ]
                }, benefit);
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(selectPlan_planDetailsCard_styles_Hr, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_BottomFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PriceWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PriceDivFlex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PriceFlex, {
                                            children: [
                                                "₹",
                                                premium
                                            ]
                                        }),
                                        partner !== utils_constants/* Partners.HERO_VIDA */.wV.HERO_VIDA && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_SlashYear, {
                                            children: "/ year"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_GSTText, {
                                    children: "(incl 18% GST)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_BuyFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                            size: "small",
                            onClick: function() {
                                return onClick(planId, name, premium, planCategory, programId, productCode);
                            },
                            children: "Select"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                show: showModal,
                onHide: function() {
                    return setShowModal(false);
                },
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(planDetailsCard_planDetails, {
                    plans: (0,generics/* getCoverage */.El)(planCategory || "")
                })
            })
        ]
    });
}
/* harmony default export */ var selectPlan_planDetailsCard = (planDetailsCard_PlanDetailsCard);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/selectPlan/styles.ts

function plans_selectPlan_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 32px;\n    margin-bottom: 16px;\n"
    ]);
    plans_selectPlan_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function plans_selectPlan_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-bottom: 16px;\n"
    ]);
    plans_selectPlan_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var plans_selectPlan_styles_Wrapper = building_blocks_ui_common_dist.styled.div(plans_selectPlan_styles_templateObject());
var styles_SelectPlanText = building_blocks_ui_common_dist.styled.div(plans_selectPlan_styles_templateObject1());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/selectPlan/index.tsx







// import { getPlanName } from 'utils/generics';





function selectPlan_SelectPlan(param) {
    var plans = param.plans;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref.planDetails, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, permissions = ref.permissions, userDetails = ref.userDetails;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var onSelect = function(planId, planName, premium, planCategory, programId, productCode) {
        var showManualFlow = isManualFlowEnabled(permissions === null || permissions === void 0 ? void 0 : permissions.purchase_journey, planDetails === null || planDetails === void 0 ? void 0 : planDetails.showManualFlow);
        if (showManualFlow) {
            setActiveStage(NewPlanStages.VEHICLE_DETAILS);
        } else {
            setActiveStage(NewPlanStages.REVIEW_DETAILS);
        }
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            plan: (0,src_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.plan), {
                plan_id: planId,
                plan_name: planName,
                purchase_date: new Date().toISOString(),
                premium: premium,
                plan_category: planCategory,
                program_id: programId
            }), productCode !== undefined && {
                product_code: productCode
            })
        }));
        /**
         * Segment event
         */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.SELECT_PLAN */.iV.SELECT_PLAN,
            button_name: constants/* SegmentEventButtonNames.SELECT_PLAN */.A3.SELECT_PLAN
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(plans_selectPlan_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_SelectPlanText, {
                children: "Select your plan"
            }),
            plans.map(function(param) {
                var plan_id = param.plan_id, plan_name = param.plan_name, premium = param.premium, plan_category = param.plan_category, program_id = param.program_id, benefits = param.benefits, product_code = param.product_code;
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(selectPlan_planDetailsCard, {
                        planId: plan_id,
                        name: plan_name,
                        benefits: benefits,
                        premium: premium,
                        planCategory: plan_category,
                        programId: program_id,
                        onClick: onSelect,
                        productCode: product_code
                    })
                });
            })
        ]
    });
}
/* harmony default export */ var plans_selectPlan = (selectPlan_SelectPlan);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/styles.ts

function newPlan_plans_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    newPlan_plans_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var newPlan_plans_styles_Wrapper = building_blocks_ui_common_dist.styled.div(newPlan_plans_styles_templateObject());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/plans/index.tsx














function plans_Plans() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, planDetails = ref.planDetails, permissions = ref.permissions;
    var ref1 = (0,compat_module.useState)(false), showError = ref1[0], setShowError = ref1[1];
    var ref2 = (0,compat_module.useState)([]), plans = ref2[0], setPlans = ref2[1];
    var ref3 = (0,compat_module.useState)(true), isLoading = ref3[0], setIsLoading = ref3[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_PLAN */.g0.VIEW_PLAN,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    (0,compat_module.useEffect)(function() {
        __webpack_require__.e(/* import() */ 837).then(__webpack_require__.bind(__webpack_require__, 837)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, plans;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getModelPlans(partnerId, planDetails.device.id, permissions.group)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, plans = ref.plans;
                            if (status && plans.length > 0) {
                                setPlans(plans);
                                setShowError(false);
                            } else {
                                setShowError(true);
                            }
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    }, []);
    if (showError) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            hideHeader: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(newPlan_plans_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_plans_header, {}),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(plans_selectPlan, {
                plans: plans
            })
        ]
    });
}
/* harmony default export */ var newPlan_plans = (plans_Plans);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/vehicleDetails/styles.ts

function vehicleDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 24px;\n"
    ]);
    vehicleDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n"
    ]);
    vehicleDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n"
    ]);
    vehicleDetails_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 5;\n    align-items: center;\n    margin-top: 8px;\n    width: 100%;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n"
    ]);
    vehicleDetails_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    align-items: center;\n    color: #5b5675;\n    justify-content: center;\n"
    ]);
    vehicleDetails_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 32px;\n"
    ]);
    vehicleDetails_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 2px;\n"
    ]);
    vehicleDetails_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-left: 10px;\n"
    ]);
    vehicleDetails_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    vehicleDetails_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #e0e0e8;\n    border-radius: 8px;\n"
    ]);
    vehicleDetails_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    align-items: center;\n"
    ]);
    vehicleDetails_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function vehicleDetails_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 4;\n    align-items: center;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    vehicleDetails_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var vehicleDetails_styles_Wrapper = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject());
var styles_ScanIMEINumber = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject1());
var vehicleDetails_styles_SplitFlex = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject2());
var vehicleDetails_styles_Hr = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject3());
var vehicleDetails_styles_OrText = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject4());
var vehicleDetails_styles_InputWrapper = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject5());
var vehicleDetails_styles_CheckBoxFlex = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject6());
var vehicleDetails_styles_ConfirmationText = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject7());
var vehicleDetails_styles_ButtonWrapper = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject8());
var styles_CalendarInputWrapper = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject9());
var styles_CalendarIcon = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject10());
var vehicleDetails_styles_LabelText = building_blocks_ui_common_dist.styled.div(vehicleDetails_styles_templateObject11());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/customerDetails/index.tsx













// utils



function CustomerDetails() {
    var validator = function validator() {
        return {
            name: function(val) {
                if (!/^[a-zA-Z ]{2,60}$/.test(val)) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    name: "Please enter valid name"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    name: ""
                }));
            },
            email: function(val) {
                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val.trim())) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    email: "Please enter valid email"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    email: ""
                }));
            },
            mobile: function(val) {
                var ref;
                if (!/^[6-9]\d{9}$/i.test((ref = val === null || val === void 0 ? void 0 : val.toString()) === null || ref === void 0 ? void 0 : ref.trim())) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    mobile: "Please enter valid mobile number"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    mobile: ""
                }));
            },
            pincode: function(val) {
                var ref;
                if (!/^[1-9][0-9]{5}$/i.test((ref = val === null || val === void 0 ? void 0 : val.toString()) === null || ref === void 0 ? void 0 : ref.trim())) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    pincode: "Please enter valid pincode"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    pincode: ""
                }));
            },
            address: function(val) {
                if (val.length < 4) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    address: "Please enter valid address"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    address: ""
                }));
            }
        };
    };
    var formHandler = function formHandler(e, name) {
        var ref;
        var value = e.target.value;
        (ref = validator()) === null || ref === void 0 ? void 0 : ref[name](value);
        setFormData((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), (0,_define_property/* default */.Z)({}, name, value)));
    };
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref.planDetails, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, userDetails = ref.userDetails;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref1 = (0,compat_module.useState)({
        name: planDetails.customer.name,
        email: planDetails.customer.email,
        mobile: planDetails.customer.phone,
        address: planDetails.customer.address,
        pincode: planDetails.customer.pincode
    }), formData = ref1[0], setFormData = ref1[1];
    var ref2 = (0,compat_module.useState)({
        name: "",
        email: "",
        mobile: "",
        address: "",
        pincode: ""
    }), validationErr = ref2[0], setValidationErr = ref2[1];
    var ref3 = (0,compat_module.useState)(true), isContinueButtonDisabled = ref3[0], setIsContinueButtonDisabled = ref3[1];
    var ref4 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref4[0], setSnackbar = ref4[1];
    (0,compat_module.useEffect)(function() {
        if (true) {
            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
                page_type: constants/* SegmentEventPageTypes.CUSTOMER_DETAILS_PAGE */.s9.CUSTOMER_DETAILS_PAGE,
                view_name: constants/* SegmentEventPages.VIEW_CUSTOMER_DETAILS_PAGE */.g0.VIEW_CUSTOMER_DETAILS_PAGE
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        window
    ]);
    (0,compat_module.useEffect)(function() {
        if ((0,generics/* isEmpty */.xb)(validationErr) && !(0,generics/* isAnyKeyEmpty */.Hc)(formData)) {
            setIsContinueButtonDisabled(false);
        } else {
            setIsContinueButtonDisabled(true);
        }
    }, [
        formData
    ]);
    var onSubmit = function() {
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            customer: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.customer), {
                phone: formData.mobile,
                pincode: formData.pincode,
                address: formData.address,
                name: formData.name,
                email: formData.email
            })
        }));
        setActiveStage(NewPlanStages.REVIEW_DETAILS);
        // segment events
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.CLICK_CONTINUE_CUSTOMER_DETAILS */.iV.CLICK_CONTINUE_CUSTOMER_DETAILS,
            button_name: constants/* SegmentEventButtonNames.CONTINUE_FROM_CUSTOMER_DETAILS */.A3.CONTINUE_FROM_CUSTOMER_DETAILS
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    var onFieldClick = function(fieldName) {
        var actionName = getFieldActionName(fieldName);
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.ENTER_TEXT */.Qy.ENTER_TEXT,
            action_name: actionName
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    return(// prettier-ignore
    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(vehicleDetails_styles_Wrapper, {
        style: {
            position: "relative",
            height: "100%",
            minHeight: "500px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ScanIMEINumber, {
                children: "Enter your customer details"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("name");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Full name",
                    name: "name",
                    type: "text",
                    value: formData.name,
                    onChange: function(e) {
                        return formHandler(e, "name");
                    },
                    errMsg: validationErr.name,
                    hasError: validationErr.name.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("mobile");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Mobile No.",
                    name: "mobile",
                    type: "number",
                    value: formData.mobile,
                    onChange: function(e) {
                        return formHandler(e, "mobile");
                    },
                    errMsg: validationErr.mobile,
                    hasError: validationErr.mobile.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("email");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Email ID",
                    name: "email",
                    type: "text",
                    value: formData.email,
                    onChange: function(e) {
                        return formHandler(e, "email");
                    },
                    errMsg: validationErr.email,
                    hasError: validationErr.email.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("address");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Address",
                    name: "address",
                    type: "text",
                    value: formData.address,
                    onChange: function(e) {
                        return formHandler(e, "address");
                    },
                    errMsg: validationErr.address,
                    hasError: validationErr.address.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("pincode");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Pin Code",
                    name: "pincode",
                    type: "number",
                    value: formData.pincode,
                    onChange: function(e) {
                        return formHandler(e, "pincode");
                    },
                    errMsg: validationErr.pincode,
                    hasError: validationErr.pincode.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_ButtonWrapper, {
                style: {
                    position: "absolute",
                    bottom: "0",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    disabled: isContinueButtonDisabled,
                    onClick: onSubmit,
                    children: "Continue"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    }));
}
/* harmony default export */ var customerDetails = (CustomerDetails);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/customerLink/styles.ts

function newPlan_customerLink_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 50px;\n"
    ]);
    newPlan_customerLink_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    newPlan_customerLink_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n"
    ]);
    newPlan_customerLink_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 8px;\n"
    ]);
    newPlan_customerLink_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    newPlan_customerLink_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-left: 5px;\n"
    ]);
    newPlan_customerLink_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #ffffff;\n    border: 1px solid #e7e7f0;\n    border-radius: 8px;\n    margin-top: 16px;\n    padding: 12px;\n    word-break: break-all;\n    position: relative;\n"
    ]);
    newPlan_customerLink_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #1b73e8;\n"
    ]);
    newPlan_customerLink_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n"
    ]);
    newPlan_customerLink_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function newPlan_customerLink_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%{\n    opacity : 0\n  }\n  50%{\n    opacity : 1\n  }\n  51%{\n    opacity : 1\n  }\n  85%{\n    opacity : 0;\n    display: none;\n  }\n  100%{\n    opacity : 0;\n    display: none;\n  }\n"
    ]);
    newPlan_customerLink_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function customerLink_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    width: max-content;\n    box-sizing: border-box;\n    color: #0fa457;\n    border-radius: 8px;\n    font-size: 12px;\n    margin-left: 10px;\n    animation: ",
        " 1.5s ease-in-out;\n    font-weight: 700;\n\n    position: absolute;\n    bottom: -20px;\n    left: 0px;\n"
    ]);
    customerLink_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var newPlan_customerLink_styles_Wrapper = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject());
var styles_ShareLinkImage = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject1());
var newPlan_customerLink_styles_Text = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject2());
var styles_PhoneNumberWrapper = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject3());
var styles_PhoneNumber = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject4());
var styles_EditIcon = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject5());
var styles_LinkWrapper = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject6());
var customerLink_styles_Link = building_blocks_ui_common_dist.styled.span(newPlan_customerLink_styles_templateObject7());
var styles_SendButtonWrapper = building_blocks_ui_common_dist.styled.div(newPlan_customerLink_styles_templateObject8());
var Appear = (0,building_blocks_ui_common_dist.keyframes)(newPlan_customerLink_styles_templateObject9());
var Copied = building_blocks_ui_common_dist.styled.span(customerLink_styles_templateObject10(), Appear);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/customerLink/index.tsx

















function customerLink_CustomerLink() {
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, planDetails = ref.planDetails, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, userDetails = ref.userDetails;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var customer = planDetails.customer;
    var ref1 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref1[0], setSnackbar = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isBtnLoading = ref2[0], setIsBtnLoading = ref2[1];
    var ref3 = (0,compat_module.useState)(false), linkCopied = ref3[0], setLinkCopied = ref3[1];
    (0,compat_module.useEffect)(function() {
        var timer;
        if (linkCopied) {
            timer = setTimeout(function() {
                setLinkCopied(false);
            }, 1200);
        }
        return function() {
            timer && clearTimeout(timer);
        };
    }, [
        linkCopied
    ]);
    /**
     * view segment hook
     */ (0,compat_module.useEffect)(function() {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
            page_type: constants/* SegmentEventPageTypes.SEND_LINK_TO_CUSTOMER_PAGE */.s9.SEND_LINK_TO_CUSTOMER_PAGE,
            view_name: constants/* SegmentEventPages.VIEW_SEND_LINK_TO_CUSTOMER_PAGE */.g0.VIEW_SEND_LINK_TO_CUSTOMER_PAGE
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    }, []);
    var linkText = function() {
        if (window !== undefined) {
            var domain = "https://www.acko.com";
            if (window.location.origin.includes("pos-dev") || window.location.origin.includes("pos-auto-dev")) {
                domain = "https://sandbox2.acko.com";
            } else if (window.location.origin.includes("pos.ackodev.com")) {
                domain = "https://www.ackodev.com";
            }
            return "".concat(domain, "/mpos/partner/").concat(partnerId, "?order_ekey=").concat(planDetails.order_ekey, "&phone=").concat(customer.phone);
        }
        return "https://www.acko.com/mpos/partner/".concat(partnerId, "?order_ekey=").concat(planDetails.order_ekey, "&phone=").concat(customer.phone);
    };
    var copyLink = function(text) {
        navigator.clipboard.writeText(text);
    };
    var sendLink = function() {
        __webpack_require__.e(/* import() */ 51).then(__webpack_require__.bind(__webpack_require__, 8051)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, statusCode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsBtnLoading(true);
                            return [
                                4,
                                req.sendLinkToCustomer(planDetails.order_ekey, partnerId)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, statusCode = ref.statusCode;
                            setIsBtnLoading(false);
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status) {
                                setActiveStage(NewPlanStages.CONGRATULATION);
                                setPlanDetails(policyDetailsInitState);
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: "Oops. Something went wrong"
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
        /**
         * Segment event
         */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.SEND_LINK_TO_CUSTOMER */.iV.SEND_LINK_TO_CUSTOMER,
            button_name: constants/* SegmentEventButtonNames.SEND_TO_CUSTOMER */.A3.SEND_TO_CUSTOMER
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(newPlan_customerLink_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ShareLinkImage, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "120px",
                    height: "120px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/shareEmail.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_customerLink_styles_Text, {
                children: "Send link to the customer mobile"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PhoneNumberWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PhoneNumber, {
                        children: customer.phone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_EditIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "20px",
                            height: "20px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/blueEdit.svg"),
                            onClick: function() {
                                return setActiveStage(NewPlanStages.IMEI);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_LinkWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerLink_styles_Link, {
                        children: linkText()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        style: {
                            marginLeft: "1rem",
                            marginTop: "4px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "12px",
                            height: "12px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/copy.svg"),
                            onClick: function() {
                                copyLink(linkText());
                                setLinkCopied(true);
                            }
                        })
                    }),
                    linkCopied && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Copied, {
                        children: "Link copied"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_SendButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    loading: isBtnLoading,
                    onClick: sendLink,
                    children: "Send to customer"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var newPlan_customerLink = (customerLink_CustomerLink);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/styles.ts

function auto_lob_newPlan_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    auto_lob_newPlan_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function auto_lob_newPlan_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-bottom: 1rem;\n"
    ]);
    auto_lob_newPlan_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function auto_lob_newPlan_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    auto_lob_newPlan_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function auto_lob_newPlan_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    auto_lob_newPlan_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function auto_lob_newPlan_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n"
    ]);
    auto_lob_newPlan_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var auto_lob_newPlan_styles_Wrapper = building_blocks_ui_common_dist.styled.div(auto_lob_newPlan_styles_templateObject());
var auto_lob_newPlan_styles_Header = building_blocks_ui_common_dist.styled.div(auto_lob_newPlan_styles_templateObject1());
var auto_lob_newPlan_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(auto_lob_newPlan_styles_templateObject2());
var newPlan_styles_SelectModelText = building_blocks_ui_common_dist.styled.div(auto_lob_newPlan_styles_templateObject3());
var newPlan_styles_SelectModelDropdown = building_blocks_ui_common_dist.styled.div(auto_lob_newPlan_styles_templateObject4());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/vehicleDetails/utils.ts
var getDayMonthYear = function(date) {
    if (date) {
        var formattedDate = new Date(date);
        var d = formattedDate.getDate();
        var m = formattedDate.getMonth() + 1;
        var y = formattedDate.getFullYear();
        var day = d > 9 ? d : "0".concat(d);
        var month = m > 9 ? m : "0".concat(m);
        return "".concat(day, "/").concat(month, "/").concat(y);
    }
    return "";
};
var utils_getFieldActionName = function(fieldName) {
    switch(fieldName){
        case "invoice_date":
            return "enter_invoice_date";
        case "bin2":
            return "enter_bin2";
        case "registration_number":
            return "enter_registration_number";
        case "motor_number":
            return "enter_motor_number";
        case "charger_number":
            return "enter_charger_number";
        case "rto":
            return "enter_rto";
        default:
            return "";
    }
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/vehicleDetails/index.tsx
/* eslint-disable */ 


















function VehicleDetails() {
    var validator = function validator() {
        return {
            motor_number: function() {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    motor_number: ""
                }));
            },
            charger_number: function() {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    charger_number: ""
                }));
            },
            rto: function(val) {
                if (!/^[A-Za-z]{2}[0-9]{2}$/i.test(val)) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    rto: "Please enter valid rto"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    rto: ""
                }));
            },
            vin: function(val) {
                if (!/^[a-zA-Z0-9]{17}$/.test(val)) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    vin: "Please enter valid VIN"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    vin: ""
                }));
            },
            bin: function(val) {
                if (!/^[a-zA-Z0-9]{12,16}$/.test(val)) setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    bin: "Please enter valid BIN"
                }));
                else setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    bin: ""
                }));
            },
            bin2: function() {
                setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                    bin2: ""
                }));
            },
            registration_number: function(val) {
                var registrationNumberRegex = [
                    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][A-Z][1-9][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
                    "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
                    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
                    "^[0-9][0-9][A-Z][A-Z][0-9][0-9]$",
                    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9]$",
                    "^[0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
                    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z]$",
                    "^[0-9][0-9][X][X][0-9][0-9][0-9][0-9][A-Z][A-Z]$", 
                ];
                var isValid = false;
                for(var i = 0; i < registrationNumberRegex.length; i++){
                    var regex = new RegExp(registrationNumberRegex[i], "i");
                    var isRegNumberValid = regex.test(val);
                    if (isRegNumberValid) {
                        isValid = true;
                    }
                }
                if (val && !isValid) {
                    setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                        registration_number: "Please enter valid registration number"
                    }));
                } else {
                    setValidationErr((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                        registration_number: ""
                    }));
                }
            }
        };
    };
    var formHandler = function formHandler(e, name) {
        var ref;
        var value = e.target.value;
        (ref = validator()) === null || ref === void 0 ? void 0 : ref[name](value);
        setFormData((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), (0,_define_property/* default */.Z)({}, name, value)));
    };
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref.planDetails, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, userDetails = ref.userDetails;
    var ref1 = (0,compat_module.useState)(false), showCalendarModal = ref1[0], setShowCalendarModal = ref1[1];
    var ref2 = (0,compat_module.useState)(true), isContinueButtonDisabled = ref2[0], setIsContinueButtonDisabled = ref2[1];
    var ref3 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref3[0], setSnackbar = ref3[1];
    var ref4 = (0,compat_module.useState)({
        vin: "",
        bin: "",
        bin2: "",
        rto: "",
        registration_number: "",
        motor_number: "",
        charger_number: ""
    }), validationErr = ref4[0], setValidationErr = ref4[1];
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref5 = (0,compat_module.useState)(false), onClickSerialNumber = ref5[0], setOnClickSerialNumber = ref5[1];
    var ref6 = (0,compat_module.useState)(false), onClickConfirmSerialNumber = ref6[0], setOnClickConfirmSerialNumber = ref6[1];
    var ref7 = (0,compat_module.useState)({
        rto: planDetails.device.rto_code,
        vin: planDetails.device.vin_number,
        bin: planDetails.device.bin_number,
        bin2: planDetails.device.bin2_number,
        registration_number: planDetails.device.registration_number,
        invoice_date: planDetails.device.invoice_date,
        motor_number: planDetails.device.motor_number,
        charger_number: planDetails.device.charger_number
    }), formData = ref7[0], setFormData = ref7[1];
    (0,compat_module.useEffect)(function() {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
            page_type: constants/* SegmentEventPageTypes.VEHICLE_DETAILS_PAGE */.s9.VEHICLE_DETAILS_PAGE,
            view_name: constants/* SegmentEventPages.VIEW_VEHICLE_DETAILS_PAGE */.g0.VIEW_VEHICLE_DETAILS_PAGE
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    }, [
        window
    ]);
    (0,compat_module.useEffect)(function() {
        if ((0,generics/* isEmpty */.xb)(validationErr) && !(0,generics/* isAnyKeyEmpty */.Hc)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
            registration_number: "dummy",
            charger_number: "dummy",
            motor_number: "dummy",
            bin2: "dummy"
        }))) {
            setIsContinueButtonDisabled(false);
        } else {
            setIsContinueButtonDisabled(true);
        }
    }, [
        formData
    ]);
    (0,compat_module.useEffect)(function() {
        if (onClickSerialNumber) {
            /**
             * Segment event
             */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                action_type: constants/* SegmentEventActionTypes.ENTER_TEXT */.Qy.ENTER_TEXT,
                action_name: constants/* SegmentEventActionNames.ENTER_VIN_NUMBER */.iV.ENTER_VIN_NUMBER
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        onClickSerialNumber
    ]);
    (0,compat_module.useEffect)(function() {
        if (onClickConfirmSerialNumber) {
            /**
             * Segment event
             */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                action_type: constants/* SegmentEventActionTypes.ENTER_TEXT */.Qy.ENTER_TEXT,
                action_name: constants/* SegmentEventActionNames.CLICK_BIN_NUMBER */.iV.CLICK_BIN_NUMBER
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        onClickConfirmSerialNumber
    ]);
    var onSubmit = function() {
        setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
            device: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails.device), {
                vin_number: formData.vin,
                bin_number: formData.bin,
                bin2_number: formData.bin2,
                registration_number: formData.registration_number,
                rto_code: formData.rto,
                invoice_date: formData.invoice_date,
                motor_number: formData.motor_number,
                charger_number: formData.charger_number
            })
        }));
        setActiveStage(NewPlanStages.USER_DETAILS);
        /**
             * Segment event
             */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.CLICK_CONTINUE_VEHICLE_DETAILS */.iV.CLICK_CONTINUE_VEHICLE_DETAILS
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    var onFieldClick = function(fieldName) {
        var actionName = utils_getFieldActionName(fieldName);
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.ENTER_TEXT */.Qy.ENTER_TEXT,
            action_name: actionName
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    var onInvoiceDateClick = function() {
        setShowCalendarModal(true);
        onFieldClick("invoice_date");
    };
    var onDateSelect = function(d) {
        setFormData((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
            invoice_date: d.toISOString()
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(vehicleDetails_styles_Wrapper, {
        style: {
            position: "relative",
            height: "100%",
            minHeight: "580px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ScanIMEINumber, {
                children: "Enter your vehicle details"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: onInvoiceDateClick,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Date of vehicle Invoice",
                    name: "date",
                    type: "text",
                    value: getDayMonthYear(formData === null || formData === void 0 ? void 0 : formData.invoice_date),
                    onChange: function(e) {
                        return formHandler(e, "invoice_date");
                    },
                    rightElement: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)("/icons/calendar.svg"),
                        width: 24,
                        height: 24
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "11px",
                        height: "16px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)("/icons/bike.svg")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return setOnClickSerialNumber(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "VIN Number",
                    name: "vin",
                    type: "text",
                    value: formData.vin,
                    onChange: function(e) {
                        return formHandler(e, "vin");
                    },
                    errMsg: validationErr.vin,
                    hasError: validationErr.vin.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return setOnClickConfirmSerialNumber(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "BIN Number",
                    name: "bin",
                    type: "text",
                    value: formData.bin,
                    onChange: function(e) {
                        return formHandler(e, "bin");
                    },
                    errMsg: validationErr.bin,
                    hasError: validationErr.bin.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("bin2");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "BIN2 Number (Optional)",
                    name: "bin2_number",
                    type: "text",
                    value: formData.bin2,
                    onChange: function(e) {
                        return formHandler(e, "bin2");
                    },
                    errMsg: validationErr.bin2,
                    hasError: validationErr.bin2.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("registration_number");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Registration number (Optional)",
                    name: "registration_number",
                    type: "text",
                    value: formData.registration_number,
                    onChange: function(e) {
                        return formHandler(e, "registration_number");
                    },
                    errMsg: validationErr.registration_number,
                    hasError: validationErr.registration_number.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("rto");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "RTO Code",
                    name: "rto",
                    type: "text",
                    value: formData.rto,
                    onChange: function(e) {
                        return formHandler(e, "rto");
                    },
                    errMsg: validationErr.rto,
                    hasError: validationErr.rto.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("motor_number");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Motor Number (Optional)",
                    name: "motor_number",
                    type: "text",
                    value: formData.motor_number,
                    onChange: function(e) {
                        return formHandler(e, "motor_number");
                    },
                    errMsg: validationErr.motor_number,
                    hasError: validationErr.motor_number.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_InputWrapper, {
                onClick: function() {
                    return onFieldClick("charger_number");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    className: "",
                    labelText: "Charger Number (Optional)",
                    name: "charger_number",
                    type: "text",
                    value: formData.charger_number,
                    onChange: function(e) {
                        return formHandler(e, "charger_number");
                    },
                    errMsg: validationErr.charger_number,
                    hasError: validationErr.charger_number.length > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_ButtonWrapper, {
                style: {
                    width: "100%",
                    margin: "10px 0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    disabled: isContinueButtonDisabled,
                    onClick: onSubmit,
                    children: "Continue"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_modal_dist.ModalMobile, {
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                urlhash: "",
                show: showCalendarModal,
                onHide: function() {
                    return setShowCalendarModal(false);
                },
                padding: "20px",
                showOverlayBackground: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                    title: "",
                    defaultDate: formData.invoice_date ? new Date(formData.invoice_date) : new Date(),
                    onSelect: function(date) {
                        setShowCalendarModal(false), onDateSelect(date);
                    },
                    enableWindow: {
                        start: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
                        current: new Date(),
                        end: new Date()
                    },
                    isDesktop: false
                })
            })
        ]
    });
}
/* harmony default export */ var vehicleDetails = (VehicleDetails);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/reviewDetails/styles.ts

function reviewDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 30px 0;\n"
    ]);
    reviewDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 8px;\n    border: 1px solid #e0e0e7;\n"
    ]);
    reviewDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        ";\n    border-bottom: 1px solid #e0e0e7;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    reviewDetails_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    font-weight: ",
        ";\n    display: flex;\n    align-items: center;\n    color: #040222;\n"
    ]);
    reviewDetails_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    margin-bottom: 25px;\n    font-weight: ",
        ";\n"
    ]);
    reviewDetails_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #1a73e7;\n    cursor: pointer;\n"
    ]);
    reviewDetails_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        " ",
        " 0 ",
        ";\n"
    ]);
    reviewDetails_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: ",
        ";\n"
    ]);
    reviewDetails_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #040222;\n    font-weight: ",
        ";\n    width: max-content;\n"
    ]);
    reviewDetails_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: gray;\n    font-weight: ",
        ";\n    width: max-content;\n    text-align: right;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    hyphens: auto;\n"
    ]);
    reviewDetails_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function reviewDetails_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-right: 10px;\n"
    ]);
    reviewDetails_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

// import {styled} from '@acko-tech/building-blocks.ui.common';
var spacing = "16px";
var PageWrapper = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject());
var reviewDetails_styles_Wrapper = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject1());
var HeaderContainer = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject2(), spacing);
var Heading = building_blocks_ui_common_dist.styled.p(reviewDetails_styles_templateObject3(), building_blocks_ui_common_dist.$fontWeightBolder);
var PageHeading = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject4(), building_blocks_ui_common_dist.$fontWeightBolder);
var reviewDetails_styles_Link = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject5());
var BodyContainer = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject6(), spacing, spacing, spacing);
var styles_Row = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject7(), spacing);
var reviewDetails_styles_Label = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject8(), building_blocks_ui_common_dist.$fontWeightBold);
var reviewDetails_styles_Value = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject9(), building_blocks_ui_common_dist.$fontWeightLight);
var ImageContainer = building_blocks_ui_common_dist.styled.div(reviewDetails_styles_templateObject10());

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/reviewDetails/constants.ts
var REVIEW_DETAILS = {
    VEHICLE_DETAILS: "VEHICLE_DETAILS",
    CUSTOMER_DETAILS: "CUSTOMER_DETAILS",
    PLAN_DETAILS: "PLAN_DETAILS"
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/reviewDetails/utils.ts

var getEditActionName = function(fieldName) {
    switch(fieldName){
        case REVIEW_DETAILS.CUSTOMER_DETAILS:
            return "edit_customer_details";
        case REVIEW_DETAILS.VEHICLE_DETAILS:
            return "edit_vehicle_details";
        case REVIEW_DETAILS.PLAN_DETAILS:
            return "edit_plan_details";
        default:
            return "";
    }
};

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/reviewDetails/detailsCard.tsx






var detailsCard_DetailsCard = function(param) {
    var data = param.data, _showEditInfo = param.showEditInfo, showEditInfo = _showEditInfo === void 0 ? true : _showEditInfo, userDetails = param.userDetails, isMobile = param.isMobile;
    var src = data.src;
    var onEditInfoClickHandler = function() {
        var ref;
        var actionName = getEditActionName(data.id);
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: actionName
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        return (ref = data.header) === null || ref === void 0 ? void 0 : ref.link();
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reviewDetails_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(HeaderContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Heading, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    width: "24px",
                                    height: "24px",
                                    alt: "",
                                    src: src
                                })
                            }),
                            data.header.heading
                        ]
                    }),
                    showEditInfo && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reviewDetails_styles_Link, {
                        onClick: onEditInfoClickHandler,
                        children: "Edit info"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BodyContainer, {
                children: data.body.map(function(data) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reviewDetails_styles_Label, {
                                children: data.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reviewDetails_styles_Value, {
                                children: data.value
                            })
                        ]
                    }, data.label);
                })
            })
        ]
    });
};
/* harmony default export */ var reviewDetails_detailsCard = (detailsCard_DetailsCard);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/reviewDetails/index.tsx





















var ReviewDetails = function() {
    var ref = (0,compat_module.useState)([]), renderData = ref[0], setRenderData = ref[1];
    var ref1 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref1[0], setSnackbar = ref1[1];
    var ref2 = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref2.planDetails, partnerId = ref2.partnerId, setPlanDetails = ref2.setPlanDetails, setActiveStage = ref2.setActiveStage, permissions = ref2.permissions, userDetails = ref2.userDetails;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,compat_module.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    // Segment Events
    (0,compat_module.useEffect)(function() {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
            page_type: constants/* SegmentEventPageTypes.REVIEW_DETAILS_PAGE */.s9.REVIEW_DETAILS_PAGE,
            view_name: constants/* SegmentEventPages.VIEW_REVIEW_DETAILS_PAGE */.g0.VIEW_REVIEW_DETAILS_PAGE
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    }, [
        window
    ]);
    (0,compat_module.useEffect)(function() {
        if (planDetails) {
            var ref;
            var invoice_date = planDetails.device.invoice_date;
            var rData = [];
            var vehicleDetails = {
                id: REVIEW_DETAILS.VEHICLE_DETAILS,
                src: (0,generics/* getImageBasePath */.m4)("/icons/vehicle.svg"),
                header: {
                    heading: "Vehicle details",
                    link: function() {
                        setActiveStage(NewPlanStages.VEHICLE_DETAILS);
                    }
                },
                body: [
                    {
                        label: "Vehicle model",
                        value: (planDetails === null || planDetails === void 0 ? void 0 : (ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.name) || ""
                    },
                    {
                        label: "Date of vehicle Invoice",
                        value: (0,date/* getDD_MM_YYYY */.PZ)(new Date(invoice_date)).replace(/-/g, "/")
                    },
                    {
                        label: "Vin",
                        value: planDetails.device.vin_number
                    },
                    {
                        label: "Bin",
                        value: planDetails.device.bin_number
                    },
                    {
                        label: "Bin 2",
                        value: planDetails.device.bin2_number || "NA"
                    },
                    {
                        label: "Motor number",
                        value: planDetails.device.motor_number || "NA"
                    },
                    {
                        label: "Charger number",
                        value: planDetails.device.charger_number || "NA"
                    }, 
                ]
            };
            if (planDetails === null || planDetails === void 0 ? void 0 : planDetails.device.registration_number) {
                vehicleDetails.body.push({
                    label: "Registration Number",
                    value: planDetails.device.registration_number
                });
            }
            var userDetails = {
                id: REVIEW_DETAILS.CUSTOMER_DETAILS,
                src: (0,generics/* getImageBasePath */.m4)("/icons/customer.svg"),
                header: {
                    heading: "Customer details",
                    link: function() {
                        setActiveStage(NewPlanStages.USER_DETAILS);
                    }
                },
                body: [
                    {
                        label: "Full Name",
                        value: planDetails.customer.name
                    },
                    {
                        label: "Mobile No.",
                        value: planDetails.customer.phone
                    },
                    {
                        label: "Email ID",
                        value: planDetails.customer.email
                    },
                    {
                        label: "Address",
                        value: planDetails.customer.address
                    },
                    {
                        label: "Pin Code",
                        value: planDetails.customer.pincode
                    }, 
                ]
            };
            var pDetails = {
                id: REVIEW_DETAILS.PLAN_DETAILS,
                src: (0,generics/* getImageBasePath */.m4)("/icons/plan.svg"),
                header: {
                    heading: "Plan details",
                    link: function() {
                        setActiveStage(NewPlanStages.PLAN);
                    }
                },
                body: [
                    {
                        label: planDetails.plan.plan_category,
                        value: "₹".concat(planDetails.plan.premium)
                    }, 
                ]
            };
            rData.push(vehicleDetails);
            rData.push(userDetails);
            rData.push(pDetails);
            setRenderData(rData);
        }
    }, [
        planDetails
    ]);
    var handleSubmit = function() {
        var sNo = (0,generics/* uuid */.Vj)(16);
        // segment Events
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.ISSUE_POLICY */.iV.ISSUE_POLICY
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        __webpack_require__.e(/* import() */ 882).then(__webpack_require__.bind(__webpack_require__, 6447)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, orderDetails, ref8, status, data, statusCode, message, order_ekey;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            orderDetails = {
                                customer: {
                                    phone: planDetails.customer.phone,
                                    name: planDetails.customer.name,
                                    email: planDetails.customer.email,
                                    pincode: planDetails.customer.pincode,
                                    address: planDetails.customer.address
                                },
                                device: {
                                    name: planDetails.device.name,
                                    category: planDetails.device.type,
                                    serial_number: planDetails.device.serial_number || sNo,
                                    purchase_date: (0,date/* getYYYY_MM_DD */.a6)(new Date((ref = planDetails.device) === null || ref === void 0 ? void 0 : ref.invoice_date)),
                                    delivery_date: (0,date/* getYYYY_MM_DD */.a6)(new Date()),
                                    price: planDetails.device.price || 100,
                                    brand: planDetails.device.brand,
                                    vin: planDetails.device.vin_number,
                                    bin: planDetails.device.bin_number,
                                    bin2: (ref5 = (ref1 = planDetails.device) === null || ref1 === void 0 ? void 0 : ref1.bin2_number) !== null && ref5 !== void 0 ? ref5 : null,
                                    registration_number: (ref2 = planDetails.device) === null || ref2 === void 0 ? void 0 : ref2.registration_number,
                                    manufacturer_warranty: {
                                        years: Number(3),
                                        months: 0,
                                        days: 0
                                    },
                                    rto_code: planDetails.device.rto_code,
                                    motor_number: (ref6 = (ref3 = planDetails.device) === null || ref3 === void 0 ? void 0 : ref3.motor_number) !== null && ref6 !== void 0 ? ref6 : "",
                                    charger_number: (ref7 = (ref4 = planDetails.device) === null || ref4 === void 0 ? void 0 : ref4.charger_number) !== null && ref7 !== void 0 ? ref7 : ""
                                },
                                document_urls: {
                                    imei: sNo,
                                    invoice: (0,generics/* uuid */.Vj)(10)
                                },
                                plan: (0,src_object_spread/* default */.Z)({
                                    partner: partnerId,
                                    plan_id: planDetails.plan.plan_id,
                                    plan_name: planDetails.plan.plan_name,
                                    premium: planDetails.plan.premium,
                                    promo_name: planDetails.plan.promo_name,
                                    insurance_program_id: planDetails.plan.program_id,
                                    insurance_order_id: (0,generics/* uuid */.Vj)(10),
                                    insurance_program_name: "ACKO INSURANCE",
                                    plan_purchase_date: (0,date/* getYYYY_MM_DD */.a6)(new Date()),
                                    plan_category: planDetails.plan.plan_category,
                                    masterpolicy_number: planDetails.plan.program_id
                                }, planDetails.plan.product_code && {
                                    product_code: planDetails.plan.product_code
                                }),
                                order_communication: false,
                                policy_communication: true
                            };
                            return [
                                4,
                                req.postOrderDetails(orderDetails, partnerId, permissions.group)
                            ];
                        case 1:
                            ref8 = _state.sent(), status = ref8.status, data = ref8.data, statusCode = ref8.statusCode, message = ref8.message;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            setIsLoading(false);
                            if (statusCode === 409) {
                                setSnackbar({
                                    type: "failure",
                                    message: message || "Policy already exists for this BIN number"
                                });
                                return [
                                    2
                                ];
                            }
                            if (status && data) {
                                order_ekey = data.order_ekey;
                                setPlanDetails((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, planDetails), {
                                    order_ekey: order_ekey
                                }));
                                setActiveStage(NewPlanStages.CUSTOMER_LINK);
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: message || "Oops. Something went wrong."
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var isManualFlow = isManualFlowEnabled(permissions === null || permissions === void 0 ? void 0 : permissions.purchase_journey, planDetails === null || planDetails === void 0 ? void 0 : planDetails.showManualFlow);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PageWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PageHeading, {
                children: "Review details"
            }),
            renderData.map(function(item) {
                var showEditInfo = item.id === REVIEW_DETAILS.PLAN_DETAILS || isManualFlow;
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    style: {
                        marginBottom: "25px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reviewDetails_detailsCard, {
                        data: item,
                        showEditInfo: showEditInfo,
                        userDetails: userDetails,
                        isMobile: isMobile
                    })
                }, item.header.heading);
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails_styles_ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    loading: isLoading,
                    onClick: handleSubmit,
                    children: "Issue Plan"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var reviewDetails = (ReviewDetails);

;// CONCATENATED MODULE: ./components/auto-lob/newPlan/index.tsx





















function newPlan_NewPlan() {
    var ref = (0,useFetchParams/* useFetchParams */.u)(), lob = ref.lob, partner = ref.partner;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,compat_module.useContext)(context/* MPosContext */.w), stage = ref1.activeStage, setActiveStage = ref1.setActiveStage, permissions = ref1.permissions, planDetails = ref1.planDetails, userDetails = ref1.userDetails;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var onBack = function() {
        /**
         * Segment event
         */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.CLICK_BACK_BUTTON */.iV.CLICK_BACK_BUTTON,
            button_name: "click_".concat(stage, "_back_button")
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        var planStageBackFromReviewDetails = getPlanStageBackFromReviewDetails(permissions, planDetails);
        switch(stage){
            case NewPlanStages.MODEL:
                router.push("/".concat(lob, "/").concat(partner, "/dashboard"));
                return;
            case NewPlanStages.PLAN:
                setActiveStage(NewPlanStages.MODEL);
                return;
            case NewPlanStages.VEHICLE_DETAILS:
                setActiveStage(NewPlanStages.PLAN);
                return;
            case NewPlanStages.USER_DETAILS:
                setActiveStage(NewPlanStages.VEHICLE_DETAILS);
                return;
            case NewPlanStages.REVIEW_DETAILS:
                setActiveStage(planStageBackFromReviewDetails);
                return;
            case NewPlanStages.CUSTOMER_LINK:
                setActiveStage(NewPlanStages.REVIEW_DETAILS);
                return;
            case NewPlanStages.CONGRATULATION:
                router.push("/".concat(lob, "/").concat(partner, "/dashboard"));
                return;
            default:
                setActiveStage(NewPlanStages.MODEL);
        }
    };
    var activeNewPlanStage = function() {
        switch(stage){
            case NewPlanStages.MODEL:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_mobileModels, {});
            case NewPlanStages.PLAN:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_plans, {});
            case NewPlanStages.VEHICLE_DETAILS:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(vehicleDetails, {});
            case NewPlanStages.USER_DETAILS:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(customerDetails, {});
            case NewPlanStages.CUSTOMER_LINK:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_customerLink, {});
            case NewPlanStages.REVIEW_DETAILS:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reviewDetails, {});
            case NewPlanStages.CONGRATULATION:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(congratulations, {
                    message: "Plan details shared with customer, waiting for customer to pay"
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan_mobileModels, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(auto_lob_newPlan_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_newPlan_styles_Header, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_newPlan_styles_BackArrowIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "10px",
                        height: "24px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                        onClick: onBack
                    })
                })
            }),
            activeNewPlanStage()
        ]
    });
}
/* harmony default export */ var auto_lob_newPlan = (newPlan_NewPlan);

;// CONCATENATED MODULE: ./components/auto-lob/payment/styles.ts

function auto_lob_payment_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    auto_lob_payment_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 20px;\n    padding-bottom: 0px;\n"
    ]);
    auto_lob_payment_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    padding-bottom: 35px;\n    background: linear-gradient(161.3deg, #fff7e5 -2.04%, #fbe9f6 102.81%);\n"
    ]);
    auto_lob_payment_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin: 5px 0;\n"
    ]);
    auto_lob_payment_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 12px;\n    flex-direction: column;\n    background: #ffffff;\n    border-radius: 12px;\n    margin-top: 14px;\n"
    ]);
    auto_lob_payment_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 10px;\n"
    ]);
    auto_lob_payment_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    auto_lob_payment_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    text-align: end;\n"
    ]);
    auto_lob_payment_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    opacity: 0.1;\n    border: 1px solid #040222;\n    margin-top: 10px;\n"
    ]);
    auto_lob_payment_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    background: #ffffff;\n    box-shadow: 0px -6px 12px -2px rgba(54, 53, 76, 0.08);\n    border-radius: 24px 24px 0px 0px;\n    margin-top: -15px;\n"
    ]);
    auto_lob_payment_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n"
    ]);
    auto_lob_payment_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 24px;\n"
    ]);
    auto_lob_payment_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 15px;\n"
    ]);
    auto_lob_payment_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 5px;\n"
    ]);
    auto_lob_payment_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-left: 10px;\n"
    ]);
    auto_lob_payment_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 15px 20px;\n"
    ]);
    auto_lob_payment_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 29px;\n    letter-spacing: -0.8px;\n    color: #040222;\n"
    ]);
    auto_lob_payment_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 3;\n    align-items: center;\n    margin-left: 10px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    auto_lob_payment_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n"
    ]);
    auto_lob_payment_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function auto_lob_payment_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-end;\n"
    ]);
    auto_lob_payment_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}

var auto_lob_payment_styles_Wrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject());
var payment_styles_HeaderWrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject1());
var styles_CustomPlanDetailsWrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject2());
var styles_HeaderTitle = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject3());
var styles_PlanDetailsWrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject4());
var styles_RowWrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject5());
var payment_styles_LabelText = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject6());
var styles_ValueText = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject7());
var auto_lob_payment_styles_Hr = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject8());
var styles_CustomerDetailsFormWrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject9());
var styles_FormTitle = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject10());
var auto_lob_payment_styles_InputWrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject11());
var styles_TncWrapper = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject12());
var styles_CheckboxFlex = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject13());
var styles_TncText = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject14());
var styles_PriceDetailsFlex = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject15());
var styles_Price = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject16());
var styles_Tax = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject17());
var payment_styles_Hr1 = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject18());
var styles_PayNowButton = building_blocks_ui_common_dist.styled.div(auto_lob_payment_styles_templateObject19());

;// CONCATENATED MODULE: ./components/auto-lob/payment/index.tsx









// import Checkbox from 'library/checkbox';








function payment_Payment() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var order_ekey = router.query.order_ekey;
    var ref6 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref6.partnerId, dealerType = ref6.dealerType;
    var ref7 = (0,compat_module.useState)(null), orderDetails = ref7[0], setOrderDetails = ref7[1];
    var ref8 = (0,compat_module.useState)(true), isLoading = ref8[0], setIsLoading = ref8[1];
    // const [isCheckboxSelected, setIsCheckboxSelected] = useState(true);
    var ref9 = (0,compat_module.useState)(""), errorMessage = ref9[0], setErrorMessage = ref9[1];
    var ref10 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref10[0], setSnackbar = ref10[1];
    var ref11 = (0,compat_module.useState)(false), isBtnLoading = ref11[0], setIsBtnLoading = ref11[1];
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentViewEvents.VIEW_DEALER_PAYMENT */.od.VIEW_DEALER_PAYMENT, {
        page: constants/* SegmentPages.PAYMENT */.IT.PAYMENT,
        product: "pos",
        journey: "buy",
        platform: "mweb",
        partner: partnerId,
        type: dealerType
    });
    (0,compat_module.useEffect)(function() {
        __webpack_require__.e(/* import() */ 596).then(__webpack_require__.bind(__webpack_require__, 5596)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, ref1, status, data, statusCode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getCustomerPlanDetails(partnerId, order_ekey)
                            ];
                        case 1:
                            ref1 = _state.sent(), status = ref1.status, data = ref1.data, statusCode = ref1.statusCode;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            setIsLoading(false);
                            if (status && (data === null || data === void 0 ? void 0 : (ref = data.recent_orders) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                setOrderDetails(data.recent_orders[0]);
                                setErrorMessage("");
                            } else {
                                setErrorMessage("Oops. something went wrong.");
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    }, []);
    var onPayNow = function() {
        setIsBtnLoading(true);
        __webpack_require__.e(/* import() */ 596).then(__webpack_require__.bind(__webpack_require__, 5596)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, data, status, statusCode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.dealerPayment(partnerId, order_ekey)
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, status = ref.status, statusCode = ref.statusCode;
                            setIsBtnLoading(false);
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status && data) {
                                if (status && (data === null || data === void 0 ? void 0 : data.payment_gateway_url)) {
                                    window.location.href = "".concat(data.payment_gateway_url, "?id=").concat(data === null || data === void 0 ? void 0 : data.payment_order_ekey);
                                }
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: "Oops. Something went wrong."
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    // const onClickTnc = () => {
    //     window.open(
    //         'https://templates.corp.ackodev.com/templateservice/t/mPOS_dealer_TnC/1.0',
    //         '_target'
    //     );
    // };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {});
    }
    if (errorMessage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(auto_lob_payment_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_HeaderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CustomPlanDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_HeaderTitle, {
                        children: "Confirm and pay for your customer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PlanDetailsWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_LabelText, {
                                        children: "Device model"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.device.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_LabelText, {
                                        children: "VIN"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.device) === null || ref === void 0 ? void 0 : ref.vin
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_LabelText, {
                                        children: "BIN"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: (0,generics/* getPlanName */.s0)((orderDetails === null || orderDetails === void 0 ? void 0 : (ref1 = orderDetails.device) === null || ref1 === void 0 ? void 0 : ref1.bin) || "")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_LabelText, {
                                        children: "RTO"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: orderDetails === null || orderDetails === void 0 ? void 0 : (ref2 = orderDetails.device) === null || ref2 === void 0 ? void 0 : ref2.rto_code
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CustomerDetailsFormWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_FormTitle, {
                        children: "Please find your customer's details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "name",
                            type: "text",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.customer.name) || "",
                            onChange: function() {},
                            labelText: "Full name",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "email",
                            type: "text",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : (ref3 = orderDetails.customer) === null || ref3 === void 0 ? void 0 : ref3.email) || "",
                            onChange: function() {},
                            labelText: "Email address",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "mobile",
                            type: "text",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.customer.phone) || "",
                            onChange: function() {},
                            labelText: "Mobile number",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "address",
                            type: "text",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : (ref4 = orderDetails.customer) === null || ref4 === void 0 ? void 0 : ref4.address) || "",
                            onChange: function() {},
                            labelText: "Address",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment_styles_InputWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                            name: "pincode",
                            type: "number",
                            className: "",
                            value: (orderDetails === null || orderDetails === void 0 ? void 0 : (ref5 = orderDetails.customer) === null || ref5 === void 0 ? void 0 : ref5.pincode) || "",
                            onChange: function() {},
                            labelText: "Pincode",
                            disabled: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment_styles_Hr1, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PriceDetailsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Price, {
                        children: [
                            "₹",
                            orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.plan.premium
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Tax, {
                        children: "(incl 18% GST)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PayNowButton, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                            loading: isBtnLoading,
                            size: "small",
                            // disabled={!isCheckboxSelected}
                            onClick: onPayNow,
                            children: "Pay now"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var auto_lob_payment = (payment_Payment);

;// CONCATENATED MODULE: ./components/thankyou/styles.ts

function thankyou_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 20px;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    thankyou_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n"
    ]);
    thankyou_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 22px;\n    text-align: center;\n    color: #040222;\n    margin-top: 12px;\n"
    ]);
    thankyou_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    color: #5b5675;\n    margin-top: 10px;\n"
    ]);
    thankyou_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 150%;\n    color: #5b5675;\n    margin-top: 16px;\n    text-align: center;\n"
    ]);
    thankyou_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 40px;\n    justify-content: center;\n"
    ]);
    thankyou_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 150%;\n    color: #5b5675;\n    text-align: center;\n    margin-right: 10px;\n"
    ]);
    thankyou_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    thankyou_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n"
    ]);
    thankyou_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    text-align: center;\n    color: #1b73e8;\n    margin-top: 16px;\n"
    ]);
    thankyou_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function thankyou_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    thankyou_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var thankyou_styles_Wrapper = styled_components_browser_esm["default"].div(thankyou_styles_templateObject());
var Banner = styled_components_browser_esm["default"].div(thankyou_styles_templateObject1());
var thankyou_styles_Text = styled_components_browser_esm["default"].div(thankyou_styles_templateObject2());
var SubText = styled_components_browser_esm["default"].div(thankyou_styles_templateObject3());
var styles_Description = styled_components_browser_esm["default"].div(thankyou_styles_templateObject4());
var AvailableOn = styled_components_browser_esm["default"].div(thankyou_styles_templateObject5());
var AvailableOnText = styled_components_browser_esm["default"].div(thankyou_styles_templateObject6());
var thankyou_styles_IconFlex = styled_components_browser_esm["default"].div(thankyou_styles_templateObject7());
var thankyou_styles_ButtonWrapper = styled_components_browser_esm["default"].div(thankyou_styles_templateObject8());
var GoToMyAccount = styled_components_browser_esm["default"].div(thankyou_styles_templateObject9());
var styles_GoHomeButtonWrapper = styled_components_browser_esm["default"].div(thankyou_styles_templateObject10());

;// CONCATENATED MODULE: ./components/thankyou/success/index.tsx





function Success(param) {
    var text = param.text, subText = param.subText, description = param.description, btnName = param.btnName, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(thankyou_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Banner, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "250px",
                    height: "250px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/congratulation.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyou_styles_Text, {
                children: text
            }),
            subText && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubText, {
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Description, {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_GoHomeButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onClick,
                    children: btnName
                })
            })
        ]
    });
}
/* harmony default export */ var success = (Success);

;// CONCATENATED MODULE: ./components/thankyou/failure/index.tsx





function Failure(param) {
    var text = param.text, subText = param.subText, description = param.description, btnName = param.btnName, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(thankyou_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Banner, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "250px",
                    height: "250px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/errorScreen.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyou_styles_Text, {
                children: text
            }),
            subText && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubText, {
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Description, {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_GoHomeButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onClick,
                    children: btnName
                })
            })
        ]
    });
}
/* harmony default export */ var failure = (Failure);

;// CONCATENATED MODULE: ./components/thankyou/index.tsx



















function Thankyou() {
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, dealerType = ref.dealerType;
    var _query = router.query, partner = _query.partner, payment_mode = _query.payment_mode, payment_order_ekey = _query.payment_order_ekey;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var ref1 = (0,compat_module.useState)(""), paymentStatus = ref1[0], setPaymentStatus = ref1[1];
    var ref2 = (0,compat_module.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,compat_module.useState)(""), errorMessage = ref3[0], setErrorMessage = ref3[1];
    (0,compat_module.useEffect)(function() {
        if (payment_mode === "customer") {
            setIsLoading(false);
            return;
        }
        function getPaymentStatus() {
            return _getPaymentStatus.apply(this, arguments);
        }
        function _getPaymentStatus() {
            _getPaymentStatus = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, status, data, eventName, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            return [
                                4,
                                (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    method: "GET",
                                    url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partner, "/payment"),
                                    params: {
                                        payment_order_ekey: payment_order_ekey,
                                        user_type: "dealer"
                                    }
                                }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status === 200 && data) {
                                setErrorMessage("");
                                setPaymentStatus(data);
                                eventName = data === "success" ? constants/* SegmentViewEvents.VIEW_PAYMENT_SUCCESS */.od.VIEW_PAYMENT_SUCCESS : constants/* SegmentViewEvents.VIEW_PAYMENT_FAILURE */.od.VIEW_PAYMENT_FAILURE;
                                (0,building_blocks_ui_acko_analytics_dist.pageEvent)(eventName, {
                                    page: constants/* SegmentPages.PAYMENT */.IT.PAYMENT,
                                    partner: partnerId,
                                    product: "pos",
                                    journey: "buy",
                                    platform: "mweb",
                                    type: dealerType
                                });
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            e = _state.sent();
                            setErrorMessage("Oops. Something went wrong.");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _getPaymentStatus.apply(this, arguments);
        }
        getPaymentStatus();
    }, []);
    var goHome = function() {
        router.push("/".concat(lob, "/").concat(partnerId, "/dashboard"));
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                    src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
                })
            ]
        });
    }
    if (errorMessage || payment_mode === "customer") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {}),
                ";"
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.ThemeProvider, {
        theme: dist.AckoMainTheme,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            style: {
                padding: "20px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                paymentStatus === "success" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(success, {
                    text: "Congratulations!",
                    subText: "Your device is now protected",
                    description: "Your plan and coverage details are being sent to your registered mobile number",
                    btnName: "Go Home",
                    onClick: goHome
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(failure, {
                    text: "Payment failed!",
                    subText: "Oops. Something went wrong.",
                    description: "Please contact the showroom dealer for more details.",
                    btnName: "Go Home",
                    onClick: goHome
                })
            ]
        })
    });
}
/* harmony default export */ var thankyou = (Thankyou);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.form/dist/index.js
var building_blocks_ui_form_dist = __webpack_require__(5184);
var building_blocks_ui_form_dist_default = /*#__PURE__*/__webpack_require__.n(building_blocks_ui_form_dist);
;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/inputField/styles.tsx

function inputField_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid #d6d9e0;\n    border-radius: 8px;\n    padding: 1.18em 3em 1.18em 1.18em;\n    font-size: ",
        ";\n    width: 100%;\n    height: 100%;\n    outline: none;\n    text-transform: none;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    ::placeholder {\n        font-weight: ",
        ";\n        font-size: ",
        ";\n        line-height: 18px;\n        color: #5b5675;\n        text-transform: none;\n    }\n    :focus {\n        border: 1px solid #4f34d2;\n    }\n    text-transform: ",
        ";\n    ",
        ";\n    ",
        ";\n    ",
        "\n    ",
        ";\n    ",
        "\n"
    ]);
    inputField_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function inputField_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0px;\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 15px;\n    letter-spacing: 0.04em;\n    display: inline-block;\n    background-color: white;\n    padding: 0 5px;\n    transition: all 0.3s;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translate(0.8em, -0.6em);\n    ",
        "\n    ",
        ":placeholder-shown ~ & {\n        visibility: hidden;\n        opacity: 0;\n        transform: translate(0.8em, 1.4em);\n    }\n    // ",
        "\n"
    ]);
    inputField_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function inputField_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    margin-top: ",
        ";\n    width: 100%;\n    ",
        "\n"
    ]);
    inputField_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function inputField_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: ",
        ";\n    font-size: 0.7rem;\n    color: #555a68;\n    padding: 8px 1em 0;\n    box-sizing: border-box;\n    ",
        "\n    padding-left: ",
        ";\n"
    ]);
    inputField_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function inputField_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 16px;\n    width: 90%;\n    color: ",
        ";\n    font-size: 12px;\n    font-weight: 400;\n    text-align: center;\n    margin: ",
        ";\n    text-align: left;\n"
    ]);
    inputField_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function inputField_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 0.55em;\n    height: 0.55em;\n    transform: rotate(45deg);\n    border-right: 1.5px solid #151619;\n    border-bottom: 1.5px solid #151619;\n    display: inline;\n    position: absolute;\n    top: 40%;\n    right: 1.5em;\n    cursor: pointer;\n"
    ]);
    inputField_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function inputField_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 1.5em;\n    cursor: pointer;\n"
    ]);
    inputField_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function inputField_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 10px;\n    font-size: ",
        ";\n"
    ]);
    inputField_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var Input = building_blocks_ui_common_dist.styled.input(inputField_styles_templateObject(), building_blocks_ui_common_dist.$fontSize.xs, building_blocks_ui_common_dist.$fontWeightLight, building_blocks_ui_common_dist.$fontSize.xs, function(props) {
    return props.autoCapitalize ? "uppercase" : "none";
}, function(props) {
    return props.isDesktop && "height: 55px";
}, function(props) {
    return props.pointerCursor && "cursor: pointer";
}, function(props) {
    return props.leftPadding && "padding: 1.18em 3em 1.18em 3.5em;";
}, function(props) {
    return props.isPrefix && "padding-left: 38px";
}, function(props) {
    return props.styles;
});
var inputField_styles_Label = building_blocks_ui_common_dist.styled.p(inputField_styles_templateObject1(), building_blocks_ui_common_dist.$fontWeightLight, building_blocks_ui_common_dist.$fontSize.xxs, function(props) {
    return props.focused ? "color: #4f34d2" : "color: #5B5675";
}, Input, function(props) {
    return props.styles;
});
var inputField_styles_InputWrapper = building_blocks_ui_common_dist.styled.div(inputField_styles_templateObject2(), function(props) {
    return props.isDesktop ? "1.875rem" : "1.5rem";
}, function(props) {
    return props.styles;
});
var Note = building_blocks_ui_common_dist.styled.p(inputField_styles_templateObject3(), building_blocks_ui_common_dist.$fontWeightLight, function(props) {
    return props.error && "padding-top: 4px;";
}, function(props) {
    return props.isDesktop && "10px";
});
var styles_ErrorText = building_blocks_ui_common_dist.styled.p(inputField_styles_templateObject4(), building_blocks_ui_common_dist.$error, function(props) {
    return props.margin && props.margin;
});
var DropDown = building_blocks_ui_common_dist.styled.div(inputField_styles_templateObject5());
var styles_ImageContainer = building_blocks_ui_common_dist.styled.div(inputField_styles_templateObject6());
var MobilePrefix = building_blocks_ui_common_dist.styled.div(inputField_styles_templateObject7(), building_blocks_ui_common_dist.$fontSize.xs);

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/inputField/index.tsx





var InputField = function(param) {
    var value = param.value, touched = param.touched, errors = param.errors, handleChange = param.handleChange, handleBlur = param.handleBlur, placeholder = param.placeholder, name = param.name, note = param.note, type = param.type, onChange = param.onChange, readOnly = param.readOnly, handleClick = param.handleClick, showError = param.showError, setShowError = param.setShowError, autoCapitalize = param.autoCapitalize, className = param.className, dropdown = param.dropdown, // dropdownStyles,
    autoFocus = param.autoFocus, inputStyles = param.inputStyles, disabled = param.disabled, hideLabelText = param.hideLabelText, customHandleBlur = param.customHandleBlur, inputContainerStyles = param.inputContainerStyles, location = param.location, autoComplete = param.autoComplete, onFocus = param.onFocus, _mobilePrefix = param.mobilePrefix, mobilePrefix = _mobilePrefix === void 0 ? false : _mobilePrefix, calendar = param.calendar, // calendarIcon,
    // showCrossIcon,
    Icon = param.Icon;
    var ref = (0,compat_module.useState)(false), focused = ref[0], setFocused = ref[1];
    var ref1 = (0,compat_module.useState)(false), isAutoFocused = ref1[0], setisAutoFocused = ref1[1];
    var inputEl = (0,compat_module.useRef)(null);
    (0,compat_module.useEffect)(function() {
        if (autoFocus && !isAutoFocused && inputEl !== null) {
            inputEl.current.focus();
            setisAutoFocused(true);
        }
    }, [
        autoFocus
    ]);
    // const handleCrossClick = (e) => {
    //     e.preventDefault();
    //     value = '';
    //     onChange(value, name);
    // };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(inputField_styles_InputWrapper, {
        styles: inputContainerStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Input, {
                        isPrefix: mobilePrefix,
                        ref: inputEl,
                        placeholder: placeholder,
                        id: name,
                        type: type || "text",
                        name: name,
                        value: value || "",
                        autoComplete: autoComplete,
                        onChange: function(e) {
                            if (handleChange) handleChange(e);
                            if (showError) setShowError(false);
                            var value = autoCapitalize ? e.target.value.toUpperCase() : e.target.value;
                            onChange && onChange(value, name); // eslint-disable-line
                        },
                        onBlur: function(e) {
                            if (handleBlur) handleBlur(e);
                            if (customHandleBlur) customHandleBlur(e);
                            setFocused(false);
                        },
                        onFocus: function() {
                            onFocus && onFocus();
                            setFocused(true);
                        },
                        isError: errors[name] && touched[name],
                        readOnly: readOnly || false,
                        autoCapitalize: autoCapitalize,
                        onClick: handleClick,
                        className: className,
                        // isDesktop={isDesktop}
                        pointerCursor: dropdown || location,
                        styles: inputStyles,
                        disabled: disabled
                    }, name),
                    mobilePrefix && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobilePrefix, {
                        children: "+91"
                    }),
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(inputField_styles_Label, {
                        focused: focused,
                        children: hideLabelText ? "" : placeholder
                    })
                ]
            }),
            (showError || errors[name] && touched[name]) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ErrorText, {
                // isDesktop={isDesktop}
                size: "xxs",
                margin: "4px 0px",
                children: errors[name]
            }),
            note && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Note, {
                // isDesktop={isDesktop}
                error: errors[name],
                children: note
            }),
            dropdown && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropDown, {}),
            calendar && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "24px",
                    height: "24px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/icons/calendar.svg")
                })
            })
        ]
    });
};
/* harmony default export */ var inputField = (InputField);

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/styles.tsx

function dealerForm_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"
    ]);
    dealerForm_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dealerForm_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    padding: 1rem 0px;\n\n    @media (min-width: 768px) {\n        max-width: 500px;\n    }\n"
    ]);
    dealerForm_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dealerForm_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0.5rem 0px 0px;\n    color: rgb(4, 2, 34);\n    font-weight: 600;\n    font-size: 1.125rem;\n"
    ]);
    dealerForm_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function dealerForm_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: sticky;\n    left: 0px;\n    bottom: 0px;\n    width: 100%;\n    padding: 1rem;\n    background-color: white;\n    box-shadow: rgba(0, 0, 0, 0.05) 0px -2px 4px;\n\n    @media (min-width: 768px) {\n        max-width: 500px;\n        box-shadow: unset;\n        padding: 1rem;\n        border: 1px solid rgba(0, 0, 0, 0.05);\n        border-radius: 8px 8px 0px 0px;\n    }\n"
    ]);
    dealerForm_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function dealerForm_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    text-align: left18px;\n    font-weight: 60018px;\n    line-height: 1.5rem18px;\n"
    ]);
    dealerForm_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function dealerForm_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n"
    ]);
    dealerForm_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function dealerForm_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    font-size: 1rem;\n    border-bottom: 1px solid #d6d9e0;\n    color: #040222;\n\n    :first-child {\n        border-top: 1px solid #d6d9e0;\n    }\n"
    ]);
    dealerForm_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var dealerForm_styles_Wrapper = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(dealerForm_styles_templateObject());
var styles_Container = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(dealerForm_styles_templateObject1());
var styles_Heading = building_blocks_ui_common_dist.styled.p(dealerForm_styles_templateObject2());
var styles_ButtonContainer = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(dealerForm_styles_templateObject3());
var ModalHeading = building_blocks_ui_common_dist.styled.div(dealerForm_styles_templateObject4());
var TrailersContainer = building_blocks_ui_common_dist.styled.div(dealerForm_styles_templateObject5());
var Trailer = building_blocks_ui_common_dist.styled.div(dealerForm_styles_templateObject6());

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.radio-button/dist/index.js
var building_blocks_ui_radio_button_dist = __webpack_require__(4106);
var building_blocks_ui_radio_button_dist_default = /*#__PURE__*/__webpack_require__.n(building_blocks_ui_radio_button_dist);
;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/radioField/styles.tsx

function radioField_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    box-sizing: border-box;\n    border: 1px solid #e7e7f0;\n    border-radius: 8px;\n    padding: 12px 16px 16px;\n    margin-top: 16px;\n\n    ",
        "\n"
    ]);
    radioField_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function radioField_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n"
    ]);
    radioField_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function radioField_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #5b5675;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n"
    ]);
    radioField_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function radioField_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // margin-bottom: 24px;\n"
    ]);
    radioField_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var $primaryColorsV2 = building_blocks_ui_common_dist.$primaryColorsGreen;
var radioField_styles_Container = building_blocks_ui_common_dist.styled.div(radioField_styles_templateObject(), function(props) {
    return props.styles;
});
var FieldContainer = building_blocks_ui_common_dist.styled.div(radioField_styles_templateObject1());
var Field = building_blocks_ui_common_dist.styled.div(radioField_styles_templateObject2());
var radioField_styles_Wrapper = building_blocks_ui_common_dist.styled.div(radioField_styles_templateObject3());

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/radioField/index.tsx




var RadioField = function(param) {
    var field = param.field, selectedValue = param.selectedValue, setValue = param.setValue, submitCallback = param.submitCallback, ctaObj = param.ctaObj, options = param.options, name = param.name, styles = param.styles;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(radioField_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(radioField_styles_Container, {
            styles: styles,
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FieldContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Field, {
                            children: field
                        }),
                        ctaObj && ctaObj.text && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            onClick: function() {
                                return ctaObj.ctaOnClick && ctaObj.ctaOnClick();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                style: ctaObj.textStyles,
                                children: ctaObj.text
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    style: {
                        display: "flex",
                        marginTop: "0.75rem"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_radio_button_dist_default()), {
                        selectedValue: selectedValue,
                        options: options.filter(function(o) {
                            return !(o === null || o === void 0 ? void 0 : o.isDisabled);
                        }),
                        onSubmit: function(value) {
                            setValue(value, name);
                            submitCallback && submitCallback(value, name);
                        },
                        theme: {
                            selected: $primaryColorsV2.normal,
                            selectedText: "#040222",
                            default: "#040222"
                        },
                        fontSize: "xs",
                        widthBwButtons: building_blocks_ui_radio_button_dist.RadioButtonWidthOptions.xl
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var radioField = (RadioField);

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/yearMonthSelector/styles.tsx

function yearMonthSelector_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-gap: 10px;\n    margin-top: 30px;\n"
    ]);
    yearMonthSelector_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function yearMonthSelector_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n"
    ]);
    yearMonthSelector_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function yearMonthSelector_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 8px 12px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border: ",
        ";\n    border-radius: 6px;\n    cursor: pointer;\n    margin-right: 8px;\n"
    ]);
    yearMonthSelector_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function yearMonthSelector_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 500;\n    color: #040222;\n    margin-right: 10px;\n    font-weight: ",
        ";\n"
    ]);
    yearMonthSelector_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function yearMonthSelector_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px 16px;\n    font-size: 16px;\n\n    background-color: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    border-radius: 6px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    box-sizing: border-box;\n    text-align: center;\n    width: 65px;\n"
    ]);
    yearMonthSelector_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var yearMonthSelector_styles_Container = building_blocks_ui_common_dist.styled.div(yearMonthSelector_styles_templateObject());
var SelectorContainer = building_blocks_ui_common_dist.styled.div(yearMonthSelector_styles_templateObject1());
var Selector = building_blocks_ui_common_dist.styled.div(yearMonthSelector_styles_templateObject2(), function(props) {
    return props.selected ? "1px solid #5B5675" : "1px solid #E7E7F0";
});
var SelectorText = building_blocks_ui_common_dist.styled.div(yearMonthSelector_styles_templateObject3(), function(props) {
    return props.selected ? "600" : "500";
});
var Tile = building_blocks_ui_common_dist.styled.div(yearMonthSelector_styles_templateObject4(), function(props) {
    return props.selected ? "#0fa457" : "transparent";
}, function(props) {
    return props.selected ? "600" : "400";
}, function(props) {
    return props.selected ? "white" : "#040222";
});

// EXTERNAL MODULE: ./utils/date/constants.ts
var date_constants = __webpack_require__(1552);
;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/yearMonthSelector/index.tsx






var YearMonthSelector = function(param) {
    var showModal = param.showModal, setShowModal = param.setShowModal, monthOptions = param.monthOptions, activeMonth = param.activeMonth, setActiveMonth = param.setActiveMonth, activeYear = param.activeYear, setActiveYear = param.setActiveYear, yearOptions = param.yearOptions;
    var ref;
    var ref1 = (0,compat_module.useState)("year"), selector = ref1[0], setSelector = ref1[1];
    var ref2 = (0,compat_module.useState)(activeMonth), selectedMonth = ref2[0], setSelectedMonth = ref2[1];
    var ref3 = (0,compat_module.useState)(activeYear), selectedYear = ref3[0], setSelectedYear = ref3[1];
    var currentYear = new Date().getFullYear();
    var currentMonth = new Date().getMonth();
    if (selectedYear.toString() === currentYear.toString()) {
        monthOptions = monthOptions.filter(function(item) {
            return item.value - 1 <= currentMonth;
        });
    }
    (0,compat_module.useEffect)(function() {
        if (selectedYear === currentYear && monthOptions.findIndex(function(month) {
            return month.name === selectedMonth;
        }) === -1) {
            setActiveMonth("Jan");
            setSelectedMonth("Jan");
        }
    }, [
        showModal,
        selectedYear
    ]);
    (0,compat_module.useEffect)(function() {
        showModal && setSelector("year");
    }, [
        showModal
    ]);
    var displayMonth = (ref = monthOptions.filter(function(month) {
        return month.name === selectedMonth;
    })[0]) === null || ref === void 0 ? void 0 : ref.displayName;
    var months = monthOptions.map(function(month) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Tile, {
            selected: month.name === selectedMonth,
            onClick: function() {
                setSelectedMonth(month.name);
                setActiveMonth(month.name);
                selectedYear !== "" && setShowModal(false);
            // setRecentMonthTileClick(true);
            // yearIndex !== undefined ? setShowModal(false) : setSelector("year");
            },
            children: month.name
        }, month.value);
    });
    var years = yearOptions.map(function(year) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Tile, {
            selected: year.name === selectedYear,
            onClick: function() {
                setActiveYear(year.name);
                setSelectedYear(year.name);
                if (year.name !== "Before ".concat(date_constants/* maskedYearStart */.nq)) setSelector("month");
                else {
                    setShowModal(false);
                    setActiveMonth("Jan");
                }
            // recentMonthTileClick ? setShowModal(false) : setSelector("month");
            },
            children: year.name
        }, year.value);
    });
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SelectorContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Selector, {
                                onClick: function() {
                                    setSelector("year");
                                },
                                selected: selector === "year",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectorText, {
                                        selected: selector === "year",
                                        children: selectedYear || "Year"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                        style: {
                                            cursor: "pointer",
                                            transform: selector === "year" ? "rotate(180deg)" : "rotate(0deg)",
                                            transitionDuration: "100ms"
                                        },
                                        src: (0,generics/* getImageBasePath */.m4)("/icons/arrow.svg"),
                                        width: "12px",
                                        height: "12px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Selector, {
                                onClick: function() {
                                    setSelector("month");
                                },
                                selected: selector === "month",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectorText, {
                                        selected: selector === "month",
                                        children: displayMonth || "Month"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                        style: {
                                            cursor: "pointer",
                                            transform: selector === "month" ? "rotate(180deg)" : "rotate(0deg)",
                                            transitionDuration: "100ms"
                                        },
                                        src: (0,generics/* getImageBasePath */.m4)("/icons/arrow.svg"),
                                        width: "12px",
                                        height: "12px"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(yearMonthSelector_styles_Container, {
                        children: [
                            selector === "month" && months,
                            selector === "year" && years
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var yearMonthSelector = (YearMonthSelector);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(2222);
;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/utils/errorMessages.ts
var FIELD_ERROR_MESSAGE = {
    commonField: {
        required: "Field is required",
        invalid: ""
    },
    pincode: {
        required: "Pincode is required",
        invalid: "Please enter a valid pincode"
    },
    name: {
        required: "Owner's name is required",
        invalid: "Please enter a valid name"
    },
    financierName: {
        required: "Financier's name is required",
        invalid: "Please enter a valid name"
    },
    phone: {
        required: "Mobile number is required",
        invalid: "Please enter a valid phone number"
    },
    mmv: {
        required: "Make & model is required",
        invalid: ""
    },
    ncb: {
        required: "Please select one of the options",
        invalid: ""
    },
    pped: {
        required: "Policy expiry date is required",
        invalid: ""
    },
    cng: {
        required: "Please select one of the options",
        invalid: "External CNG kit value is invalid",
        value: "External CNG kit value is required"
    },
    regdYear: {
        required: "Registration year is required",
        invalid: ""
    },
    regdMonth: {
        required: "Registration months is required",
        invalid: ""
    },
    claimedPolicy: {
        required: "Please select one of the options",
        invalid: ""
    },
    fuelType: {
        required: "Fuel type is required",
        invalid: ""
    },
    engine: {
        required: "Engine number is required",
        invalid: "Please enter a valid engine number"
    },
    chassis: {
        required: "Chassis number is required",
        invalid: "Please enter a valid chassis number"
    },
    email: {
        required: "Email is required",
        invalid: "Please enter a valid email address"
    },
    carNumber: {
        required: "Registration number is required",
        invalid: "Please enter a valid registration number"
    },
    address: {
        required: "Address is required",
        invalid: ""
    },
    expiryMonth: {
        required: "Expiry month is required",
        invalid: ""
    },
    policyStartDate: {
        required: "New policy start date is required",
        invalid: ""
    },
    previousPolicyInsurer: {
        required: "Previous insurer is required",
        invalid: "Please enter a valid name"
    },
    policyDate: {
        required: "Policy date is required"
    },
    make: {
        required: "Make is required"
    },
    model: {
        required: "Fuel type is required"
    },
    variant: {
        required: "Variant is required"
    }
};
/* harmony default export */ var errorMessages = (FIELD_ERROR_MESSAGE);

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/utils/validate.ts
// note: this file is for frontend validation only
// backend validation are handled separately


var cleanRegNo = function(carNumber) {
    var ref;
    return (ref = carNumber === null || carNumber === void 0 ? void 0 : carNumber.toUpperCase()) === null || ref === void 0 ? void 0 : ref.replace(/[. ,:-]+/g, "");
};
var validate = {
    name: function name(values) {
        var name1 = values.name;
        var errors = {};
        if (!name1) {
            errors.name = errorMessages.name.required;
        } else if (!/^[a-zA-Z ]{2,60}$/.test(values.name)) {
            errors.name = errorMessages.name.invalid;
        }
        return errors;
    },
    financierName: function financierName(values) {
        var financierName1 = values.financierName;
        var errors = {};
        if (!financierName1) {
            errors.financierName = errorMessages.financierName.required;
        } else if (!/^[a-zA-Z ]{2,60}$/.test(values.financierName)) {
            errors.financierName = errorMessages.financierName.invalid;
        }
        return errors;
    },
    email: function email(values) {
        var errors = {};
        if (!values.email) {
            errors.email = errorMessages.email.required;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email.trim())) {
            errors.email = errorMessages.email.invalid;
        }
        return errors;
    },
    phoneNumber: function phoneNumber(values) {
        var ref, ref1;
        var errors = {};
        if (!values.phoneNumber) {
            errors.phoneNumber = errorMessages.phone.required;
        } else if (!/^[6-9]\d{9}$/i.test((ref1 = (ref = values.phoneNumber) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.trim())) {
            errors.phoneNumber = errorMessages.phone.invalid;
        }
        return errors;
    },
    registrationNumber: function registrationNumber(values) {
        var errors = {};
        var isValid = false;
        if (!(values === null || values === void 0 ? void 0 : values.registrationNumber)) {
            errors.registrationNumber = "Enter your registration number to continue";
            return errors;
        }
        /* eslint-disable no-plusplus */ for(var i = 0; i < registrationNumberRegexArray.length; i++){
            var regex = new RegExp(registrationNumberRegexArray[i], "i");
            var isRegNumberValid = regex.test(values === null || values === void 0 ? void 0 : values.registrationNumber);
            if (isRegNumberValid) {
                isValid = true;
                break;
            }
        }
        if (!isValid) {
            errors.registrationNumber = "Please enter a valid registration number";
            return errors;
        }
        return errors;
    },
    engineNumber: function engineNumber(values) {
        var ref, ref1;
        var errors = {};
        if (!values.engineNumber) {
            errors.engineNumber = errorMessages.engine.required;
        } else if (((ref = cleanRegNo(values.engineNumber)) === null || ref === void 0 ? void 0 : ref.length) < 6 || ((ref1 = cleanRegNo(values.engineNumber)) === null || ref1 === void 0 ? void 0 : ref1.length) > 26) {
            errors.engineNumber = errorMessages.engine.invalid;
        }
        return errors;
    },
    chassisNumber: function chassisNumber(values) {
        var ref, ref1;
        var errors = {};
        if (!values.chassisNumber) {
            errors.chassisNumber = errorMessages.chassis.required;
        } else if (((ref = cleanRegNo(values.chassisNumber)) === null || ref === void 0 ? void 0 : ref.length) < 6 || ((ref1 = cleanRegNo(values.chassisNumber)) === null || ref1 === void 0 ? void 0 : ref1.length) > 26) {
            errors.chassisNumber = errorMessages.chassis.invalid;
        }
        return errors;
    },
    pincode: function pincode(values) {
        var ref, ref1;
        var errors = {};
        var pinCodeRegex = "^[1-9][0-9]{5}$";
        if (!values.pincode) {
            errors.pincode = errorMessages.pincode.required;
        } else if (!new RegExp(pinCodeRegex, "i").test((ref1 = (ref = values.pincode) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.trim())) {
            errors.pincode = errorMessages.pincode.invalid;
        }
        return errors;
    },
    previousPolicyInsurer: function previousPolicyInsurer(values) {
        var previousPolicyInsurer1 = values.previousPolicyInsurer;
        var errors = {};
        if (!previousPolicyInsurer1) {
            errors.previousPolicyInsurer = errorMessages.previousPolicyInsurer.required;
        } else if (!/^[a-zA-Z ]{2,60}$/.test(values.previousPolicyInsurer)) {
            errors.previousPolicyInsurer = errorMessages.previousPolicyInsurer.invalid;
        }
        return errors;
    },
    // Regex to check only for numbers
    numeric: function numeric(value) {
        var regex = /(^$)|(^\d+$)/;
        return value && regex.test(value);
    },
    /**
     * Returns true only if a value is not empty
     */ required: function required(val) {
        switch(typeof val === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(val)){
            case "string":
                return !!val.trim();
            case "number":
                return Number.isFinite(val);
            default:
                return !!val;
        }
    },
    address: function address(value) {
        var ref;
        var errors = {};
        if (!(value === null || value === void 0 ? void 0 : value.address) || !(value === null || value === void 0 ? void 0 : (ref = value.address) === null || ref === void 0 ? void 0 : ref.trim())) {
            errors.address = errorMessages.address.required;
        }
        return errors;
    }
};
/* harmony default export */ var utils_validate = (validate);
var registrationNumberRegexArray = [
    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][1-9][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z]$",
    "^[0-9][0-9][X][X][0-9][0-9][0-9][0-9][A-Z][A-Z]$", 
];

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/actions.ts
var ACTIONS = {
    SET_FORM_DATA: "SET_FORM_DATA",
    SET_SHOW_ERROR: "SET_SHOW_ERROR",
    SET_ERRORS: "SET_ERRORS",
    DELETE_ERROR: "DELETE_ERROR",
    GET_AMOUNT: "GET_AMOUNT",
    RESET_FIELD: "RESET_FIELD",
    RESET_MMV: "RESET_MMV",
    SET_FORM_SUBMITTED: "SET_FORM_SUBMITTED",
    INITIATE_TRAILERS_INFO: "INITIATE_TRAILERS_INFO",
    SET_TRAILERS_INFO: "SET_TRAILERS_INFO",
    SET_TRAILER_INFO_ERROR: "SET_TRAILER_INFO_ERROR",
    DELETE_TRAILER_INFO_ERROR: "DELETE_TRAILER_INFO_ERROR"
};

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/utils/scrollIntoView.ts
var scrollIntoViewWrapper = function(element) {
    var blockType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "center";
    var target = document.getElementById(element);
    target && (target === null || target === void 0 ? void 0 : target.scrollIntoView({
        behavior: "smooth",
        block: blockType,
        inline: "center"
    }));
};

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/api.ts





var fetchAmount = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(payload) {
        var response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/auto-insurance/mpos/quote/get_price"), (0,src_object_spread/* default */.Z)({
                            method: "POST",
                            data: JSON.stringify((0,src_object_spread/* default */.Z)({}, payload))
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        error
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchAmount(payload) {
        return _ref.apply(this, arguments);
    };
}();
var postData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(payload) {
        var response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/auto-insurance/mpos/quote/issue"), (0,src_object_spread/* default */.Z)({
                            method: "POST",
                            data: JSON.stringify((0,src_object_spread/* default */.Z)({}, payload))
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            status: response === null || response === void 0 ? void 0 : response.status,
                            data: response === null || response === void 0 ? void 0 : response.data
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        error
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function postData(payload) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/utils/constants.ts
var months = [
    {
        name: "Jan",
        displayName: "January",
        value: 1
    },
    {
        name: "Feb",
        displayName: "February",
        value: 2
    },
    {
        name: "Mar",
        displayName: "March",
        value: 3
    },
    {
        name: "Apr",
        displayName: "April",
        value: 4
    },
    {
        name: "May",
        displayName: "May",
        value: 5
    },
    {
        name: "Jun",
        displayName: "June",
        value: 6
    },
    {
        name: "Jul",
        displayName: "July",
        value: 7
    },
    {
        name: "Aug",
        displayName: "August",
        value: 8
    },
    {
        name: "Sep",
        displayName: "September",
        value: 9
    },
    {
        name: "Oct",
        displayName: "October",
        value: 10
    },
    {
        name: "Nov",
        displayName: "November",
        value: 11
    },
    {
        name: "Dec",
        displayName: "December",
        value: 12
    }, 
];

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/utils/quotePriceResponse.ts
function num(v) {
    if (v === null || v === undefined) return null;
    var n = Number(v);
    return Number.isFinite(n) ? n : null;
}
function normalizeQuotePrice(raw) {
    if (!raw || typeof raw !== "object") {
        return {
            netPremium: null,
            grossPremium: null,
            gst: null
        };
    }
    var o = raw;
    var _premium;
    var single = num((_premium = o.premium) !== null && _premium !== void 0 ? _premium : o.amount);
    var _net_premium, ref;
    var net = (ref = num((_net_premium = o.net_premium) !== null && _net_premium !== void 0 ? _net_premium : o.netPremium)) !== null && ref !== void 0 ? ref : single;
    var _gross_premium, ref1;
    var gross = (ref1 = num((_gross_premium = o.gross_premium) !== null && _gross_premium !== void 0 ? _gross_premium : o.grossPremium)) !== null && ref1 !== void 0 ? ref1 : single;
    return {
        netPremium: net,
        grossPremium: gross,
        gst: num(o.gst)
    };
}
function normalizeAddonPriceFromRaw(o) {
    var priceAsScalar = o.price != null && typeof o.price !== "object" ? num(o.price) : null;
    var nested = o.price && typeof o.price === "object" ? normalizeQuotePrice(o.price) : {
        netPremium: null,
        grossPremium: null,
        gst: null
    };
    var _premium, ref, ref1, ref2;
    var flatSingle = (ref2 = num((ref1 = (ref = (_premium = o.premium) !== null && _premium !== void 0 ? _premium : o.amount) !== null && ref !== void 0 ? ref : o.addon_premium) !== null && ref1 !== void 0 ? ref1 : o.addonPremium)) !== null && ref2 !== void 0 ? ref2 : priceAsScalar;
    var _gross_premium;
    var flatGross = num((_gross_premium = o.gross_premium) !== null && _gross_premium !== void 0 ? _gross_premium : o.grossPremium);
    var _net_premium;
    var flatNet = num((_net_premium = o.net_premium) !== null && _net_premium !== void 0 ? _net_premium : o.netPremium);
    var flatGst = num(o.gst);
    var _grossPremium, ref3;
    var gross = (ref3 = (_grossPremium = nested.grossPremium) !== null && _grossPremium !== void 0 ? _grossPremium : flatGross) !== null && ref3 !== void 0 ? ref3 : flatSingle;
    var _netPremium, ref4;
    var net = (ref4 = (_netPremium = nested.netPremium) !== null && _netPremium !== void 0 ? _netPremium : flatNet) !== null && ref4 !== void 0 ? ref4 : flatSingle;
    var _gst;
    var gst = (_gst = nested.gst) !== null && _gst !== void 0 ? _gst : flatGst;
    if (gross == null && net != null) {
        gross = net;
    }
    if (net == null && gross != null) {
        net = gross;
    }
    return {
        grossPremium: gross,
        netPremium: net,
        gst: gst
    };
}
function parseAddonScalarFields(o) {
    var price = null;
    if (o.price != null && typeof o.price !== "object") {
        price = num(o.price);
    } else if (o.price && typeof o.price === "object") {
        var p = normalizeQuotePrice(o.price);
        var _netPremium;
        price = (_netPremium = p.netPremium) !== null && _netPremium !== void 0 ? _netPremium : p.grossPremium;
    } else {
        var _net_premium, _premium, ref, ref1;
        price = (ref1 = (ref = num((_net_premium = o.net_premium) !== null && _net_premium !== void 0 ? _net_premium : o.netPremium)) !== null && ref !== void 0 ? ref : num((_premium = o.premium) !== null && _premium !== void 0 ? _premium : o.amount)) !== null && ref1 !== void 0 ? ref1 : null;
    }
    return {
        price: price,
        gst: num(o.gst)
    };
}
function normalizeCover(raw) {
    if (!raw || typeof raw !== "object") return null;
    var o = raw;
    var _name;
    var name = (_name = o.name) !== null && _name !== void 0 ? _name : o.cover_name;
    return {
        name: name != null ? String(name) : null,
        price: normalizeAddonPriceFromRaw(o)
    };
}
function normalizeAddonLine(raw) {
    if (!raw || typeof raw !== "object") return null;
    var o = raw;
    var _addon_id, ref;
    var addonId = (ref = (_addon_id = o.addon_id) !== null && _addon_id !== void 0 ? _addon_id : o.addonId) !== null && ref !== void 0 ? ref : o.id;
    if (addonId == null) return null;
    var _name;
    var name = (_name = o.name) !== null && _name !== void 0 ? _name : o.addon_name;
    var ref1 = parseAddonScalarFields(o), price = ref1.price, gst = ref1.gst;
    return {
        addonId: String(addonId),
        name: name != null ? String(name) : null,
        price: price,
        gst: gst
    };
}
function parseAddonsAvailable(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map(function(item) {
        if (!item || typeof item !== "object") return null;
        var o = item;
        var _addon_id, ref;
        var id = (ref = (_addon_id = o.addon_id) !== null && _addon_id !== void 0 ? _addon_id : o.addonId) !== null && ref !== void 0 ? ref : o.id;
        if (id == null || id === "") return null;
        var ref1 = parseAddonScalarFields(o), price = ref1.price, gst = ref1.gst;
        var g = gst != null && Number.isFinite(gst) ? gst : 0;
        var _name;
        return {
            id: String(id),
            name: String((_name = o.name) !== null && _name !== void 0 ? _name : ""),
            price: price != null && Number.isFinite(price) ? price : 0,
            gst: g
        };
    }).filter(function(x) {
        return x != null;
    });
}
function parseGetQuotePriceResponse(raw) {
    var d = raw && typeof raw === "object" ? raw : {};
    var _variant_id;
    var vid = (_variant_id = d.variant_id) !== null && _variant_id !== void 0 ? _variant_id : d.variantId;
    var variantId = vid !== undefined && vid !== null && vid !== "" ? String(vid) : null;
    var _addons_available;
    var addonsAvailable = parseAddonsAvailable((_addons_available = d.addons_available) !== null && _addons_available !== void 0 ? _addons_available : d.addonsAvailable);
    var planRaw = d.plan;
    if (planRaw && typeof planRaw === "object") {
        var p = planRaw;
        var _id, ref;
        var id = (ref = (_id = p.id) !== null && _id !== void 0 ? _id : p.plan_id) !== null && ref !== void 0 ? ref : p.planId;
        var _tenure_unit;
        var tenureUnit = (_tenure_unit = p.tenure_unit) !== null && _tenure_unit !== void 0 ? _tenure_unit : p.tenureUnit;
        var _covers;
        var coversCoerced = (_covers = p.covers) !== null && _covers !== void 0 ? _covers : p.cover;
        var covers = Array.isArray(coversCoerced) ? coversCoerced.map(function(c) {
            return normalizeCover(c);
        }).filter(function(c) {
            return c != null;
        }) : function() {
            var single = normalizeCover(coversCoerced);
            return single ? [
                single
            ] : [];
        }();
        var addonsRaw = p.addons;
        var addons = Array.isArray(addonsRaw) ? addonsRaw.map(function(a) {
            return normalizeAddonLine(a);
        }).filter(function(line) {
            return line != null;
        }) : [];
        var _price, ref1;
        var priceObj = (ref1 = (_price = p.price) !== null && _price !== void 0 ? _price : p.total_price) !== null && ref1 !== void 0 ? ref1 : p.totalPrice;
        var price = priceObj && typeof priceObj === "object" ? normalizeQuotePrice(priceObj) : normalizeAddonPriceFromRaw(p);
        return {
            plan: {
                id: id != null ? String(id) : null,
                tenureUnit: tenureUnit != null ? String(tenureUnit) : null,
                covers: covers,
                addons: addons,
                price: price
            },
            variantId: variantId,
            addonsAvailable: addonsAvailable
        };
    }
    var _quote_price;
    var legacyQuote = (_quote_price = d.quote_price) !== null && _quote_price !== void 0 ? _quote_price : d.quotePrice;
    var legacyAmount = num(legacyQuote);
    if (legacyAmount != null) {
        return {
            plan: {
                id: null,
                tenureUnit: null,
                covers: [],
                addons: [],
                price: {
                    netPremium: legacyAmount,
                    grossPremium: null,
                    gst: null
                }
            },
            variantId: variantId,
            addonsAvailable: addonsAvailable
        };
    }
    return {
        plan: null,
        variantId: variantId,
        addonsAvailable: addonsAvailable
    };
}
function roundTotalAmount(n) {
    if (n === null || n === undefined || !Number.isFinite(Number(n))) {
        return null;
    }
    return Math.round(Number(n));
}
function hasMeaningfulPlanPrice(price) {
    if (!price) return false;
    return price.netPremium != null || price.grossPremium != null || price.gst != null;
}
function getTotalPremiumInclGst(quotePlan) {
    var price = quotePlan === null || quotePlan === void 0 ? void 0 : quotePlan.price;
    if (price == null || !hasMeaningfulPlanPrice(price)) {
        return 0;
    }
    var grossPremium = price.grossPremium, netPremium = price.netPremium, gst = price.gst;
    if (grossPremium != null && Number.isFinite(Number(grossPremium))) {
        return Math.round(Number(grossPremium));
    }
    if (netPremium != null && gst != null && Number.isFinite(Number(netPremium)) && Number.isFinite(Number(gst))) {
        return Math.round(Number(netPremium) + Number(gst));
    }
    if (netPremium != null && Number.isFinite(Number(netPremium))) {
        return Math.round(Number(netPremium));
    }
    return 0;
}

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/utils/helper.ts




/** Same four fields as backend `Addon` for quote/issue (no client-side premium math). */ function toAddonPayload(a) {
    return {
        id: a.id,
        name: a.name,
        price: Number(a.price),
        gst: Number(a.gst)
    };
}
function mapAddonIdsForQuotePriceRequest(selectedAddons) {
    var _id;
    return (selectedAddons !== null && selectedAddons !== void 0 ? selectedAddons : []).map(function(a) {
        return String((_id = a.id) !== null && _id !== void 0 ? _id : "").trim();
    }).filter(Boolean);
}
function mapAddonsForIssueRequestFromPlan(quotePlan, selectedAddons) {
    var ref;
    var ref1;
    var lines = (ref1 = quotePlan === null || quotePlan === void 0 ? void 0 : (ref = quotePlan.addons) === null || ref === void 0 ? void 0 : ref.filter(Boolean)) !== null && ref1 !== void 0 ? ref1 : [];
    if (!lines.length) {
        return (selectedAddons !== null && selectedAddons !== void 0 ? selectedAddons : []).map(toAddonPayload);
    }
    var _addonId, _name;
    return lines.map(function(line) {
        return {
            id: (_addonId = line.addonId) !== null && _addonId !== void 0 ? _addonId : "",
            name: (_name = line.name) !== null && _name !== void 0 ? _name : "",
            price: line.price != null ? Number(line.price) : 0,
            gst: line.gst != null ? Number(line.gst) : 0
        };
    });
}
var constructPayload = function(state) {
    var name = state.name, phoneNumber = state.phoneNumber, email = state.email, pincode = state.pincode, address = state.address, vehicleType = state.vehicleType, registrationNumber = state.registrationNumber, registrationYear = state.registrationYear, registrationMonth = state.registrationMonth, engineNumber = state.engineNumber, chassisNumber = state.chassisNumber, isVehicleFinanced = state.isVehicleFinanced, financierName = state.financierName, isPreviousPolicyExpired = state.isPreviousPolicyExpired, claimedInPreviousPolicy = state.claimedInPreviousPolicy, previousPolicyInsurer = state.previousPolicyInsurer, totalAmount = state.totalAmount, selectedAddons = state.selectedAddons, quotePlan = state.quotePlan, previousPolicyExpiryDate = state.previousPolicyExpiryDate, policyStartDate = state.policyStartDate, make = state.make, variant = state.variant, variant_id = state.variant_id, numberOfTrailers = state.numberOfTrailers, trailersInfo = state.trailersInfo;
    var attached_trailers = (vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value) === "tractor" && numberOfTrailers > 1 && trailersInfo.map(function(t) {
        var ref;
        return {
            trailer_type: t === null || t === void 0 ? void 0 : (ref = t.type) === null || ref === void 0 ? void 0 : ref.value,
            registration_number: t === null || t === void 0 ? void 0 : t.registrationNumber,
            chassis_number: t === null || t === void 0 ? void 0 : t.chassisNumber
        };
    });
    var totalFromPlan = getTotalPremiumInclGst(quotePlan);
    var totalAmountForPayload = totalFromPlan > 0 ? totalFromPlan : totalAmount != null && Number.isFinite(Number(totalAmount)) ? Math.round(Number(totalAmount)) : 0;
    var addonLines = mapAddonsForIssueRequestFromPlan(quotePlan, selectedAddons);
    var paylaodData = {
        user: {
            name: name,
            phone: phoneNumber,
            email: email,
            pincode: pincode,
            communication_address: address
        },
        vehicle: (0,src_object_spread/* default */.Z)({
            mmv_details: {
                make: make.name,
                model: make.name,
                variant: variant.name,
                variant_id: variant_id,
                variant_ekey: variant.id
            },
            registration_year: registrationYear,
            registration_month: months.filter(function(m) {
                return (m === null || m === void 0 ? void 0 : m.name) === registrationMonth;
            })[0].value,
            registration_number: registrationNumber,
            vehicle_type: vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value,
            engine_number: engineNumber,
            chassis_number: chassisNumber,
            hypothecation: (0,src_object_spread/* default */.Z)({
                is_financed: Boolean(parseInt(isVehicleFinanced === null || isVehicleFinanced === void 0 ? void 0 : isVehicleFinanced.value, 10))
            }, Boolean(parseInt(isVehicleFinanced === null || isVehicleFinanced === void 0 ? void 0 : isVehicleFinanced.value, 10)) && {
                financier_name: financierName
            }),
            previous_policy_details: {
                is_claimed: Boolean(parseInt(claimedInPreviousPolicy === null || claimedInPreviousPolicy === void 0 ? void 0 : claimedInPreviousPolicy.value, 10)),
                is_expired: Boolean(parseInt(isPreviousPolicyExpired === null || isPreviousPolicyExpired === void 0 ? void 0 : isPreviousPolicyExpired.value, 10)),
                previous_insurer_name: previousPolicyInsurer,
                expiry_date: new Date(new Date(previousPolicyExpiryDate).setHours(0, 0, 0, 0))
            }
        }, attached_trailers && {
            attached_trailers: attached_trailers
        }),
        addons: addonLines,
        total_amount: totalAmountForPayload,
        policy_start_date: policyStartDate
    };
    return paylaodData;
};
var formatDate = function(date) {
    return "".concat(date.getDate(), " / ").concat(date.getMonth() + 1, " / ").concat(date.getFullYear());
};
var currentYear = new Date().getFullYear();
var getRegistrationYears = function() {
    var years = (0,_to_consumable_array/* default */.Z)(Array(new Date().getFullYear() - 2000 + 1).keys()).map(function(k) {
        var year = (currentYear - k).toString();
        return {
            name: year,
            value: year
        };
    });
    return years;
};

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useFormData/index.tsx













var useFormData = function() {
    var reducer = function reducer(state, action) {
        if (action.type === ACTIONS.SET_FORM_DATA) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, action.payload.key, action.payload.value));
        }
        if (action.type === ACTIONS.RESET_FIELD) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, action.payload.key, initalState[action.payload.key]));
        }
        if (action.type === ACTIONS.RESET_MMV) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                make: initalState.make,
                model: initalState.model,
                variant: initalState.variant,
                totalAmount: initalState.totalAmount,
                variant_id: initalState.variant_id,
                quotePlan: initalState.quotePlan,
                addonsAvailable: initalState.addonsAvailable,
                selectedAddons: initalState.selectedAddons,
                errors: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.errors), {
                    make: initalErrorState.make,
                    model: initalErrorState.model,
                    variant: initalErrorState.variant
                })
            });
        }
        if (action.type === ACTIONS.SET_SHOW_ERROR) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                showError: action.payload
            });
        }
        if (action.type === ACTIONS.SET_ERRORS) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                errors: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.errors), (0,_define_property/* default */.Z)({}, action.payload.key, action.payload.value))
            });
        }
        if (action.type === ACTIONS.DELETE_ERROR) {
            var tempState = (0,src_object_spread/* default */.Z)({}, state);
            delete tempState.errors[action.payload.key];
            return tempState;
        }
        if (action.type === ACTIONS.GET_AMOUNT) {
            getAmountForVariant((0,src_object_spread/* default */.Z)({}, action.payload));
        }
        if (action.type === ACTIONS.SET_FORM_SUBMITTED) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                formSubmitted: true
            });
        }
        if (action.type === ACTIONS.INITIATE_TRAILERS_INFO) {
            var trailersNumber = state.numberOfTrailers;
            var trailersInfo = [];
            var trailersInfoErrors = [];
            trailersNumber && trailersNumber > 1 && (0,_to_consumable_array/* default */.Z)(Array(trailersNumber - 1).keys()).forEach(function(t) {
                trailersInfo.push({
                    id: "trailer_".concat(t),
                    registrationNumber: "",
                    chassisNumber: "",
                    type: {
                        value: "open",
                        displayValue: "Open"
                    },
                    label: "Trailer ".concat(t + 1, " details")
                });
                trailersInfoErrors.push((0,src_object_spread/* default */.Z)({
                    id: "trailer_".concat(t)
                }, initalTrailerErrorState));
            });
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                trailersInfo: trailersInfo,
                trailerInfoErrors: trailersInfoErrors,
                errors: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.errors), {
                    trailersInfo: "Please fill all the trailers information"
                })
            });
        }
        if (action.type === ACTIONS.SET_TRAILERS_INFO) {
            var _payload = action.payload, id = _payload.id, key = _payload.key, value = _payload.value;
            var trailersInfo1 = state.trailersInfo ? (0,_to_consumable_array/* default */.Z)(state.trailersInfo) : null;
            trailersInfo1 = trailersInfo1 && trailersInfo1.map(function(t) {
                if ((t === null || t === void 0 ? void 0 : t.id) === id) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, t), (0,_define_property/* default */.Z)({}, key, value));
                }
                return t;
            });
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                trailersInfo: trailersInfo1
            });
        }
        if (action.type === ACTIONS.SET_TRAILER_INFO_ERROR) {
            var _payload1 = action.payload, key1 = _payload1.key, value1 = _payload1.value, id1 = _payload1.id;
            var trailerInfoErrors = state.trailerInfoErrors ? (0,_to_consumable_array/* default */.Z)(state.trailerInfoErrors) : null;
            trailerInfoErrors = trailerInfoErrors && trailerInfoErrors.map(function(trailerErrorObj) {
                if (id1 === (trailerErrorObj === null || trailerErrorObj === void 0 ? void 0 : trailerErrorObj.id)) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, trailerErrorObj), (0,_define_property/* default */.Z)({}, key1, value1));
                }
                return trailerErrorObj;
            });
            return (0,src_object_spread/* default */.Z)({}, state, trailerInfoErrors && {
                trailerInfoErrors: trailerInfoErrors
            });
        }
        if (action.type === ACTIONS.DELETE_TRAILER_INFO_ERROR) {
            var _payload2 = action.payload, key2 = _payload2.key, id2 = _payload2.id;
            var trailerInfoErrors1 = state.trailerInfoErrors ? (0,_to_consumable_array/* default */.Z)(state.trailerInfoErrors) : null;
            trailerInfoErrors1 = trailerInfoErrors1 && trailerInfoErrors1.map(function(trailerErrorObj) {
                if (id2 === (trailerErrorObj === null || trailerErrorObj === void 0 ? void 0 : trailerErrorObj.id)) {
                    trailerErrorObj === null || trailerErrorObj === void 0 ? void 0 : delete trailerErrorObj[key2];
                    return trailerErrorObj;
                }
                return trailerErrorObj;
            });
            return (0,src_object_spread/* default */.Z)({}, state, trailerInfoErrors1 && {
                trailerInfoErrors: trailerInfoErrors1
            });
        }
        return (0,src_object_spread/* default */.Z)({}, state);
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var getAmountForVariant = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
            var vehicle_type, variant_ekey, no_of_trailers, selected_addons, data, ref, plan, variantId, addonsAvailable, displayTotal, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        vehicle_type = param.vehicle_type, variant_ekey = param.variant_ekey, no_of_trailers = param.no_of_trailers, selected_addons = param.selected_addons;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchAmount({
                                vehicle_type: vehicle_type,
                                variant_ekey: variant_ekey,
                                no_of_trailers: no_of_trailers,
                                addons: mapAddonIdsForQuotePriceRequest(selected_addons)
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        ref = parseGetQuotePriceResponse(data), plan = ref.plan, variantId = ref.variantId, addonsAvailable = ref.addonsAvailable;
                        displayTotal = getTotalPremiumInclGst(plan);
                        dispatch({
                            type: ACTIONS.SET_FORM_DATA,
                            payload: {
                                key: "quotePlan",
                                value: plan
                            }
                        });
                        dispatch({
                            type: ACTIONS.SET_FORM_DATA,
                            payload: {
                                key: "addonsAvailable",
                                value: addonsAvailable
                            }
                        });
                        dispatch({
                            type: ACTIONS.SET_FORM_DATA,
                            payload: {
                                key: "totalAmount",
                                value: displayTotal > 0 ? displayTotal : null
                            }
                        });
                        dispatch({
                            type: ACTIONS.SET_FORM_DATA,
                            payload: {
                                key: "variant_id",
                                value: variantId
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getAmountForVariant(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitFormData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var payload, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = constructPayload(state);
                        return [
                            4,
                            postData(payload)
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status === 202) {
                            dispatch({
                                type: ACTIONS.SET_FORM_SUBMITTED
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function submitFormData() {
            return _ref.apply(this, arguments);
        };
    }();
    var initalErrorState = {
        name: errorMessages.name.required,
        phoneNumber: errorMessages.phone.required,
        email: errorMessages.email.required,
        pincode: errorMessages.pincode.required,
        address: errorMessages.address.required,
        registrationNumber: "Registration number is required",
        registrationYearMonth: "Registration year and month are required",
        engineNumber: errorMessages.engine.required,
        chassisNumber: errorMessages.chassis.required,
        previousPolicyInsurer: errorMessages.previousPolicyInsurer.required,
        // totalAmount: 'Total amount is required',
        make: errorMessages === null || errorMessages === void 0 ? void 0 : (ref = errorMessages.make) === null || ref === void 0 ? void 0 : ref.required,
        model: errorMessages === null || errorMessages === void 0 ? void 0 : (ref1 = errorMessages.model) === null || ref1 === void 0 ? void 0 : ref1.required,
        variant: errorMessages === null || errorMessages === void 0 ? void 0 : (ref2 = errorMessages.variant) === null || ref2 === void 0 ? void 0 : ref2.required
    };
    var initalTrailerErrorState = {
        registrationNumber: "Registration number is required",
        chassisNumber: errorMessages.chassis.required,
        type: "Trailer type is required"
    };
    var initalState = {
        name: "",
        phoneNumber: "",
        email: "",
        pincode: "",
        address: "",
        registrationNumber: "",
        registrationYear: "",
        registrationMonth: "",
        engineNumber: "",
        chassisNumber: "",
        financierName: "",
        previousPolicyInsurer: "",
        totalAmount: null,
        isVehicleFinanced: {
            value: "0",
            displayValue: "No"
        },
        isPreviousPolicyExpired: {
            value: "1",
            displayValue: "Yes"
        },
        previousPolicyExpiryDate: new Date(new Date().setDate(new Date().getDate() - 1)),
        policyStartDate: new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)),
        claimedInPreviousPolicy: {
            value: "0",
            displayValue: "No"
        },
        vehicleType: {
            value: "pcv",
            displayValue: "PCV"
        },
        make: {
            id: "",
            image: "",
            name: "",
            variants: []
        },
        model: {
            name: "",
            value: ""
        },
        variant: {
            id: "",
            name: "",
            fuel_type: "",
            cc: ""
        },
        numberOfTrailers: null,
        errors: initalErrorState,
        trailerInfoErrors: null,
        showError: false,
        variant_id: null,
        quotePlan: null,
        addonsAvailable: [],
        selectedAddons: [],
        formSubmitted: null,
        trailersInfo: null
    };
    var ref6 = (0,compat_module.useReducer)(reducer, initalState), state = ref6[0], dispatch = ref6[1];
    var ref7 = (0,compat_module.useState)(false), shouldScrollIntoView = ref7[0], setShouldScrollIntoView = ref7[1];
    (0,compat_module.useEffect)(function() {
        var registrationYear = state.registrationYear, registrationMonth = state.registrationMonth;
        if (registrationYear === "" && registrationMonth === "") {
            dispatch({
                type: ACTIONS.SET_ERRORS,
                payload: {
                    key: "registrationYearMonth",
                    value: "Registration year and month are required"
                }
            });
        } else if (registrationYear && registrationMonth === "") {
            dispatch({
                type: ACTIONS.SET_ERRORS,
                payload: {
                    key: "registrationYearMonth",
                    value: errorMessages.regdYear.required
                }
            });
        } else if (registrationMonth && registrationYear === "") {
            dispatch({
                type: ACTIONS.SET_ERRORS,
                payload: {
                    key: "registrationYearMonth",
                    value: errorMessages.regdMonth.required
                }
            });
        } else {
            dispatch({
                type: ACTIONS.DELETE_ERROR,
                payload: {
                    key: "registrationYearMonth"
                }
            });
        }
    }, [
        state.registrationYear,
        state.registrationMonth
    ]);
    (0,compat_module.useEffect)(function() {
        var variant = state.variant, numberOfTrailers = state.numberOfTrailers, vehicleType = state.vehicleType;
        if ((variant === null || variant === void 0 ? void 0 : variant.id) && (vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value)) {
            var ref;
            if ((vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value) === "tractor" && numberOfTrailers && numberOfTrailers >= 0 || (vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value) !== "tractor") dispatch({
                type: ACTIONS.GET_AMOUNT,
                payload: {
                    vehicle_type: (ref = state.vehicleType) === null || ref === void 0 ? void 0 : ref.value,
                    variant_ekey: state.variant.id,
                    no_of_trailers: state.numberOfTrailers,
                    selected_addons: state.selectedAddons
                }
            });
        }
    }, [
        state === null || state === void 0 ? void 0 : (ref3 = state.variant) === null || ref3 === void 0 ? void 0 : ref3.id,
        state === null || state === void 0 ? void 0 : state.numberOfTrailers,
        state === null || state === void 0 ? void 0 : (ref4 = state.vehicleType) === null || ref4 === void 0 ? void 0 : ref4.value,
        state === null || state === void 0 ? void 0 : state.selectedAddons, 
    ]);
    (0,compat_module.useEffect)(function() {
        if (shouldScrollIntoView) {
            var errorKeys = Object.keys(state.errors);
            var toScrollId = errorKeys[0];
            scrollIntoViewWrapper(toScrollId);
            setShouldScrollIntoView(false);
        }
    }, [
        shouldScrollIntoView
    ]);
    (0,compat_module.useEffect)(function() {
        var ref;
        if (((ref = state.vehicleType) === null || ref === void 0 ? void 0 : ref.value) === "tractor" && state.numberOfTrailers) {
            if (state.numberOfTrailers > 1) {
                dispatch({
                    type: ACTIONS.INITIATE_TRAILERS_INFO
                });
            } else {
                dispatch({
                    type: ACTIONS.DELETE_ERROR,
                    payload: {
                        key: "trailersInfo"
                    }
                });
            }
        }
    // Add reset logic if pcv, gcv is selected
    }, [
        (ref5 = state.vehicleType) === null || ref5 === void 0 ? void 0 : ref5.value,
        state.numberOfTrailers
    ]);
    (0,compat_module.useEffect)(function() {
        var trailerInfoErrors = state.trailerInfoErrors;
        var isTrailerInfoErrorPresent = false;
        if (trailerInfoErrors && (trailerInfoErrors === null || trailerInfoErrors === void 0 ? void 0 : trailerInfoErrors.length) > 0) {
            trailerInfoErrors.forEach(function(errorObj) {
                if (!!(errorObj === null || errorObj === void 0 ? void 0 : errorObj.registrationNumber) || !!(errorObj === null || errorObj === void 0 ? void 0 : errorObj.chassisNumber)) {
                    isTrailerInfoErrorPresent = true;
                }
            });
        }
        if (!isTrailerInfoErrorPresent) {
            dispatch({
                type: ACTIONS.DELETE_ERROR,
                payload: {
                    key: "trailersInfo"
                }
            });
        }
    }, [
        state.trailerInfoErrors
    ]);
    return {
        setShouldScrollIntoView: setShouldScrollIntoView,
        submitFormData: submitFormData,
        state: state,
        dispatch: dispatch
    };
};

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useMmvData/actions.ts
var actions_ACTIONS = {
    GET_MMV_DATA: "GET_MMV_DATA",
    SET_MMV_DATA: "SET_MMV_DATA"
};

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useMmvData/api.ts



var fetchMmvData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var vehicle_type, url, response, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    vehicle_type = param.vehicle_type;
                    url = "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/auto-insurance/mpos/mmv/?vehicle_type=").concat(vehicle_type);
                    return [
                        4,
                        fetch(url, {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "SOURCE-ID": "Test",
                                "DATASET-LABEL": "new"
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMmvData(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useMmvData/index.tsx







var useMmvData = function() {
    var reducer = function reducer(state, action) {
        if (action.type === actions_ACTIONS.GET_MMV_DATA) {
            var ref;
            getMmvData({
                vehicle_type: action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.vehicle_type
            });
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                isFetching: true
            });
        }
        if (action.type === actions_ACTIONS.SET_MMV_DATA) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                isFetching: false,
                isSuccess: true,
                mmvData: (0,src_object_spread/* default */.Z)({}, action.payload)
            });
        }
        return (0,src_object_spread/* default */.Z)({}, state);
    };
    var ref = (0,compat_module.useReducer)(reducer, {
        isFetching: null,
        isSuccess: null,
        isError: null,
        mmvData: {}
    }), state = ref[0], dispatch = ref[1];
    var getMmvData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
            var vehicle_type, data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        vehicle_type = param.vehicle_type;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchMmvData({
                                vehicle_type: vehicle_type
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        dispatch({
                            type: actions_ACTIONS.SET_MMV_DATA,
                            payload: data === null || data === void 0 ? void 0 : data.result
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getMmvData(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        mmvStore: state,
        dispatch: dispatch
    };
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__(4070);
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);
;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/mmvOptions/styles.tsx

function mmvOptions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    mmvOptions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mmvOptions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    font-size: 11px;\n    color: ",
        ";\n    white-space: pre-wrap;\n    margin-bottom: 1em;\n"
    ]);
    mmvOptions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mmvOptions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 0;\n    font-size: ",
        ";\n    line-height: 22px;\n    color: #040222;\n"
    ]);
    mmvOptions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mmvOptions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 1rem 0;\n    cursor: pointer;\n    :not(:last-child) {\n        border-bottom: 1px solid #dcdce0;\n    }\n    :first-child {\n        padding-top: 4px;\n    }\n"
    ]);
    mmvOptions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var StyledBox = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(mmvOptions_styles_templateObject());
var mmvOptions_styles_ErrorText = building_blocks_ui_common_dist.styled.p(mmvOptions_styles_templateObject1(), building_blocks_ui_common_dist.$error);
var FuelOptionsText = building_blocks_ui_common_dist.styled.p(mmvOptions_styles_templateObject2(), building_blocks_ui_common_dist.$fontSize.xs);
var FuelTextContainer = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(mmvOptions_styles_templateObject3());

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/mmvOptions/index.tsx







var InputSearch = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 814).then(__webpack_require__.bind(__webpack_require__, 9814));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9814)
            ];
        }
    },
    ssr: true
});
function MmvOptions(param) {
    var queryType = param.queryType, popularVehicles = param.popularVehicles, fuelType = param.fuelType, variantType = param.variantType, vehicles = param.vehicles, handleClick = param.handleClick, vehicleType = param.vehicleType;
    var handleSelect = function(option) {
        return handleClick(option);
    };
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var isDesktop = !isMobile;
    var fuseOptions = {
        keys: [
            "name"
        ]
    };
    switch(queryType){
        case "make":
            {
                var fuseMake = new (fuse_default())(vehicles, fuseOptions);
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputSearch, {
                    defaultOptions: popularVehicles,
                    // totalOptions={vehicles}
                    handleSelect: function(value, searchText) {
                        return handleSelect({
                            value: value,
                            type: "make",
                            searchText: searchText
                        });
                    },
                    placeHolder: "Search your car",
                    defaultHeading: "Top Search Results",
                    errorText: "We couldn't find this car. Try searching for another one, or check for typing errors.",
                    fuseObject: fuseMake,
                    showMobileType: !isDesktop,
                    displaySearchItems: 60,
                    searchCallback: function() {},
                    showCrossIcon: true,
                    pb: true
                });
            }
        case "model":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_common_dist.Flex, {
                justifyContent: "center",
                flexDirection: "column",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StyledBox, {
                    children: fuelType.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FuelTextContainer, {
                            onClick: function() {
                                handleSelect({
                                    value: item,
                                    type: "model"
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FuelOptionsText, {
                                children: item.name
                            })
                        }, item.name);
                    })
                })
            });
        case "variant":
            {
                var fuseVariant = new (fuse_default())(variantType, fuseOptions);
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InputSearch, {
                    defaultOptions: variantType,
                    // totalOptions={variantType}
                    handleSelect: function(value, searchText) {
                        handleSelect({
                            value: value,
                            type: "variant",
                            searchText: searchText
                        });
                    },
                    placeHolder: "Select your car's variant type",
                    errorText: "We couldn't find this variant. Try searching for another one, or check for typing errors.",
                    // checkpoint="variant"
                    fuseObject: fuseVariant,
                    showMobileType: !isDesktop,
                    displaySearchItems: 60,
                    searchCallback: function() {},
                    showSeatingCapacity: vehicleType === "pcv",
                    showGrossVehicleWeight: vehicleType === "gcv",
                    showCrossIcon: true,
                    pb: true
                });
            }
        default:
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                children: " "
            });
    }
}

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/addonsOptions/styles.tsx

function addonsOptions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    addonsOptions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    font-size: 11px;\n    color: ",
        ";\n    white-space: pre-wrap;\n    margin-bottom: 1em;\n"
    ]);
    addonsOptions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 0;\n    font-size: ",
        ";\n    line-height: 22px;\n    color: #040222;\n"
    ]);
    addonsOptions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 1rem 0;\n    cursor: pointer;\n    :not(:last-child) {\n        border-bottom: 1px solid #dcdce0;\n    }\n    :first-child {\n        padding-top: 4px;\n    }\n"
    ]);
    addonsOptions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 1rem 0;\n    border-bottom: 1px solid #dcdce0;\n    &:first-child {\n        padding-top: 4px;\n    }\n    &:last-child {\n        border-bottom: none;\n    }\n"
    ]);
    addonsOptions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    min-width: 0;\n"
    ]);
    addonsOptions_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: none;\n    border: none;\n    padding: 4px 0;\n    margin: 0;\n    font-size: 12px;\n    line-height: 22px;\n    color: #2563eb;\n    cursor: pointer;\n    text-decoration: underline;\n    flex-shrink: 0;\n    font-weight: 500;\n\n    &[data-variant='danger'] {\n        color: #e11d48;\n    }\n\n    &:disabled {\n        color: #9ca3af;\n        cursor: not-allowed;\n        text-decoration: none;\n    }\n"
    ]);
    addonsOptions_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0.75rem;\n    padding: 0 2px;\n"
    ]);
    addonsOptions_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 12px;\n    padding: 10px 0;\n    border-bottom: 1px solid #ececf0;\n    &:last-child {\n        border-bottom: none;\n    }\n"
    ]);
    addonsOptions_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    font-size: ",
        ";\n    line-height: 22px;\n    color: #040222;\n    font-weight: 500;\n"
    ]);
    addonsOptions_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 2px 0 0;\n    font-size: 12px;\n    line-height: 18px;\n    color: #5c5c6e;\n"
    ]);
    addonsOptions_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 1rem;\n    padding: 14px 16px;\n    border-radius: 8px;\n    background: #f7f7f9;\n    border: 1px solid #ececf0;\n"
    ]);
    addonsOptions_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: ",
        ";\n    line-height: 22px;\n    color: #040222;\n    &:not(:last-child) {\n        margin-bottom: 8px;\n    }\n"
    ]);
    addonsOptions_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function addonsOptions_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid #dcdce0;\n    font-weight: 600;\n"
    ]);
    addonsOptions_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

var styles_StyledBox = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject());
var addonsOptions_styles_ErrorText = building_blocks_ui_common_dist.styled.p(addonsOptions_styles_templateObject1(), building_blocks_ui_common_dist.$error);
var styles_FuelOptionsText = building_blocks_ui_common_dist.styled.p(addonsOptions_styles_templateObject2(), building_blocks_ui_common_dist.$fontSize.xs);
var styles_FuelTextContainer = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject3());
var AddonModalRow = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject4());
var AddonModalRowMain = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject5());
var AddonRowAction = building_blocks_ui_common_dist.styled.button(addonsOptions_styles_templateObject6());
var SelectedAddonsWrap = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject7());
var SelectedAddonLine = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject8());
var SelectedAddonName = building_blocks_ui_common_dist.styled.p(addonsOptions_styles_templateObject9(), building_blocks_ui_common_dist.$fontSize.xs);
var SelectedAddonMeta = building_blocks_ui_common_dist.styled.p(addonsOptions_styles_templateObject10());
var PremiumBreakdownBox = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject11());
var PremiumBreakdownRow = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(addonsOptions_styles_templateObject12(), building_blocks_ui_common_dist.$fontSize.xs);
var PremiumBreakdownTotal = (0,building_blocks_ui_common_dist.styled)(PremiumBreakdownRow)(addonsOptions_styles_templateObject13());

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/addonsOptions/format.ts
function formatAddonRupee(amount) {
    if (amount === null || amount === undefined || Number.isNaN(amount)) {
        return "—";
    }
    var roundedAmount = Math.round(amount);
    return "₹".concat(roundedAmount.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }));
}
function formatAddonDisplayName(apiName) {
    if (!apiName) return "";
    return apiName.split(/[_\s]+/).filter(Boolean).map(function(w) {
        return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(" ");
}

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/addonsOptions/selectedSummary.tsx





function SelectedAddonsSummary(param) {
    var selectedAddons = param.selectedAddons;
    if (!(selectedAddons === null || selectedAddons === void 0 ? void 0 : selectedAddons.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectedAddonsWrap, {
        children: selectedAddons.map(function(addon) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectedAddonLine, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(building_blocks_ui_common_dist.Box, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectedAddonName, {
                            children: formatAddonDisplayName(addon.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectedAddonMeta, {
                            children: formatAddonRupee(addon.price)
                        })
                    ]
                })
            }, addon.id);
        })
    });
}

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/addonsOptions/index.tsx





function AddonsOptions(param) {
    var addons = param.addons, selectedIds = param.selectedIds, onAdd = param.onAdd, onRemove = param.onRemove;
    if (!addons.length) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_FuelOptionsText, {
            children: "No add-ons available."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_common_dist.Flex, {
        justifyContent: "center",
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_StyledBox, {
            children: addons.map(function(item) {
                var isSelected = selectedIds.has(item.id);
                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(AddonModalRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(AddonModalRowMain, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_FuelOptionsText, {
                                    children: [
                                        formatAddonDisplayName(item.name),
                                        " — ".concat(formatAddonRupee(item.price), " ")
                                    ]
                                }),
                                isSelected && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_FuelOptionsText, {
                                    style: {
                                        marginTop: 4,
                                        fontSize: 12,
                                        color: "#5c5c6e"
                                    },
                                    children: "Selected"
                                })
                            ]
                        }),
                        isSelected ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AddonRowAction, {
                            type: "button",
                            "data-variant": "danger",
                            onClick: function(e) {
                                e.stopPropagation();
                                onRemove(item.id);
                            },
                            children: "Remove"
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AddonRowAction, {
                            type: "button",
                            onClick: function(e) {
                                e.stopPropagation();
                                onAdd(item);
                            },
                            children: "Add"
                        })
                    ]
                }, item.id);
            })
        })
    });
}



;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useMmvData/utils/mapping.ts
var allFuelTypes = {
    petrol: "Petrol",
    diesel: "Diesel",
    internal_lpg_cng: "CNG",
    electric: "Electric"
};

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/useMmvData/utils/helper.ts



var getHeadingText = function(type) {
    switch(type){
        case "make":
            return "Select your car's make";
        case "model":
            return "Select your car's fuel type";
        case "variant":
            return "Select your car's \nvariant type";
        default:
            return "";
    }
};
var getFuelType = function(param) {
    var allFuelTypes = param.allFuelTypes, make = param.make;
    var uniqueFuelType = [];
    if (!(0,generics/* isEmpty */.xb)(make.variants)) {
        make.variants.forEach(function(item) {
            if (uniqueFuelType.indexOf(item.fuel_type) === -1) {
                // eslint-disable-line
                uniqueFuelType.push(item.fuel_type); // eslint-disable-line
            }
        });
    }
    return uniqueFuelType.map(function(item) {
        return {
            name: allFuelTypes[item],
            key: item
        };
    });
};
var getVariantType = function(param) {
    var allFuelTypes = param.allFuelTypes, make = param.make, model = param.model;
    return !(0,generics/* isEmpty */.xb)(make.variants) && !(0,generics/* isEmpty */.xb)(model) ? make.variants.filter(function(item) {
        return allFuelTypes[item.fuel_type] === model.name;
    }) : [];
};
var handleNextModal = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var type, setMmvType, nextModal;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    type = param.type, setMmvType = param.setMmvType;
                    return [
                        4,
                        setMmvType("")
                    ];
                case 1:
                    _state.sent();
                    nextModal = "";
                    if (type === "make") nextModal = "model";
                    if (type === "model") nextModal = "variant";
                    return [
                        4,
                        setMmvType(nextModal)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleNextModal(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.loaders/dist/index.js
var building_blocks_ui_loaders_dist = __webpack_require__(5158);
;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/trailerInputGroup/styles.tsx

function trailerInputGroup_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    box-sizing: border-box;\n    border: 3px solid #e7e7f0;\n    border-radius: 8px;\n    padding: 0px 16px 16px;\n    margin-top: 16px;\n\n    position: relative;\n"
    ]);
    trailerInputGroup_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function trailerInputGroup_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: max-content;\n    padding: 2px 4px;\n    font-size: 12px;\n    color: #5b5675;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    transform: translate(0.8em, -22px);\n    background: white;\n    display: inline-block;\n"
    ]);
    trailerInputGroup_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var trailerInputGroup_styles_Container = building_blocks_ui_common_dist.styled.div(trailerInputGroup_styles_templateObject());
var trailerInputGroup_styles_Label = building_blocks_ui_common_dist.styled.p(trailerInputGroup_styles_templateObject1());

;// CONCATENATED MODULE: ./utils/validate.ts
// note: this file is for frontend validation only
// backend validation are handled separately


var validate_cleanRegNo = function(carNumber) {
    var ref;
    return (ref = carNumber === null || carNumber === void 0 ? void 0 : carNumber.toUpperCase()) === null || ref === void 0 ? void 0 : ref.replace(/[. ,:-]+/g, "");
};
var validate_validate = {
    name: function name(values) {
        var name1 = values.name;
        var errors = {};
        if (!name1) {
            errors.name = errorMessages.name.required;
        } else if (!/^[a-zA-Z ]{2,60}$/.test(values.name)) {
            errors.name = errorMessages.name.invalid;
        }
        return errors;
    },
    financierName: function financierName(values) {
        var financierName1 = values.financierName;
        var errors = {};
        if (!financierName1) {
            errors.financierName = errorMessages.financierName.required;
        } else if (!/^[a-zA-Z ]{2,60}$/.test(values.financierName)) {
            errors.financierName = errorMessages.financierName.invalid;
        }
        return errors;
    },
    email: function email(values) {
        var errors = {};
        if (!values.email) {
            errors.email = errorMessages.email.required;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email.trim())) {
            errors.email = errorMessages.email.invalid;
        }
        return errors;
    },
    phoneNumber: function phoneNumber(values) {
        var ref, ref1;
        var errors = {};
        if (!values.phoneNumber) {
            errors.phoneNumber = errorMessages.phone.required;
        } else if (!/^[6-9]\d{9}$/i.test((ref1 = (ref = values.phoneNumber) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.trim())) {
            errors.phoneNumber = errorMessages.phone.invalid;
        }
        return errors;
    },
    registrationNumber: function registrationNumber(values) {
        var errors = {};
        var isValid = false;
        if (!(values === null || values === void 0 ? void 0 : values.registrationNumber)) {
            errors.registrationNumber = "Enter your registration number to continue";
            return errors;
        }
        /* eslint-disable no-plusplus */ for(var i = 0; i < validate_registrationNumberRegexArray.length; i++){
            var regex = new RegExp(validate_registrationNumberRegexArray[i], "i");
            var isRegNumberValid = regex.test(values === null || values === void 0 ? void 0 : values.registrationNumber);
            if (isRegNumberValid) {
                isValid = true;
                break;
            }
        }
        if (!isValid) {
            errors.registrationNumber = "Please enter a valid registration number";
            return errors;
        }
        return errors;
    },
    engineNumber: function engineNumber(values) {
        var ref, ref1;
        var errors = {};
        if (!values.engineNumber) {
            errors.engineNumber = errorMessages.engine.required;
        } else if (((ref = validate_cleanRegNo(values.engineNumber)) === null || ref === void 0 ? void 0 : ref.length) < 6 || ((ref1 = validate_cleanRegNo(values.engineNumber)) === null || ref1 === void 0 ? void 0 : ref1.length) > 26) {
            errors.engineNumber = errorMessages.engine.invalid;
        }
        return errors;
    },
    chassisNumber: function chassisNumber(values) {
        var ref, ref1;
        var errors = {};
        if (!values.chassisNumber) {
            errors.chassisNumber = errorMessages.chassis.required;
        } else if (((ref = validate_cleanRegNo(values.chassisNumber)) === null || ref === void 0 ? void 0 : ref.length) < 6 || ((ref1 = validate_cleanRegNo(values.chassisNumber)) === null || ref1 === void 0 ? void 0 : ref1.length) > 26) {
            errors.chassisNumber = errorMessages.chassis.invalid;
        }
        return errors;
    },
    pincode: function pincode(values) {
        var ref, ref1;
        var errors = {};
        var pinCodeRegex = "^[1-9][0-9]{5}$";
        if (!values.pincode) {
            errors.pincode = errorMessages.pincode.required;
        } else if (!new RegExp(pinCodeRegex, "i").test((ref1 = (ref = values.pincode) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.trim())) {
            errors.pincode = errorMessages.pincode.invalid;
        }
        return errors;
    },
    previousPolicyInsurer: function previousPolicyInsurer(values) {
        var previousPolicyInsurer1 = values.previousPolicyInsurer;
        var errors = {};
        if (!previousPolicyInsurer1) {
            errors.previousPolicyInsurer = errorMessages.previousPolicyInsurer.required;
        } else if (!/^[a-zA-Z ]{2,60}$/.test(values.previousPolicyInsurer)) {
            errors.previousPolicyInsurer = errorMessages.previousPolicyInsurer.invalid;
        }
        return errors;
    },
    // Regex to check only for numbers
    numeric: function numeric(value) {
        var regex = /(^$)|(^\d+$)/;
        return value && regex.test(value);
    },
    /**
     * Returns true only if a value is not empty
     */ required: function required(val) {
        switch(typeof val === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(val)){
            case "string":
                return !!val.trim();
            case "number":
                return Number.isFinite(val);
            default:
                return !!val;
        }
    },
    address: function address(value) {
        var errors = {};
        if (!value || !(value === null || value === void 0 ? void 0 : value.trim())) {
            errors.address = errorMessages.address.required;
        }
        return errors;
    }
};
/* harmony default export */ var utils_validate_0 = (validate_validate);
var validate_registrationNumberRegexArray = [
    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][1-9][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
    "^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$",
    "^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z]$",
    "^[0-9][0-9][X][X][0-9][0-9][0-9][0-9][A-Z][A-Z]$", 
];

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/form/trailerInputGroup/index.tsx










var TrailerInputGroup = function(param) {
    var registrationNumber = param.registrationNumber, chassisNumber = param.chassisNumber, setTrailerInfo = param.setTrailerInfo, registrationNumberError = param.registrationNumberError, chassisNumberError = param.chassisNumberError, typeError = param.typeError, setError = param.setError, deleteError = param.deleteError, showError = param.showError, // setShowError,
    label = param.label, id = param.id, type = param.type;
    var errors = {
        registrationNumber: registrationNumberError,
        chassisNumber: chassisNumberError,
        type: typeError
    };
    var setShowError = function() {};
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(trailerInputGroup_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(trailerInputGroup_styles_Label, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                name: "registrationNumber",
                initialValue: registrationNumber,
                validate: function(values) {
                    var registrationNumberErrors = utils_validate_0.registrationNumber(values);
                    if (registrationNumberErrors.registrationNumber) {
                        setError({
                            key: "registrationNumber",
                            value: registrationNumberErrors.registrationNumber,
                            id: id
                        });
                    } else {
                        deleteError({
                            key: "registrationNumber",
                            id: id
                        });
                    }
                    return registrationNumberErrors;
                },
                value: registrationNumber,
                handleNext: function() {
                    return null;
                },
                buttonText: "",
                validateOnBlur: true,
                customInput: function(_param) {
                    var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                        "errors"
                    ]);
                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                    }, props), {
                        showError: showError,
                        setShowError: setShowError,
                        placeholder: "Registration number",
                        name: "registrationNumber",
                        onChange: function(value) {
                            setTrailerInfo({
                                value: value === null || value === void 0 ? void 0 : value.toUpperCase(),
                                key: "registrationNumber",
                                id: id
                            });
                        },
                        value: registrationNumber,
                        className: "fs-exclude"
                    }));
                },
                enableReinitialize: true
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                name: "chassisNumber",
                initialValue: chassisNumber,
                validate: function(values) {
                    var chassisNumberErrors = utils_validate_0.chassisNumber(values);
                    if (chassisNumberErrors.chassisNumber) {
                        setError({
                            key: "chassisNumber",
                            value: chassisNumberErrors.chassisNumber,
                            id: id
                        });
                    } else {
                        deleteError({
                            key: "chassisNumber",
                            id: id
                        });
                    }
                    return chassisNumberErrors;
                },
                value: chassisNumber,
                handleNext: function() {
                    return null;
                },
                buttonText: "",
                validateOnBlur: true,
                customInput: function(_param) {
                    var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                        "errors"
                    ]);
                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                    }, props), {
                        showError: showError,
                        setShowError: setShowError,
                        placeholder: "Chassis number",
                        name: "chassisNumber",
                        onChange: function(value) {
                            setTrailerInfo({
                                value: value === null || value === void 0 ? void 0 : value.toUpperCase(),
                                key: "chassisNumber",
                                id: id
                            });
                        },
                        value: chassisNumber,
                        className: "fs-exclude"
                    }));
                },
                enableReinitialize: true
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(radioField, {
                field: "Select trailer type",
                selectedValue: type,
                name: "isPreviousPolicyExpired",
                setValue: function(selection) {
                    setTrailerInfo({
                        value: selection,
                        key: "type",
                        id: id
                    });
                },
                options: [
                    {
                        value: "open",
                        displayValue: "Open"
                    },
                    {
                        value: "closed",
                        displayValue: "Closed"
                    }, 
                ],
                styles: {
                    padding: "8px 12px 1rem",
                    border: "unset"
                }
            })
        ]
    });
};
/* harmony default export */ var trailerInputGroup = (/*#__PURE__*/(0,compat_module.memo)(TrailerInputGroup));

;// CONCATENATED MODULE: ./components/auto-lob/dealerForm/index.tsx

































var Form = function() {
    var ref, ref1, ref2, ref3, ref4;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    var ref5 = (0,compat_module.useState)(false), showRegistrationyarMonthCalendar = ref5[0], setShowRegistrationYearMonthCalendar = ref5[1];
    var ref6 = (0,compat_module.useState)("make"), mmvType = ref6[0], setMmvType = ref6[1];
    var ref7 = (0,compat_module.useState)(false), showMmvModal = ref7[0], setShowMmvModal = ref7[1];
    var ref8 = (0,compat_module.useState)(false), showTrailersModal = ref8[0], setShowTrailersModal = ref8[1];
    var ref9 = (0,compat_module.useState)(false), showFormSuccessModal = ref9[0], setShowFormSuccessModal = ref9[1];
    var ref10 = (0,compat_module.useState)(false), showAddonsModal = ref10[0], setShowAddonsModal = ref10[1];
    var ref11 = useFormData(), state = ref11.state, dispatch = ref11.dispatch, setShouldScrollIntoView = ref11.setShouldScrollIntoView, submitFormData = ref11.submitFormData;
    var ref12 = useMmvData(), mmvStore = ref12.mmvStore, mmvDispatch = ref12.dispatch;
    var isMmvApiSuccess = mmvStore.isSuccess, isMmvApiFetching = mmvStore.isFetching;
    var _mmvData = mmvStore.mmvData, vehicles = _mmvData.vehicles, popularVehicles = _mmvData.popular_vehicles;
    var setShowError = function(val) {
        dispatch({
            type: ACTIONS.SET_SHOW_ERROR,
            payload: val
        });
    };
    var setFormData = function(param) {
        var key = param.key, value = param.value;
        dispatch({
            type: ACTIONS.SET_FORM_DATA,
            payload: {
                key: key,
                value: value
            }
        });
    };
    var setError = function(param) {
        var key = param.key, value = param.value;
        dispatch({
            type: ACTIONS.SET_ERRORS,
            payload: {
                key: key,
                value: value
            }
        });
    };
    var deleteError = function(param) {
        var key = param.key;
        dispatch({
            type: ACTIONS.DELETE_ERROR,
            payload: {
                key: key
            }
        });
    };
    var resetMmv = function() {
        dispatch({
            type: ACTIONS.RESET_MMV
        });
    };
    var setTrailerInfo = (0,compat_module.useCallback)(function(param) {
        var key = param.key, value = param.value, id = param.id;
        dispatch({
            type: ACTIONS.SET_TRAILERS_INFO,
            payload: {
                key: key,
                value: value,
                id: id
            }
        });
    }, []);
    var setTrailerInfoError = (0,compat_module.useCallback)(function(param) {
        var key = param.key, value = param.value, id = param.id;
        dispatch({
            type: ACTIONS.SET_TRAILER_INFO_ERROR,
            payload: {
                key: key,
                value: value,
                id: id
            }
        });
    }, []);
    var deleteTrailerInfoError = (0,compat_module.useCallback)(function(param) {
        var key = param.key, id = param.id;
        dispatch({
            type: ACTIONS.DELETE_TRAILER_INFO_ERROR,
            payload: {
                key: key,
                id: id
            }
        });
    }, []);
    var errors = state.errors, trailerInfoErrors = state.trailerInfoErrors, showError = state.showError, name = state.name, phoneNumber = state.phoneNumber, email = state.email, pincode = state.pincode, address = state.address, vehicleType = state.vehicleType, registrationNumber = state.registrationNumber, registrationYear = state.registrationYear, registrationMonth = state.registrationMonth, engineNumber = state.engineNumber, chassisNumber = state.chassisNumber, isVehicleFinanced = state.isVehicleFinanced, financierName = state.financierName, isPreviousPolicyExpired = state.isPreviousPolicyExpired, claimedInPreviousPolicy = state.claimedInPreviousPolicy, previousPolicyInsurer = state.previousPolicyInsurer, totalAmount = state.totalAmount, quotePlan = state.quotePlan, addonsAvailable = state.addonsAvailable, make = state.make, model = state.model, policyStartDate = state.policyStartDate, numberOfTrailers = state.numberOfTrailers, trailersInfo = state.trailersInfo, previousPolicyExpiryDate = state.previousPolicyExpiryDate, formSubmitted = state.formSubmitted, selectedAddons = state.selectedAddons;
    var selectedAddonIds = (0,compat_module.useMemo)(function() {
        return new Set((selectedAddons !== null && selectedAddons !== void 0 ? selectedAddons : []).map(function(a) {
            return a.id;
        }));
    }, [
        selectedAddons
    ]);
    var apiPlanPrice = quotePlan === null || quotePlan === void 0 ? void 0 : quotePlan.price;
    var hasApiPricing = hasMeaningfulPlanPrice(apiPlanPrice);
    var addonsCatalog = addonsAvailable !== null && addonsAvailable !== void 0 ? addonsAvailable : [];
    var subtotalExclGst = hasApiPricing && (apiPlanPrice === null || apiPlanPrice === void 0 ? void 0 : apiPlanPrice.netPremium) != null ? apiPlanPrice.netPremium : null;
    var gstAmount = hasApiPricing && (apiPlanPrice === null || apiPlanPrice === void 0 ? void 0 : apiPlanPrice.gst) != null ? apiPlanPrice.gst : null;
    var grandTotalInclGst = getTotalPremiumInclGst(quotePlan);
    var ref13;
    var showPremiumBreakdown = hasApiPricing || totalAmount != null || ((ref13 = selectedAddons === null || selectedAddons === void 0 ? void 0 : selectedAddons.length) !== null && ref13 !== void 0 ? ref13 : 0) > 0;
    (0,compat_module.useEffect)(function() {
        mmvDispatch({
            type: actions_ACTIONS.GET_MMV_DATA,
            payload: {
                vehicle_type: vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value
            }
        });
    }, [
        vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value
    ]);
    var prevVehicleTypeRef = (0,compat_module.useRef)(undefined);
    (0,compat_module.useEffect)(function() {
        if (!(vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value)) return;
        var v = vehicleType.value;
        if (prevVehicleTypeRef.current !== undefined && prevVehicleTypeRef.current !== v) {
            setFormData({
                key: "selectedAddons",
                value: []
            });
            setFormData({
                key: "addonsAvailable",
                value: []
            });
            setFormData({
                key: "quotePlan",
                value: null
            });
        }
        prevVehicleTypeRef.current = v;
    }, [
        vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value
    ]);
    (0,compat_module.useEffect)(function() {
        if (formSubmitted) {
            setShowFormSuccessModal(true);
        }
    }, [
        formSubmitted
    ]);
    var fuelType = getFuelType({
        allFuelTypes: allFuelTypes,
        make: make
    });
    var variantTypes = getVariantType({
        allFuelTypes: allFuelTypes,
        make: make,
        model: model
    });
    var years = getRegistrationYears();
    var ref14, ref15, _name, _netPremium, ref16, _name1, _name2, _price, _addonId, ref17, _price1;
    return isMmvApiFetching && !isMmvApiSuccess ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_loaders_dist.BasicLoader, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dealerForm_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Container, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Heading, {
                            children: "Please enter following details"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "name",
                            initialValue: name,
                            validate: function(values) {
                                var nameErrors = utils_validate.name(values);
                                if (nameErrors.name) {
                                    setError({
                                        key: "name",
                                        value: nameErrors.name
                                    });
                                } else {
                                    deleteError({
                                        key: "name"
                                    });
                                }
                                return nameErrors;
                            },
                            value: name,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Full Name",
                                    name: "name",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value
                                        });
                                    },
                                    value: name,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "phoneNumber",
                            initialValue: phoneNumber,
                            validate: function(values) {
                                var phoneNumberErrors = utils_validate.phoneNumber(values);
                                if (phoneNumberErrors.phoneNumber) {
                                    setError({
                                        key: "phoneNumber",
                                        value: phoneNumberErrors.phoneNumber
                                    });
                                } else {
                                    deleteError({
                                        key: "phoneNumber"
                                    });
                                }
                                return phoneNumberErrors;
                            },
                            value: phoneNumber,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Phone number",
                                    name: "phoneNumber",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value
                                        });
                                    },
                                    value: phoneNumber,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "email",
                            initialValue: email,
                            validate: function(values) {
                                var emailErrors = utils_validate.email(values);
                                if (emailErrors.email) {
                                    setError({
                                        key: "email",
                                        value: emailErrors.email
                                    });
                                } else {
                                    deleteError({
                                        key: "email"
                                    });
                                }
                                return emailErrors;
                            },
                            value: email,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Email",
                                    name: "email",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value
                                        });
                                    },
                                    value: email,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "pincode",
                            initialValue: pincode,
                            validate: function(values) {
                                var pincodeErrors = utils_validate.pincode(values);
                                if (pincodeErrors.pincode) {
                                    setError({
                                        key: "pincode",
                                        value: pincodeErrors.pincode
                                    });
                                } else {
                                    deleteError({
                                        key: "pincode"
                                    });
                                }
                                return pincodeErrors;
                            },
                            value: pincode,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Pincode",
                                    name: "pincode",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value
                                        });
                                    },
                                    value: pincode,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "address",
                            initialValue: address,
                            validate: function(values) {
                                var addressErrors = utils_validate.address(values);
                                if (addressErrors.address) {
                                    setError({
                                        key: "address",
                                        value: addressErrors.address
                                    });
                                } else {
                                    deleteError({
                                        key: "address"
                                    });
                                }
                                return addressErrors;
                            },
                            value: address,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Address",
                                    name: "address",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value
                                        });
                                    },
                                    value: address,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(radioField, {
                            field: "Vehicle type?",
                            selectedValue: vehicleType,
                            name: "vehicleType",
                            setValue: function(selection, key) {
                                resetMmv();
                                setFormData({
                                    key: key,
                                    value: selection
                                });
                                if (selection.value === "tractor") {
                                    setError({
                                        key: "numberOfTrailers",
                                        value: "Number of trailers is required"
                                    });
                                } else {
                                    setFormData({
                                        key: "numberOfTrailers",
                                        value: null
                                    });
                                    deleteError({
                                        key: "numberOfTrailers"
                                    });
                                }
                            },
                            options: [
                                {
                                    value: "pcv",
                                    displayValue: "PCV"
                                },
                                {
                                    value: "gcv",
                                    displayValue: "GCV"
                                },
                                {
                                    value: "tractor",
                                    displayValue: "Tractor"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(inputField, {
                            name: "make",
                            style: {
                                width: "100px"
                            },
                            handleClick: function() {
                                setMmvType("make");
                                setShowMmvModal(true);
                            },
                            placeholder: "Select make and model",
                            value: (ref = state["make"]) === null || ref === void 0 ? void 0 : ref.name,
                            // handleBlur={() => setTouched(true)}
                            readOnly: true,
                            hideLabelText: showError && (errors === null || errors === void 0 ? void 0 : errors.make),
                            inputContainerStyles: {
                                marginTop: "1.5rem",
                                height: "50px",
                                marginBottom: showError && (errors === null || errors === void 0 ? void 0 : errors.make) && "1.5rem"
                            },
                            showError: showError && (errors === null || errors === void 0 ? void 0 : errors.make),
                            errors: {
                                make: errors === null || errors === void 0 ? void 0 : errors.make
                            },
                            touched: {},
                            dropdown: true,
                            pb: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(inputField, {
                            name: "model",
                            style: {
                                width: "100px"
                            },
                            handleClick: function() {
                                setMmvType("model");
                                setShowMmvModal(true);
                            },
                            placeholder: "Select fuel type",
                            value: (ref1 = state["model"]) === null || ref1 === void 0 ? void 0 : ref1.name,
                            readOnly: true,
                            hideLabelText: showError && (errors === null || errors === void 0 ? void 0 : errors.model),
                            inputContainerStyles: {
                                marginTop: "1.5rem",
                                height: "50px",
                                marginBottom: showError && (errors === null || errors === void 0 ? void 0 : errors.model) && "1.5rem"
                            },
                            showError: showError && (errors === null || errors === void 0 ? void 0 : errors.model),
                            errors: {
                                model: errors === null || errors === void 0 ? void 0 : errors.model
                            },
                            touched: {},
                            dropdown: true,
                            pb: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(inputField, {
                            name: "variant",
                            style: {
                                width: "100px"
                            },
                            handleClick: function() {
                                setMmvType("variant");
                                setShowMmvModal(true);
                            },
                            placeholder: "Select variant",
                            value: (ref2 = state["variant"]) === null || ref2 === void 0 ? void 0 : ref2.name,
                            // handleBlur={() => setTouched(true)}
                            readOnly: true,
                            hideLabelText: showError && (errors === null || errors === void 0 ? void 0 : errors.variant),
                            inputContainerStyles: {
                                marginTop: "1.5rem",
                                height: "50px",
                                marginBottom: showError && (errors === null || errors === void 0 ? void 0 : errors.variant) && "1.5rem"
                            },
                            showError: showError && (errors === null || errors === void 0 ? void 0 : errors.variant),
                            errors: {
                                variant: errors === null || errors === void 0 ? void 0 : errors.variant
                            },
                            touched: {},
                            dropdown: true,
                            pb: true
                        }),
                        (vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value) === "tractor" && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(inputField, {
                            errors: {
                                numberOfTrailers: errors === null || errors === void 0 ? void 0 : errors.numberOfTrailers
                            },
                            placeholder: "Number of trailers",
                            name: "numberOfTrailers",
                            value: numberOfTrailers,
                            handleClick: function() {
                                setShowTrailersModal(true);
                            },
                            touched: {},
                            showError: showError && (errors === null || errors === void 0 ? void 0 : errors.numberOfTrailers),
                            readOnly: true,
                            dropdown: true,
                            className: "fs-exclude"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            id: "trailersInfo",
                            children: (vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value) === "tractor" && numberOfTrailers && numberOfTrailers > 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: trailersInfo === null || trailersInfo === void 0 ? void 0 : trailersInfo.map(function(trailer, i) {
                                    var ref, ref1, ref2;
                                    var registrationNumber = trailer.registrationNumber, chassisNumber = trailer.chassisNumber, label = trailer.label, id = trailer.id, type = trailer.type;
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(trailerInputGroup, {
                                        id: id,
                                        registrationNumber: registrationNumber,
                                        chassisNumber: chassisNumber,
                                        type: type,
                                        setTrailerInfo: setTrailerInfo,
                                        // Passing error messages seperatley to avaoid re-render of child component
                                        // Re-render will happen if object is passed
                                        registrationNumberError: (ref = trailerInfoErrors[i]) === null || ref === void 0 ? void 0 : ref.registrationNumber,
                                        chassisNumberError: (ref1 = trailerInfoErrors[i]) === null || ref1 === void 0 ? void 0 : ref1.chassisNumber,
                                        typeError: (ref2 = trailerInfoErrors[i]) === null || ref2 === void 0 ? void 0 : ref2.type,
                                        showError: showError,
                                        label: label,
                                        setError: setTrailerInfoError,
                                        deleteError: deleteTrailerInfoError
                                    }, id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "registrationNumber",
                            initialValue: registrationNumber,
                            validate: function(values) {
                                var registrationNumberErrors = utils_validate.registrationNumber(values);
                                if (registrationNumberErrors.registrationNumber) {
                                    setError({
                                        key: "registrationNumber",
                                        value: registrationNumberErrors.registrationNumber
                                    });
                                } else {
                                    deleteError({
                                        key: "registrationNumber"
                                    });
                                }
                                return registrationNumberErrors;
                            },
                            value: registrationNumber,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Registration number",
                                    name: "registrationNumber",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value === null || value === void 0 ? void 0 : value.toUpperCase()
                                        });
                                    },
                                    value: registrationNumber,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "registrationYearMonth",
                            initialValue: registrationYear || registrationMonth ? " ".concat(registrationYear, " ").concat(registrationMonth) : "",
                            validate: function() {
                                return {};
                            },
                            value: registrationYear || registrationMonth ? "".concat(registrationYear, " ").concat(registrationMonth) : "",
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            readOnly: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Registration year and month",
                                    name: "registrationYearMonth",
                                    readOnly: true,
                                    handleClick: function() {
                                        setShowRegistrationYearMonthCalendar(true);
                                    },
                                    value: registrationYear || registrationMonth ? "".concat(registrationYear, " ").concat(registrationMonth) : "",
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "engineNumber",
                            initialValue: engineNumber,
                            validate: function(values) {
                                var engineNumberErrors = utils_validate.engineNumber(values);
                                if (engineNumberErrors.engineNumber) {
                                    setError({
                                        key: "engineNumber",
                                        value: engineNumberErrors.engineNumber
                                    });
                                } else {
                                    deleteError({
                                        key: "engineNumber"
                                    });
                                }
                                return engineNumberErrors;
                            },
                            value: engineNumber,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Engine/motor number",
                                    name: "engineNumber",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value === null || value === void 0 ? void 0 : value.toUpperCase()
                                        });
                                    },
                                    value: engineNumber,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "chassisNumber",
                            initialValue: chassisNumber,
                            validate: function(values) {
                                var chassisNumberErrors = utils_validate.chassisNumber(values);
                                if (chassisNumberErrors.chassisNumber) {
                                    setError({
                                        key: "chassisNumber",
                                        value: chassisNumberErrors.chassisNumber
                                    });
                                } else {
                                    deleteError({
                                        key: "chassisNumber"
                                    });
                                }
                                return chassisNumberErrors;
                            },
                            value: chassisNumber,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Chassis number",
                                    name: "chassisNumber",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value === null || value === void 0 ? void 0 : value.toUpperCase()
                                        });
                                    },
                                    value: chassisNumber,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(radioField, {
                            field: "Is vehicle financed?",
                            selectedValue: isVehicleFinanced,
                            name: "isVehicleFinanced",
                            setValue: function(selection, key) {
                                setFormData({
                                    key: "financierName",
                                    value: ""
                                });
                                if ((selection === null || selection === void 0 ? void 0 : selection.displayValue) === "Yes") {
                                    setError({
                                        key: "financierName",
                                        value: "Financier name is required"
                                    });
                                } else {
                                    deleteError({
                                        key: "financierName"
                                    });
                                }
                                setFormData({
                                    key: key,
                                    value: selection
                                });
                            },
                            options: [
                                {
                                    value: "0",
                                    displayValue: "No"
                                },
                                {
                                    value: "1",
                                    displayValue: "Yes"
                                }, 
                            ]
                        }),
                        (isVehicleFinanced === null || isVehicleFinanced === void 0 ? void 0 : isVehicleFinanced.displayValue) === "Yes" && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "financierName",
                            initialValue: financierName,
                            validate: function(values) {
                                var financierNameErrors = utils_validate.financierName(values);
                                if (financierNameErrors.financierName) {
                                    setError({
                                        key: "financierName",
                                        value: financierNameErrors.financierName
                                    });
                                } else {
                                    deleteError({
                                        key: "financierName"
                                    });
                                }
                                return financierNameErrors;
                            },
                            value: financierName,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Financier name",
                                    name: "financierName",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value
                                        });
                                    },
                                    value: financierName,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(radioField, {
                            field: "Is previous policy expired?",
                            selectedValue: isPreviousPolicyExpired,
                            name: "isPreviousPolicyExpired",
                            setValue: function(selection, key) {
                                setFormData({
                                    key: key,
                                    value: selection
                                });
                            },
                            options: [
                                {
                                    value: "1",
                                    displayValue: "Yes"
                                },
                                {
                                    value: "0",
                                    displayValue: "No",
                                    isDisabled: true
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            style: {
                                marginTop: "1.5rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                                title: "Previous policy expiry date",
                                defaultDate: previousPolicyExpiryDate,
                                onSelect: function(date) {
                                    setFormData({
                                        key: "previousPolicyExpiryDate",
                                        value: date
                                    });
                                },
                                enableWindow: {
                                    start: (isPreviousPolicyExpired === null || isPreviousPolicyExpired === void 0 ? void 0 : isPreviousPolicyExpired.displayValue) === "Yes" ? new Date(new Date().setFullYear(new Date().getFullYear() - 10)) : new Date(new Date().setDate(new Date().getDate() - 1)),
                                    current: new Date(new Date().setDate(new Date().getDate() - 1)),
                                    end: (isPreviousPolicyExpired === null || isPreviousPolicyExpired === void 0 ? void 0 : isPreviousPolicyExpired.displayValue) === "Yes" ? new Date(new Date().setDate(new Date().getDate() - 1)) : new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                                },
                                isDesktop: !isMobile
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(radioField, {
                            field: "Claimed in previous policy?",
                            selectedValue: claimedInPreviousPolicy,
                            name: "claimedInPreviousPolicy",
                            setValue: function(selection, key) {
                                setFormData({
                                    key: key,
                                    value: selection
                                });
                            },
                            options: [
                                {
                                    value: "0",
                                    displayValue: "No"
                                },
                                {
                                    value: "1",
                                    displayValue: "Yes"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "previousPolicyInsurer",
                            initialValue: previousPolicyInsurer,
                            validate: function(values) {
                                var previousPolicyInsurerErrors = utils_validate.previousPolicyInsurer(values);
                                if (previousPolicyInsurerErrors.previousPolicyInsurer) {
                                    setError({
                                        key: "previousPolicyInsurer",
                                        value: previousPolicyInsurerErrors.previousPolicyInsurer
                                    });
                                } else {
                                    deleteError({
                                        key: "previousPolicyInsurer"
                                    });
                                }
                                return previousPolicyInsurerErrors;
                            },
                            value: previousPolicyInsurer,
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            customInput: function(_param) {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    showError: showError,
                                    setShowError: setShowError,
                                    placeholder: "Previous policy insurer",
                                    name: "previousPolicyInsurer",
                                    onChange: function(value, name) {
                                        setFormData({
                                            key: name,
                                            value: value === null || value === void 0 ? void 0 : value.toUpperCase()
                                        });
                                    },
                                    value: previousPolicyInsurer,
                                    className: "fs-exclude"
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(inputField, {
                            name: "addonCovers",
                            style: {
                                width: "100px"
                            },
                            handleClick: function() {
                                return setShowAddonsModal(true);
                            },
                            placeholder: "Add add-on covers",
                            value: (selectedAddons === null || selectedAddons === void 0 ? void 0 : selectedAddons.length) ? "".concat(selectedAddons.length, " selected") : "",
                            readOnly: true,
                            inputContainerStyles: {
                                marginTop: "1.5rem",
                                height: "50px"
                            },
                            errors: {},
                            touched: {},
                            dropdown: true,
                            pb: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SelectedAddonsSummary, {
                            selectedAddons: selectedAddons !== null && selectedAddons !== void 0 ? selectedAddons : []
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(inputField, {
                            errors: {},
                            placeholder: "Policy start date",
                            name: "policyStartDate",
                            value: formatDate(policyStartDate),
                            readOnly: true,
                            calendar: true,
                            className: "fs-exclude"
                        }),
                        showPremiumBreakdown && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownBox, {
                            children: [
                                hasApiPricing && ((ref14 = quotePlan === null || quotePlan === void 0 ? void 0 : (ref3 = quotePlan.covers) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref14 !== void 0 ? ref14 : 0) > 0 && ((ref15 = quotePlan === null || quotePlan === void 0 ? void 0 : quotePlan.covers) !== null && ref15 !== void 0 ? ref15 : []).map(function(c, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                children: (_name = c.name) !== null && _name !== void 0 ? _name : "Base third-party premium"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                children: formatAddonRupee((ref16 = (_netPremium = c.price.netPremium) !== null && _netPremium !== void 0 ? _netPremium : c.price.grossPremium) !== null && ref16 !== void 0 ? ref16 : 0)
                                            })
                                        ]
                                    }, (_name1 = c.name) !== null && _name1 !== void 0 ? _name1 : "cover_".concat(idx));
                                }),
                                !hasApiPricing && totalAmount != null && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: "Base third-party premium"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: formatAddonRupee(totalAmount)
                                        })
                                    ]
                                }),
                                (quotePlan === null || quotePlan === void 0 ? void 0 : (ref4 = quotePlan.addons) === null || ref4 === void 0 ? void 0 : ref4.length) ? quotePlan.addons.map(function(line) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                                children: [
                                                    formatAddonDisplayName((_name2 = line.name) !== null && _name2 !== void 0 ? _name2 : ""),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                children: formatAddonRupee((_price = line.price) !== null && _price !== void 0 ? _price : 0)
                                            })
                                        ]
                                    }, (ref17 = (_addonId = line.addonId) !== null && _addonId !== void 0 ? _addonId : line.name) !== null && ref17 !== void 0 ? ref17 : "");
                                }) : (selectedAddons !== null && selectedAddons !== void 0 ? selectedAddons : []).map(function(addon) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                                                children: [
                                                    formatAddonDisplayName(addon.name),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                children: formatAddonRupee((_price1 = addon.price) !== null && _price1 !== void 0 ? _price1 : 0)
                                            })
                                        ]
                                    }, addon.id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: "Subtotal (excl. GST)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: formatAddonRupee(subtotalExclGst)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: "Total GST"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: formatAddonRupee(gstAmount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PremiumBreakdownTotal, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: "Total payable (incl. GST)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            children: formatAddonRupee(grandTotalInclGst)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_form_dist_default()), {
                            name: "totalAmount",
                            initialValue: grandTotalInclGst ? grandTotalInclGst.toString() : "",
                            validate: function() {
                                return {};
                            },
                            value: grandTotalInclGst ? grandTotalInclGst.toString() : "",
                            handleNext: function() {
                                return null;
                            },
                            buttonText: "",
                            validateOnBlur: true,
                            type: "number",
                            readOnly: true,
                            customInput: function(_param) /*#__PURE__*/ {
                                var formikErrors = _param.errors, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "errors"
                                ]);
                                return (0,jsx_runtime/* jsx */.tZ)(inputField, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    errors: (0,src_object_spread/* default */.Z)({}, errors, formikErrors)
                                }, props), {
                                    // showError={showError}
                                    // setShowError={setShowError}
                                    placeholder: "Total premium (incl. GST)",
                                    name: "totalAmount",
                                    // onChange={(value, name) => {
                                    //     setFormData({
                                    //         key: name,
                                    //         value,
                                    //     });
                                    // }}
                                    value: grandTotalInclGst ? grandTotalInclGst.toString() : "",
                                    className: "fs-exclude",
                                    type: "number",
                                    readOnly: true
                                }));
                            },
                            enableReinitialize: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                            header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalHeading, {
                                children: getHeadingText(mmvType)
                            }),
                            maxWidth: "600px",
                            show: isMmvApiSuccess && showMmvModal && !!mmvType,
                            onHide: function() {
                                setShowMmvModal(false);
                            },
                            padding: isMobile ? "24px 20px 20px" : "32px",
                            showOverlayBackground: true,
                            wrapperStyles: {
                                padding: "32px 20px 20px",
                                maxHeight: "95vh",
                                borderRadius: "16px 16px 0px 0px"
                            },
                            styles: {
                                minWidth: "500px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MmvOptions, {
                                handleClick: function(options) {
                                    var value = options.value, type = options.type;
                                    setFormData({
                                        key: type,
                                        value: value
                                    });
                                    deleteError({
                                        key: type
                                    });
                                    handleNextModal({
                                        type: mmvType,
                                        setMmvType: setMmvType
                                    });
                                },
                                queryType: mmvType,
                                fuelType: fuelType,
                                popularVehicles: popularVehicles,
                                vehicles: vehicles,
                                variantType: variantTypes,
                                vehicleType: vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.value
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                            header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalHeading, {
                                children: "Select add-on covers"
                            }),
                            maxWidth: "600px",
                            show: showAddonsModal,
                            onHide: function() {
                                setShowAddonsModal(false);
                            },
                            padding: isMobile ? "24px 20px 20px" : "32px",
                            showOverlayBackground: true,
                            wrapperStyles: {
                                padding: "32px 20px 20px",
                                maxHeight: "95vh",
                                borderRadius: "16px 16px 0px 0px"
                            },
                            styles: {
                                minWidth: "500px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AddonsOptions, {
                                addons: addonsCatalog,
                                selectedIds: selectedAddonIds,
                                onAdd: function(addon) {
                                    if (selectedAddonIds.has(addon.id)) return;
                                    setFormData({
                                        key: "selectedAddons",
                                        value: (0,_to_consumable_array/* default */.Z)(selectedAddons !== null && selectedAddons !== void 0 ? selectedAddons : []).concat([
                                            addon
                                        ])
                                    });
                                },
                                onRemove: function(id) {
                                    setFormData({
                                        key: "selectedAddons",
                                        value: (selectedAddons !== null && selectedAddons !== void 0 ? selectedAddons : []).filter(function(a) {
                                            return a.id !== id;
                                        })
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                            header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalHeading, {
                                children: "Select registration year and month"
                            }),
                            maxWidth: "600px",
                            show: showRegistrationyarMonthCalendar,
                            onHide: function() {
                                setShowRegistrationYearMonthCalendar(false);
                            },
                            padding: isMobile ? "24px 20px 20px" : "32px",
                            showOverlayBackground: true,
                            wrapperStyles: {
                                padding: "32px 20px 20px",
                                maxHeight: "95vh",
                                borderRadius: "16px 16px 0px 0px"
                            },
                            styles: {
                                minWidth: "500px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(yearMonthSelector, {
                                    showModal: showRegistrationyarMonthCalendar,
                                    setShowModal: setShowRegistrationYearMonthCalendar,
                                    monthOptions: months,
                                    yearOptions: years,
                                    activeMonth: registrationMonth,
                                    activeYear: registrationYear,
                                    setActiveMonth: function(value) {
                                        setFormData({
                                            key: "registrationMonth",
                                            value: value
                                        });
                                    },
                                    setActiveYear: function(value) {
                                        setFormData({
                                            key: "registrationYear",
                                            value: value
                                        });
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                            header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalHeading, {
                                children: "Select number of trailers"
                            }),
                            maxWidth: "600px",
                            show: showTrailersModal,
                            onHide: function() {
                                setShowTrailersModal(false);
                            },
                            padding: isMobile ? "24px 20px 20px" : "32px",
                            showOverlayBackground: true,
                            wrapperStyles: {
                                padding: "32px 20px 20px",
                                maxHeight: "95vh",
                                borderRadius: "16px 16px 0px 0px"
                            },
                            styles: {
                                minWidth: "500px"
                            },
                            children: (0,_to_consumable_array/* default */.Z)(Array(5).keys()).map(function(k) {
                                return k + 1;
                            }).map(function(trailer) {
                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Trailer, {
                                    onClick: function() {
                                        setFormData({
                                            key: "numberOfTrailers",
                                            value: trailer
                                        });
                                        deleteError({
                                            key: "numberOfTrailers"
                                        });
                                        setShowTrailersModal(false);
                                    },
                                    children: trailer
                                }, trailer);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                            header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalHeading, {
                                children: "Form submitted successfully"
                            }),
                            maxWidth: "600px",
                            show: showFormSuccessModal,
                            onHide: function() {},
                            padding: isMobile ? "24px 20px 20px" : "32px",
                            showOverlayBackground: true,
                            wrapperStyles: {
                                padding: "32px 20px 20px",
                                maxHeight: "95vh",
                                borderRadius: "16px 16px 0px 0px"
                            },
                            styles: {
                                minWidth: "500px"
                            },
                            disableOverlayClose: true,
                            hideCloseButton: true,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                style: {
                                    width: "100%",
                                    marginTop: "1rem"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                    onClick: function() {
                                        window.location.reload();
                                    },
                                    isFullWidth: true,
                                    children: "Punch new policy"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                        onClick: function() {
                            if ((0,generics/* isEmpty */.xb)(errors)) {
                                submitFormData();
                            } else {
                                dispatch({
                                    type: ACTIONS.SET_SHOW_ERROR,
                                    payload: true
                                });
                                setShouldScrollIntoView(true);
                            }
                        },
                        children: "Submit"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var dealerForm = (Form);

;// CONCATENATED MODULE: ./components/CommissionListingV1/styles.ts

function CommissionListingV1_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 20px 20px 20px;\n    max-width: ",
        ";\n    margin: 0 auto;\n\n    @media screen and (max-width: 769px) {\n        max-width: 100%;\n    }\n"
    ]);
    CommissionListingV1_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-bottom: 20px;\n    transform: translateX(-20px);\n"
    ]);
    CommissionListingV1_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n"
    ]);
    CommissionListingV1_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 8px;\n"
    ]);
    CommissionListingV1_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n"
    ]);
    CommissionListingV1_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    CommissionListingV1_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: white;\n    border-radius: 12px;\n    padding: 24px;\n    margin-top: 16px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n"
    ]);
    CommissionListingV1_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 16px;\n    align-items: flex-start;\n    flex-wrap: wrap;\n\n    @media screen and (max-width: 769px) {\n        flex-direction: column;\n    }\n"
    ]);
    CommissionListingV1_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n"
    ]);
    CommissionListingV1_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #666;\n    font-weight: 500;\n"
    ]);
    CommissionListingV1_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px;\n    background: white;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    min-height: 44px;\n\n    &:hover {\n        border-color: #ccc;\n    }\n\n    /* Override calendar component styles */\n    .calendar-input {\n        border: none;\n        background: transparent;\n        padding: 0;\n        font-size: 14px;\n        color: #333;\n        flex: 1;\n    }\n\n    .calendar-icon {\n        color: #666;\n    }\n"
    ]);
    CommissionListingV1_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n"
    ]);
    CommissionListingV1_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #666;\n    font-weight: 500;\n"
    ]);
    CommissionListingV1_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 12px;\n    background: white;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    min-height: 44px;\n\n    &:hover {\n        border-color: #ccc;\n    }\n"
    ]);
    CommissionListingV1_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    CommissionListingV1_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n"
    ]);
    CommissionListingV1_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    CommissionListingV1_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 8px;\n"
    ]);
    CommissionListingV1_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 8px;\n"
    ]);
    CommissionListingV1_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function CommissionListingV1_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #34a853;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 12px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n        background: #16a34a;\n    }\n\n    &:disabled {\n        background: #9ca3af;\n        cursor: not-allowed;\n    }\n"
    ]);
    CommissionListingV1_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n    display: flex;\n"
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: ",
        ";\n    margin: 10px 0;\n    ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 10px 0;\n    @media screen and (max-width: 769px) {\n        max-width: 180px;\n\n        margin: 0;\n    }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    line-height: 16px;\n    margin-top: 4px;\n    color: rgb(216, 61, 55);\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: '100%';\n    display: 'grid';\n    place-items: 'center';\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    gap: 10px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    border: none;\n    background: transparent;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n    margin-top: 8px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 16px 12px;\n    border: 1px solid ",
        ";\n    border-radius: 12px;\n    background: ",
        ";\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-height: 80px;\n\n    &:hover {\n        border-color: ",
        ";\n    }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 8px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 500;\n    color: ",
        ";\n    text-align: center;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    margin-top: 4px;\n    max-height: 300px;\n    overflow-y: auto;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    cursor: pointer;\n    background: ",
        ";\n    transition: background-color 0.2s ease;\n\n    &:hover {\n        background: #f9fafb;\n    }\n\n    &:first-child {\n        border-radius: 8px 8px 0 0;\n    }\n\n    &:last-child {\n        border-radius: 0 0 8px 8px;\n    }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 12px;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 8px;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    background-color: #f3f4f6;\n    border-radius: 8px;\n    padding: 4px;\n    width: fit-content;\n    margin: 32px auto;\n\n    @media screen and (max-width: 769px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 8px;\n    width: 200px;\n    background: ",
        ";\n    border: none;\n    color: ",
        ";\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    border-radius: 8px;\n    position: relative;\n    transition: all 0.2s ease;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #8b5cf6;\n    color: white;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    font-weight: 500;\n    padding: 2px;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: white;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 20px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #6b7280;\n    font-weight: 500;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    width: 100%;\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: flex-start;\n    padding: 20px;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    transition: all 0.2s ease;\n    position: relative;\n    margin-bottom: 16px;\n    opacity: ",
        ";\n    pointer-events: ",
        ";\n\n    @media screen and (max-width: 769px) {\n        flex-direction: column;\n        gap: 16px;\n        align-items: stretch;\n    }\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 10px;\n    font-weight: 500;\n    color: ",
        ";\n    background: ",
        ";\n    padding: 4px 10px;\n    border-radius: 12px;\n    white-space: nowrap;\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    color: rgb(115, 115, 115);\n    font-weight: 400;\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    color: #9ca3af;\n    font-weight: 400;\n    margin-top: 4px;\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 12px;\n    color: rgb(115, 115, 115);\n    font-weight: 400;\n    margin-top: 8px;\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 12px;\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    height: 6px;\n    background: #e5e7eb;\n    border-radius: 3px;\n    overflow: hidden;\n    width: 100%;\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100%;\n    background: #3b82f6;\n    width: ",
        "%;\n    transition: width 0.3s ease;\n    border-radius: 3px;\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-left: 16px;\n    margin: 0;\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background: white;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n        border-color: #d1d5db;\n        background: #f9fafb;\n        transform: translateY(-1px);\n    }\n\n    &:active {\n        transform: translateY(0);\n    }\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    border: unset;\n    background: #3b82f6;\n    color: white;\n    font-size: 12px;\n    border-radius: 6px;\n    padding: 4px 8px;\n    cursor: pointer;\n\n    &:hover {\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    }\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #666;\n    font-weight: 500;\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: 1fr;\n    margin-top: 8px;\n    gap: 12px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 12px;\n    background: white;\n    max-height: 200px;\n    overflow: scroll;\n\n    @media (min-width: 768px) {\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n    }\n"
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    text-transform: capitalize;\n    font-size: 14px;\n    gap: 4px;\n    color: #333;\n"
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    color: #666;\n"
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 8px 0;\n    max-width: 50%;\n\n    @media screen and (max-width: 768px) {\n        max-width: 100%;\n    }\n"
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}

var CommissionListingV1_styles_Wrapper = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject(), function(param) {
    var showHeader = param.showHeader;
    return showHeader ? "80%" : "100%";
});
var CommissionListingV1_styles_Hr = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject1());
var CommissionListingV1_styles_Header = styled_components_browser_esm["default"].header(CommissionListingV1_styles_templateObject2());
var HeaderTextWrapper = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject3());
var HeaderText = styled_components_browser_esm["default"].h3(CommissionListingV1_styles_templateObject4());
var HeaderIcon = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject5());
var MainCard = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject6());
var DateRangeContainer = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject7());
var DateField = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject8());
var DateLabel = styled_components_browser_esm["default"].label(CommissionListingV1_styles_templateObject9());
var DateInputWrapper = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject10());
var GroupByContainer = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject11());
var GroupByLabel = styled_components_browser_esm["default"].label(CommissionListingV1_styles_templateObject12());
var GroupByInputWrapper = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject13());
var GroupByIcon = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject14());
var GroupByText = styled_components_browser_esm["default"].span(CommissionListingV1_styles_templateObject15());
var DropdownIcon = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject16());
var GenerateButtonWrapper = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject17());
var ButtonIcon = styled_components_browser_esm["default"].div(CommissionListingV1_styles_templateObject18());
var GenerateButton = styled_components_browser_esm["default"].button(CommissionListingV1_styles_templateObject19());
var CommisionFilterWrapper = styled_components_browser_esm["default"].div(styles_templateObject20());
var DropDownBox = styled_components_browser_esm["default"].div(_templateObject21(), function(props) {
    return props.is_mobile ? "row" : "column";
}, function(props) {
    return props.is_mobile ? "justify-content: space-around;" : "align-items:center;";
});
var CalendarWrapper = styled_components_browser_esm["default"].div(_templateObject22());
var CommissionListingV1_styles_ErrorText = styled_components_browser_esm["default"].p(_templateObject23());
var ListingWrapper = styled_components_browser_esm["default"].div(_templateObject24());
var LoaderBox = styled_components_browser_esm["default"].div(_templateObject25());
var CommissionListingV1_styles_ButtonWrapper = styled_components_browser_esm["default"].footer(_templateObject26());
var FilterOptionButtonWrapper = styled_components_browser_esm["default"].button(_templateObject27());
// New styled components for Group By filter
var GroupByBoxesContainer = styled_components_browser_esm["default"].div(_templateObject28());
var GroupByBox = styled_components_browser_esm["default"].div(_templateObject29(), function(props) {
    return props.isSelected ? "#8b5cf6" : "#e0e0e0";
}, function(props) {
    return props.isSelected ? "#8b5cf6" : "white";
}, function(props) {
    return props.isSelected ? "#8b5cf6" : "#ccc";
});
var BoxIcon = styled_components_browser_esm["default"].div(_templateObject30());
var BoxText = styled_components_browser_esm["default"].span(_templateObject31(), function(props) {
    return props.isSelected ? "white" : "#333";
});
var GroupByDropdownContainer = styled_components_browser_esm["default"].div(_templateObject32());
var DropdownMenu = styled_components_browser_esm["default"].div(_templateObject33());
var DropdownItem = styled_components_browser_esm["default"].div(_templateObject34(), function(props) {
    return props.isSelected ? "#f3f4f6" : "white";
});
var DropdownItemIcon = styled_components_browser_esm["default"].div(_templateObject35());
var DropdownItemText = styled_components_browser_esm["default"].span(_templateObject36());
var DropdownCheckIcon = styled_components_browser_esm["default"].div(_templateObject37());
var NavigationTabs = styled_components_browser_esm["default"].div(_templateObject38());
var Tab = styled_components_browser_esm["default"].button(_templateObject39(), function(props) {
    return props.isActive ? "white" : "#f3f4f6";
}, function(props) {
    return props.isActive ? "#374151" : "#6b7280";
});
var TabIcon = styled_components_browser_esm["default"].div(_templateObject40());
var Badge = styled_components_browser_esm["default"].span(_templateObject41());
// Report History styled components
var ReportHistoryContainer = styled_components_browser_esm["default"].div(_templateObject42());
var ReportHistoryHeader = styled_components_browser_esm["default"].div(_templateObject43());
var ReportHistoryTitle = styled_components_browser_esm["default"].h3(_templateObject44());
var ReportHistoryCount = styled_components_browser_esm["default"].span(_templateObject45());
var ReportHistoryList = styled_components_browser_esm["default"].div(_templateObject46());
var ReportHeader = styled_components_browser_esm["default"].div(_templateObject47());
var ReportHistoryItem = styled_components_browser_esm["default"].div(_templateObject48(), function(props) {
    return props.isLoading ? 0.5 : 1;
}, function(props) {
    return props.isLoading ? "none" : "auto";
});
var ReportStatus = styled_components_browser_esm["default"].span(_templateObject49(), function(props) {
    return props.isComplete ? "#059669" : (props === null || props === void 0 ? void 0 : props.isFailed) ? "rgb(216, 61, 55)" : "#3b82f6";
}, function(props) {
    return props.isComplete ? "#d1fae5" : (props === null || props === void 0 ? void 0 : props.isFailed) ? "rgb(255 228 227)" : "#dbeafe";
});
var StatusIcon = styled_components_browser_esm["default"].div(_templateObject50());
var ReportDetails = styled_components_browser_esm["default"].div(_templateObject51());
var ReportTitle = styled_components_browser_esm["default"].h4(_templateObject52());
var ReportData = styled_components_browser_esm["default"].span(_templateObject53());
var ReportCreated = styled_components_browser_esm["default"].span(_templateObject54());
var ReportInfoText = styled_components_browser_esm["default"].span(_templateObject55());
var ProgressContainer = styled_components_browser_esm["default"].div(_templateObject56());
var ProgressBar = styled_components_browser_esm["default"].div(_templateObject57());
var ProgressFill = styled_components_browser_esm["default"].div(_templateObject58(), function(props) {
    return props.progress;
});
var ReportActions = styled_components_browser_esm["default"].div(_templateObject59());
var ActionButton = styled_components_browser_esm["default"].button(_templateObject60());
var RetryButton = styled_components_browser_esm["default"].button(_templateObject61());
var SecondaryFiltersWrapper = styled_components_browser_esm["default"].div(_templateObject62());
var SecondaryFiltersHeaderText = styled_components_browser_esm["default"].div(_templateObject63());
var SecondaryFiltersContainer = styled_components_browser_esm["default"].div(_templateObject64());
var SecondaryFilter = styled_components_browser_esm["default"].div(_templateObject65());
var styles_NoResult = styled_components_browser_esm["default"].div(_templateObject66());
var SearchWrapper = styled_components_browser_esm["default"].div(_templateObject67());

;// CONCATENATED MODULE: ./components/CommissionListingV1/config.ts
var DEFAULT_FILTERS = [
    {
        key: "TRANSACTION",
        display_name: "Transaction"
    },
    {
        key: "DATE",
        display_name: "Date"
    },
    {
        key: "MONTH",
        display_name: "Month"
    }, 
];
var FILTER_KEYS = {
    TRANSACTION: "TRANSACTION",
    DATE: "DATE",
    MONTH: "MONTH",
    SUB_DEALER: "SUB_DEALER",
    COUNTRY_STATE: "COUNTRY_STATE"
};
var NAVIGATION_TABS = {
    RESULTS: "results",
    HISTORY: "history"
};
var REPORT_STATUS = {
    FAILED: "FAILED",
    COMPLETED: "COMPLETED",
    PENDING: "PENDING",
    RUNNING: "RUNNING"
};
var ERROR_MESSAGES = {
    FETCH_COMMISSION_REPORTS_FAILED: "We're having trouble accessing the Commission results. Please try again in a few minutes.",
    FETCH_COMMISSION_REPORTS_HISTORY_FAILED: "We're having trouble accessing the Report history. Please try again in a few minutes.",
    DATE_RANGE_ERROR: "Please select a date range of 90 days or less for report generation",
    REPORT_DOWNLOAD_FAILED: "Failed to download the report.",
    REPORT_GENERATE_FAILED: "Failed to generate report.",
    GET_LATEST_STATUS_FAILED: "Failed to get latest status"
};
var SUCCESS_MESSAGES = {
    REPORT_GENERATED: "Report generation started.",
    REPORT_DOWNLOADED: "Report downloaded successfully",
    GET_LATEST_STATUS: "Getting latest status..."
};
var SNACKBAR_TYPES = {
    SUCCESS: "success",
    FAILURE: "failure"
};
var ERROR_TYPES = {
    API_ERROR: "API_ERROR",
    API_RESPONSE_ERROR: "API_RESPONSE_ERROR",
    VALIDATION_ERROR: "VALIDATION_ERROR"
};

;// CONCATENATED MODULE: ./components/CommissionListingV1/api.ts







var getCommissionSummary = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, request) {
        var response, data, status, e, ref, ref1, ref2, ref3, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/v1/reports/partner/").concat(partnerId, "/order/commission-summary")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: request
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        return [
                            2,
                            (0,src_object_spread/* default */.Z)({
                                status: true
                            }, data)
                        ];
                    }
                    return [
                        2,
                        (0,src_object_spread/* default */.Z)({
                            status: false
                        }, data)
                    ];
                case 2:
                    e = _state.sent();
                    console.log("Error while getting commission summary", e);
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    errorMessage = "";
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500) errorMessage = ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_FAILED;
                    else errorMessage = e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message;
                    return [
                        2,
                        {
                            status: false,
                            message: errorMessage
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCommissionSummary(partnerId, request) {
        return _ref.apply(this, arguments);
    };
}();
var getReportHistory = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(request) {
        var response, data, status, e, ref, ref1, ref2, ref3, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "GET",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/v1/reports/history")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: request
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        return [
                            2,
                            (0,src_object_spread/* default */.Z)({
                                status: true
                            }, data)
                        ];
                    }
                    return [
                        2,
                        (0,src_object_spread/* default */.Z)({
                            status: false
                        }, data)
                    ];
                case 2:
                    e = _state.sent();
                    console.log("Error while getting report history", e);
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    errorMessage = "";
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500) errorMessage = ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_HISTORY_FAILED;
                    else errorMessage = e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message;
                    return [
                        2,
                        {
                            status: false,
                            message: errorMessage
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getReportHistory(request) {
        return _ref.apply(this, arguments);
    };
}();
var downloadReportById = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(requestId) {
        var response, data, status, e, ref, ref1, ref2, ref3, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "GET",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/v1/reports/").concat(requestId, "/download")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        return [
                            2,
                            (0,src_object_spread/* default */.Z)({
                                status: true
                            }, data)
                        ];
                    }
                    return [
                        2,
                        (0,src_object_spread/* default */.Z)({
                            status: false
                        }, data)
                    ];
                case 2:
                    e = _state.sent();
                    console.log("Error while downloading report", e);
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    console.error("Error downloading report:", e);
                    errorMessage = "";
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500) errorMessage = ERROR_MESSAGES.REPORT_DOWNLOAD_FAILED;
                    else errorMessage = e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message;
                    return [
                        2,
                        {
                            status: false,
                            message: errorMessage
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function downloadReportById(requestId) {
        return _ref.apply(this, arguments);
    };
}();
var refetchReportStatus = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(requestId) {
        var response, data, status, e, ref, ref1, ref2, ref3, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "GET",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/v1/reports/").concat(requestId, "/status")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        return [
                            2,
                            (0,src_object_spread/* default */.Z)({
                                status: true
                            }, data)
                        ];
                    }
                    return [
                        2,
                        (0,src_object_spread/* default */.Z)({
                            status: false
                        }, data)
                    ];
                case 2:
                    e = _state.sent();
                    console.log("Error while refetching report status", e);
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    errorMessage = "";
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500) errorMessage = ERROR_MESSAGES.GET_LATEST_STATUS_FAILED;
                    else errorMessage = e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message;
                    return [
                        2,
                        {
                            status: false,
                            message: errorMessage
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function refetchReportStatus(requestId) {
        return _ref.apply(this, arguments);
    };
}();
var generateReport = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(request) {
        var response, data, status, e, ref, ref1, ref2, ref3, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/v1/reports/generate")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: request
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        return [
                            2,
                            (0,src_object_spread/* default */.Z)({
                                status: true
                            }, data)
                        ];
                    }
                    return [
                        2,
                        (0,src_object_spread/* default */.Z)({
                            status: false
                        }, data)
                    ];
                case 2:
                    e = _state.sent();
                    console.log("Error while generating report", e);
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    errorMessage = "";
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500) errorMessage = ERROR_MESSAGES.REPORT_GENERATE_FAILED;
                    else errorMessage = e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message;
                    return [
                        2,
                        {
                            status: false,
                            message: errorMessage
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function generateReport(request) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/CommissionListingV1/PaginatedTable/styles.ts

function PaginatedTable_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: white;\n    border-radius: 12px;\n    padding: 16px 0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e5e7eb;\n"
    ]);
    PaginatedTable_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    font-weight: 600;\n    color: #374151;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n        sans-serif;\n    margin: 0;\n"
    ]);
    PaginatedTable_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #6b7280;\n    font-weight: 400;\n    float: right;\n    margin-top: 4px;\n"
    ]);
    PaginatedTable_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    overflow-x: auto;\n"
    ]);
    PaginatedTable_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-collapse: collapse;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n        sans-serif;\n"
    ]);
    PaginatedTable_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: white;\n    padding: 12px 16px;\n    font-weight: 500;\n    font-size: 14px;\n    color: #374151;\n    border-bottom: 1px solid rgb(228, 228, 228);\n    text-align: left;\n\n    &:last-child {\n        text-align: right;\n    }\n"
    ]);
    PaginatedTable_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: white;\n\n    &:hover {\n        background-color: #f9fafb;\n    }\n"
    ]);
    PaginatedTable_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px 16px;\n    border-bottom: 1px solid #f3f3f3;\n    font-size: 14px;\n    color: #374151;\n    text-align: left;\n    white-space: nowrap;\n\n    &:last-child {\n        text-align: right;\n    }\n"
    ]);
    PaginatedTable_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #10b981;\n    font-weight: 500;\n"
    ]);
    PaginatedTable_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px 0 16px;\n    margin-top: 16px;\n"
    ]);
    PaginatedTable_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #6b7280;\n    font-weight: 400;\n\n    @media (max-width: 768px) {\n        font-size: 12px;\n        text-align: center;\n        max-width: 50%;\n    }\n"
    ]);
    PaginatedTable_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 8px;\n\n    @media (max-width: 768px) {\n        justify-content: space-between;\n        align-items: center;\n        gap: 4px;\n        width: 100%;\n    }\n"
    ]);
    PaginatedTable_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 8px 16px;\n    border: 1px solid #d1d5db;\n    background-color: ",
        ";\n    color: ",
        ";\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: ",
        ";\n    transition: all 0.2s ease;\n    white-space: nowrap;\n\n    &:hover {\n        ",
        "\n    }\n\n    &:disabled {\n        cursor: not-allowed;\n        opacity: 0.5;\n    }\n\n    @media (max-width: 768px) {\n        padding: 6px 10px;\n        font-size: 12px;\n    }\n"
    ]);
    PaginatedTable_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    PaginatedTable_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-transform: lowercase;\n"
    ]);
    PaginatedTable_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function PaginatedTable_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid rgb(228, 228, 228);\n    padding: 0 16px 16px 16px;\n"
    ]);
    PaginatedTable_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}

var TableCard = styled_components_browser_esm["default"].div(PaginatedTable_styles_templateObject());
var TableTitle = styled_components_browser_esm["default"].h2(PaginatedTable_styles_templateObject1());
var TotalResults = styled_components_browser_esm["default"].span(PaginatedTable_styles_templateObject2());
var TableContainer = styled_components_browser_esm["default"].div(PaginatedTable_styles_templateObject3());
var StyledTable = styled_components_browser_esm["default"].table(PaginatedTable_styles_templateObject4());
var TableHeader = styled_components_browser_esm["default"].th(PaginatedTable_styles_templateObject5());
var TableRow = styled_components_browser_esm["default"].tr(PaginatedTable_styles_templateObject6());
var TableData = styled_components_browser_esm["default"].td(PaginatedTable_styles_templateObject7());
var CommissionValue = styled_components_browser_esm["default"].span(PaginatedTable_styles_templateObject8());
var PaginationContainer = styled_components_browser_esm["default"].div(PaginatedTable_styles_templateObject9());
var PaginationInfo = styled_components_browser_esm["default"].span(PaginatedTable_styles_templateObject10());
var PaginationButtons = styled_components_browser_esm["default"].div(PaginatedTable_styles_templateObject11());
var PageButton = styled_components_browser_esm["default"].button(PaginatedTable_styles_templateObject12(), function(props) {
    return props.isActive ? "#f3f4f6" : "white";
}, function(props) {
    return props.isActive ? "#374151" : "#6b7280";
}, function(props) {
    return props.isActive ? "pointer" : "not-allowed";
}, function(props) {
    return props.isActive && "\n            border-color: #9ca3af;\n            background-color: #f9fafb;\n        ";
});
var PaginatedTable_styles_NoResult = styled_components_browser_esm["default"].div(PaginatedTable_styles_templateObject13());
var FilterText = styled_components_browser_esm["default"].span(PaginatedTable_styles_templateObject14());
var TableHead = styled_components_browser_esm["default"].div(PaginatedTable_styles_templateObject15());

;// CONCATENATED MODULE: ./components/CommissionListingV1/PaginatedTable/index.tsx




var PaginatedTable = function(props) {
    var activeFilter = props.activeFilter, headers = props.headers, data = props.data, totalPages = props.totalPages, onNext = props.onNext, onBack = props.onBack, currentPage = props.currentPage, totalResults = props.totalResults;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var formatCurrency = function(value) {
        if (typeof value === "string") {
            if (value.includes("₹")) return value;
            var num = parseFloat(value);
            if (!Number.isNaN(num)) {
                return new Intl.NumberFormat("en-IN", {
                    style: "currency",
                    currency: "INR"
                }).format(num);
            }
            return value;
        }
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR"
        }).format(value);
    };
    var formatDate = function(value) {
        if (typeof value === "string") {
            // If it's already in YYYY-MM-DD format, return as is
            if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
            // Try to parse and format
            var date = new Date(value);
            if (!Number.isNaN(date.getTime())) {
                return date.toISOString().split("T")[0];
            }
            return value;
        }
        return value;
    };
    var isCommissionColumn = function(headerKey) {
        return headerKey.toLowerCase().includes("commission") || headerKey.toLowerCase().includes("earned");
    };
    var isDateColumn = function(headerKey) {
        return headerKey.toLowerCase().includes("date");
    };
    var isCurrencyColumn = function(headerKey) {
        return headerKey.toLowerCase().includes("cost") || headerKey.toLowerCase().includes("amount") || headerKey.toLowerCase().includes("price");
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: data.length === 0 && activeFilter !== "TRANSACTION" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_styles_NoResult, {
            children: "No commissions"
        }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableHead, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableTitle, {
                            children: [
                                "Commission Results by ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterText, {
                                    children: activeFilter.toLowerCase()
                                })
                            ]
                        }),
                        totalResults && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TotalResults, {
                            children: [
                                totalResults,
                                " ",
                                "total results"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StyledTable, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tr", {
                                    children: headers === null || headers === void 0 ? void 0 : headers.map(function(header) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeader, {
                                            children: header.name
                                        }, header.key);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tbody", {
                                children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(TableRow, {
                                        children: headers === null || headers === void 0 ? void 0 : headers.map(function(header) {
                                            var value = item[header.key];
                                            var displayValue = value;
                                            if (isDateColumn(header.key)) {
                                                displayValue = formatDate(value);
                                            } else if (isCurrencyColumn(header.key) || isCommissionColumn(header.key)) {
                                                displayValue = formatCurrency(value);
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableData, {
                                                children: isCommissionColumn(header.key) ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionValue, {
                                                    children: displayValue
                                                }) : displayValue
                                            }, header.key);
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginationContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaginationButtons, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PageButton, {
                                onClick: onBack,
                                disabled: currentPage === 1,
                                isActive: currentPage > 1,
                                children: [
                                    "< ",
                                    "Previous"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaginationInfo, {
                                children: [
                                    "Page ",
                                    currentPage,
                                    " of ",
                                    totalPages,
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                    "(",
                                    data.length,
                                    " of",
                                    " ",
                                    totalResults || "unknown",
                                    " results)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PageButton, {
                                onClick: onNext,
                                disabled: currentPage === totalPages,
                                isActive: currentPage < totalPages,
                                children: [
                                    "Next",
                                    " >"
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaginationContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaginationInfo, {
                            children: [
                                "Page ",
                                currentPage,
                                " of ",
                                totalPages,
                                " (showing",
                                " ",
                                data.length,
                                " of ",
                                totalResults || "unknown",
                                " ",
                                "results)"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaginationButtons, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PageButton, {
                                    onClick: onBack,
                                    disabled: currentPage === 1,
                                    isActive: currentPage > 1,
                                    children: [
                                        "< ",
                                        "Previous"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PageButton, {
                                    onClick: onNext,
                                    disabled: currentPage === totalPages,
                                    isActive: currentPage < totalPages,
                                    children: [
                                        "Next",
                                        " >"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CommissionListingV1_PaginatedTable = (PaginatedTable);

;// CONCATENATED MODULE: ./components/CommissionListingV1/ConfirmationPopup/styles.ts

function ConfirmationPopup_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 20px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n    line-height: 1.4;\n\n    @media screen and (max-width: 769px) {\n        font-size: 18px;\n    }\n"
    ]);
    ConfirmationPopup_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmationPopup_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n"
    ]);
    ConfirmationPopup_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConfirmationPopup_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #666;\n    line-height: 1.5;\n    margin: 0;\n    text-align: center;\n"
    ]);
    ConfirmationPopup_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConfirmationPopup_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    margin-top: 8px;\n"
    ]);
    ConfirmationPopup_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var ModalTitle = styled_components_browser_esm["default"].h2(ConfirmationPopup_styles_templateObject());
var ModalContent = styled_components_browser_esm["default"].div(ConfirmationPopup_styles_templateObject1());
var ModalDescription = styled_components_browser_esm["default"].p(ConfirmationPopup_styles_templateObject2());
var ConfirmationPopup_styles_ButtonContainer = styled_components_browser_esm["default"].div(ConfirmationPopup_styles_templateObject3());

;// CONCATENATED MODULE: ./components/CommissionListingV1/ConfirmationPopup/index.tsx







var ConfirmationPopup = function(param) {
    var show = param.show, handleSubmit = param.handleSubmit, sendSegmentEvent = param.sendSegmentEvent, userDetails = param.userDetails;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    (0,compat_module.useEffect)(function() {
        if (show) {
            sendSegmentEvent(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
                view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE,
                page_type: constants/* SegmentEventPages.GENERATE_REPORT_INFO_POPUP */.g0.GENERATE_REPORT_INFO_POPUP
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
        urlhash: "",
        show: show,
        onHide: handleSubmit,
        padding: isMobile ? "24px 20px 20px" : "24px",
        showOverlayBackground: true,
        styles: {
            maxWidth: isMobile ? "100%" : "420px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ModalContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ModalDescription, {
                    children: [
                        "Your request has been received, allow us a moment to prepare your report. Please visit",
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("b", {
                            children: " 'Report History' "
                        }),
                        "to check the status of your report"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ConfirmationPopup_styles_ButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                        onClick: handleSubmit,
                        size: "large",
                        children: "OK"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CommissionListingV1_ConfirmationPopup = (ConfirmationPopup);

;// CONCATENATED MODULE: ./components/CommissionListingV1/ReportCard/index.tsx















var ReportCard = function(param) {
    var isLoading = param.isLoading, created_on = param.created_on, status = param.status, from_date = param.from_date, to_date = param.to_date, request_id = param.request_id, handleDownloadReport = param.handleDownloadReport, sendSegmentEvent = param.sendSegmentEvent;
    var ref = (0,compat_module.useState)(status), currentStatus = ref[0], setCurrentStatus = ref[1];
    var ref1 = (0,compat_module.useState)(isLoading), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref2[0], setSnackbar = ref2[1];
    var userDetails = (0,compat_module.useContext)(context/* MPosContext */.w).userDetails;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var isComplete = currentStatus === REPORT_STATUS.COMPLETED;
    var isProcessing = currentStatus === REPORT_STATUS.RUNNING;
    var isPending = currentStatus === REPORT_STATUS.PENDING;
    var isFailed = currentStatus === REPORT_STATUS.FAILED;
    (0,compat_module.useEffect)(function() {
        setCurrentStatus(status);
    }, [
        status
    ]);
    (0,compat_module.useEffect)(function() {
        setLoading(isLoading);
    }, [
        isLoading
    ]);
    var handleRefetchStatus = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var data, e, ref, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!request_id) return [
                            2
                        ];
                        setLoading(true);
                        sendSegmentEvent(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActions.TAP_REFRESH_BTN */.vn.TAP_REFRESH_BTN,
                            value: request_id,
                            view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            refetchReportStatus(request_id)
                        ];
                    case 2:
                        data = _state.sent();
                        if (data === null || data === void 0 ? void 0 : data.status) {
                            setSnackbar({
                                type: SNACKBAR_TYPES.SUCCESS,
                                message: SUCCESS_MESSAGES.GET_LATEST_STATUS
                            });
                            setCurrentStatus(data === null || data === void 0 ? void 0 : data.status);
                        } else {
                            setSnackbar({
                                type: SNACKBAR_TYPES.FAILURE,
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.GET_LATEST_STATUS_FAILED
                            });
                            sendSegmentEvent(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.GET_LATEST_STATUS_FAILED,
                                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                                action_name: constants/* SegmentEventActions.TAP_REFRESH_BTN */.vn.TAP_REFRESH_BTN,
                                view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                            }, {
                                userDetails: userDetails,
                                isMobile: isMobile
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setSnackbar({
                            type: SNACKBAR_TYPES.FAILURE,
                            message: (e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || ERROR_MESSAGES.GET_LATEST_STATUS_FAILED
                        });
                        sendSegmentEvent(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                            message: (e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || ERROR_MESSAGES.GET_LATEST_STATUS_FAILED,
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActions.TAP_REFRESH_BTN */.vn.TAP_REFRESH_BTN,
                            view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        console.log("Error while refetching status", e);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRefetchStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportHistoryItem, {
                isLoading: loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportDetails, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ReportTitle, {
                                        children: "Commission Report"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportStatus, {
                                        isComplete: isComplete,
                                        isFailed: isFailed,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StatusIcon, {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                    src: (0,generics/* getImageBasePath */.m4)(isComplete ? "/icons/greenTick.svg" : isFailed ? "/icons/cross.svg" : "/icons/clock-icon.svg"),
                                                    alt: "",
                                                    width: "14px",
                                                    height: "14px"
                                                })
                                            }),
                                            currentStatus
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ReportData, {
                                children: "Report duration: ".concat(new Date(from_date).toLocaleDateString("en-IN"), " to ").concat(new Date(to_date).toLocaleDateString("en-IN"))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportCreated, {
                                children: [
                                    "Created on: ",
                                    new Date(created_on).toLocaleDateString("en-IN")
                                ]
                            }),
                            (isPending || isProcessing) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ReportInfoText, {
                                children: "Generating report."
                            }),
                            isComplete && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ReportInfoText, {
                                children: "Note: The data is 1 hour behind real-time"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportActions, {
                        children: [
                            isComplete && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ActionButton, {
                                title: "Download Report",
                                onClick: function() {
                                    return handleDownloadReport(request_id);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    src: (0,generics/* getImageBasePath */.m4)("/icons/download.svg"),
                                    alt: "",
                                    width: "16px",
                                    height: "16px"
                                })
                            }),
                            (isProcessing || isPending) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RetryButton, {
                                title: "Get latest status",
                                onClick: function() {
                                    return handleRefetchStatus();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                        src: (0,generics/* getImageBasePath */.m4)("/icons/refresh-icon.svg"),
                                        alt: "",
                                        width: "14px",
                                        height: "14px"
                                    }),
                                    "Refresh Status"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var CommissionListingV1_ReportCard = (ReportCard);

;// CONCATENATED MODULE: ./components/CommissionListingV1/index.tsx


























var CommissionListingV1 = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var showHeader = props.showHeader;
    var ref7 = (0,compat_module.useState)({
        from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
        end: new Date()
    }), dateRange = ref7[0], setDateRange = ref7[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref8 = (0,compat_module.useState)(true), loader = ref8[0], setLoader = ref8[1];
    var ref9 = (0,compat_module.useState)(false), filterClicked = ref9[0], setFilterClicked = ref9[1];
    var ref10 = (0,compat_module.useState)("group_by"), selectedKey = ref10[0];
    var ref11 = (0,compat_module.useState)("DATE"), selectedFilterKey = ref11[0], setSelectedFilterKey = ref11[1];
    var ref12 = (0,compat_module.useState)(DEFAULT_FILTERS), filters = ref12[0], setFilters = ref12[1];
    var ref13 = (0,compat_module.useState)([]), secondaryFilters = ref13[0], setSecondaryFilters = ref13[1];
    var ref14 = (0,compat_module.useState)([]), selectedSecondaryFilters = ref14[0], setSelectedSecondaryFilters = ref14[1];
    var ref15 = (0,compat_module.useState)(0), page = ref15[0], setPage = ref15[1];
    var ref16 = (0,compat_module.useState)(null), pageData = ref16[0], setPageData = ref16[1];
    var ref17 = (0,compat_module.useState)(NAVIGATION_TABS.RESULTS), activeTab = ref17[0], setActiveTab = ref17[1];
    var ref18 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref18[0], setSnackbar = ref18[1];
    var ref19 = (0,compat_module.useState)(false), isApiTriggered = ref19[0], setIsApiTriggered = ref19[1];
    var ref20 = (0,compat_module.useState)(""), calendarError = ref20[0], setCalendarError = ref20[1];
    var ref21 = (0,compat_module.useState)(false), buttonLoader = ref21[0], setButtonLoader = ref21[1];
    var dropdownRef = (0,compat_module.useRef)(null);
    var ref22 = (0,compat_module.useState)(false), confirmationModalShow = ref22[0], setConfirmationModalShow = ref22[1];
    var ref23 = (0,compat_module.useState)([]), reportsHistory = ref23[0], setReportsHistory = ref23[1];
    var ref24 = (0,compat_module.useState)(""), searchText = ref24[0], setSearchText = ref24[1];
    var ref25 = (0,compat_module.useState)([]), secondaryFilteredList = ref25[0], setSecondaryFilteredList = ref25[1];
    var ref26 = (0,compat_module.useContext)(context/* MPosContext */.w), userDetails = ref26.userDetails, permissions = ref26.permissions;
    (0,compat_module.useEffect)(function() {
        if (true) {
            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
                page_type: constants/* SegmentEventPages.VIEW_PAGE */.g0.VIEW_PAGE,
                view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        window
    ]);
    var getSummary = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(page) {
            var _obj, request, data, ref, ref1, ref2, selectedFilter, selectedFilterValue, e, ref3, ref4, ref5, ref6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoader(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        request = (_obj = {
                            from_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.from),
                            to_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.end),
                            page: page
                        }, (0,_define_property/* default */.Z)(_obj, selectedKey, selectedFilterKey), (0,_define_property/* default */.Z)(_obj, "user_group_name", permissions.group), _obj);
                        return [
                            4,
                            getCommissionSummary(permissions.partner_id, request)
                        ];
                    case 2:
                        data = _state.sent();
                        if (data === null || data === void 0 ? void 0 : data.status) {
                            ;
                            selectedFilter = data === null || data === void 0 ? void 0 : (ref = data.filters_v2) === null || ref === void 0 ? void 0 : ref.find(function(filter) {
                                return (filter === null || filter === void 0 ? void 0 : filter.key) === selectedKey;
                            });
                            selectedFilterValue = selectedFilter === null || selectedFilter === void 0 ? void 0 : (ref1 = selectedFilter.values) === null || ref1 === void 0 ? void 0 : ref1.find(function(value) {
                                return (value === null || value === void 0 ? void 0 : value.key) === selectedFilterKey;
                            });
                            setFilters(data === null || data === void 0 ? void 0 : data.filters_v2);
                            if ((selectedFilterValue === null || selectedFilterValue === void 0 ? void 0 : (ref2 = selectedFilterValue.values) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
                                setSecondaryFilters(selectedFilterValue === null || selectedFilterValue === void 0 ? void 0 : selectedFilterValue.values);
                            } else {
                                setSecondaryFilters([]);
                            }
                            setPageData(data);
                        } else {
                            setSnackbar({
                                type: SNACKBAR_TYPES.FAILURE,
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_FAILED
                            });
                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_FAILED
                            }, {
                                userDetails: userDetails,
                                isMobile: isMobile
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setSnackbar({
                            type: SNACKBAR_TYPES.FAILURE,
                            message: (e === null || e === void 0 ? void 0 : (ref3 = e.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_FAILED
                        });
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                            message: (e === null || e === void 0 ? void 0 : (ref5 = e.response) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_FAILED
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoader(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getSummary(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var getReports = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var _obj, request, data, e, ref, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoader(true);
                        request = (_obj = {
                            from_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.from),
                            to_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.end)
                        }, (0,_define_property/* default */.Z)(_obj, selectedKey, selectedFilterKey), (0,_define_property/* default */.Z)(_obj, "sub_dealers", selectedFilterKey === FILTER_KEYS.SUB_DEALER ? selectedSecondaryFilters : []), (0,_define_property/* default */.Z)(_obj, "states", selectedFilterKey === FILTER_KEYS.COUNTRY_STATE ? selectedSecondaryFilters : []), (0,_define_property/* default */.Z)(_obj, "user_group_name", permissions.group), _obj);
                        return [
                            4,
                            getReportHistory(request)
                        ];
                    case 1:
                        data = _state.sent();
                        if (data === null || data === void 0 ? void 0 : data.status) setReportsHistory(data === null || data === void 0 ? void 0 : data.jobs);
                        else {
                            setSnackbar({
                                type: SNACKBAR_TYPES.FAILURE,
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_HISTORY_FAILED
                            });
                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_HISTORY_FAILED
                            }, {
                                userDetails: userDetails,
                                isMobile: isMobile
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        setSnackbar({
                            type: SNACKBAR_TYPES.FAILURE,
                            message: (e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_HISTORY_FAILED
                        });
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                            message: (e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || ERROR_MESSAGES.FETCH_COMMISSION_REPORTS_HISTORY_FAILED
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoader(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getReports() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,compat_module.useEffect)(function() {
        if (!isApiTriggered) {
            getSummary(0);
            setIsApiTriggered(true);
        }
    }, []);
    (0,compat_module.useEffect)(function() {
        if (activeTab === NAVIGATION_TABS.HISTORY) {
            getReports();
        }
    }, [
        activeTab
    ]);
    (0,compat_module.useEffect)(function() {
        if (isApiTriggered) {
            setPage(0);
            getSummary(0);
        }
    }, [
        selectedFilterKey
    ]);
    (0,compat_module.useEffect)(function() {
        if (isApiTriggered) {
            if (dateRange.from.getTime() > dateRange.end.getTime()) {
                setCalendarError("Start Date cannot be greater than End date");
            } else {
                setCalendarError("");
                getSummary(0);
            }
        }
    }, [
        dateRange
    ]);
    (0,compat_module.useEffect)(function() {
        if (isApiTriggered) {
            getSummary(page);
        }
    }, [
        page
    ]);
    (0,compat_module.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setFilterClicked(false);
            }
        };
        if (filterClicked) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        filterClicked
    ]);
    (0,compat_module.useEffect)(function() {
        if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) > 0) {
            var filteredList = secondaryFilters === null || secondaryFilters === void 0 ? void 0 : secondaryFilters.filter(function(filter) {
                var ref;
                var value = (filter === null || filter === void 0 ? void 0 : (ref = filter.display_name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
                var searchQuery = searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase();
                if ((value === null || value === void 0 ? void 0 : value.includes(searchQuery)) || (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.includes(value))) {
                    return true;
                }
                return false;
            });
            setSecondaryFilteredList(filteredList);
        } else {
            setSecondaryFilteredList(secondaryFilters);
        }
    }, [
        searchText,
        secondaryFilters
    ]);
    var onChange = function(e, id) {
        switch(id){
            case "from":
                setDateRange(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        from: e
                    });
                });
                break;
            case "end":
                setDateRange(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        end: e
                    });
                });
                break;
            default:
        }
    };
    var onNextPage = function() {
        setPage(page + 1);
    };
    var onPrevioudPage = function() {
        setPage(page - 1);
    };
    var handleGenerateReport = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, daysDifference, _obj, request, data, e, ref2, ref3, ref4, ref5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActions.TAP_GENERATE_BTN */.vn.TAP_GENERATE_BTN,
                            view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        setButtonLoader(true);
                        daysDifference = Math === null || Math === void 0 ? void 0 : Math.ceil(((dateRange === null || dateRange === void 0 ? void 0 : (ref = dateRange.end) === null || ref === void 0 ? void 0 : ref.getTime()) - (dateRange === null || dateRange === void 0 ? void 0 : (ref1 = dateRange.from) === null || ref1 === void 0 ? void 0 : ref1.getTime())) / (1000 * 60 * 60 * 24));
                        if (daysDifference > 90) {
                            setSnackbar({
                                type: SNACKBAR_TYPES.FAILURE,
                                message: ERROR_MESSAGES.DATE_RANGE_ERROR
                            });
                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                                message: ERROR_MESSAGES.DATE_RANGE_ERROR,
                                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                                action_name: constants/* SegmentEventActions.TAP_GENERATE_BTN */.vn.TAP_GENERATE_BTN
                            }, {
                                userDetails: userDetails,
                                isMobile: isMobile
                            });
                            setTimeout(function() {
                                return setButtonLoader(false);
                            }, 2000);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        request = (_obj = {
                            from_date: (0,date/* getYYYY_MM_DD */.a6)(dateRange === null || dateRange === void 0 ? void 0 : dateRange.from),
                            to_date: (0,date/* getYYYY_MM_DD */.a6)(dateRange === null || dateRange === void 0 ? void 0 : dateRange.end)
                        }, (0,_define_property/* default */.Z)(_obj, selectedKey, selectedFilterKey), (0,_define_property/* default */.Z)(_obj, "sub_dealers", selectedFilterKey === FILTER_KEYS.SUB_DEALER ? selectedSecondaryFilters : []), (0,_define_property/* default */.Z)(_obj, "states", selectedFilterKey === FILTER_KEYS.COUNTRY_STATE ? selectedSecondaryFilters : []), (0,_define_property/* default */.Z)(_obj, "user_group_name", permissions.group), _obj);
                        return [
                            4,
                            generateReport(request)
                        ];
                    case 2:
                        data = _state.sent();
                        if (data === null || data === void 0 ? void 0 : data.status) {
                            setConfirmationModalShow(true);
                            setTimeout(function() {
                                return setConfirmationModalShow(false);
                            }, 4000);
                            if (activeTab === NAVIGATION_TABS.HISTORY) getReports();
                        } else {
                            setSnackbar({
                                type: SNACKBAR_TYPES.FAILURE,
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.REPORT_GENERATE_FAILED
                            });
                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.REPORT_GENERATE_FAILED,
                                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                                action_name: constants/* SegmentEventActions.TAP_GENERATE_BTN */.vn.TAP_GENERATE_BTN
                            }, {
                                userDetails: userDetails,
                                isMobile: isMobile
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setSnackbar({
                            type: SNACKBAR_TYPES.FAILURE,
                            message: (e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || ERROR_MESSAGES.REPORT_GENERATE_FAILED
                        });
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                            message: (e === null || e === void 0 ? void 0 : (ref4 = e.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || ERROR_MESSAGES.REPORT_GENERATE_FAILED,
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActions.TAP_GENERATE_BTN */.vn.TAP_GENERATE_BTN
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        console.log("Error while generating report", e);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setButtonLoader(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGenerateReport() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownloadReport = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(requestId) {
            var data, e, ref, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setButtonLoader(true);
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActions.TAP_DOWNLOAD_BTN */.vn.TAP_DOWNLOAD_BTN,
                            value: requestId,
                            view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            downloadReportById(requestId)
                        ];
                    case 2:
                        data = _state.sent();
                        if ((data === null || data === void 0 ? void 0 : data.status) && (data === null || data === void 0 ? void 0 : data.downloadUrl) && "object" !== "undefined") {
                            setSnackbar({
                                type: SNACKBAR_TYPES.SUCCESS,
                                message: SUCCESS_MESSAGES.REPORT_DOWNLOADED
                            });
                            window === null || window === void 0 ? void 0 : window.open(data === null || data === void 0 ? void 0 : data.downloadUrl, "_blank");
                        } else {
                            setSnackbar({
                                type: SNACKBAR_TYPES.FAILURE,
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.REPORT_DOWNLOAD_FAILED
                            });
                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                                message: (data === null || data === void 0 ? void 0 : data.message) || ERROR_MESSAGES.REPORT_DOWNLOAD_FAILED,
                                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                                action_name: constants/* SegmentEventActions.TAP_DOWNLOAD_BTN */.vn.TAP_DOWNLOAD_BTN
                            }, {
                                userDetails: userDetails,
                                isMobile: isMobile
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setSnackbar({
                            type: SNACKBAR_TYPES.FAILURE,
                            message: (e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || ERROR_MESSAGES.REPORT_DOWNLOAD_FAILED
                        });
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.EXCEPTION */.Pg.EXCEPTION, {
                            message: (e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || ERROR_MESSAGES.REPORT_DOWNLOAD_FAILED,
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActions.TAP_DOWNLOAD_BTN */.vn.TAP_DOWNLOAD_BTN
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        console.log("Error while downloading report", e);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setButtonLoader(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownloadReport(requestId) {
            return _ref.apply(this, arguments);
        };
    }();
    var getSelectedFilterDisplayName = function() {
        var selectedFilter = filters === null || filters === void 0 ? void 0 : filters.find(function(filter) {
            return filter.key === selectedKey;
        });
        if (selectedFilter) {
            var ref;
            var selectedValueObj = selectedFilter === null || selectedFilter === void 0 ? void 0 : (ref = selectedFilter.values) === null || ref === void 0 ? void 0 : ref.find(function(value) {
                return value.key === selectedFilterKey;
            });
            return selectedValueObj ? selectedValueObj.display_name : selectedFilterKey;
        }
        return selectedFilterKey;
    };
    var getIconForFilter = function(filterKey) {
        var iconMap = {
            TRANSACTION: "/icons/transaction.svg",
            DATE: "/icons/calendar.svg",
            MONTH: "/icons/calendar.svg",
            SUB_DEALER: "/icons/building-icon.png",
            COUNTRY_STATE: "/icons/map-icon.png"
        };
        return iconMap[filterKey] || "/icons/transaction.svg";
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            showHeader && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {
                        wrapperStyles: {
                            maxWidth: isMobile ? "100%" : "80%",
                            margin: "0 auto",
                            padding: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListingV1_styles_Hr, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CommissionListingV1_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListingV1_styles_Header, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HeaderTextWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HeaderText, {
                                children: "Commissions earned"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MainCard, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DateRangeContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DateField, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DateLabel, {
                                                children: "From"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                                                title: "",
                                                defaultDate: dateRange === null || dateRange === void 0 ? void 0 : dateRange.from,
                                                onSelect: function(date) {
                                                    onChange(date, "from");
                                                    (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                                        action_type: constants/* SegmentEventActionTypes.TAP_CALENDER */.Qy.TAP_CALENDER,
                                                        action_name: constants/* SegmentEventActions.TAP_DATE_TO_DATE_RANGE */.vn.TAP_DATE_TO_DATE_RANGE,
                                                        date: date,
                                                        view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                                                    }, {
                                                        userDetails: userDetails,
                                                        isMobile: isMobile
                                                    });
                                                },
                                                enableWindow: {
                                                    start: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
                                                    current: dateRange.from,
                                                    end: new Date()
                                                },
                                                isDesktop: !isMobile
                                            }),
                                            calendarError && calendarError !== null && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListingV1_styles_ErrorText, {
                                                children: calendarError
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DateField, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DateLabel, {
                                                children: "To"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                                                title: "",
                                                defaultDate: dateRange.end,
                                                onSelect: function(date) {
                                                    onChange(date, "end");
                                                    (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                                        action_type: constants/* SegmentEventActionTypes.TAP_CALENDER */.Qy.TAP_CALENDER,
                                                        action_name: constants/* SegmentEventActions.TAP_DATE_FROM_DATE_RANGE */.vn.TAP_DATE_FROM_DATE_RANGE,
                                                        date: date,
                                                        view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                                                    }, {
                                                        userDetails: userDetails,
                                                        isMobile: isMobile
                                                    });
                                                },
                                                enableWindow: {
                                                    start: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
                                                    current: dateRange.end,
                                                    end: new Date()
                                                },
                                                isDesktop: !isMobile
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(GroupByContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupByLabel, {
                                        children: "Group By"
                                    }),
                                    isMobile ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupByBoxesContainer, {
                                        children: (ref = filters === null || filters === void 0 ? void 0 : filters.find(function(filter) {
                                            return filter.key === selectedKey;
                                        })) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1.map(function(value) {
                                            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)(GroupByBox, {
                                                isSelected: value.key === selectedFilterKey,
                                                onClick: function() {
                                                    setSelectedFilterKey(value.key);
                                                    (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                                        action_type: constants/* SegmentEventActions.TAP_GROUPBY */.vn.TAP_GROUPBY,
                                                        action_name: value === null || value === void 0 ? void 0 : value.display_name,
                                                        view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                                                    }, {
                                                        userDetails: userDetails,
                                                        isMobile: isMobile
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BoxIcon, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                            src: (0,generics/* getImageBasePath */.m4)(getIconForFilter(value.key)),
                                                            alt: "",
                                                            width: "20px",
                                                            height: "20px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BoxText, {
                                                        isSelected: value.key === selectedFilterKey,
                                                        children: value.display_name
                                                    })
                                                ]
                                            }, value.key);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(GroupByDropdownContainer, {
                                        ref: dropdownRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(GroupByInputWrapper, {
                                                onClick: function() {
                                                    return setFilterClicked(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupByIcon, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                            src: (0,generics/* getImageBasePath */.m4)(getIconForFilter(selectedFilterKey)),
                                                            alt: "",
                                                            width: "16px",
                                                            height: "16px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupByText, {
                                                        children: getSelectedFilterDisplayName()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownIcon, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                            src: (0,generics/* getImageBasePath */.m4)("/icons/chevron-down.svg"),
                                                            alt: "",
                                                            width: "12px",
                                                            height: "12px"
                                                        })
                                                    })
                                                ]
                                            }),
                                            filterClicked && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownMenu, {
                                                children: (ref2 = filters === null || filters === void 0 ? void 0 : filters.find(function(filter) {
                                                    return filter.key === selectedKey;
                                                })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.values) === null || ref3 === void 0 ? void 0 : ref3.map(function(value) {
                                                    /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)(DropdownItem, {
                                                        isSelected: value.key === selectedFilterKey,
                                                        onClick: function() {
                                                            setSelectedFilterKey(value.key);
                                                            setFilterClicked(false);
                                                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                                                action_type: constants/* SegmentEventActions.TAP_GROUPBY */.vn.TAP_GROUPBY,
                                                                action_name: value === null || value === void 0 ? void 0 : value.display_name,
                                                                view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                                                            }, {
                                                                userDetails: userDetails,
                                                                isMobile: isMobile
                                                            });
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownItemIcon, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                                    src: (0,generics/* getImageBasePath */.m4)(getIconForFilter(value.key)),
                                                                    alt: "",
                                                                    width: "16px",
                                                                    height: "16px"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownItemText, {
                                                                children: value.display_name
                                                            }),
                                                            value.key === selectedFilterKey && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropdownCheckIcon, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                                    src: (0,generics/* getImageBasePath */.m4)("/icons/greenTick.svg"),
                                                                    alt: "",
                                                                    width: "16px",
                                                                    height: "16px"
                                                                })
                                                            })
                                                        ]
                                                    }, value.key);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (secondaryFilters === null || secondaryFilters === void 0 ? void 0 : secondaryFilters.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SecondaryFiltersWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SecondaryFiltersHeaderText, {
                                        children: "Select ".concat((ref4 = selectedFilterKey === null || selectedFilterKey === void 0 ? void 0 : selectedFilterKey.toLowerCase()) === null || ref4 === void 0 ? void 0 : ref4.replace("_", " "))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SearchWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                            name: "search",
                                            type: "text",
                                            value: searchText,
                                            labelText: "Search",
                                            onChange: function(e) {
                                                var ref;
                                                return setSearchText(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                            },
                                            rightElement: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                                children: ((ref5 = searchText === null || searchText === void 0 ? void 0 : searchText.trim()) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                    src: (0,generics/* getImageBasePath */.m4)("/icons/close.svg"),
                                                    width: 20,
                                                    height: 20,
                                                    onClick: function() {
                                                        return setSearchText("");
                                                    },
                                                    style: {
                                                        cursor: "pointer"
                                                    }
                                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                    src: (0,generics/* getImageBasePath */.m4)("/images/search.svg"),
                                                    width: 20,
                                                    height: 20
                                                })
                                            })
                                        })
                                    }),
                                    (secondaryFilteredList === null || secondaryFilteredList === void 0 ? void 0 : secondaryFilteredList.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SecondaryFiltersContainer, {
                                        children: secondaryFilteredList === null || secondaryFilteredList === void 0 ? void 0 : secondaryFilteredList.map(function(filter) {
                                            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)(SecondaryFilter, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Checkbox, {
                                                        label: filter === null || filter === void 0 ? void 0 : filter.display_name,
                                                        value: filter === null || filter === void 0 ? void 0 : filter.key,
                                                        onChange: function() {
                                                            if (selectedSecondaryFilters === null || selectedSecondaryFilters === void 0 ? void 0 : selectedSecondaryFilters.includes(filter === null || filter === void 0 ? void 0 : filter.key)) {
                                                                setSelectedSecondaryFilters(function(state) {
                                                                    return state.filter(function(item) {
                                                                        return item !== (filter === null || filter === void 0 ? void 0 : filter.key);
                                                                    });
                                                                });
                                                            } else {
                                                                setSelectedSecondaryFilters(function(state) {
                                                                    return (0,_to_consumable_array/* default */.Z)(state).concat([
                                                                        filter === null || filter === void 0 ? void 0 : filter.key, 
                                                                    ]);
                                                                });
                                                            }
                                                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                                                action_type: constants/* SegmentEventActionTypes.TAP_CHECKBOX */.Qy.TAP_CHECKBOX,
                                                                action_name: constants/* SegmentEventActions.TAP_SUB_DEALER_NAME */.vn.TAP_SUB_DEALER_NAME,
                                                                value: filter === null || filter === void 0 ? void 0 : filter.display_name,
                                                                view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                                                            }, {
                                                                userDetails: userDetails,
                                                                isMobile: isMobile
                                                            });
                                                        },
                                                        checked: selectedSecondaryFilters === null || selectedSecondaryFilters === void 0 ? void 0 : selectedSecondaryFilters.includes(filter === null || filter === void 0 ? void 0 : filter.key)
                                                    }),
                                                    filter === null || filter === void 0 ? void 0 : filter.display_name
                                                ]
                                            }, filter === null || filter === void 0 ? void 0 : filter.key);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_NoResult, {
                                        style: {
                                            justifyContent: "left",
                                            color: "rgb(216, 61, 55)"
                                        },
                                        children: "No results found for '".concat(searchText, "'")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GenerateButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(GenerateButton, {
                                    onClick: function() {
                                        return handleGenerateReport();
                                    },
                                    disabled: buttonLoader,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonIcon, {
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                src: (0,generics/* getImageBasePath */.m4)("/icons/download-icon.png"),
                                                alt: "",
                                                width: "20px",
                                                height: "20px"
                                            })
                                        }),
                                        "Generate Report"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(NavigationTabs, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Tab, {
                                isActive: activeTab === NAVIGATION_TABS.RESULTS,
                                onClick: function() {
                                    setActiveTab(NAVIGATION_TABS.RESULTS);
                                    (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                        action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                                        action_name: constants/* SegmentEventActions.TAP_REPORTS_TAB */.vn.TAP_REPORTS_TAB,
                                        view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                                    }, {
                                        userDetails: userDetails,
                                        isMobile: isMobile
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                            src: (0,generics/* getImageBasePath */.m4)("/icons/graph-icon.png"),
                                            alt: "",
                                            width: "16px",
                                            height: "16px"
                                        })
                                    }),
                                    "Reports"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Tab, {
                                isActive: activeTab === NAVIGATION_TABS.HISTORY,
                                onClick: function() {
                                    setActiveTab(NAVIGATION_TABS.HISTORY);
                                    (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                        action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                                        action_name: constants/* SegmentEventActions.TAP_REPORT_HISTORY_TAB */.vn.TAP_REPORT_HISTORY_TAB,
                                        view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                                    }, {
                                        userDetails: userDetails,
                                        isMobile: isMobile
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                            src: (0,generics/* getImageBasePath */.m4)("/icons/clock-icon.svg"),
                                            alt: "",
                                            width: "20px",
                                            height: "20px"
                                        })
                                    }),
                                    "Report History",
                                    (reportsHistory === null || reportsHistory === void 0 ? void 0 : reportsHistory.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Badge, {
                                        children: reportsHistory === null || reportsHistory === void 0 ? void 0 : reportsHistory.length
                                    })
                                ]
                            })
                        ]
                    }),
                    activeTab === NAVIGATION_TABS.RESULTS && (loader ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LoaderBox, {
                        style: {
                            height: "100%",
                            display: "grid",
                            placeItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: "/gif/pageLoader.gif",
                            alt: "",
                            height: isMobile ? "60px" : "100px",
                            width: isMobile ? "60px" : "100px",
                            style: {
                                margin: "0 auto"
                            }
                        })
                    }) : (pageData === null || pageData === void 0 ? void 0 : pageData.data) && (pageData === null || pageData === void 0 ? void 0 : (ref6 = pageData.data) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListingV1_PaginatedTable, {
                        activeFilter: selectedFilterKey,
                        headers: pageData === null || pageData === void 0 ? void 0 : pageData.headers,
                        data: pageData === null || pageData === void 0 ? void 0 : pageData.data,
                        totalPages: pageData === null || pageData === void 0 ? void 0 : pageData.total_pages,
                        onNext: onNextPage,
                        onBack: onPrevioudPage,
                        currentPage: page + 1,
                        totalResults: pageData === null || pageData === void 0 ? void 0 : pageData.total_records
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ListingWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_NoResult, {
                            children: "No commissions"
                        })
                    })),
                    activeTab === NAVIGATION_TABS.HISTORY && (loader ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LoaderBox, {
                        style: {
                            height: "100%",
                            display: "grid",
                            placeItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: "/gif/pageLoader.gif",
                            alt: "",
                            height: isMobile ? "60px" : "100px",
                            width: isMobile ? "60px" : "100px",
                            style: {
                                margin: "0 auto"
                            }
                        })
                    }) : (reportsHistory === null || reportsHistory === void 0 ? void 0 : reportsHistory.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ListingWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportHistoryContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ReportHistoryHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ReportHistoryTitle, {
                                            children: "Report History"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ReportHistoryCount, {
                                            children: "".concat(reportsHistory === null || reportsHistory === void 0 ? void 0 : reportsHistory.length, " reports")
                                        })
                                    ]
                                }),
                                reportsHistory === null || reportsHistory === void 0 ? void 0 : reportsHistory.map(function(report) {
                                    /*#__PURE__*/ return (0,compat_module.createElement)(CommissionListingV1_ReportCard, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, report), {
                                        key: report === null || report === void 0 ? void 0 : report.request_id,
                                        handleDownloadReport: handleDownloadReport,
                                        isLoading: buttonLoader,
                                        sendSegmentEvent: segment/* default */.Z
                                    }));
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ListingWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_NoResult, {
                            children: "No reports."
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListingV1_ConfirmationPopup, {
                show: confirmationModalShow,
                handleSubmit: function() {
                    setConfirmationModalShow(false);
                    (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                        page_type: constants/* SegmentEventPages.GENERATE_REPORT_INFO_POPUP */.g0.GENERATE_REPORT_INFO_POPUP,
                        action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                        action_name: constants/* SegmentEventActions.TAP_GENERATE_REPORT_INFO_BTN_OK */.vn.TAP_GENERATE_REPORT_INFO_BTN_OK,
                        view_name: constants/* SegmentEventPages.COMMISSION_EARNED_V1_PAGE */.g0.COMMISSION_EARNED_V1_PAGE
                    }, {
                        userDetails: userDetails,
                        isMobile: isMobile
                    });
                },
                sendSegmentEvent: segment/* default */.Z,
                userDetails: userDetails
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var components_CommissionListingV1 = (CommissionListingV1);

;// CONCATENATED MODULE: ./components/SalesReport/styles.ts

function SalesReport_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* padding: 20px; */\n"
    ]);
    SalesReport_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 24px;\n    margin-top: 16px;\n"
    ]);
    SalesReport_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-flex;\n    background: #e9ecef;\n    border-radius: 12px;\n    padding: 4px;\n    align-items: center;\n"
    ]);
    SalesReport_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    SalesReport_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: none;\n    padding: 10px 24px;\n    border-radius: 10px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    background: ",
        ";\n    color: ",
        ";\n    box-shadow: ",
        ";\n"
    ]);
    SalesReport_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    font-weight: 500;\n"
    ]);
    SalesReport_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px 14px;\n    font-size: 16px;\n    border-radius: 8px;\n    border: 1px solid #cbd5e1;\n    min-width: 240px;\n"
    ]);
    SalesReport_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 24px;\n    height: 75vh;\n"
    ]);
    SalesReport_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SalesReport_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 32px;\n    font-size: 18px;\n"
    ]);
    SalesReport_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var styles_PageWrapper = styled_components_browser_esm["default"].div(SalesReport_styles_templateObject());
var ControlsRow = styled_components_browser_esm["default"].div(SalesReport_styles_templateObject1());
var TabsContainer = styled_components_browser_esm["default"].div(SalesReport_styles_templateObject2());
var ContentContainer = styled_components_browser_esm["default"].div(SalesReport_styles_templateObject3());
var TabButton = styled_components_browser_esm["default"].button(SalesReport_styles_templateObject4(), function(param) {
    var active = param.active;
    return active ? "#ffffff" : "transparent";
}, function(param) {
    var active = param.active;
    return active ? "#111827" : "#6b7280";
}, function(param) {
    var active = param.active;
    return active ? "0 1px 3px rgba(0,0,0,0.08)" : "none";
});
var SalesReport_styles_Label = styled_components_browser_esm["default"].label(SalesReport_styles_templateObject5());
var Select = styled_components_browser_esm["default"].select(SalesReport_styles_templateObject6());
var IframeWrapper = styled_components_browser_esm["default"].div(SalesReport_styles_templateObject7());
var Loader = styled_components_browser_esm["default"].div(SalesReport_styles_templateObject8());

;// CONCATENATED MODULE: ./components/SalesReport/api.ts






// const EMBED_API = `${getDomainOrigin()}/api/mpos/partner/Xiaomi/user/report/dashboard/embed`;
var EMBED_API = function(partner) {
    // return `${getDomainOrigin()}/api/mpos/partner/${partner}/user/d6bb4f6e-a4fa-423c-8dec-9d4bb70f7cb7/report/dashboard/embed/internal`;
    return "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partner, "/user/report/dashboard/embed");
};
// export const fetchDashboardEmbed = async (
//     partner: string,
//     payload: EmbedRequest
// ): Promise<DashboardConfigResponse> => {
//     const response = await axios.post(EMBED_API(partner), payload);
//     const configs: DashboardConfigResponse = response.data;
//     console.log(configs);
//     return configs;
// };
var abortController = null;
var fetchDashboardEmbed = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partner, payload) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (abortController) {
                        abortController.abort();
                    }
                    abortController = new AbortController();
                    return [
                        4,
                        lib_axios/* default.post */.Z.post(EMBED_API(partner), payload, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            signal: abortController.signal
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function fetchDashboardEmbed(partner, payload) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/SalesReport/SalesDropDown/styles.ts

function SalesDropDown_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    width: 260px;\n"
    ]);
    SalesDropDown_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalesDropDown_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding: 14px 16px;\n    font-size: 16px;\n    text-align: left;\n    border-radius: 12px;\n    border: 1.5px solid #bfc6d1;\n    background: #fff;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    &:focus {\n        outline: none;\n        border-color: #8b5cf6;\n    }\n"
    ]);
    SalesDropDown_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalesDropDown_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: solid #6b7280;\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 4px;\n    transform: ",
        ";\n    transition: transform 0.2s ease;\n"
    ]);
    SalesDropDown_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SalesDropDown_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: calc(100% + 8px);\n    width: 100%;\n    background: #f3f3f3;\n    border-radius: 14px;\n    padding: 8px 0;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n    z-index: 10;\n    max-height: 360px;\n    overflow-y: auto;\n"
    ]);
    SalesDropDown_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SalesDropDown_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 14px 18px;\n    font-size: 18px;\n    cursor: pointer;\n    background: ",
        ";\n\n    &:hover {\n        background: #e5e7eb;\n    }\n"
    ]);
    SalesDropDown_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var DropdownWrapper = styled_components_browser_esm["default"].div(SalesDropDown_styles_templateObject());
var DropdownButton = styled_components_browser_esm["default"].button(SalesDropDown_styles_templateObject1());
var Chevron = styled_components_browser_esm["default"].span(SalesDropDown_styles_templateObject2(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "rotate(-135deg)" : "rotate(45deg)";
});
var Menu = styled_components_browser_esm["default"].div(SalesDropDown_styles_templateObject3());
var MenuItem = styled_components_browser_esm["default"].div(SalesDropDown_styles_templateObject4(), function(param) {
    var active = param.active;
    return active ? "#dfe3e8" : "transparent";
});

;// CONCATENATED MODULE: ./components/SalesReport/SalesDropDown/index.tsx



var SalesDropDown = function(param) {
    var value = param.value, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Select hour slab" : _placeholder, options = param.options, onChange = param.onChange;
    var ref = (0,compat_module.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,compat_module.useRef)(null);
    var selected = options.find(function(o) {
        return o.value === value;
    });
    // close on outside click
    (0,compat_module.useEffect)(function() {
        var handler = function(e) {
            if (ref1.current && !ref1.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return function() {
            return document.removeEventListener("mousedown", handler);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DropdownWrapper, {
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DropdownButton, {
                isOpen: open,
                onClick: function() {
                    return setOpen(!open);
                },
                children: [
                    (selected === null || selected === void 0 ? void 0 : selected.label) || placeholder,
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Chevron, {
                        isOpen: open
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Menu, {
                children: options.map(function(opt) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MenuItem, {
                        active: opt.value === value,
                        onClick: function() {
                            onChange(opt.value);
                            setOpen(false);
                        },
                        children: opt.label
                    }, opt.value);
                })
            })
        ]
    });
};
/* harmony default export */ var SalesReport_SalesDropDown = (SalesDropDown);

;// CONCATENATED MODULE: ./components/SalesReport/index.tsx
















var SalesReport = function() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), permissions = ref.permissions, partnerId = ref.partnerId, userDetails = ref.userDetails;
    var ref1 = (0,compat_module.useState)([]), dashboardTypes = ref1[0], setDashboardTypes = ref1[1];
    var ref2 = (0,compat_module.useState)(null), activeDashboardId = ref2[0], setActiveDashboardId = ref2[1];
    var ref3 = (0,compat_module.useState)({}), filters = ref3[0], setFilters = ref3[1];
    var ref4 = (0,compat_module.useState)(""), embedUrl = ref4[0], setEmbedUrl = ref4[1];
    var ref5 = (0,compat_module.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 = (0,compat_module.useState)(0), isInit = ref6[0], setIsInit = ref6[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_REPORT_DASHBORD */.g0.VIEW_REPORT_DASHBORD,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    /* Initial Load */ (0,compat_module.useEffect)(function() {
        var init = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var res, types;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            return [
                                4,
                                fetchDashboardEmbed(partnerId, {
                                    group: permissions.group
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            types = res.user_dashboard_config.dashboard_page.dashboard_types;
                            setDashboardTypes(types);
                            setActiveDashboardId(types[0].id);
                            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                                action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                                action_name: (0,date/* toSnakeCase */.D1)(types[0].name)
                            }, {
                                userDetails: userDetails,
                                isMobile: isMobile
                            });
                            setIsInit(1);
                            setEmbedUrl(res.url);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function init() {
                return _ref.apply(this, arguments);
            };
        }();
        init();
    }, []);
    var activeDashboard = (0,compat_module.useMemo)(function() {
        return dashboardTypes.find(function(d) {
            return d.id === activeDashboardId;
        });
    }, [
        dashboardTypes,
        activeDashboardId
    ]);
    /* Reset filters on dashboard change */ (0,compat_module.useEffect)(function() {
        if (!activeDashboard) return;
        var defaults = {};
        activeDashboard.filters.forEach(function(f) {
            defaults[f.id] = f.default_value;
        });
        setFilters(defaults);
    }, [
        activeDashboard
    ]);
    /* Fetch embed on tab / filter change */ (0,compat_module.useEffect)(function() {
        if (!activeDashboardId) return;
        var fetchEmbed = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            return [
                                4,
                                fetchDashboardEmbed(partnerId, (0,src_object_spread/* default */.Z)({
                                    group: permissions.group,
                                    dashboard: activeDashboardId
                                }, filters))
                            ];
                        case 1:
                            res = _state.sent();
                            setEmbedUrl(res.url);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchEmbed() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isInit > 2) {
            fetchEmbed();
        } else {
            setIsInit(isInit + 1);
        }
    }, [
        activeDashboardId,
        filters
    ]);
    var onChangeTabHandler = function(d) {
        setActiveDashboardId(d.id);
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: (0,date/* toSnakeCase */.D1)(d.name)
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PageWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabsContainer, {
                children: dashboardTypes.map(function(d) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabButton, {
                        active: d.id === activeDashboardId,
                        onClick: function() {
                            return onChangeTabHandler(d);
                        },
                        children: d.name
                    }, d.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ContentContainer, {
                children: [
                    activeDashboard && (activeDashboard === null || activeDashboard === void 0 ? void 0 : activeDashboard.filters.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ControlsRow, {
                        children: activeDashboard.filters.map(function(filter) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SalesReport_SalesDropDown, {
                                    options: filter.data_source.options,
                                    onChange: function(value) {
                                        return setFilters((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, filters), (0,_define_property/* default */.Z)({}, filter.id, value)));
                                    },
                                    value: filters[filter.id]
                                })
                            });
                        })
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Loader, {
                        children: "Loading dashboard..."
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IframeWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("iframe", {
                            title: "report-dashboard",
                            src: embedUrl,
                            width: "100%",
                            height: "100%",
                            frameBorder: 0
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SalesReport = (SalesReport);

;// CONCATENATED MODULE: ./widgets/tabs/styles.ts

function tabs_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    tabs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function tabs_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-flex;\n    background: #e9ecef;\n    border-radius: 12px;\n    padding: 4px;\n    gap: 4px;\n"
    ]);
    tabs_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function tabs_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: none;\n    background: ",
        ";\n    padding: 10px 24px;\n    font-size: 16px;\n    font-weight: 500;\n    border-radius: 10px;\n    cursor: pointer;\n    color: ",
        ";\n    box-shadow: ",
        ";\n    transition: all 0.2s ease;\n\n    &:hover {\n        color: #111827;\n    }\n"
    ]);
    tabs_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function tabs_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* margin: 16px; */\n    margin: 16px 8px;\n"
    ]);
    tabs_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var TabsWrapper = styled_components_browser_esm["default"].div(tabs_styles_templateObject());
var styles_TabsContainer = styled_components_browser_esm["default"].div(tabs_styles_templateObject1());
var styles_TabButton = styled_components_browser_esm["default"].button(tabs_styles_templateObject2(), function(param) {
    var active = param.active;
    return active ? "#ffffff" : "transparent";
}, function(param) {
    var active = param.active;
    return active ? "#111827" : "#6b7280";
}, function(param) {
    var active = param.active;
    return active ? "0 1px 3px rgba(0,0,0,0.08)" : "none";
});
var TabContent = styled_components_browser_esm["default"].div(tabs_styles_templateObject3());

;// CONCATENATED MODULE: ./widgets/tabs/index.tsx



var Tabs = function(param) {
    var tabs = param.tabs, defaultTab = param.defaultTab, onChange = param.onChange;
    var ref = (0,compat_module.useState)(defaultTab), active = ref[0], setActive = ref[1];
    var activeTabConfig = tabs.find(function(tab) {
        return tab.id === active;
    });
    var onChangeTabHandler = function(id) {
        setActive(id);
        onChange(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TabsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_TabsContainer, {
                children: tabs.map(function(tab) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_TabButton, {
                        active: tab.id === active,
                        onClick: function() {
                            return onChangeTabHandler(tab.id);
                        },
                        children: tab.label
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabContent, {
                children: activeTabConfig === null || activeTabConfig === void 0 ? void 0 : activeTabConfig.component
            })
        ]
    });
};
/* harmony default export */ var tabs = (Tabs);

;// CONCATENATED MODULE: ./components/reportDashboard/configs.ts
var dashboardConfigs = {
    title: "Sales Dashboard"
};
var configs_Tabs;
(function(Tabs) {
    Tabs["REPORT_DASHBOARD"] = "report_dashboard";
    Tabs["DOWNLOAD_HISTORY"] = "download_history";
})(configs_Tabs || (configs_Tabs = {}));

;// CONCATENATED MODULE: ./components/reportDashboard/styles.ts

function reportDashboard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 20px 20px 20px;\n    width: 100%;\n    margin: 0 auto;\n\n    @media screen and (max-width: 769px) {\n        max-width: 100%;\n    }\n"
    ]);
    reportDashboard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function reportDashboard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-bottom: 20px;\n    transform: translateX(-20px);\n"
    ]);
    reportDashboard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function reportDashboard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n"
    ]);
    reportDashboard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function reportDashboard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 8px;\n"
    ]);
    reportDashboard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function reportDashboard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n"
    ]);
    reportDashboard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function reportDashboard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: white;\n    border-radius: 12px;\n    padding: 24px;\n    margin-top: 16px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    display: inline-flex;\n    gap: 24px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    width: 100%;\n\n    /* Mobile */\n    @media (max-width: 768px) {\n        padding: 12px;\n        gap: 12px;\n    }\n\n    @media (max-width: 480px) {\n        padding: 8px;\n    }\n"
    ]);
    reportDashboard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var reportDashboard_styles_Wrapper = styled_components_browser_esm["default"].div(reportDashboard_styles_templateObject());
var reportDashboard_styles_Hr = styled_components_browser_esm["default"].div(reportDashboard_styles_templateObject1());
var reportDashboard_styles_Header = styled_components_browser_esm["default"].header(reportDashboard_styles_templateObject2());
var styles_HeaderTextWrapper = styled_components_browser_esm["default"].div(reportDashboard_styles_templateObject3());
var styles_HeaderText = styled_components_browser_esm["default"].h3(reportDashboard_styles_templateObject4());
var styles_MainCard = styled_components_browser_esm["default"].div(reportDashboard_styles_templateObject5());

;// CONCATENATED MODULE: ./components/reportDashboard/index.tsx








var ReportDashboard = function() {
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var title = dashboardConfigs.title;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {
                wrapperStyles: {
                    maxWidth: isMobile ? "100%" : "80%",
                    margin: "0 auto",
                    padding: "20px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reportDashboard_styles_Hr, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reportDashboard_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reportDashboard_styles_Header, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_HeaderTextWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_HeaderText, {
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_MainCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tabs, {
                            tabs: [
                                {
                                    id: configs_Tabs.REPORT_DASHBOARD,
                                    label: "Dashboard",
                                    component: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_SalesReport, {})
                                },
                                {
                                    id: configs_Tabs.DOWNLOAD_HISTORY,
                                    label: "Download Reports",
                                    component: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_CommissionListingV1, {})
                                }, 
                            ],
                            defaultTab: configs_Tabs.REPORT_DASHBOARD,
                            onChange: function() {}
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var reportDashboard = (ReportDashboard);

;// CONCATENATED MODULE: ./widgets/configurableForm/helpers.ts
var hasAllRequiredValues = function(uiConfig, values) {
    var requiredFields = uiConfig.filter(function(field) {
        return field.required;
    });
    var hasAllRequiredValues = requiredFields.every(function(field) {
        var ref;
        var key = (ref = field.props) === null || ref === void 0 ? void 0 : ref.key_name;
        var val = values[key];
        return !!val;
    });
    return hasAllRequiredValues;
};

;// CONCATENATED MODULE: ./widgets/configurableForm/styles.ts

function configurableForm_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"
    ]);
    configurableForm_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    max-width: 440px;\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    margin-top: 5px;\n"
    ]);
    configurableForm_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: visible;\n"
    ]);
    configurableForm_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    margin-bottom: 20px;\n"
    ]);
    configurableForm_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 16px;\n"
    ]);
    configurableForm_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    configurableForm_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    line-height: 24px;\n    color: #040222;\n    padding: 16px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n"
    ]);
    configurableForm_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #5b5675;\n"
    ]);
    configurableForm_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function configurableForm_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    color: #5b5675;\n    font-weight: 600;\n    margin-left: 5px;\n"
    ]);
    configurableForm_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var Page = building_blocks_ui_common_dist.styled.div(configurableForm_styles_templateObject());
var Card = building_blocks_ui_common_dist.styled.form(configurableForm_styles_templateObject1());
var FormBody = building_blocks_ui_common_dist.styled.div(configurableForm_styles_templateObject2());
var FieldWrapper = building_blocks_ui_common_dist.styled.div(configurableForm_styles_templateObject3());
var Footer = building_blocks_ui_common_dist.styled.div(configurableForm_styles_templateObject4());
var styles_SubmitButtonWrapper = building_blocks_ui_common_dist.styled.div(configurableForm_styles_templateObject5());
var ModalText = building_blocks_ui_common_dist.styled.div(configurableForm_styles_templateObject6());
var ModalSubText = building_blocks_ui_common_dist.styled.span(configurableForm_styles_templateObject7());
var styles_PageHeading = building_blocks_ui_common_dist.styled.h1(configurableForm_styles_templateObject8());

;// CONCATENATED MODULE: ./widgets/configurableForm/ConfigurableForm.tsx












// utils


// helpers

// styles





function ConfigurableForm(param) {
    var uiConfig = param.uiConfig, _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? {} : _initialValues, formType = param.formType, onSubmit = param.onSubmit, validator = param.validator, setErrorMessage = param.setErrorMessage, setShowErrorScreen = param.setShowErrorScreen, shouldUpdateDetails = param.shouldUpdateDetails;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), permissions = ref.permissions, userDetails = ref.userDetails;
    var ref1 = (0,compat_module.useState)(initialValues), values = ref1[0], setValues = ref1[1];
    var ref2 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref2[0], setSnackbar = ref2[1];
    var ref3 = (0,compat_module.useState)({}), validationErr = ref3[0], setValidationErr = ref3[1];
    var ref4 = (0,compat_module.useState)(true), isContinueButtonDisabled = ref4[0], setIsContinueButtonDisabled = ref4[1];
    var ref5 = (0,compat_module.useState)(false), showSuccessModal = ref5[0], setShowSuccessModal = ref5[1];
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    (0,compat_module.useEffect)(function() {
        var allRequiredValuesValid = hasAllRequiredValues(uiConfig, values);
        if ((0,generics/* isEmpty */.xb)(validationErr) && allRequiredValuesValid) {
            setIsContinueButtonDisabled(false);
        } else {
            setIsContinueButtonDisabled(true);
        }
    }, [
        values,
        validationErr,
        uiConfig
    ]);
    (0,compat_module.useEffect)(function() {
        if (showSuccessModal) {
            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
                page_type: constants/* SegmentEventPageTypes.DEALER_DETAILS_PAGE */.s9.DEALER_DETAILS_PAGE,
                view_name: constants/* SegmentEventPages.VIEW_CONFIRMATION_MODAL */.g0.VIEW_CONFIRMATION_MODAL
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        showSuccessModal
    ]);
    var handleFieldChange = function(props) {
        return function(e) {
            var ref;
            var key = props.key_name;
            var value = (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
            var error = validator((0,src_object_spread/* default */.Z)({
                value: value
            }, props));
            setValidationErr(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, error));
            });
            setValues(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, value));
            });
        };
    };
    var handleSubmit = function() {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.SUBMIT_DETAILS */.iV.SUBMIT_DETAILS,
            button_name: constants/* SegmentEventButtonNames.SUBMIT */.A3.SUBMIT
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        setShowSuccessModal(true);
    };
    var handleConfirmSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var url, status, e, ref, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = shouldUpdateDetails ? "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/genie/onboarding/").concat(permissions === null || permissions === void 0 ? void 0 : permissions.partner_id, "/details/update?user_group=").concat(permissions === null || permissions === void 0 ? void 0 : permissions.group) : "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/genie/onboarding/").concat(permissions === null || permissions === void 0 ? void 0 : permissions.partner_id, "/details/submit?user_group=").concat(permissions === null || permissions === void 0 ? void 0 : permissions.group);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,lib_axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                method: "POST",
                                url: url
                            }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                                data: {
                                    form_type: formType,
                                    form_data: values
                                }
                            }))
                        ];
                    case 2:
                        status = _state.sent().status;
                        if (status === 200) {
                            setShowSuccessModal(false);
                            onSubmit();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 404) {
                            ;
                            setErrorMessage(e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message);
                        }
                        setShowErrorScreen(true);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSnakbarComplete = function() {
        setSnackbar({
            type: "",
            message: ""
        });
    };
    var onModalCancel = function() {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: constants/* SegmentEventActionNames.CLICK_CANCEL_MODAL */.iV.CLICK_CANCEL_MODAL,
            button_name: constants/* SegmentEventButtonNames.CANCEL_MODAL */.A3.CANCEL_MODAL
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        setShowSuccessModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Page, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Card, {
                noValidate: true,
                onSubmit: function(e) {
                    e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FormBody, {
                        children: uiConfig.map(function(field) {
                            var ref;
                            var key = ((ref = field.props) === null || ref === void 0 ? void 0 : ref.key_name) || field.id;
                            if (field.component === "input") {
                                var ref1, ref2;
                                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FieldWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PageHeading, {
                                            children: field === null || field === void 0 ? void 0 : field.label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                            name: key,
                                            type: field.type,
                                            value: values[key] || "",
                                            className: "",
                                            placeHolder: field.title,
                                            onChange: handleFieldChange(field.props),
                                            errMsg: validationErr === null || validationErr === void 0 ? void 0 : validationErr[key],
                                            hasError: (validationErr === null || validationErr === void 0 ? void 0 : (ref1 = validationErr[key]) === null || ref1 === void 0 ? void 0 : ref1.length) > 0,
                                            disabled: ((ref2 = field.props) === null || ref2 === void 0 ? void 0 : ref2.editable) === false
                                        })
                                    ]
                                }, field.id);
                            }
                            return null;
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Footer, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_SubmitButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                type: "button",
                                onClick: handleSubmit,
                                disabled: isContinueButtonDisabled,
                                children: "Submit"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                        handleSnakbarComplete: handleSnakbarComplete
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Modal, {
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                urlhash: "",
                show: showSuccessModal,
                onHide: function() {
                    setShowSuccessModal(false);
                },
                padding: "20px",
                showOverlayBackground: true,
                maxWidth: "350px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                hideCloseButton: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ModalText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                children: "Are you sure?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalSubText, {
                                children: "Incorrect information could lead to data inaccuracies."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                            marginTop: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.SecondaryButton, {
                                type: "button",
                                onClick: onModalCancel,
                                children: "No"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                type: "button",
                                onClick: handleConfirmSubmit,
                                children: "Yes"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var configurableForm_ConfigurableForm = (ConfigurableForm);

;// CONCATENATED MODULE: ./widgets/configurableForm/index.ts

/* harmony default export */ var configurableForm = (configurableForm_ConfigurableForm);

// EXTERNAL MODULE: ./utils/helpers/bootstrapUserPermissions.ts
var bootstrapUserPermissions = __webpack_require__(1272);
;// CONCATENATED MODULE: ./components/dealerDetails/styles.ts

function dealerDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    dealerDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var dealerDetails_styles_Wrapper = building_blocks_ui_common_dist.styled.div(dealerDetails_styles_templateObject());

;// CONCATENATED MODULE: ./components/dealerDetails/DealerDetails.tsx





// context


// constant

// components




// styles



function DealerDetails_DealerDetails() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), setPermissions = ref.setPermissions, setUserDetails = ref.setUserDetails, setPartnerId = ref.setPartnerId, setLoggedUserRole = ref.setLoggedUserRole, setLegalDetailsUploadedStatus = ref.setLegalDetailsUploadedStatus, setActiveStage = ref.setActiveStage, setMetaData = ref.setMetaData, setGstDetailsValid = ref.setGstDetailsValid, setPermissionsMap = ref.setPermissionsMap, setGstDetailsSubmitAction = ref.setGstDetailsSubmitAction, setFormConfigsMap = ref.setFormConfigsMap, setSnackbar = ref.setSnackbar, formConfigsMap = ref.formConfigsMap, permissions = ref.permissions, userDetails = ref.userDetails;
    var formConfig = formConfigsMap[utils_constants/* FORM_TYPES.DEALER_DETAILS */.dz.DEALER_DETAILS];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,compat_module.useState)(""), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,compat_module.useState)(false), showErrorScreen = ref2[0], setShowErrorScreen = ref2[1];
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    if (!formConfig) {
        return null;
    }
    var uiConfig = formConfig.uiConfig, captured_data = formConfig.captured_data, details_update_required = formConfig.details_update_required;
    if (!uiConfig || !Array.isArray(uiConfig)) {
        return null;
    }
    (0,compat_module.useEffect)(function() {
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
            page_type: constants/* SegmentEventPageTypes.DEALER_DETAILS_PAGE */.s9.DEALER_DETAILS_PAGE,
            view_name: constants/* SegmentEventPages.VIEW_DEALER_DETAILS_PAGE */.g0.VIEW_DEALER_DETAILS_PAGE
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    }, []);
    var onDealerFormSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                            page_type: constants/* SegmentEventPageTypes.DEALER_DETAILS_PAGE */.s9.DEALER_DETAILS_PAGE,
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            action_name: constants/* SegmentEventActionNames.SUBMIT_MODAL */.iV.SUBMIT_MODAL,
                            button_name: constants/* SegmentEventButtonNames.SUBMIT_MODAL */.A3.SUBMIT_MODAL
                        }, {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        return [
                            4,
                            (0,bootstrapUserPermissions/* bootstrapUserPermissions */.u)({
                                router: router,
                                partnerId: userDetails.partner_id,
                                groupName: permissions.group,
                                setPermissions: setPermissions,
                                setUserDetails: setUserDetails,
                                setMetaData: setMetaData,
                                setPartnerId: setPartnerId,
                                setPermissionsMap: setPermissionsMap,
                                setLoggedUserRole: setLoggedUserRole,
                                setLegalDetailsUploadedStatus: setLegalDetailsUploadedStatus,
                                setActiveStage: setActiveStage,
                                setGstDetailsValid: setGstDetailsValid,
                                setGstDetailsSubmitAction: setGstDetailsSubmitAction,
                                setFormConfigsMap: setFormConfigsMap,
                                setSnackbar: setSnackbar,
                                setErrorMessage: setErrorMessage,
                                setShowErrorScreen: setShowErrorScreen,
                                setIsLoading: function() {}
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onDealerFormSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showErrorScreen) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            errorMessage: errorMessage
        });
    }
    var validator = function(param) {
        var value = param.value, maxLength = param.maxLength, regex = param.regex;
        if (regex && !new RegExp(regex).test(value)) {
            return "Please enter a valid value";
        }
        if (maxLength && value.length > maxLength) {
            return "Value is too long";
        }
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dealerDetails_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(configurableForm, {
                formType: utils_constants/* FORM_TYPES.DEALER_DETAILS */.dz.DEALER_DETAILS,
                uiConfig: uiConfig,
                initialValues: captured_data || {},
                onSubmit: onDealerFormSubmit,
                setErrorMessage: setErrorMessage,
                setShowErrorScreen: setShowErrorScreen,
                validator: validator,
                shouldUpdateDetails: details_update_required
            })
        ]
    });
}
/* harmony default export */ var dealerDetails_DealerDetails = (DealerDetails_DealerDetails);

;// CONCATENATED MODULE: ./components/dealerDetails/index.ts

/* harmony default export */ var components_dealerDetails = (dealerDetails_DealerDetails);

;// CONCATENATED MODULE: ./components/details/styles.ts

function details_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    details_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function details_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    details_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function details_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    details_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function details_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    details_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function details_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    color: #5b5675;\n    margin-bottom: 20px;\n"
    ]);
    details_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function details_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 16px;\n    display: flex;\n    justify-content: space-between;\n"
    ]);
    details_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var details_styles_Wrapper = building_blocks_ui_common_dist.styled.div(details_styles_templateObject());
var HeaderStyles = building_blocks_ui_common_dist.styled.div(details_styles_templateObject1());
var details_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(details_styles_templateObject2());
var details_styles_Title = building_blocks_ui_common_dist.styled.div(details_styles_templateObject3());
var details_styles_Text = building_blocks_ui_common_dist.styled.div(details_styles_templateObject4());
var details_styles_RowWrapper = building_blocks_ui_common_dist.styled.div(details_styles_templateObject5());

// EXTERNAL MODULE: ./components/login/helpers.ts
var helpers = __webpack_require__(2186);
;// CONCATENATED MODULE: ./components/details/Details.tsx



















function Details_Details() {
    var ref = (0,compat_module.useState)([]), data = ref[0], setData = ref[1];
    var ref1 = (0,compat_module.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,compat_module.useState)(""), error = ref2[0], setError = ref2[1];
    var ref3 = (0,compat_module.useContext)(context/* MPosContext */.w), setFormConfigsMap = ref3.setFormConfigsMap, setShowHamburger = ref3.setShowHamburger, formConfigsMap = ref3.formConfigsMap, permissions = ref3.permissions, userDetails = ref3.userDetails;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var onBack = function() {
        // Segment Event
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            button_name: constants/* SegmentEventButtonNames.DETAILS_BACK_BUTTON */.A3.DETAILS_BACK_BUTTON,
            action_name: constants/* SegmentEventActionNames.CLICK_BACK_BUTTON */.iV.CLICK_BACK_BUTTON
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        setShowHamburger(true);
    };
    (0,compat_module.useEffect)(function() {
        // If dealer_details config with captured_data is already present, skip API call
        var dealerFromContext = formConfigsMap[utils_constants/* FORM_TYPES.DEALER_DETAILS */.dz.DEALER_DETAILS];
        var hasCapturedData = dealerFromContext && dealerFromContext.captured_data && Object.keys(dealerFromContext.captured_data).length > 0;
        if (hasCapturedData) {
            setIsLoading(false);
            return;
        }
        var fetchDetails = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, status, data, newFormConfigsMap, e, ref1, ref2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            return [
                                4,
                                (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    method: "GET",
                                    url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/genie/onboarding/").concat(permissions === null || permissions === void 0 ? void 0 : permissions.partner_id, "/details/get-data?user_group=").concat(permissions === null || permissions === void 0 ? void 0 : permissions.group)
                                }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status === 200 && Array.isArray(data)) {
                                setData(data);
                                newFormConfigsMap = (0,helpers/* mapFormConfigs */.c)(data);
                                setFormConfigsMap(newFormConfigsMap);
                            } else {
                                setError("Something went wrong while fetching details.");
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            e = _state.sent();
                            setError((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "Something went wrong while fetching details.");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchDetails() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchDetails();
    }, []);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            errorMessage: error
        });
    }
    var dealerFormFromContext = formConfigsMap[utils_constants/* FORM_TYPES.DEALER_DETAILS */.dz.DEALER_DETAILS];
    var dealerFormFromApi = data.find(function(form) {
        return form.form_type === "dealer_details";
    });
    var uiConfig = (dealerFormFromContext === null || dealerFormFromContext === void 0 ? void 0 : dealerFormFromContext.uiConfig) || (dealerFormFromApi === null || dealerFormFromApi === void 0 ? void 0 : dealerFormFromApi.ui_config) || [];
    var capturedData = (dealerFormFromContext === null || dealerFormFromContext === void 0 ? void 0 : dealerFormFromContext.captured_data) || (dealerFormFromApi === null || dealerFormFromApi === void 0 ? void 0 : dealerFormFromApi.captured_data) || {};
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(details_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HeaderStyles, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(details_styles_BackArrowIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "10px",
                        height: "24px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                        onClick: onBack
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(details_styles_Title, {
                children: "Details"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(details_styles_Text, {
                children: uiConfig.map(function(field) {
                    var ref;
                    var keyName = (ref = field.props) === null || ref === void 0 ? void 0 : ref.key_name;
                    var _keyName;
                    var value = (_keyName = capturedData[keyName]) !== null && _keyName !== void 0 ? _keyName : "-";
                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(details_styles_RowWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                children: field.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                children: value
                            })
                        ]
                    }, field.id);
                })
            })
        ]
    });
}
/* harmony default export */ var details_Details = (Details_Details);

;// CONCATENATED MODULE: ./components/details/index.ts

/* harmony default export */ var details = (details_Details);

;// CONCATENATED MODULE: ./components/walletTransactions/styles.ts

function walletTransactions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 100vh;\n    padding-bottom: 32px;\n"
    ]);
    walletTransactions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function walletTransactions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 95%;\n    margin: 16px auto 0;\n    padding: 10px 24px;\n    border-radius: 12px;\n    background: #ffffff;\n\n    @media screen and (max-width: 769px) {\n        width: 100%;\n        margin: 0;\n        padding: 10px 14px 20px;\n        border-radius: 0;\n    }\n"
    ]);
    walletTransactions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function walletTransactions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 10px;\n"
    ]);
    walletTransactions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function walletTransactions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 0;\n    background: transparent;\n    padding: 0;\n    color: #5d4aa8;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n"
    ]);
    walletTransactions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function walletTransactions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 20px;\n    margin: 0;\n"
    ]);
    walletTransactions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function walletTransactions_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 1px;\n    background: #ece9f4;\n"
    ]);
    walletTransactions_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var walletTransactions_styles_Container = building_blocks_ui_common_dist.styled.div(walletTransactions_styles_templateObject());
var SectionsCard = building_blocks_ui_common_dist.styled.div(walletTransactions_styles_templateObject1());
var TitleRow = building_blocks_ui_common_dist.styled.div(walletTransactions_styles_templateObject2());
var BackButton = building_blocks_ui_common_dist.styled.button(walletTransactions_styles_templateObject3());
var PageTitle = building_blocks_ui_common_dist.styled.h1(walletTransactions_styles_templateObject4());
var SectionDivider = building_blocks_ui_common_dist.styled.div(walletTransactions_styles_templateObject5());

;// CONCATENATED MODULE: ./components/walletTransactions/header/styles.ts

function walletTransactions_header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% { background-position: -220px 0; }\n    100% { background-position: 220px 0; }\n"
    ]);
    walletTransactions_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function walletTransactions_header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin: 24px 0;\n\n    @media screen and (max-width: 769px) {\n        padding: 10px;\n        gap: 10px;\n    }\n\n    .userDropdown {\n        min-width: 200px;\n        width: 200px;\n    }\n\n    @media screen and (max-width: 769px) {\n        .userDropdown {\n            min-width: 100%;\n            width: 100%;\n        }\n    }\n"
    ]);
    walletTransactions_header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function walletTransactions_header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n    margin-bottom: 12px;\n\n    @media screen and (max-width: 769px) {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 6px;\n        margin-bottom: 8px;\n    }\n"
    ]);
    walletTransactions_header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function walletTransactions_header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #5f5f73;\n    font-size: 14px;\n    font-weight: 500;\n    white-space: nowrap;\n\n    @media screen and (max-width: 769px) {\n        font-size: 12px;\n        color: #a0a0af;\n    }\n"
    ]);
    walletTransactions_header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function walletTransactions_header_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 400px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 28px;\n\n    @media screen and (max-width: 769px) {\n        flex-direction: column;\n        gap: 16px;\n    }\n"
    ]);
    walletTransactions_header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function walletTransactions_header_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.4;\n    color: #8c8c9b;\n    font-weight: 400;\n\n    @media screen and (max-width: 769px) {\n        font-size: 12px;\n        width: 100%;\n    }\n"
    ]);
    walletTransactions_header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function walletTransactions_header_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    border-radius: 10px;\n    background: #faf9fd;\n    padding: 40px 14px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n"
    ]);
    walletTransactions_header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #767386;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: left;\n"
    ]);
    header_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function header_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #2f2e38;\n    font-size: 28px;\n    line-height: 38px;\n    font-weight: 700;\n    text-align: left;\n\n    @media screen and (max-width: 769px) {\n        font-size: 26px;\n        line-height: 36px;\n    }\n"
    ]);
    header_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function header_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #0b7a6f;\n"
    ]);
    header_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function header_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #767386;\n    font-size: 12px;\n    font-weight: 500;\n"
    ]);
    header_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function header_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 12px;\n    background: #f5f4f9;\n    padding: 12px;\n    text-align: left;\n"
    ]);
    header_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function header_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n    display: flex;\n    gap: 16px;\n"
    ]);
    header_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function header_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    border-radius: 8px;\n    background: #ffffff;\n    padding: 8px 10px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n"
    ]);
    header_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function header_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #9b98a8;\n    font-size: 12px;\n    text-align: left;\n"
    ]);
    header_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function header_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    font-weight: 700;\n    color: #2f2e38;\n    text-align: left;\n"
    ]);
    header_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function header_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #0b7a6f;\n"
    ]);
    header_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function header_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 160px;\n    height: 28px;\n    border-radius: 8px;\n    background: linear-gradient(90deg, #f2f2f5 25%, #ececf2 50%, #f2f2f5 75%);\n    background-size: 220px 100%;\n    animation: ",
        " 1.2s infinite;\n"
    ]);
    header_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}

var shimmer = (0,building_blocks_ui_common_dist.keyframes)(walletTransactions_header_styles_templateObject());
var HeaderCard = building_blocks_ui_common_dist.styled.div(walletTransactions_header_styles_templateObject1());
var DropdownRow = building_blocks_ui_common_dist.styled.div(walletTransactions_header_styles_templateObject2());
var DealerLabel = building_blocks_ui_common_dist.styled.div(walletTransactions_header_styles_templateObject3());
var SummaryRow = building_blocks_ui_common_dist.styled.div(walletTransactions_header_styles_templateObject4());
var DataSyncHint = building_blocks_ui_common_dist.styled.p(walletTransactions_header_styles_templateObject5());
var SummaryCard = building_blocks_ui_common_dist.styled.div(walletTransactions_header_styles_templateObject6());
var SummaryLabel = building_blocks_ui_common_dist.styled.div(header_styles_templateObject7());
var SummaryValue = building_blocks_ui_common_dist.styled.div(header_styles_templateObject8());
var SummaryValueDeposits = (0,building_blocks_ui_common_dist.styled)(SummaryValue)(header_styles_templateObject9());
var SummaryPeriodLabel = building_blocks_ui_common_dist.styled.div(header_styles_templateObject10());
var MobileSummaryCard = building_blocks_ui_common_dist.styled.div(header_styles_templateObject11());
var MobileMiniSummaryRow = building_blocks_ui_common_dist.styled.div(header_styles_templateObject12());
var MobileMiniSummaryCard = building_blocks_ui_common_dist.styled.div(header_styles_templateObject13());
var MobileMiniLabel = building_blocks_ui_common_dist.styled.div(header_styles_templateObject14());
var MobileMiniValue = building_blocks_ui_common_dist.styled.div(header_styles_templateObject15());
var MobileMiniValueDeposits = (0,building_blocks_ui_common_dist.styled)(MobileMiniValue)(header_styles_templateObject16());
var ValueSkeleton = building_blocks_ui_common_dist.styled.div(header_styles_templateObject17(), shimmer);

;// CONCATENATED MODULE: ./components/walletTransactions/header/apis.tsx





var getFloatBalanceByPartnerId = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, groupName, walletUserId, productId) {
        var ref, status, data, e, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/user/wallet/balance?wallet_user_id=").concat(walletUserId, "&product_id=").concat(productId, "&group_name=").concat(groupName), (0,src_object_spread/* default */.Z)({
                            method: "GET"
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    return [
                        2,
                        {
                            status: status === 200,
                            data: data || null,
                            statusCode: status
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            status: false,
                            data: null,
                            statusCode: (e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) || 500
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getFloatBalanceByPartnerId(partnerId, groupName, walletUserId, productId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/walletTransactions/header/SummaryCard.tsx


var formatDateForPeriod = function(date) {
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
};
function SummaryCard_SummaryCard(param) {
    var config = param.config, startDate = param.startDate, endDate = param.endDate, isMobile = param.isMobile;
    var ValueComponent = config.valueVariant === "deposits" ? SummaryValueDeposits : SummaryValue;
    var MobileValueComponent = config.valueVariant === "deposits" ? MobileMiniValueDeposits : MobileMiniValue;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileMiniSummaryCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileMiniLabel, {
                    children: config.label
                }),
                config.isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileValueComponent, {
                    children: config.value
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SummaryCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SummaryLabel, {
                children: config.label
            }),
            config.isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueComponent, {
                children: config.value
            }),
            config.showPeriod && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SummaryPeriodLabel, {
                children: [
                    "Period: ",
                    formatDateForPeriod(startDate),
                    " -",
                    " ",
                    formatDateForPeriod(endDate)
                ]
            })
        ]
    });
}
/* harmony default export */ var header_SummaryCard = (SummaryCard_SummaryCard);

;// CONCATENATED MODULE: ./components/walletTransactions/header/MobileSummaryCard.tsx



function MobileSummaryCard_MobileSummaryCard(param) {
    var summaryCardConfig = param.summaryCardConfig, startDate = param.startDate, endDate = param.endDate;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileSummaryCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SummaryLabel, {
                children: summaryCardConfig[0].label
            }),
            summaryCardConfig[0].isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SummaryValue, {
                children: summaryCardConfig[0].value
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileMiniSummaryRow, {
                children: summaryCardConfig.slice(1).map(function(config) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header_SummaryCard, {
                        config: config,
                        startDate: startDate,
                        endDate: endDate,
                        isMobile: true
                    }, config.label);
                })
            })
        ]
    });
}
/* harmony default export */ var header_MobileSummaryCard = (MobileSummaryCard_MobileSummaryCard);

;// CONCATENATED MODULE: ./components/walletTransactions/header/helpers.ts
function getFloatBalanceSummaryCardConfig(floatBalance, isFloatBalanceLoading) {
    return [
        {
            label: "Float Balance",
            value: "₹".concat(floatBalance.toLocaleString("en-IN")),
            showPeriod: false,
            valueVariant: "default",
            isLoading: isFloatBalanceLoading
        }, 
    ];
}

;// CONCATENATED MODULE: ./components/walletTransactions/header/index.tsx












function LedgerTransactionsHeader(param) {
    var startDate = param.startDate, endDate = param.endDate, productsList = param.productsList, selectedProduct = param.selectedProduct, setSelectedProduct = param.setSelectedProduct;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, permissions = ref.permissions;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref1 = (0,compat_module.useState)(0), floatBalance = ref1[0], setFloatBalance = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isFloatBalanceLoading = ref2[0], setIsFloatBalanceLoading = ref2[1];
    var productOptions = productsList.map(function(product) {
        return {
            value: product.product_id,
            displayValue: product.name
        };
    });
    var selectedProductOption = selectedProduct ? {
        value: selectedProduct.product_id,
        displayValue: selectedProduct.name
    } : null;
    (0,compat_module.useEffect)(function() {
        var fetchHeaderData = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var balanceResponse;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!partnerId || !selectedProduct) return [
                                2
                            ];
                            setIsFloatBalanceLoading(true);
                            return [
                                4,
                                getFloatBalanceByPartnerId(partnerId, permissions.group, selectedProduct.user_id, selectedProduct.product_id)
                            ];
                        case 1:
                            balanceResponse = _state.sent();
                            if (balanceResponse.status && balanceResponse.data) {
                                setFloatBalance(Number(balanceResponse.data) || 0);
                            }
                            setIsFloatBalanceLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchHeaderData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchHeaderData();
    }, [
        partnerId,
        permissions.group,
        selectedProduct
    ]);
    var summaryCardConfig = getFloatBalanceSummaryCardConfig(floatBalance, isFloatBalanceLoading);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(HeaderCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DropdownRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DealerLabel, {
                        children: "Search By Wallet Owner Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                        className: "userDropdown",
                        value: selectedProductOption,
                        label: "Select wallet owner",
                        options: productOptions,
                        onChange: function(selected) {
                            var product = productsList.find(function(item) {
                                return item.product_id === selected.value;
                            });
                            if (product) {
                                setSelectedProduct(product);
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header_MobileSummaryCard, {
                        summaryCardConfig: summaryCardConfig,
                        startDate: startDate,
                        endDate: endDate
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SummaryRow, {
                        children: summaryCardConfig.map(function(config) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header_SummaryCard, {
                                config: config,
                                startDate: startDate,
                                endDate: endDate
                            }, config.label);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DataSyncHint, {
                        children: "Note: Data Refreshes Every Hour. Reload The Page To See The Latest Numbers."
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var walletTransactions_header = (LedgerTransactionsHeader);

;// CONCATENATED MODULE: ./components/walletTransactions/filtersSection/styles.ts

function filtersSection_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% { transform: scale(1); }\n    50% { transform: scale(0.97); }\n    100% { transform: scale(1); }\n"
    ]);
    filtersSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-start;\n    gap: 10px;\n    margin-bottom: 0;\n    flex-wrap: wrap;\n\n    @media screen and (max-width: 769px) {\n        flex-wrap: wrap;\n        overflow-x: visible;\n        padding-bottom: 0;\n    }\n"
    ]);
    filtersSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid #5d4aa8;\n    background: ",
        ";\n    width: auto;\n    min-width: 104px;\n    height: 36px;\n    padding: 0 14px;\n    border-radius: 999px;\n    font-size: 14px;\n    cursor: pointer;\n    color: ",
        ";\n    font-weight: ",
        ";\n    box-shadow: ",
        ";\n    transition: background 0.25s ease, color 0.25s ease, box-shadow 0.25s ease,\n        transform 0.2s ease;\n\n    &:active {\n        animation: ",
        " 0.25s ease;\n    }\n\n    @media screen and (max-width: 769px) {\n        min-width: 86px;\n        height: 32px;\n        padding: 0 12px;\n        font-size: 13px;\n    }\n"
    ]);
    filtersSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: column;\n    width: 100%;\n\n    @media screen and (max-width: 769px) {\n        border-radius: 10px;\n        background: #faf9fd;\n        border: 1px solid #ece9f4;\n        padding: 12px;\n        margin-top: 10px;\n\n        .aggregateByDropdown {\n            min-width: 100px;\n            width: 120px;\n            position: static;\n            top: 0;\n        }\n    }\n\n    .aggregateByDropdown {\n        min-width: 140px;\n        width: 160px;\n        height: 36px;\n        position: relative;\n    }\n\n    @media screen and (min-width: 770px) {\n        .aggregateByDropdown {\n            top: 8px;\n        }\n    }\n\n    .monthDropdown {\n        min-width: 140px;\n        width: 140px;\n        height: 34px;\n    }\n\n    .tagFilterDropdown {\n        min-width: 160px;\n        width: 160px;\n    }\n"
    ]);
    filtersSection_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n"
    ]);
    filtersSection_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 10px;\n"
    ]);
    filtersSection_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n"
    ]);
    filtersSection_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n    flex-wrap: wrap;\n"
    ]);
    filtersSection_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 12px;\n"
    ]);
    filtersSection_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n"
    ]);
    filtersSection_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #8c8c9b;\n    font-size: 12px;\n    white-space: nowrap;\n"
    ]);
    filtersSection_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 34px;\n    border: 0;\n    border-radius: 8px;\n    padding: 0 12px;\n    color: #ffffff;\n    background: #5d4aa8;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n    }\n"
    ]);
    filtersSection_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 34px;\n    border: 0;\n    border-radius: 8px;\n    padding: 0 16px;\n    color: #ffffff;\n    background: #5d4aa8;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    position: relative;\n    top: 8px;\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n    }\n"
    ]);
    filtersSection_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    gap: 8px;\n    position: relative;\n    z-index: 20;\n\n    &.inlineControls {\n        margin-top: 10px;\n        width: 100%;\n        flex-shrink: 1;\n    }\n"
    ]);
    filtersSection_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #77778b;\n    font-size: 14px;\n    font-weight: 500;\n    margin-right: 6px;\n    position: relative;\n    top: 8px;\n"
    ]);
    filtersSection_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n"
    ]);
    filtersSection_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n"
    ]);
    filtersSection_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #7b62bd;\n    font-size: 10px;\n    font-weight: 500;\n"
    ]);
    filtersSection_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function filtersSection_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n"
    ]);
    filtersSection_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}

var tabSwitchPulse = (0,building_blocks_ui_common_dist.keyframes)(filtersSection_styles_templateObject());
var TabRow = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject1());
var filtersSection_styles_TabButton = building_blocks_ui_common_dist.styled.button(filtersSection_styles_templateObject2(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#5d4aa8" : "#f2edff";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? "#ffffff" : "#3f2f7f";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? 600 : 500;
}, function(param) {
    var isActive = param.isActive;
    return isActive ? "0 4px 10px rgba(93, 74, 168, 0.25)" : "none";
}, tabSwitchPulse);
var FilterCard = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject3());
var DesktopTopRow = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject4());
var MobileControlsWrapper = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject5());
var MobileTopRow = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject6());
var MobileBottomRow = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject7());
var MobileApplyRow = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject8());
var MobileAggregateField = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject9());
var MobileAggregateLabel = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject10());
var MobileApplyFiltersButton = building_blocks_ui_common_dist.styled.button(filtersSection_styles_templateObject11());
var ApplyFiltersButton = building_blocks_ui_common_dist.styled.button(filtersSection_styles_templateObject12());
var FilterControls = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject13());
var FiltersLabel = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject14());
var FilterField = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject15());
var styles_CalendarWrapper = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject16());
var FilterFieldLabel = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject17());
var styles_Date = building_blocks_ui_common_dist.styled.div(filtersSection_styles_templateObject18());

;// CONCATENATED MODULE: ./components/walletTransactions/constants/types.ts
var FilterTag;
(function(FilterTag) {
    FilterTag["ALL"] = "all";
    FilterTag["DEPOSITS"] = "deposits";
    FilterTag["PREMIUM"] = "premium";
    FilterTag["WALLET_REFUND"] = "wallet_refund";
})(FilterTag || (FilterTag = {}));
var LEDGER_TAG_TABS = [
    {
        label: "All",
        value: FilterTag.ALL
    },
    {
        label: "Deposits",
        value: FilterTag.DEPOSITS
    },
    {
        label: "Premium",
        value: FilterTag.PREMIUM
    },
    {
        label: "Wallet Refund",
        value: FilterTag.WALLET_REFUND
    }, 
];

;// CONCATENATED MODULE: ./components/walletTransactions/filtersSection/helpers.ts

var MONTH_LABELS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec", 
];
var getCurrentMonthInput = function() {
    var now = new Date();
    var month = String(now.getMonth() + 1).padStart(2, "0");
    return "".concat(now.getFullYear(), "-").concat(month);
};
var getLastTwelveMonthsOptions = function() {
    var options = [];
    var date = new Date();
    date.setDate(1);
    for(var index = 0; index < 12; index += 1){
        var month = String(date.getMonth() + 1).padStart(2, "0");
        var year = date.getFullYear();
        options.push({
            value: "".concat(year, "-").concat(month),
            displayValue: "".concat(MONTH_LABELS[date.getMonth()], " ").concat(year)
        });
        date.setMonth(date.getMonth() - 1);
    }
    return options;
};
var AGGREGATE_BY_OPTIONS = [
    {
        value: "day",
        displayValue: "Day"
    },
    {
        value: "month",
        displayValue: "Month"
    }, 
];
/** First moment and last moment of the calendar month for `YYYY-MM`. */ var getMonthDateRange = function(yyyyMm) {
    var ref = (0,_sliced_to_array/* default */.Z)(yyyyMm.split("-").map(function(part) {
        return parseInt(part, 10);
    }), 2), y = ref[0], m = ref[1];
    var start = new Date(y, m - 1, 1, 0, 0, 0, 0);
    var end = new Date(y, m, 0, 23, 59, 59, 999);
    return {
        start: start,
        end: end
    };
};

;// CONCATENATED MODULE: ./components/walletTransactions/filtersSection/index.tsx








var FiltersSection = function(param) {
    var activeTag = param.activeTag, onGroupByTag = param.onGroupByTag, startDate = param.startDate, endDate = param.endDate, setStartDate = param.setStartDate, setEndDate = param.setEndDate, onApplyFilters = param.onApplyFilters;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var isDesktop = !isMobile;
    var ref = (0,compat_module.useState)(AGGREGATE_BY_OPTIONS[0]), aggregateBy = ref[0], setAggregateBy = ref[1];
    var monthOptions = getLastTwelveMonthsOptions();
    var ref1 = (0,compat_module.useState)(getCurrentMonthInput()), selectedMonth = ref1[0], setSelectedMonth = ref1[1];
    var today = new Date();
    var minDate = new Date();
    minDate.setMonth(today.getMonth() - 4);
    var selectedMonthOption = monthOptions.find(function(option) {
        return option.value === selectedMonth;
    }) || monthOptions[0];
    /** From: minDate → min(endDate, today). To: startDate → today. */ var fromCalendarEnd = new Date(Math.min(endDate.getTime(), today.getTime()));
    var renderAggregateByDropdown = function() {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
            className: "aggregateByDropdown",
            value: aggregateBy,
            heading: "Aggregate by",
            label: "",
            options: AGGREGATE_BY_OPTIONS,
            onChange: function(selected) {
                return setAggregateBy(selected);
            }
        });
    };
    var renderDateRangeFields = function() {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Date, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CalendarWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                        title: "From",
                        defaultDate: startDate,
                        onSelect: function(date) {
                            setStartDate(date);
                        },
                        enableWindow: {
                            start: minDate,
                            current: startDate,
                            end: fromCalendarEnd
                        },
                        isDesktop: isDesktop
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CalendarWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                        title: "To",
                        defaultDate: endDate,
                        onSelect: function(date) {
                            setEndDate(date);
                        },
                        enableWindow: {
                            start: startDate,
                            current: endDate,
                            end: today
                        },
                        isDesktop: isDesktop
                    })
                })
            ]
        });
    };
    var renderAggregateFields = function() {
        if (aggregateBy.value === "day") {
            return renderDateRangeFields();
        }
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FilterField, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterFieldLabel, {
                    children: "month"
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                    className: "monthDropdown",
                    value: selectedMonthOption,
                    heading: "Month",
                    label: "",
                    options: monthOptions,
                    onChange: function(selected) {
                        return setSelectedMonth(selected.value);
                    }
                })
            ]
        });
    };
    var handleApplyClick = function() {
        if (aggregateBy.value === "day") {
            onApplyFilters({
                startDate: startDate,
                endDate: endDate,
                txnAggLevel: "day"
            });
            return;
        }
        var ref = getMonthDateRange(selectedMonth), start = ref.start, end = ref.end;
        onApplyFilters({
            startDate: start,
            endDate: end,
            txnAggLevel: "month"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FilterCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DesktopTopRow, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabRow, {
                    children: LEDGER_TAG_TABS.map(function(tab) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(filtersSection_styles_TabButton, {
                            isActive: activeTag === tab.value,
                            onClick: function() {
                                return onGroupByTag(tab.value);
                            },
                            children: tab.label
                        }, tab.value);
                    })
                })
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileControlsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileTopRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileAggregateLabel, {
                                children: "Aggregate by"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileAggregateField, {
                                children: renderAggregateByDropdown()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileBottomRow, {
                        children: aggregateBy.value === "day" ? renderDateRangeFields() : renderAggregateFields()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileApplyRow, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileApplyFiltersButton, {
                            type: "button",
                            onClick: handleApplyClick,
                            children: "Apply"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FilterControls, {
                className: "inlineControls",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FiltersLabel, {
                        children: "Aggregate By"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterField, {
                        children: renderAggregateByDropdown()
                    }),
                    renderAggregateFields(),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ApplyFiltersButton, {
                        type: "button",
                        onClick: handleApplyClick,
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var filtersSection = (FiltersSection);

;// CONCATENATED MODULE: ./components/walletTransactions/ledgerTable/styles.ts

function ledgerTable_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from { opacity: 0; }\n    to { opacity: 1; }\n"
    ]);
    ledgerTable_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% { background-position: -240px 0; }\n    100% { background-position: 240px 0; }\n"
    ]);
    ledgerTable_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 14px;\n    border-radius: 10px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    background: #ffffff;\n    animation: ",
        " 0.3s ease;\n"
    ]);
    ledgerTable_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-collapse: collapse;\n\n    @media screen and (max-width: 768px) {\n        min-width: 560px;\n    }\n"
    ]);
    ledgerTable_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #f5f5f5;\n"
    ]);
    ledgerTable_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 14px 14px 14px 24px;\n    color: #5c5c6f;\n    font-size: 16px;\n    font-weight: 600;\n    text-align: left;\n\n    &:first-child {\n        border-top-left-radius: 8px;\n        border-bottom-left-radius: 8px;\n    }\n\n    &:last-child {\n        border-top-right-radius: 8px;\n        border-bottom-right-radius: 8px;\n    }\n"
    ]);
    ledgerTable_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 14px 20px 14px 24px;\n    color: #5d4aa8;\n    font-size: 15px;\n    text-align: left;\n"
    ]);
    ledgerTable_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #ffffff;\n    border-bottom: 1px solid #efefef;\n"
    ]);
    ledgerTable_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n"
    ]);
    ledgerTable_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #7c7c8b;\n"
    ]);
    ledgerTable_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 400;\n"
    ]);
    ledgerTable_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #2f2e38;\n    font-weight: 400;\n"
    ]);
    ledgerTable_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 12px;\n    animation: ",
        " 0.3s ease;\n"
    ]);
    ledgerTable_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #1f1e2f;\n    font-size: 28px;\n    font-weight: 700;\n    margin-bottom: 8px;\n"
    ]);
    ledgerTable_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px 0;\n    border-bottom: 1px solid #ececf2;\n"
    ]);
    ledgerTable_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    ledgerTable_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    ledgerTable_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 6px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n"
    ]);
    ledgerTable_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n"
    ]);
    ledgerTable_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #8f8f9f;\n    font-size: 12px;\n"
    ]);
    ledgerTable_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function ledgerTable_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #1f1e2f;\n    font-size: 18px;\n    font-weight: 700;\n"
    ]);
    ledgerTable_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #8f8f9f;\n    font-size: 14px;\n"
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #9e9eab;\n    font-size: 14px;\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 14px;\n    border-radius: 10px;\n    background: #ffffff;\n    padding: 12px;\n"
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 16px;\n    border-radius: 6px;\n    margin-bottom: 10px;\n    background: linear-gradient(90deg, #f2f2f5 25%, #ececf2 50%, #f2f2f5 75%);\n    background-size: 240px 100%;\n    animation: ",
        " 1.2s infinite;\n"
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}

var styles_fadeIn = (0,building_blocks_ui_common_dist.keyframes)(ledgerTable_styles_templateObject());
var styles_shimmer = (0,building_blocks_ui_common_dist.keyframes)(ledgerTable_styles_templateObject1());
var TableWrapper = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject2(), styles_fadeIn);
var Table = building_blocks_ui_common_dist.styled.table(ledgerTable_styles_templateObject3());
var TableHeaderRow = building_blocks_ui_common_dist.styled.tr(ledgerTable_styles_templateObject4());
var TableHeaderCell = building_blocks_ui_common_dist.styled.th(ledgerTable_styles_templateObject5());
var TableBodyCell = building_blocks_ui_common_dist.styled.td(ledgerTable_styles_templateObject6());
var TableBodyRow = building_blocks_ui_common_dist.styled.tr(ledgerTable_styles_templateObject7());
var TableBodyCellStrong = (0,building_blocks_ui_common_dist.styled)(TableBodyCell)(ledgerTable_styles_templateObject8());
var TableBodyCellMuted = (0,building_blocks_ui_common_dist.styled)(TableBodyCell)(ledgerTable_styles_templateObject9());
var TableBodyCellAmount = (0,building_blocks_ui_common_dist.styled)(TableBodyCell)(ledgerTable_styles_templateObject10(), function(param) {
    var variant = param.variant;
    return variant === "positive" ? "#0b7a6f" : variant === "negative" ? "#c45b5b" : "#2f2e38";
});
var TableBodyCellBalance = (0,building_blocks_ui_common_dist.styled)(TableBodyCell)(ledgerTable_styles_templateObject11());
var MobileWrapper = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject12(), styles_fadeIn);
var MobileTitle = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject13());
var MobileItem = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject14());
var styles_MobileTopRow = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject15());
var styles_MobileBottomRow = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject16());
var MobileCategoriesRow = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject17());
var MobileCategory = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject18());
var MobileCategoryLabel = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject19());
var MobileDate = building_blocks_ui_common_dist.styled.div(ledgerTable_styles_templateObject20());
var MobileType = building_blocks_ui_common_dist.styled.div(styles_templateObject21());
var MobileBalance = building_blocks_ui_common_dist.styled.div(styles_templateObject22());
var TableSkeletonWrapper = building_blocks_ui_common_dist.styled.div(styles_templateObject23());
var SkeletonBlock = building_blocks_ui_common_dist.styled.div(styles_templateObject24(), styles_shimmer);

;// CONCATENATED MODULE: ./components/walletTransactions/ledgerTable/helpers.ts

var getColumnVisibility = function(tag) {
    var isAll = tag === FilterTag.ALL;
    return {
        showDeposits: isAll || tag === FilterTag.DEPOSITS,
        showPremium: isAll || tag === FilterTag.PREMIUM,
        showRefund: isAll || tag === FilterTag.WALLET_REFUND
    };
};
var getAmountVariant = function(amount) {
    var trimmed = amount.trim();
    if (trimmed === "0.0" || trimmed === "0") return "zero";
    if (trimmed.startsWith("+")) return "positive";
    return "negative";
};
var parseAmount = function(amount) {
    var cleaned = amount.replace(/[₹,]/g, "").replace(/^\+/, "").trim();
    var num = parseFloat(cleaned);
    return Number.isNaN(num) ? 0 : Math.abs(num);
};
function aggregateRowsByDate(rows) {
    var byDate = rows.reduce(function(acc, row) {
        if (!acc[row.date]) {
            acc[row.date] = {
                date: row.date,
                balance: row.balance,
                deposits: 0,
                premium: 0,
                refund: 0
            };
        }
        if (row.tag === FilterTag.DEPOSITS) {
            acc[row.date].deposits += parseAmount(row.amount);
        } else if (row.tag === FilterTag.PREMIUM) {
            acc[row.date].premium += parseAmount(row.amount);
        } else if (row.tag === FilterTag.WALLET_REFUND) {
            acc[row.date].refund += parseAmount(row.amount);
        }
        return acc;
    }, {});
    return Object.values(byDate);
}
var formatAmount = function(value) {
    if (value === 0) return "0";
    if (value > 0) {
        return "₹".concat(value.toLocaleString("en-IN", {
            minimumFractionDigits: 2
        }));
    }
    return "—";
};
var formatGroupedBalance = function(value) {
    return "₹".concat(value.toLocaleString("en-IN", {
        minimumFractionDigits: 2
    }));
};
var getAmountForColumn = function(row, tag) {
    if (row.tag !== tag) return "0.0";
    return row.amount;
};
var getWalletRefundAmount = function(row) {
    if (row.tag !== FilterTag.WALLET_REFUND) return "0.0";
    return row.amount;
};

;// CONCATENATED MODULE: ./components/walletTransactions/ledgerTable/index.tsx





function LedgerTable(param) {
    var rows = param.rows, activeTag = param.activeTag, _isGrouped = param.isGrouped, isGrouped = _isGrouped === void 0 ? false : _isGrouped, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref = getColumnVisibility(activeTag), showDeposits = ref.showDeposits, showPremium = ref.showPremium, showRefund = ref.showRefund;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableSkeletonWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SkeletonBlock, {
                    style: {
                        width: "38%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SkeletonBlock, {
                    style: {
                        width: "100%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SkeletonBlock, {
                    style: {
                        width: "92%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SkeletonBlock, {
                    style: {
                        width: "96%"
                    }
                }),
                isMobile && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SkeletonBlock, {
                    style: {
                        width: "88%"
                    }
                })
            ]
        });
    }
    var groupedRows = isGrouped ? rows : [];
    var transactionRows = !isGrouped ? rows : [];
    var filteredGroupedRows = groupedRows;
    var tableRows = isGrouped ? [] : activeTag === FilterTag.ALL ? transactionRows : transactionRows.filter(function(row) {
        return row.tag === activeTag;
    });
    if (isMobile) {
        if (isGrouped) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileTitle, {
                        children: "Transactions"
                    }),
                    filteredGroupedRows.map(function(day) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_MobileTopRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileDate, {
                                            children: day.date
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileBalance, {
                                            children: "Bal: ".concat(formatGroupedBalance(day.balance))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategoriesRow, {
                                    children: [
                                        showDeposits && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategory, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileCategoryLabel, {
                                                    children: "Deposits"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                                    as: "div",
                                                    variant: day.deposits > 0 ? "positive" : "zero",
                                                    children: formatAmount(day.deposits)
                                                })
                                            ]
                                        }),
                                        showPremium && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategory, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileCategoryLabel, {
                                                    children: "Premium"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                                    as: "div",
                                                    variant: day.premium > 0 ? "negative" : "zero",
                                                    children: formatAmount(day.premium)
                                                })
                                            ]
                                        }),
                                        showRefund && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategory, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileCategoryLabel, {
                                                    children: "Refund"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                                    as: "div",
                                                    variant: day.refund > 0 ? "positive" : "zero",
                                                    children: formatAmount(day.refund)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, day.date);
                    })
                ]
            });
        }
        var aggregated = aggregateRowsByDate(tableRows);
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileTitle, {
                    children: "Transactions"
                }),
                aggregated.map(function(day) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_MobileTopRow, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileDate, {
                                        children: day.date
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileBalance, {
                                        children: "Bal: ".concat(day.balance)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategoriesRow, {
                                children: [
                                    showDeposits && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategory, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileCategoryLabel, {
                                                children: "Deposits"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                                as: "div",
                                                variant: day.deposits > 0 ? "positive" : "zero",
                                                children: formatAmount(day.deposits)
                                            })
                                        ]
                                    }),
                                    showPremium && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategory, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileCategoryLabel, {
                                                children: "Premium"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                                as: "div",
                                                variant: day.premium > 0 ? "negative" : "zero",
                                                children: formatAmount(day.premium)
                                            })
                                        ]
                                    }),
                                    showRefund && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(MobileCategory, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileCategoryLabel, {
                                                children: "Refund"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                                as: "div",
                                                variant: day.refund > 0 ? "positive" : "zero",
                                                children: formatAmount(day.refund)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, day.date);
                })
            ]
        });
    }
    if (isGrouped) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Table, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableHeaderRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                    children: "Date"
                                }),
                                showDeposits && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                    children: "Deposits"
                                }),
                                showPremium && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                    children: "Premium"
                                }),
                                showRefund && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                    children: "Wallet Refund"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                    children: "Total Balance"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tbody", {
                        children: filteredGroupedRows.map(function(row) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableBodyRow, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCell, {
                                        children: row.date
                                    }),
                                    showDeposits && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                        variant: row.deposits > 0 ? "positive" : "zero",
                                        children: row.deposits > 0 ? "+".concat(formatGroupedBalance(row.deposits)) : "0.0"
                                    }),
                                    showPremium && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                        variant: row.premium > 0 ? "negative" : "zero",
                                        children: row.premium > 0 ? "-".concat(formatGroupedBalance(row.premium)) : "0.0"
                                    }),
                                    showRefund && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                        variant: row.refund > 0 ? "positive" : "zero",
                                        children: row.refund > 0 ? "+".concat(formatGroupedBalance(row.refund)) : "0.0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellBalance, {
                                        children: formatGroupedBalance(row.balance)
                                    })
                                ]
                            }, row.date);
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Table, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableHeaderRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                children: "Date"
                            }),
                            showDeposits && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                children: "Deposits"
                            }),
                            showPremium && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                children: "Premium"
                            }),
                            showRefund && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                children: "Wallet Refund"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableHeaderCell, {
                                children: "Total Balance"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tbody", {
                    children: tableRows.map(function(row, index) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TableBodyRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCell, {
                                    children: row.date
                                }),
                                showDeposits && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                    variant: getAmountVariant(getAmountForColumn(row, FilterTag.DEPOSITS)),
                                    children: getAmountForColumn(row, FilterTag.DEPOSITS)
                                }),
                                showPremium && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                    variant: getAmountVariant(getAmountForColumn(row, FilterTag.PREMIUM)),
                                    children: getAmountForColumn(row, FilterTag.PREMIUM)
                                }),
                                showRefund && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellAmount, {
                                    variant: getAmountVariant(getWalletRefundAmount(row)),
                                    children: getWalletRefundAmount(row)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TableBodyCellBalance, {
                                    children: row.balance
                                })
                            ]
                        }, "".concat(row.date, "-").concat(index));
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var ledgerTable = (LedgerTable);

;// CONCATENATED MODULE: ./components/walletTransactions/pagination/styles.ts

function pagination_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 8px;\n    width: 100%;\n\n    @media screen and (max-width: 768px) {\n        justify-content: center;\n        margin-top: 20px;\n        padding-bottom: 8px;\n    }\n"
    ]);
    pagination_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pagination_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #6e6e6e;\n    font-size: 14px;\n    margin-right: 8px;\n"
    ]);
    pagination_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function pagination_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    color: #2f2e38;\n    font-size: 14px;\n    font-weight: ",
        ";\n    cursor: pointer;\n"
    ]);
    pagination_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function pagination_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid #d6d6d6;\n    background: #ffffff;\n    color: #2f2e38;\n    font-size: 14px;\n    cursor: ",
        ";\n    opacity: ",
        ";\n"
    ]);
    pagination_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function pagination_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #6e6e6e;\n    font-size: 14px;\n    padding: 0 2px;\n"
    ]);
    pagination_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var PaginationRow = building_blocks_ui_common_dist.styled.div(pagination_styles_templateObject());
var PaginationMeta = building_blocks_ui_common_dist.styled.span(pagination_styles_templateObject1());
var styles_PageButton = building_blocks_ui_common_dist.styled.button(pagination_styles_templateObject2(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#5d4aa8" : "#d6d6d6";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? "#ffffff" : "transparent";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? 600 : 400;
});
var PaginationArrow = building_blocks_ui_common_dist.styled.button(pagination_styles_templateObject3(), function(param) {
    var disabled = param.disabled;
    return disabled ? "not-allowed" : "pointer";
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
});
var PaginationDots = building_blocks_ui_common_dist.styled.span(pagination_styles_templateObject4());

;// CONCATENATED MODULE: ./components/walletTransactions/pagination/index.tsx


function LedgerPagination(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, rowsPerPage = param.rowsPerPage, onPageChange = param.onPageChange;
    var visiblePages = function() {
        if (totalPages <= 5) {
            return Array.from({
                length: totalPages
            }, function(_, index) {
                return index + 1;
            });
        }
        if (currentPage <= 3) {
            return [
                1,
                2,
                3,
                4,
                "...",
                totalPages
            ];
        }
        if (currentPage >= totalPages - 2) {
            return [
                1,
                "...",
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages, 
            ];
        }
        return [
            1,
            "...",
            currentPage - 1,
            currentPage,
            currentPage + 1,
            "...",
            totalPages, 
        ];
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaginationRow, {
        children: [
            rowsPerPage != null && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginationMeta, {
                children: "Rows per page: ".concat(rowsPerPage)
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginationArrow, {
                disabled: currentPage === 1,
                onClick: function() {
                    return onPageChange(Math.max(1, currentPage - 1));
                },
                children: "<"
            }),
            visiblePages().map(function(page, index) {
                return page === "..." ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginationDots, {
                    children: "..."
                }, "dots-".concat(index)) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_PageButton, {
                    isActive: currentPage === Number(page),
                    onClick: function() {
                        return onPageChange(Number(page));
                    },
                    children: page
                }, "page-".concat(page));
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginationArrow, {
                disabled: currentPage === totalPages,
                onClick: function() {
                    return onPageChange(Math.min(totalPages, currentPage + 1));
                },
                children: ">"
            })
        ]
    });
}
/* harmony default export */ var pagination = (LedgerPagination);

;// CONCATENATED MODULE: ./components/walletTransactions/utils/transformGroupedLedger.ts

var transformGroupedLedger_formatDate = function(isoString) {
    var d = new Date(isoString);
    return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
};
var getLastTransactionMs = function(item) {
    var ref, ref1;
    var ref2;
    var raw = (ref2 = (ref = item.endTime) === null || ref === void 0 ? void 0 : ref.value) !== null && ref2 !== void 0 ? ref2 : (ref1 = item.startTime) === null || ref1 === void 0 ? void 0 : ref1.value;
    if (!raw) return 0;
    var t = new Date(raw).getTime();
    return Number.isNaN(t) ? 0 : t;
};
var ref, ref1;
var getLastTransactionDateIso = function(item) {
    var ref2, ref3;
    return (ref1 = (ref = (ref2 = item.endTime) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref !== void 0 ? ref : (ref3 = item.startTime) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref1 !== void 0 ? ref1 : "";
};
function transformGroupedToLedgerRows(grouped) {
    var sorted = (0,_to_consumable_array/* default */.Z)(grouped).sort(function(a, b) {
        return getLastTransactionMs(b) - getLastTransactionMs(a);
    });
    return sorted.map(function(item) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6, ref7;
        var premium = ((ref6 = (ref = item.issuanceAmount) === null || ref === void 0 ? void 0 : ref.value) !== null && ref6 !== void 0 ? ref6 : 0) + ((ref7 = (ref1 = item.endorsementAmount) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref7 !== void 0 ? ref7 : 0);
        var ref8, ref9;
        var refund = ((ref8 = (ref2 = item.accountRefundAmount) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref8 !== void 0 ? ref8 : 0) + ((ref9 = (ref3 = item.cancellationAmount) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref9 !== void 0 ? ref9 : 0);
        var ref10;
        var deposits = (ref10 = (ref4 = item.depositAmount) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref10 !== void 0 ? ref10 : 0;
        var ref11;
        var balance = (ref11 = (ref5 = item.totalBalance) === null || ref5 === void 0 ? void 0 : ref5.value) !== null && ref11 !== void 0 ? ref11 : 0;
        return {
            date: transformGroupedLedger_formatDate(getLastTransactionDateIso(item)),
            deposits: deposits,
            premium: premium,
            refund: refund,
            balance: balance
        };
    });
}

;// CONCATENATED MODULE: ./components/walletTransactions/apis.ts





var getProductsByPartnerId = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, groupName) {
        var ref, status, data, e, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/user/wallet/products?group_name=").concat(groupName), (0,src_object_spread/* default */.Z)({
                            method: "GET"
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    return [
                        2,
                        {
                            status: status === 200,
                            data: data !== null && data !== void 0 ? data : null,
                            statusCode: status
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            status: false,
                            data: null,
                            statusCode: (e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) || 500
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getProductsByPartnerId(partnerId, groupName) {
        return _ref.apply(this, arguments);
    };
}();
var getWalletLedger = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, params, groupName) {
        var _page, ref, status, data, e, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/user/wallet/transactions-summary?group_name=").concat(groupName), (0,src_object_spread/* default */.Z)({
                            method: "POST",
                            data: {
                                page: (_page = params.page) !== null && _page !== void 0 ? _page : 1,
                                product_id: params.productId,
                                start_time: params.startTime,
                                end_time: params.endTime,
                                txn_agg_level: params.txnAggLevel,
                                wallet_user_id: params.walletUserId
                            }
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200) {
                        return [
                            2,
                            {
                                status: true,
                                data: data !== null && data !== void 0 ? data : null,
                                statusCode: status
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false,
                            data: null,
                            statusCode: status
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            status: false,
                            data: null,
                            statusCode: (e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) || 500
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getWalletLedger(partnerId, params, groupName) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/walletTransactions/index.tsx






// styles

// components







// constants

// utils





// apis

var getDateThreeMonthsAgo = function() {
    var d = new Date();
    d.setMonth(d.getMonth() - 3);
    return d;
};
var pad2 = function(n) {
    return String(n).padStart(2, "0");
};
/** Local calendar date as YYYY-MM-DD (avoids UTC shift from toISOString). */ var formatLocalDateForApi = function(date) {
    return "".concat(date.getFullYear(), "-").concat(pad2(date.getMonth() + 1), "-").concat(pad2(date.getDate()));
};
var formatStartTimeForApi = function(date) {
    return "".concat(formatLocalDateForApi(date), "T00:00:00");
};
var formatEndTimeForApi = function(date) {
    return "".concat(formatLocalDateForApi(date), "T23:59:59");
};
function WalletTransactions() {
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var router = (0,next_router.useRouter)();
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, permissions = ref.permissions;
    var ref1 = (0,compat_module.useState)(FilterTag.ALL), activeTag = ref1[0], setActiveTag = ref1[1];
    var ref2 = (0,compat_module.useState)(1), currentPage = ref2[0], setCurrentPage = ref2[1];
    var ref3 = (0,compat_module.useState)(function() {
        return getDateThreeMonthsAgo();
    }), startDate = ref3[0], setStartDate = ref3[1];
    var ref4 = (0,compat_module.useState)(function() {
        return new Date();
    }), endDate = ref4[0], setEndDate = ref4[1];
    var ref5 = (0,compat_module.useState)(function() {
        return getDateThreeMonthsAgo();
    }), appliedStartDate = ref5[0], setAppliedStartDate = ref5[1];
    var ref6 = (0,compat_module.useState)(function() {
        return new Date();
    }), appliedEndDate = ref6[0], setAppliedEndDate = ref6[1];
    var ref7 = (0,compat_module.useState)("day"), appliedTxnAggLevel = ref7[0], setAppliedTxnAggLevel = ref7[1];
    var ref8 = (0,compat_module.useState)([]), groupedRows = ref8[0], setGroupedRows = ref8[1];
    var ref9 = (0,compat_module.useState)([]), productsList = ref9[0], setProductsList = ref9[1];
    var ref10 = (0,compat_module.useState)(null), selectedProduct = ref10[0], setSelectedProduct = ref10[1];
    var ref11 = (0,compat_module.useState)(true), isFetchingProductId = ref11[0], setIsFetchingProductId = ref11[1];
    var ref12 = (0,compat_module.useState)(false), isFetchingLedger = ref12[0], setIsFetchingLedger = ref12[1];
    var ref13 = (0,compat_module.useState)(null), totalPagesFromApi = ref13[0], setTotalPagesFromApi = ref13[1];
    var ref14 = (0,compat_module.useState)(false), showError = ref14[0], setShowError = ref14[1];
    (0,compat_module.useEffect)(function() {
        var fetchProductId = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, status, data, products;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!partnerId) {
                                setIsFetchingProductId(false);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                getProductsByPartnerId(partnerId, permissions.group)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status && data) {
                                products = Array.isArray(data) ? data : (data === null || data === void 0 ? void 0 : data.products) || [];
                                setProductsList(products);
                                if (products.length > 0) {
                                    setSelectedProduct(products[0]);
                                }
                            } else {
                                setShowError(true);
                            }
                            setIsFetchingProductId(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchProductId() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProductId();
    }, [
        partnerId
    ]);
    (0,compat_module.useEffect)(function() {
        if (!partnerId || isFetchingProductId || !selectedProduct) return;
        var fetchLedger = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, status, data, ref1, ref2, ref3, ref4, payload, groupedTxnSummaries, totalPageNumbers;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsFetchingLedger(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                getWalletLedger(partnerId, {
                                    page: currentPage,
                                    startTime: formatStartTimeForApi(appliedStartDate),
                                    endTime: formatEndTimeForApi(appliedEndDate),
                                    productId: selectedProduct.product_id,
                                    walletUserId: selectedProduct.user_id,
                                    txnAggLevel: appliedTxnAggLevel
                                }, permissions.group)
                            ];
                        case 2:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status && data) {
                                ;
                                payload = data;
                                groupedTxnSummaries = (payload === null || payload === void 0 ? void 0 : payload.groupedTxnSummaries) || (payload === null || payload === void 0 ? void 0 : (ref1 = payload.data) === null || ref1 === void 0 ? void 0 : ref1.groupedTxnSummaries) || [];
                                totalPageNumbers = (payload === null || payload === void 0 ? void 0 : (ref2 = payload.totalPageNumbers) === null || ref2 === void 0 ? void 0 : ref2.value) || (payload === null || payload === void 0 ? void 0 : (ref3 = payload.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.totalPageNumbers) === null || ref4 === void 0 ? void 0 : ref4.value) || 1;
                                setGroupedRows(transformGroupedToLedgerRows(groupedTxnSummaries));
                                setTotalPagesFromApi(totalPageNumbers);
                            } else {
                                setGroupedRows([]);
                                setTotalPagesFromApi(1);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setIsFetchingLedger(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLedger() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchLedger();
    }, [
        partnerId,
        permissions.group,
        currentPage,
        appliedStartDate,
        appliedEndDate,
        appliedTxnAggLevel,
        selectedProduct,
        isFetchingProductId, 
    ]);
    var handleApplyFilters = function(payload) {
        setAppliedStartDate(payload.startDate);
        setAppliedEndDate(payload.endDate);
        setAppliedTxnAggLevel(payload.txnAggLevel);
        setCurrentPage(1);
        if (payload.txnAggLevel === "month") {
            setStartDate(payload.startDate);
            setEndDate(payload.endDate);
        }
    };
    var totalPages = totalPagesFromApi !== null && totalPagesFromApi !== void 0 ? totalPagesFromApi : 1;
    var onGroupByTag = function(tag) {
        setActiveTag(tag);
        setCurrentPage(1);
    };
    var onBack = function() {
        router.push("/".concat(lob, "/").concat(partnerId, "/dashboard"));
    };
    if (isFetchingProductId) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (showError) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            hideHeader: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(walletTransactions_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {
                wrapperStyles: {
                    maxWidth: isMobile ? "100%" : "95%",
                    margin: "0 auto",
                    padding: "20px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SectionDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SectionsCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TitleRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BackButton, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    width: "10px",
                                    height: "24px",
                                    alt: "",
                                    src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                                    onClick: onBack
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PageTitle, {
                                children: "Wallet Transactions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(walletTransactions_header, {
                        startDate: appliedStartDate,
                        endDate: appliedEndDate,
                        productsList: productsList,
                        selectedProduct: selectedProduct,
                        setSelectedProduct: setSelectedProduct
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(filtersSection, {
                        activeTag: activeTag,
                        onGroupByTag: onGroupByTag,
                        startDate: startDate,
                        endDate: endDate,
                        setStartDate: setStartDate,
                        setEndDate: setEndDate,
                        onApplyFilters: handleApplyFilters
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ledgerTable, {
                        rows: groupedRows,
                        activeTag: activeTag,
                        isGrouped: true,
                        isLoading: isFetchingLedger
                    }, activeTag),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(pagination, {
                        currentPage: currentPage,
                        totalPages: totalPages,
                        rowsPerPage: undefined,
                        onPageChange: setCurrentPage
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var walletTransactions = (WalletTransactions);

;// CONCATENATED MODULE: ./components/paymentMode/styles.ts

function paymentMode_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    padding: 20px;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    paymentMode_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    paymentMode_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 24px;\n    color: #040222;\n    margin-top: 10px;\n"
    ]);
    paymentMode_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n    font-size: 14px;\n    line-height: 24px;\n    color: #666666;\n    font-weight: 400;\n"
    ]);
    paymentMode_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 36px;\n    padding: 15px;\n    border-radius: 12px;\n    background: rgba(82, 82, 86, 0.08);\n    border: 1px solid #e3e4f2;\n    box-shadow: 0 2px 10px rgba(4, 2, 34, 0.08);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    paymentMode_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    line-height: 24px;\n    color: #666666;\n"
    ]);
    paymentMode_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 20px;\n    line-height: 24px;\n    font-weight: 600;\n    color: #040222;\n"
    ]);
    paymentMode_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n    padding: 14px;\n    border-radius: 12px;\n    border: ",
        ";\n    background: ",
        ";\n    box-shadow: 0 2px 10px rgba(4, 2, 34, 0.08);\n    cursor: ",
        ";\n    opacity: ",
        ";\n"
    ]);
    paymentMode_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 10px;\n"
    ]);
    paymentMode_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 1px solid #2563eb;\n    position: relative;\n    flex-shrink: 0;\n\n    &::after {\n        content: '';\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        background: #2563eb;\n        position: absolute;\n        top: 3px;\n        left: 3px;\n        opacity: ",
        ";\n    }\n"
    ]);
    paymentMode_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 5px;\n    color: #2563eb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    paymentMode_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 600;\n    color: #040222;\n"
    ]);
    paymentMode_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 4px;\n    margin-left: 24px;\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 200;\n    color: #666666;\n"
    ]);
    paymentMode_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: auto;\n    padding-top: 25px;\n    padding-bottom: 10px;\n"
    ]);
    paymentMode_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    margin-left: 10px;\n"
    ]);
    paymentMode_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: rgba(229, 14, 14, 0.8);\n    font-weight: 400;\n    font-size: 14px;\n    margin-left: 6px;\n"
    ]);
    paymentMode_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 10px;\n    padding: 12px 15px;\n    border-radius: 12px;\n    border: 1px solid rgba(37, 99, 235, 0.2);\n    background: rgba(37, 99, 235, 0.08);\n"
    ]);
    paymentMode_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 400;\n    color: #2563eb;\n"
    ]);
    paymentMode_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function paymentMode_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 4px;\n    margin-left: 44px;\n    font-size: 12px;\n    line-height: 20px;\n    color: rgba(37, 99, 235, 0.9);\n"
    ]);
    paymentMode_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}

var paymentMode_styles_Wrapper = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject());
var paymentMode_styles_BackArrowIcon = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject1());
var paymentMode_styles_Title = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject2());
var paymentMode_styles_SubTitle = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject3());
var AmountCard = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject4());
var AmountLabel = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject5());
var AmountValue = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject6());
var OptionCard = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject7(), function(param) {
    var isSelected = param.isSelected, isDisabled = param.isDisabled;
    return isSelected ? "2px solid #2463eb" : isDisabled ? "1px solid rgba(218, 218, 250, 0.24)" : "1px solid rgba(98, 99, 187, 0.08)";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "rgba(126, 126, 129, 0.08)" : "#2463eb0d";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "not-allowed" : "pointer";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? 0.4 : 1;
});
var OptionTopRow = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject8());
var Radio = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject9(), function(param) {
    var isSelected = param.isSelected;
    return isSelected ? 1 : 0;
});
var IconWrapper = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject10());
var OptionTitle = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject11());
var OptionSuccessText = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject12());
var StickyFooter = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject13());
var WarningTitleContainer = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject14());
var WarningTitleText = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject15());
var RedirectInfoCard = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject16());
var RedirectInfoTitle = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject17());
var RedirectInfoSubText = building_blocks_ui_common_dist.styled.div(paymentMode_styles_templateObject18());

;// CONCATENATED MODULE: ./components/paymentMode/constants.ts
var PAYMENT_METHODS = {
    WALLET: "WALLET",
    PAYMENT_GATEWAY: "PAYMENT_GATEWAY"
};

;// CONCATENATED MODULE: ./components/paymentMode/apis.ts





var getPaymentMethod = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, orderEkey, groupName) {
        var ref, status, data, e, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/wallet/payment-summary?order_ekey=").concat(orderEkey, "&user_group=").concat(groupName), (0,src_object_spread/* default */.Z)({
                            method: "GET"
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200 && data) {
                        return [
                            2,
                            {
                                data: {
                                    orderEkey: data.order_ekey,
                                    net_payable: data.net_payable,
                                    premium: data.premium,
                                    available_method: data.available_method || [
                                        "WALLET",
                                        "PAYMENT_GATEWAY"
                                    ],
                                    has_sufficient_balance: data.has_sufficient_balance
                                },
                                status: true,
                                statusCode: 200
                            }
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                data: {
                                    orderEkey: "",
                                    net_payable: 0,
                                    premium: 0,
                                    available_method: [],
                                    has_sufficient_balance: false
                                },
                                status: false,
                                statusCode: 401
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: {
                                orderEkey: "",
                                net_payable: 0,
                                premium: 0,
                                available_method: [],
                                has_sufficient_balance: false
                            },
                            status: false,
                            statusCode: 500
                        }
                    ];
                case 3:
                    return [
                        2,
                        {
                            data: {
                                orderEkey: "",
                                net_payable: 0,
                                premium: 0,
                                available_method: [],
                                has_sufficient_balance: false
                            },
                            status: false,
                            statusCode: 500
                        }
                    ];
            }
        });
    });
    return function getPaymentMethod(partnerId, orderEkey, groupName) {
        return _ref.apply(this, arguments);
    };
}();
var completePayment = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(partnerId, orderEkey) {
        var ref, status, data, e, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)("".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/wallet/create-payment"), (0,src_object_spread/* default */.Z)({
                            method: "POST",
                            data: {
                                order_ekey: orderEkey
                            }
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200) {
                        return [
                            2,
                            {
                                status: true,
                                statusCode: 200,
                                data: data
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false,
                            statusCode: 500,
                            data: null
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                status: false,
                                statusCode: 401,
                                data: null
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false,
                            statusCode: 500,
                            data: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function completePayment(partnerId, orderEkey) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/paymentMode/PaymentMethodOptionCard.tsx





function PaymentMethodOptionCard(param) {
    var method = param.method, config = param.config, selectedPaymentMethod = param.selectedPaymentMethod, isWalletDisabled = param.isWalletDisabled, onSelectMethod = param.onSelectMethod;
    var isWalletMethod = method === PAYMENT_METHODS.WALLET;
    var isDisabled = isWalletMethod ? isWalletDisabled : false;
    var onCardClick = function() {
        if (isDisabled) return;
        onSelectMethod(method);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(OptionCard, {
        isSelected: selectedPaymentMethod === method,
        isDisabled: isDisabled,
        onClick: onCardClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(OptionTopRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Radio, {
                        isSelected: selectedPaymentMethod === method
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: (0,generics/* getImageBasePath */.m4)(config.icon),
                            alt: "",
                            width: "22px",
                            height: "22px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OptionTitle, {
                        children: config.optionTitle
                    })
                ]
            }),
            isWalletMethod && isWalletDisabled ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(WarningTitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)("/icons/errorRed.svg"),
                        alt: "",
                        width: 14,
                        height: 14
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WarningTitleText, {
                        children: "Insufficient balance for this order"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OptionSuccessText, {
                children: config.successText
            })
        ]
    }, method);
}
/* harmony default export */ var paymentMode_PaymentMethodOptionCard = (PaymentMethodOptionCard);

;// CONCATENATED MODULE: ./components/paymentMode/helpers.ts






var getPaymentMethodConfig = function(formattedOrderAmount) {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, PAYMENT_METHODS.WALLET, {
        icon: "/icons/wallet.svg",
        optionTitle: "Debit from Wallet",
        successText: "₹".concat(formattedOrderAmount, " will be debited from wallet")
    }), (0,_define_property/* default */.Z)(_obj, PAYMENT_METHODS.PAYMENT_GATEWAY, {
        icon: "/icons/card.svg",
        optionTitle: "Use Payment Gateway",
        successText: "Pay using Credit/Debit Card, UPI, or Net Banking"
    }), _obj;
};
var handleCompletePayment = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var selectedPaymentMethod, orderEkey, partnerId, setIsBtnLoading, setSnackbar, redirectToLogin, redirectToThankYou, redirectToGateway, ref, status, statusCode, data, ref1, data1, status1, statusCode1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedPaymentMethod = param.selectedPaymentMethod, orderEkey = param.orderEkey, partnerId = param.partnerId, setIsBtnLoading = param.setIsBtnLoading, setSnackbar = param.setSnackbar, redirectToLogin = param.redirectToLogin, redirectToThankYou = param.redirectToThankYou, redirectToGateway = param.redirectToGateway;
                    setIsBtnLoading(true);
                    if (!orderEkey || !partnerId) {
                        setIsBtnLoading(false);
                        setSnackbar({
                            type: "failure",
                            message: "Unable to complete payment. Please try again."
                        });
                        return [
                            2
                        ];
                    }
                    if (!(selectedPaymentMethod === PAYMENT_METHODS.WALLET)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        completePayment(partnerId, orderEkey)
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, statusCode = ref.statusCode, data = ref.data;
                    if (statusCode === 401) {
                        redirectToLogin();
                        setSnackbar({
                            type: "failure",
                            message: "Token expired. Redirecting to login page."
                        });
                        setIsBtnLoading(false);
                        return [
                            2
                        ];
                    }
                    if (status) {
                        redirectToThankYou(data === null || data === void 0 ? void 0 : data.payment_order_ekey);
                        return [
                            2
                        ];
                    }
                    setIsBtnLoading(false);
                    setSnackbar({
                        type: "failure",
                        message: "Unable to complete payment. Please try again."
                    });
                    return [
                        2
                    ];
                case 2:
                    if (!(selectedPaymentMethod === PAYMENT_METHODS.PAYMENT_GATEWAY)) return [
                        3,
                        4
                    ];
                    if (!orderEkey) {
                        setIsBtnLoading(false);
                        setSnackbar({
                            type: "failure",
                            message: "Unable to complete payment. Please try again."
                        });
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        (0,services.dealerPayment)(partnerId, String(orderEkey))
                    ];
                case 3:
                    ref1 = _state.sent(), data1 = ref1.data, status1 = ref1.status, statusCode1 = ref1.statusCode;
                    if (statusCode1 === 401) {
                        redirectToLogin();
                        setSnackbar({
                            type: "failure",
                            message: "Token expired. Redirecting to login page."
                        });
                        return [
                            2
                        ];
                    }
                    if (status1 && (data1 === null || data1 === void 0 ? void 0 : data1.payment_gateway_url)) {
                        redirectToGateway(String(data1.payment_gateway_url), String((data1 === null || data1 === void 0 ? void 0 : data1.payment_order_ekey) || ""));
                        return [
                            2
                        ];
                    }
                    setSnackbar({
                        type: "failure",
                        message: "Oops. Something went wrong."
                    });
                    setIsBtnLoading(false);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleCompletePayment(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/paymentMode/index.tsx








// component

// utils




// styles

// constants





function PaymentMode() {
    var ref;
    var router = (0,next_router.useRouter)();
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var ref1 = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref1.planDetails, partnerId = ref1.partnerId, permissions = ref1.permissions;
    var ref2 = (0,compat_module.useState)(0), orderAmount = ref2[0], setOrderAmount = ref2[1];
    var ref3 = (0,compat_module.useState)([]), paymentMethods = ref3[0], setPaymentMethods = ref3[1];
    var ref4 = (0,compat_module.useState)(false), isWalletEnabled = ref4[0], setIsWalletEnabled = ref4[1];
    var ref5 = (0,compat_module.useState)(""), selectedPaymentMethod = ref5[0], setSelectedPaymentMethod = ref5[1];
    var ref6 = (0,compat_module.useState)(false), isBtnLoading = ref6[0], setIsBtnLoading = ref6[1];
    var ref7 = (0,compat_module.useState)(true), isFetchingPaymentDetails = ref7[0], setIsFetchingPaymentDetails = ref7[1];
    var ref8 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref8[0], setSnackbar = ref8[1];
    var formattedOrderAmount = orderAmount === null || orderAmount === void 0 ? void 0 : orderAmount.toLocaleString("en-IN");
    var orderEkey = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.order_ekey) || (planDetails === null || planDetails === void 0 ? void 0 : planDetails.order_ekey);
    var paymentMethodConfig = getPaymentMethodConfig(formattedOrderAmount);
    var onCompletePayment = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleCompletePayment({
                                selectedPaymentMethod: selectedPaymentMethod,
                                orderEkey: orderEkey,
                                partnerId: partnerId,
                                setIsBtnLoading: setIsBtnLoading,
                                setSnackbar: setSnackbar,
                                redirectToLogin: function() {
                                    return router.push("/login");
                                },
                                redirectToThankYou: function(paymentOrderEkey) {
                                    window.location.href = "/".concat(lob, "/").concat(partnerId, "/thankyou?payment_order_ekey=").concat(paymentOrderEkey);
                                },
                                redirectToGateway: function(paymentGatewayUrl, paymentOrderEkey) {
                                    window.location.href = "".concat(paymentGatewayUrl, "?id=").concat(paymentOrderEkey, "&redirect_source=pos_dealer");
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onCompletePayment() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,compat_module.useEffect)(function() {
        var fetchPaymentDetails = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var ref, _data, net_payable, available_method, has_sufficient_balance, status, statusCode, methods, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!orderEkey || !partnerId) {
                                setIsFetchingPaymentDetails(false);
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                getPaymentMethod(partnerId, orderEkey, permissions.group)
                            ];
                        case 2:
                            ref = _state.sent(), _data = ref.data, net_payable = _data.net_payable, available_method = _data.available_method, has_sufficient_balance = _data.has_sufficient_balance, status = ref.status, statusCode = ref.statusCode;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status && statusCode === 200) {
                                setOrderAmount(net_payable);
                                methods = available_method || [
                                    PAYMENT_METHODS.PAYMENT_GATEWAY
                                ];
                                setPaymentMethods(methods);
                                setIsWalletEnabled(has_sufficient_balance);
                                setSelectedPaymentMethod(has_sufficient_balance ? PAYMENT_METHODS.WALLET : PAYMENT_METHODS.PAYMENT_GATEWAY);
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            setSnackbar({
                                type: "failure",
                                message: "Failed to fetch payment details"
                            });
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsFetchingPaymentDetails(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPaymentDetails() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPaymentDetails();
    }, [
        partnerId,
        orderEkey
    ]);
    var onBack = function() {
        router.back();
    };
    var renderRedirectInfoCard = function() {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RedirectInfoCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(OptionTopRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: (0,generics/* getImageBasePath */.m4)("/icons/card.svg"),
                                alt: "",
                                width: "24px",
                                height: "24px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RedirectInfoTitle, {
                            children: "You will be redirected to payment gateway"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RedirectInfoSubText, {
                    children: [
                        "Complete payment of ₹",
                        formattedOrderAmount,
                        "."
                    ]
                })
            ]
        });
    };
    if (isFetchingPaymentDetails) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(paymentMode_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(paymentMode_styles_BackArrowIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "10px",
                    height: "24px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                    onClick: onBack
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(paymentMode_styles_Title, {
                children: "Payment Mode"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(paymentMode_styles_SubTitle, {
                children: "Please select from the available payment methods. Click complete payment to complete your order."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(AmountCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AmountLabel, {
                        children: "Order Amount"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(AmountValue, {
                        children: [
                            "₹",
                            formattedOrderAmount
                        ]
                    })
                ]
            }),
            paymentMethods.map(function(method) {
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(paymentMode_PaymentMethodOptionCard, {
                    method: method,
                    config: paymentMethodConfig[method],
                    selectedPaymentMethod: selectedPaymentMethod,
                    isWalletDisabled: !isWalletEnabled,
                    onSelectMethod: setSelectedPaymentMethod
                }, method);
            }),
            paymentMethods.includes(PAYMENT_METHODS.PAYMENT_GATEWAY) && selectedPaymentMethod === PAYMENT_METHODS.PAYMENT_GATEWAY && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                children: renderRedirectInfoCard()
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StickyFooter, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onCompletePayment,
                    disabled: isFetchingPaymentDetails || selectedPaymentMethod === "",
                    loading: isBtnLoading,
                    children: "Complete Payment"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var paymentMode = (PaymentMode);

;// CONCATENATED MODULE: ./widgets/tnc/styles.ts

function tnc_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n\n    & > ul > li {\n        font-size: 14px;\n    }\n\n    @media screen and (min-width: 769px) {\n        width: 360px;\n    }\n"
    ]);
    tnc_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function tnc_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n"
    ]);
    tnc_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function tnc_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n"
    ]);
    tnc_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function tnc_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n"
    ]);
    tnc_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var tnc_styles_Wrapper = styled_components_browser_esm["default"].div(tnc_styles_templateObject());
var Headaer = styled_components_browser_esm["default"].div(tnc_styles_templateObject1());
var BackArrow = styled_components_browser_esm["default"].div(tnc_styles_templateObject2());
var Download = styled_components_browser_esm["default"].div(tnc_styles_templateObject3());

;// CONCATENATED MODULE: ./widgets/tnc/index.tsx




var items = [
    "I/We hereby confirm that the information provided herein is accurate, correct and complete and that the documents submitted along with this such are genuine.",
    "I/We hereby confirm that I have not concealed or distorted any information submitted.",
    "I/We undertake to inform in writing of any changes to the information already provided and to update the information whenever requested to do so.",
    "I/We undertake to conduct the business in a lawful manner and shall always abide by the applicable laws.",
    "I/We hereby declare that, in the event any information is required or needs to be shared with any third party in accordance with applicable law, I/we explicitly agree to full compliance without my/our additional consent.",
    "I/We understand that I/We might have to submit relevant information in future as and when desired and I/We agree to execute / sign relevant document to enable the transaction",
    "I/We understand and agree that this declaration is final and irrevocable, and that it is not subject to cancellation or amendments.", 
];
function LegalDocumentTnc(param) {
    var onClick = param.onClick;
    var onClickDownload = function() {
        window.open("https://acko-public.s3.ap-south-1.amazonaws.com/pos/oppo/dealer-tnc.pdf");
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(tnc_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Headaer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BackArrow, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: "/icons/backArrow.svg",
                            alt: "",
                            width: 20,
                            height: 20,
                            onClick: onClick,
                            style: {
                                cursor: "pointer"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Download, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: "/icons/download.svg",
                            alt: "",
                            width: 20,
                            height: 20,
                            onClick: onClickDownload,
                            style: {
                                cursor: "pointer"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                children: items.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                        style: {
                            margin: "10px 0",
                            lineHeight: "20px"
                        },
                        children: item
                    }, i);
                })
            })
        ]
    });
}
/* harmony default export */ var tnc = (LegalDocumentTnc);

;// CONCATENATED MODULE: ./components/legalDocuments/constants.ts
var LegalDocumentsSegments;
(function(LegalDocumentsSegments) {
    LegalDocumentsSegments["VIEW_PAGE_DEALER_DETAILS_COLLECTION"] = "view_page_dealer_details_collection";
    LegalDocumentsSegments["TAP_BTN_SUBMIT"] = "tap_btn_submit";
    LegalDocumentsSegments["TAP_BTN_TNC"] = "tap_btn_t&c";
})(LegalDocumentsSegments || (LegalDocumentsSegments = {}));

;// CONCATENATED MODULE: ./components/legalDocuments/styles.ts

function legalDocuments_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"
    ]);
    legalDocuments_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n        transform: translateY(-8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"
    ]);
    legalDocuments_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n        max-height: 0;\n        transform: translateY(-4px);\n    }\n    to {\n        opacity: 1;\n        max-height: 640px;\n        transform: translateY(0);\n    }\n"
    ]);
    legalDocuments_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% { transform: scale(1); }\n    50% { transform: scale(0.98); }\n    100% { transform: scale(1); }\n"
    ]);
    legalDocuments_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media (prefers-reduced-motion: no-preference) {\n        ",
        "\n    }\n"
    ]);
    legalDocuments_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    background: #f7f8fa;\n    min-height: 100vh;\n"
    ]);
    legalDocuments_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-rows: auto 1fr auto;\n    width: 100%;\n    min-height: 100vh;\n    background: #ffffff;\n\n    @media screen and (min-width: 768px) {\n        max-width: 480px;\n        margin: 0 auto;\n        box-shadow: 0 0 0 1px #e8e8ef;\n    }\n"
    ]);
    legalDocuments_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 20px;\n    padding-bottom: 0;\n"
    ]);
    legalDocuments_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.35s ease-out;\n    "
    ]);
    legalDocuments_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n    padding: 0 20px 24px;\n    ",
        "\n"
    ]);
    legalDocuments_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #040222;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    margin: 10px 0 4px;\n"
    ]);
    legalDocuments_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            animation: ",
        " 0.28s ease-out;\n            overflow: hidden;\n        "
    ]);
    legalDocuments_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    ",
        "\n"
    ]);
    legalDocuments_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    color: #040222;\n    font-size: 16px;\n    font-weight: 600;\n    margin: 18px 0 4px;\n"
    ]);
    legalDocuments_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 14px 0;\n"
    ]);
    legalDocuments_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 14px 0;\n    border-bottom: 1px solid #eef0f4;\n\n    &:last-child {\n        border-bottom: none;\n    }\n"
    ]);
    legalDocuments_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #5b5675;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 500;\n"
    ]);
    legalDocuments_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #040222;\n    font-size: 15px;\n    line-height: 22px;\n    font-weight: 600;\n    word-break: break-word;\n"
    ]);
    legalDocuments_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    color: #151619;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 16px;\n"
    ]);
    legalDocuments_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    color: #040222;\n    font-size: 14px;\n    line-height: 20px;\n"
    ]);
    legalDocuments_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 44px;\n"
    ]);
    legalDocuments_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 48px;\n"
    ]);
    legalDocuments_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    color: #040222;\n    font-size: 16px;\n    font-weight: 600;\n    margin-top: 10px;\n"
    ]);
    legalDocuments_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    background: white;\n    border-top: 1px solid #e0e0e8;\n    padding: 15px 20px;\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n"
    ]);
    legalDocuments_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function legalDocuments_styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 10px;\n"
    ]);
    legalDocuments_styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #040222;\n    font-size: 12px;\n    line-height: 16px;\n\n    & > span {\n        color: #1c73e8;\n        cursor: pointer;\n    }\n"
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            animation: ",
        " 0.2s ease;\n        "
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 16px;\n    ",
        "\n"
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-size: 12px;\n    line-height: 16px;\n    margin-top: 4px;\n    color: #d83d37;\n"
    ]);
    styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function styles_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: stretch;\n"
    ]);
    styles_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function styles_templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 700;\n    color: #7a4d00;\n    margin-bottom: 12px;\n"
    ]);
    styles_templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function styles_templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 500;\n    color: #53556b;\n"
    ]);
    styles_templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function styles_templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 12px 0 0;\n    font-size: 13px;\n    line-height: 18px;\n    color: #8a6420;\n"
    ]);
    styles_templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function styles_templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 24px;\n    width: 100%;\n\n    button {\n        width: 100%;\n    }\n"
    ]);
    styles_templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function styles_templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.28s ease-out;\n    "
    ]);
    styles_templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function styles_templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 12px 0 4px;\n    padding: 12px 14px;\n    border-radius: 10px;\n    background: #fef2f1;\n    border: 1px solid #f0b8b4;\n    color: #a12822;\n    font-size: 13px;\n    line-height: 18px;\n    ",
        "\n"
    ]);
    styles_templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function styles_templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 50vh;\n    color: #5b5675;\n    font-size: 14px;\n"
    ]);
    styles_templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}

var fadeSlideUp = (0,styled_components_browser_esm.keyframes)(legalDocuments_styles_templateObject());
var slideInDown = (0,styled_components_browser_esm.keyframes)(legalDocuments_styles_templateObject1());
var expandIn = (0,styled_components_browser_esm.keyframes)(legalDocuments_styles_templateObject2());
var ctaPress = (0,styled_components_browser_esm.keyframes)(legalDocuments_styles_templateObject3());
var motionSafe = function(styles) {
    return (0,styled_components_browser_esm.css)(legalDocuments_styles_templateObject4(), styles);
};
var FormItemWrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject5());
var FormGridWrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject6());
var legalDocuments_styles_HeaderWrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject7());
var legalDocuments_styles_Wrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject9(), motionSafe((0,styled_components_browser_esm.css)(legalDocuments_styles_templateObject8(), fadeSlideUp)));
var legalDocuments_styles_Title = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject10());
var SectionBlock = styled_components_browser_esm["default"].section(legalDocuments_styles_templateObject12(), function(props) {
    return props.$animateExpand && motionSafe((0,styled_components_browser_esm.css)(legalDocuments_styles_templateObject11(), expandIn));
});
var SectionTitle = styled_components_browser_esm["default"].h2(legalDocuments_styles_templateObject13());
var ItemWrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject14());
var ConfirmRow = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject15());
var ConfirmLabel = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject16());
var ConfirmValue = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject17());
var GSTTitle = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject18());
var CheckBoxText = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject19());
var legalDocuments_styles_CheckBoxFlex = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject20());
var CheckBoxItemWrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject21());
var BankDetailsTitle = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject22());
var BottomWrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject23());
var legalDocuments_styles_TncWrapper = styled_components_browser_esm["default"].div(legalDocuments_styles_templateObject24());
var TcnText = styled_components_browser_esm["default"].span(styles_templateObject25());
var legalDocuments_styles_ButtonWrapper = styled_components_browser_esm["default"].div(styles_templateObject27(), function(props) {
    return props.$pressed && motionSafe((0,styled_components_browser_esm.css)(styles_templateObject26(), ctaPress));
});
var DocumentUploadErrorMessage = styled_components_browser_esm["default"].div(styles_templateObject28());
var PartialModalContent = styled_components_browser_esm["default"].div(styles_templateObject29());
var PartialModalTitle = styled_components_browser_esm["default"].div(styles_templateObject30());
var PartialModalText = styled_components_browser_esm["default"].p(styles_templateObject31());
var PartialModalHint = styled_components_browser_esm["default"].p(styles_templateObject32());
var PartialModalActions = styled_components_browser_esm["default"].div(styles_templateObject33());
var ErrorBanner = styled_components_browser_esm["default"].div(styles_templateObject35(), motionSafe((0,styled_components_browser_esm.css)(styles_templateObject34(), slideInDown)));
var LoadingState = styled_components_browser_esm["default"].div(styles_templateObject36());
/* legacy aliases used by TNC screen */ 

// EXTERNAL MODULE: ./components/legalDocuments/types.ts
var legalDocuments_types = __webpack_require__(44);
// EXTERNAL MODULE: ./components/legalDocuments/helpers.ts
var legalDocuments_helpers = __webpack_require__(8485);
;// CONCATENATED MODULE: ./components/legalDocuments/FinancialDetailsForm.tsx










function FinancialDetailsForm(param) {
    var mode = param.mode, description = param.description, buttonName = param.buttonName, uiConfig = param.uiConfig, values = param.values, validationErr = param.validationErr, isBtnLoading = param.isBtnLoading, isBtnDisabled = param.isBtnDisabled, isFetchingIfsc = param.isFetchingIfsc, errorMessage = param.errorMessage, ctaPressed = param.ctaPressed, onChangeValue = param.onChangeValue, onBlurField = param.onBlurField, onSelectFile = param.onSelectFile, onDeleteFile = param.onDeleteFile, onClickTncLink = param.onClickTncLink, onSubmit = param.onSubmit;
    var ref;
    var sections = (0,legalDocuments_helpers/* groupFieldsBySection */.Ul)(uiConfig, values);
    var tncField = uiConfig.find(function(field) {
        return field.component === "tnc_checkbox";
    });
    var gstExpanded = Boolean(values.gst_applicable);
    var renderCaptureField = function(field) {
        var _props = field.props, key = _props.key_name, transform = _props.transform;
        var value = values[key];
        var err = validationErr[key] || "";
        var editable = (0,legalDocuments_helpers/* isFieldEditable */.Hp)(field);
        if (field.component === "input") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ItemWrapper, {
                onBlur: function() {
                    return onBlurField(field);
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                    name: key,
                    type: field.type || "text",
                    className: "",
                    value: value || "",
                    onChange: function(e) {
                        if (!editable) return;
                        var next = e.target.value;
                        if (transform === "uppercase") {
                            next = next.toUpperCase();
                        }
                        onChangeValue(key, next);
                    },
                    placeHolder: field.label || field.title || "",
                    hasError: err.length > 0,
                    errMsg: err,
                    disabled: !editable,
                    rightElement: key === "ifsc_code" && isFetchingIfsc ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: "/gif/greenCircleLoader.gif",
                        alt: "",
                        width: 20,
                        height: 20
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {})
                })
            }, field.id);
        }
        if (field.component === "dropdown") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ItemWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                    value: value || {
                        value: "",
                        displayValue: ""
                    },
                    heading: "Select ".concat(field.label),
                    label: field.label,
                    options: (0,legalDocuments_helpers/* mapDropdownOptions */.xT)(field.props.options || []),
                    onChange: function(option) {
                        if (!editable) return;
                        onChangeValue(key, option);
                    },
                    error: err,
                    disabled: !editable
                })
            }, field.id);
        }
        if (field.component === "yes_no") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ItemWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GSTTitle, {
                        children: field.label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CheckBoxItemWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(legalDocuments_styles_CheckBoxFlex, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_checkbox, {
                                        isSelected: !!value,
                                        onSelectHandler: function() {
                                            if (!editable) return;
                                            onChangeValue(key, true);
                                        },
                                        color: "#0FA457",
                                        width: "18px",
                                        height: "18px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CheckBoxText, {
                                        children: "Yes"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(legalDocuments_styles_CheckBoxFlex, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_checkbox, {
                                        isSelected: !value,
                                        onSelectHandler: function() {
                                            if (!editable) return;
                                            onChangeValue(key, false);
                                        },
                                        color: "#0FA457",
                                        width: "18px",
                                        height: "18px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CheckBoxText, {
                                        children: "No"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, field.id);
        }
        if (field.component === "document_upload") {
            return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ItemWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(documentUpload, {
                        id: field.id,
                        label: field.label,
                        title: "",
                        documentName: (value === null || value === void 0 ? void 0 : value.name) || "",
                        uploadStatus: (value === null || value === void 0 ? void 0 : value.uploadStatus) || "",
                        isMandatory: !!field.required,
                        disabled: !editable,
                        onSelect: function(id, file) {
                            return onSelectFile(id, file, field);
                        },
                        onDelete: function() {
                            return onDeleteFile(field);
                        }
                    }),
                    err.length > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DocumentUploadErrorMessage, {
                        children: err
                    })
                ]
            }, field.id);
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(legalDocuments_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocuments_styles_Title, {
                        children: description
                    }),
                    errorMessage ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ErrorBanner, {
                        children: errorMessage
                    }) : null,
                    sections.map(function(param) {
                        var section = param.section, fields = param.fields;
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SectionBlock, {
                            $animateExpand: section === "gst" && gstExpanded,
                            children: [
                                legalDocuments_types/* SECTION_TITLES */.XQ[section] ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SectionTitle, {
                                    children: legalDocuments_types/* SECTION_TITLES */.XQ[section]
                                }) : null,
                                fields.map(function(field) {
                                    return (0,legalDocuments_helpers/* isFieldVisible */.Nh)(field, values) ? renderCaptureField(field) : null;
                                })
                            ]
                        }, section);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(BottomWrapper, {
                children: [
                    mode === "capture" && tncField ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(legalDocuments_styles_TncWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocuments_styles_CheckBoxFlex, {
                                style: {
                                    alignItems: "start"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_checkbox, {
                                    isSelected: !!values[tncField.props.key_name],
                                    onSelectHandler: function() {
                                        return onChangeValue(tncField.props.key_name, !values[tncField.props.key_name]);
                                    },
                                    color: "#0FA457",
                                    width: "18px",
                                    height: "18px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TcnText, {
                                children: [
                                    "By tapping on the button below, I agree to ACKO'S",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        onClick: onClickTncLink,
                                        children: "Terms and Conditions"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    mode === "capture" && validationErr[(tncField === null || tncField === void 0 ? void 0 : (ref = tncField.props) === null || ref === void 0 ? void 0 : ref.key_name) || ""] ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DocumentUploadErrorMessage, {
                        children: validationErr[tncField.props.key_name]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocuments_styles_ButtonWrapper, {
                        $pressed: ctaPressed,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                            disabled: isBtnDisabled,
                            onClick: onSubmit,
                            loading: isBtnLoading,
                            children: buttonName
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var legalDocuments_FinancialDetailsForm = (FinancialDetailsForm);

;// CONCATENATED MODULE: ./components/legalDocuments/index.tsx























function LegalDocumentsUpload() {
    var router = (0,next_router.useRouter)();
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, legalDetailsUploadedStatus = ref.legalDetailsUploadedStatus, setSnackbar = ref.setSnackbar, setLegalDetailsUploadedStatus = ref.setLegalDetailsUploadedStatus, userDetails = ref.userDetails, permissions = ref.permissions;
    var groupName = permissions.group;
    var ref1 = (0,compat_module.useState)([]), uiConfig = ref1[0], setUiConfig = ref1[1];
    var ref2 = (0,compat_module.useState)("Please provide the below details to enable Acko to process timely protection plan commission payouts"), description = ref2[0], setDescription = ref2[1];
    var ref3 = (0,compat_module.useState)("Submit"), buttonName = ref3[0], setButtonName = ref3[1];
    var ref4 = (0,compat_module.useState)("capture"), mode = ref4[0], setMode = ref4[1];
    var ref5 = (0,compat_module.useState)({}), values = ref5[0], setValues = ref5[1];
    var ref6 = (0,compat_module.useState)({}), validationErr = ref6[0], setValidationErr = ref6[1];
    var ref7 = (0,compat_module.useState)(true), isLoading = ref7[0], setIsLoading = ref7[1];
    var ref8 = (0,compat_module.useState)(false), isBtnLoading = ref8[0], setIsBtnLoading = ref8[1];
    var ref9 = (0,compat_module.useState)(false), isFetchingIfsc = ref9[0], setIsFetchingIfsc = ref9[1];
    var ref10 = (0,compat_module.useState)(false), isValidIfsc = ref10[0], setIsValidIfsc = ref10[1];
    var ref11 = (0,compat_module.useState)(false), showTnc = ref11[0], setShowTnc = ref11[1];
    var ref12 = (0,compat_module.useState)(false), isRendered = ref12[0], setIsRendered = ref12[1];
    var ref13 = (0,compat_module.useState)(""), warningMessage = ref13[0], setWarningMessage = ref13[1];
    var ref14 = (0,compat_module.useState)(""), errorMessage = ref14[0], setErrorMessage = ref14[1];
    var ref15 = (0,compat_module.useState)(false), ctaPressed = ref15[0], setCtaPressed = ref15[1];
    // After partial payout match: stay on page with warning until user taps Continue.
    var ref16 = (0,compat_module.useState)(false), awaitingPartialContinue = ref16[0], setAwaitingPartialContinue = ref16[1];
    var validationConfig = mode === "confirm" ? uiConfig.filter(function(field) {
        return field.component !== "tnc_checkbox";
    }) : uiConfig;
    (0,compat_module.useEffect)(function() {
        (0,building_blocks_ui_acko_analytics_dist.pageEvent)(LegalDocumentsSegments.VIEW_PAGE_DEALER_DETAILS_COLLECTION, {
            page: "legalBankDocuments",
            partner: partnerId,
            product: "electronics",
            sub_product_name: "pos",
            phone: userDetails.phone,
            city_name: userDetails.pincode,
            unique_id: userDetails.user_id,
            platform: "mweb"
        });
    }, []);
    (0,compat_module.useEffect)(function() {
        var loadForm = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var response, form, config, isConfirm, flattened, draft, nextValues, dealershipField, beneficiaryField, dealershipEditable, beneficiaryEditable;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!partnerId || !groupName) return [
                                2
                            ];
                            setIsLoading(true);
                            return [
                                4,
                                (0,services.fetchFinancialDetailsForm)(partnerId, groupName)
                            ];
                        case 1:
                            response = _state.sent();
                            if (response.statusCode === 401) {
                                router.push("/login");
                                return [
                                    2
                                ];
                            }
                            if (response.is_error || !response.data) {
                                setSnackbar({
                                    type: "failure",
                                    message: response.error_message || "Failed to load financial details"
                                });
                                setIsLoading(false);
                                return [
                                    2
                                ];
                            }
                            form = response.data;
                            config = form.ui_config || [];
                            setUiConfig(config);
                            setDescription(form.description || "Please provide the below details to enable Acko to process timely protection plan commission payouts");
                            isConfirm = !!form.confirmation_required && !form.details_update_required && !!form.data;
                            setMode(isConfirm ? "confirm" : "capture");
                            setButtonName(form.button_name || (isConfirm ? "Confirm" : "Submit"));
                            flattened = (0,legalDocuments_helpers/* flattenFinancialData */.h9)(form.data, config, form.partner_name);
                            draft = isConfirm ? null : (0,legalDocuments_helpers/* loadDraftFromStorage */.xB)(partnerId, groupName);
                            nextValues = (0,legalDocuments_helpers/* mergeDraftValues */.df)(flattened, draft);
                            if (form.partner_name) {
                                dealershipField = config.find(function(f) {
                                    var ref;
                                    return ((ref = f.props) === null || ref === void 0 ? void 0 : ref.key_name) === "dealership_name";
                                });
                                beneficiaryField = config.find(function(f) {
                                    var ref;
                                    return ((ref = f.props) === null || ref === void 0 ? void 0 : ref.key_name) === "beneficiary_name";
                                });
                                dealershipEditable = dealershipField && "editable" in (dealershipField.props || {}) && dealershipField.props.editable === true;
                                beneficiaryEditable = beneficiaryField && "editable" in (beneficiaryField.props || {}) && beneficiaryField.props.editable === true;
                                if (!dealershipEditable) {
                                    nextValues.dealership_name = form.partner_name;
                                }
                                if (!beneficiaryEditable) {
                                    nextValues.beneficiary_name = form.partner_name;
                                }
                            }
                            setValues(nextValues);
                            if (nextValues.ifsc_code && String(nextValues.ifsc_code).length > 4) {
                                ifscValidation(String(nextValues.ifsc_code));
                            } else if (isConfirm && nextValues.ifsc_code) {
                                setIsValidIfsc(true);
                            }
                            setIsRendered(true);
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadForm() {
                return _ref.apply(this, arguments);
            };
        }();
        loadForm();
    }, [
        partnerId,
        groupName
    ]);
    (0,compat_module.useEffect)(function() {
        if (isRendered && mode === "capture" && partnerId && groupName) {
            (0,legalDocuments_helpers/* saveDraftToStorage */.G9)(partnerId, groupName, values);
        }
    }, [
        values,
        isRendered,
        mode,
        partnerId,
        groupName
    ]);
    var isBtnDisabled = (0,compat_module.useMemo)(function() {
        if (!uiConfig.length) return true;
        return !(0,legalDocuments_helpers/* hasAllRequiredValues */.Rm)(validationConfig, values, isValidIfsc);
    }, [
        uiConfig,
        validationConfig,
        values,
        isValidIfsc
    ]);
    var ifscValidation = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(ifscCode) {
            var ref, data, status, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsFetchingIfsc(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                                method: "GET",
                                url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/ifsc/").concat(ifscCode)
                            }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                        ];
                    case 2:
                        ref = _state.sent(), data = ref.data, status = ref.status;
                        if (status === 200 && (data === null || data === void 0 ? void 0 : data.success)) {
                            setIsValidIfsc(true);
                            setValidationErr(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
                                    ifsc_code: ""
                                });
                            });
                        } else {
                            setIsValidIfsc(false);
                            setValidationErr(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
                                    ifsc_code: "Please enter a valid IFSC code"
                                });
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setIsValidIfsc(true);
                        setValidationErr(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
                                ifsc_code: "Please enter a valid IFSC code"
                            });
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsFetchingIfsc(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function ifscValidation(ifscCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeValue = function(key, value) {
        setErrorMessage("");
        setValues(function(prev) {
            var next = (0,legalDocuments_helpers/* applySyncGroupValue */.jr)(uiConfig, prev, key, value);
            var field = uiConfig.find(function(f) {
                return f.props.key_name === key;
            });
            if (field) {
                var error = (0,legalDocuments_helpers/* validateField */.OP)(field, next);
                setValidationErr(function(prevErr) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevErr), (0,_define_property/* default */.Z)({}, key, error));
                });
            }
            if (key === "account_number" && prev.confirm_account_number) {
                var confirmField = uiConfig.find(function(f) {
                    return f.props.key_name === "confirm_account_number";
                });
                if (confirmField) {
                    var confirmError = (0,legalDocuments_helpers/* validateField */.OP)(confirmField, next);
                    setValidationErr(function(prevErr) {
                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevErr), {
                            confirm_account_number: confirmError
                        });
                    });
                }
            }
            return next;
        });
    };
    var onBlurField = function(field) {
        var ref;
        var key = field.props.key_name;
        if (key === "ifsc_code" && ((ref = values.ifsc_code) === null || ref === void 0 ? void 0 : ref.length) > 4) {
            ifscValidation(String(values.ifsc_code));
        }
        var error = (0,legalDocuments_helpers/* validateField */.OP)(field, values);
        setValidationErr(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, error));
        });
    };
    var onSelectFile = function(id, file, field) {
        var key = field.props.key_name;
        var documentType = field.props.document_type || "PAN_IMAGE";
        setValues(function(prev) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, {
                name: id,
                uploadStatus: "uploading",
                url: ((ref = prev[key]) === null || ref === void 0 ? void 0 : ref.url) || ""
            }));
        });
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1349)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var url, ref, data, statusCode, status;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            url = "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/").concat(urls/* newPlanUrls.documentUpload */.Q2.documentUpload);
                            return [
                                4,
                                req.uploadDocument(url, file, documentType, userDetails.user_id, function() {})
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, statusCode = ref.statusCode, status = ref.status;
                            if (statusCode === 401) {
                                router.push("/login");
                                return [
                                    2
                                ];
                            }
                            if (status && data) {
                                setValues(function(prev) {
                                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, {
                                        name: id,
                                        uploadStatus: "uploaded",
                                        url: data.url
                                    }));
                                });
                                setValidationErr(function(prev) {
                                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, ""));
                                });
                                return [
                                    2
                                ];
                            }
                            setValues(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, {
                                    name: id,
                                    uploadStatus: "failed",
                                    url: ""
                                }));
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var onDeleteFile = function(field) {
        var key = field.props.key_name;
        setValues(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, {
                name: "",
                uploadStatus: "",
                url: ""
            }));
        });
    };
    var redirectToDashboard = function() {
        var lobPrefix = (0,legalDocuments_helpers/* getLobPrefix */.L_)(partnerId, permissions);
        router.push("/".concat(lobPrefix, "/").concat(partnerId, "/dashboard"));
    };
    var handlePayoutMatchFailed = function(message) {
        var nextMessage = message || "Account holder name does not match bank records. Please update your registered name to match the bank account and try again.";
        setErrorMessage(nextMessage);
        setSnackbar({
            type: "failure",
            message: message || "Name mismatch with bank account. Update registered name and retry."
        });
    };
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, valid, errors, ref1, ref2, payload, response, ref3, ref4, payoutStatus, ref5, ref6, payoutMatch, ref7, ref8, message;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setCtaPressed(true);
                        setTimeout(function() {
                            return setCtaPressed(false);
                        }, 220);
                        setWarningMessage("");
                        setErrorMessage("");
                        ref = (0,legalDocuments_helpers/* validateAllFields */.wr)(validationConfig, values, {
                            isValidIfsc: isValidIfsc
                        }), valid = ref.valid, errors = ref.errors;
                        setValidationErr(errors);
                        if (!valid) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        setIsBtnLoading(true);
                        (0,building_blocks_ui_acko_analytics_dist.trackEvent)(LegalDocumentsSegments.TAP_BTN_SUBMIT, {
                            page: "legalBankDocuments",
                            partner: partnerId,
                            product: "electronics",
                            sub_product_name: "pos",
                            phone: userDetails.phone,
                            city_name: userDetails.pincode,
                            unique_id: userDetails.user_id,
                            platform: "mweb",
                            mode: mode
                        });
                        payload = (0,legalDocuments_helpers/* buildSubmitPayload */.fq)(uiConfig, values);
                        return [
                            4,
                            (0,services.submitFinancialDetails)(partnerId, groupName, payload)
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.statusCode === 401) {
                            router.push("/login");
                            return [
                                2
                            ];
                        }
                        if (response.is_error) {
                            ;
                            payoutStatus = (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.payout_match) === null || ref4 === void 0 ? void 0 : ref4.status;
                            if (payoutStatus === "failed") {
                                ;
                                handlePayoutMatchFailed(((ref5 = response.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.payout_match) === null || ref6 === void 0 ? void 0 : ref6.message) || response.error_message);
                                return [
                                    2
                                ];
                            }
                            // Genie 400 name conflict (dealership ≠ beneficiary) and other errors
                            setErrorMessage(response.error_message || "");
                            setSnackbar({
                                type: "failure",
                                message: response.error_message || "Oops. something went wrong."
                            });
                            return [
                                2
                            ];
                        }
                        payoutMatch = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.payout_match;
                        if ((payoutMatch === null || payoutMatch === void 0 ? void 0 : payoutMatch.status) === "failed") {
                            ;
                            handlePayoutMatchFailed(payoutMatch.message || ((ref7 = response.data) === null || ref7 === void 0 ? void 0 : ref7.message));
                            return [
                                2
                            ];
                        }
                        (0,legalDocuments_helpers/* clearDraftStorage */.$6)(partnerId, groupName);
                        if ((payoutMatch === null || payoutMatch === void 0 ? void 0 : payoutMatch.status) === "partial") {
                            ;
                            message = payoutMatch.message || ((ref8 = response.data) === null || ref8 === void 0 ? void 0 : ref8.message) || "Details saved with a partial name match. Please verify beneficiary details.";
                            // Keep legalDetailsUploadedStatus set so this screen stays mounted
                            // while the partial-match modal is open (null would unmount the page).
                            setWarningMessage(message);
                            setErrorMessage("");
                            setAwaitingPartialContinue(true);
                            return [
                                2
                            ];
                        }
                        // completed | skipped (fuzzy disabled) → success, no warn
                        setLegalDetailsUploadedStatus(null);
                        setSnackbar({
                            type: "success",
                            message: ((ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "Document details has been submitted successfully!"
                        });
                        redirectToDashboard();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsBtnLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onContinueAfterPartial = function() {
        setAwaitingPartialContinue(false);
        setLegalDetailsUploadedStatus(null);
        redirectToDashboard();
    };
    var onClickTnc = function() {
        setShowTnc(false);
        (0,building_blocks_ui_acko_analytics_dist.trackEvent)(LegalDocumentsSegments.TAP_BTN_TNC, {
            page: "legalBankDocuments",
            partner: partnerId,
            product: "electronics",
            sub_product_name: "pos",
            phone: userDetails.phone,
            city_name: userDetails.pincode,
            unique_id: userDetails.user_id,
            platform: "mweb"
        });
    };
    if (!legalDetailsUploadedStatus) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {});
    }
    if (showTnc) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FormGridWrapper, {
            style: {
                padding: "20px",
                maxWidth: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tnc, {
                onClick: onClickTnc
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FormItemWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FormGridWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocuments_styles_HeaderWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {})
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LoadingState, {
                        children: "Loading details…"
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocuments_FinancialDetailsForm, {
                        mode: mode,
                        description: description,
                        buttonName: buttonName,
                        uiConfig: uiConfig,
                        values: values,
                        validationErr: validationErr,
                        isBtnLoading: isBtnLoading,
                        isBtnDisabled: isBtnDisabled || isFetchingIfsc || awaitingPartialContinue,
                        isFetchingIfsc: isFetchingIfsc,
                        errorMessage: errorMessage,
                        ctaPressed: ctaPressed,
                        onChangeValue: onChangeValue,
                        onBlurField: onBlurField,
                        onSelectFile: onSelectFile,
                        onDeleteFile: onDeleteFile,
                        onClickTncLink: function() {
                            return setShowTnc(true);
                        },
                        onSubmit: onSubmit
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                show: awaitingPartialContinue,
                urlhash: "",
                onHide: function() {},
                padding: "24px",
                maxWidth: "500px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                hideCloseButton: true,
                disableOverlayClose: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PartialModalContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PartialModalTitle, {
                            children: "Name match warning"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PartialModalText, {
                            children: warningMessage || "Details saved with a partial name match. Please verify beneficiary details."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PartialModalHint, {
                            children: "You can continue to the dashboard after reviewing this warning."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PartialModalActions, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                onClick: onContinueAfterPartial,
                                children: "Continue"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var legalDocuments = (LegalDocumentsUpload);

;// CONCATENATED MODULE: ./components/gstDetails/styles.ts

function gstDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"
    ]);
    gstDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media (prefers-reduced-motion: no-preference) {\n        ",
        "\n    }\n"
    ]);
    gstDetails_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    max-width: 400px;\n    margin: 0 auto;\n    box-sizing: border-box;\n\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    gstDetails_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.35s ease-out;\n    "
    ]);
    gstDetails_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    ",
        "\n"
    ]);
    gstDetails_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n            /* "backwards" (not "both") on purpose: "both" would leave a\n               non-none transform on this element permanently after the\n               animation ends, which creates a new containing block for any\n               position:fixed descendant (e.g. a details modal), pinning it\n               near the top of this section instead of centering in the\n               real viewport. */\n            animation: ',
        " 0.35s ease-out backwards;\n            animation-delay: ",
        "s;\n        "
    ]);
    gstDetails_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    ",
        "\n"
    ]);
    gstDetails_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    padding: 24px 0 16px 0;\n    border-bottom: 1px solid #c9c8d2;\n"
    ]);
    gstDetails_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #040222;\n    margin: 24px auto;\n"
    ]);
    gstDetails_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 12px;\n"
    ]);
    gstDetails_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 24px;\n"
    ]);
    gstDetails_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 10px;\n    font-size: 1rem;\n    font-weight: 500;\n"
    ]);
    gstDetails_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 16px 0;\n"
    ]);
    gstDetails_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 4px;\n    color: red;\n    margin-left: 4px;\n"
    ]);
    gstDetails_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function gstDetails_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-size: 12px;\n    line-height: 16px;\n    margin-top: 4px;\n    color: #d83d37;\n"
    ]);
    gstDetails_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}

var styles_fadeSlideUp = (0,styled_components_browser_esm.keyframes)(gstDetails_styles_templateObject());
var styles_motionSafe = function(styles) {
    return (0,styled_components_browser_esm.css)(gstDetails_styles_templateObject1(), styles);
};
var gstDetails_styles_Wrapper = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject2());
var Content = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject4(), styles_motionSafe((0,styled_components_browser_esm.css)(gstDetails_styles_templateObject3(), styles_fadeSlideUp)));
var styles_Section = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject6(), function(param) {
    var $index = param.$index;
    return typeof $index === "number" && styles_motionSafe((0,styled_components_browser_esm.css)(gstDetails_styles_templateObject5(), styles_fadeSlideUp, Math.min($index, 4) * 0.06));
});
var gstDetails_styles_EnterMoreDetails = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject7());
var styles_Details = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject8());
var StaticWrapper = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject9());
var gstDetails_styles_InputWrapper = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject10());
var styles_InputLabel = styled_components_browser_esm["default"].p(gstDetails_styles_templateObject11());
var styles_ItemWrapper = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject12());
var MandatoryStar = styled_components_browser_esm["default"].span(gstDetails_styles_templateObject13());
var styles_DocumentUploadErrorMessage = styled_components_browser_esm["default"].div(gstDetails_styles_templateObject14());

;// CONCATENATED MODULE: ./components/gstDetails/types.ts
var GSTTypes = [
    {
        value: "regular",
        displayValue: "Regular"
    },
    {
        value: "composite",
        displayValue: "Composite"
    }, 
];
var gstNumberRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
var GSTDetailsFormState;
(function(GSTDetailsFormState) {
    GSTDetailsFormState[GSTDetailsFormState["INITATED"] = 0] = "INITATED";
    GSTDetailsFormState[GSTDetailsFormState["COMPLETED"] = 1] = "COMPLETED";
    GSTDetailsFormState[GSTDetailsFormState["FAILED"] = 2] = "FAILED";
})(GSTDetailsFormState || (GSTDetailsFormState = {}));

;// CONCATENATED MODULE: ./components/gstDetails/loading/styles.ts

function loading_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding: 10px;\n"
    ]);
    loading_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function loading_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    loading_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function loading_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    font-weight: 500;\n    font-size: 1.2rem;\n"
    ]);
    loading_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function loading_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    place-items: center;\n"
    ]);
    loading_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var loading_styles_Wrapper = styled_components_browser_esm["default"].div(loading_styles_templateObject());
var TextWrapper = styled_components_browser_esm["default"].div(loading_styles_templateObject1());
var loading_styles_Text = styled_components_browser_esm["default"].p(loading_styles_templateObject2());
var LoaderWrapper = styled_components_browser_esm["default"].div(loading_styles_templateObject3());

;// CONCATENATED MODULE: ./components/gstDetails/loading/index.tsx




var GSTLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(loading_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TextWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(loading_styles_Text, {
                    children: "Hang tight - we're checking your GST with govt database..."
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LoaderWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif"),
                        alt: "",
                        width: 80,
                        height: 80
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var loading = (GSTLoading);

;// CONCATENATED MODULE: ./components/gstDetails/gstCompleted/styles.ts

function gstCompleted_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    gstCompleted_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function gstCompleted_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n"
    ]);
    gstCompleted_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function gstCompleted_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 22px;\n    text-align: left;\n    color: #040222;\n    margin-top: 12px;\n    align-items: center;\n"
    ]);
    gstCompleted_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function gstCompleted_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 22px;\n    text-align: left;\n    color: #040222;\n    margin-top: 12px;\n"
    ]);
    gstCompleted_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function gstCompleted_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: grid;\n    place-items: center;\n    margin-top: 12px;\n"
    ]);
    gstCompleted_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var gstCompleted_styles_Container = styled_components_browser_esm["default"].div(gstCompleted_styles_templateObject());
var styles_Banner = styled_components_browser_esm["default"].div(gstCompleted_styles_templateObject1());
var BoldText = styled_components_browser_esm["default"].div(gstCompleted_styles_templateObject2());
var gstCompleted_styles_Text = styled_components_browser_esm["default"].div(gstCompleted_styles_templateObject3());
var gstCompleted_styles_ButtonContainer = styled_components_browser_esm["default"].div(gstCompleted_styles_templateObject4());

;// CONCATENATED MODULE: ./components/gstDetails/gstCompleted/index.tsx







var GSTCompleted = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,usePermissionHook/* default */.Z)(), getLobFromPermission = ref.getLobFromPermission, getPartnerIdFromPermission = ref.getPartnerIdFromPermission;
    var onClick = function() {
        var url = "/".concat(getLobFromPermission(), "/").concat(getPartnerIdFromPermission(), "/dashboard");
        router.push(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(gstCompleted_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(BoldText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)("/images/Success.svg"),
                        width: 40,
                        height: 40,
                        style: {
                            marginTop: "4px"
                        }
                    }),
                    "GST Updated Successfully"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Banner, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "250px",
                    height: "250px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/Success.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(gstCompleted_styles_Text, {
                children: [
                    "Your GST details are now verified and up to date.",
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstCompleted_styles_Text, {
                children: "You're all set to create new plans again"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstCompleted_styles_ButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onClick,
                    children: "Go to Home"
                })
            })
        ]
    });
};
/* harmony default export */ var gstCompleted = (GSTCompleted);

;// CONCATENATED MODULE: ./components/gstDetails/gstFailed/styles.ts

function gstFailed_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    gstFailed_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function gstFailed_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n"
    ]);
    gstFailed_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function gstFailed_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    text-align: left;\n    color: #040222;\n    margin-top: 12px;\n"
    ]);
    gstFailed_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function gstFailed_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: grid;\n    place-items: center;\n    margin-top: 12px;\n"
    ]);
    gstFailed_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function gstFailed_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 22px;\n    text-align: left;\n    color: #040222;\n    margin-top: 12px;\n"
    ]);
    gstFailed_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var gstFailed_styles_Container = styled_components_browser_esm["default"].div(gstFailed_styles_templateObject());
var gstFailed_styles_Banner = styled_components_browser_esm["default"].div(gstFailed_styles_templateObject1());
var gstFailed_styles_Text = styled_components_browser_esm["default"].div(gstFailed_styles_templateObject2());
var gstFailed_styles_ButtonContainer = styled_components_browser_esm["default"].div(gstFailed_styles_templateObject3());
var styles_BoldText = styled_components_browser_esm["default"].div(gstFailed_styles_templateObject4());

;// CONCATENATED MODULE: ./components/gstDetails/gstFailed/index.tsx







var GSTFailed = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,usePermissionHook/* default */.Z)(), getLobFromPermission = ref.getLobFromPermission, getPartnerIdFromPermission = ref.getPartnerIdFromPermission;
    var onClick = function() {
        router.push("/".concat(getLobFromPermission(), "/").concat(getPartnerIdFromPermission(), "/dashboard"));
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(gstFailed_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_BoldText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)("/icons/error.svg"),
                        width: 40,
                        height: 40,
                        style: {
                            marginTop: "4px"
                        }
                    }),
                    "GST Validation Failed"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstFailed_styles_Banner, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "250px",
                    height: "250px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/payment_failure.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(gstFailed_styles_Text, {
                children: [
                    "We couldn't verify your GST number because of a validation issue. Please double-check and try again.",
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstFailed_styles_Text, {
                children: "If the issue continues, contact us at mpos@acko.com and we'll help you resolve it promptly."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstFailed_styles_ButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onClick,
                    children: "Retry"
                })
            })
        ]
    });
};
/* harmony default export */ var gstFailed = (GSTFailed);

;// CONCATENATED MODULE: ./components/gstDetails/index.tsx



























var GSTDetails = function() {
    var getPartnerIdFromPermission = (0,usePermissionHook/* default */.Z)().getPartnerIdFromPermission;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), setGstDetailsValid = ref.setGstDetailsValid, permissions = ref.permissions, userDetails = ref.userDetails;
    var ref1 = (0,compat_module.useState)({
        dealershipName: "",
        gstNumber: "",
        gstType: "",
        panNumber: "",
        panUrl: ""
    }), gstData = ref1[0], setGstData = ref1[1];
    var ref2 = (0,compat_module.useState)(""), dealershipName = ref2[0], setDealershipName = ref2[1];
    var ref3 = (0,compat_module.useState)(""), gstNumber = ref3[0], setGstNumber = ref3[1];
    var ref4 = (0,compat_module.useState)({
        displayValue: "",
        value: ""
    }), gstType = ref4[0], setGstType = ref4[1];
    var ref5 = (0,compat_module.useState)(""), panNumber = ref5[0], setPanNumber = ref5[1];
    var ref6 = (0,compat_module.useState)({
        name: "",
        uploadStatus: "",
        url: ""
    }), panFileUpload = ref6[0], setPanFileUpload = ref6[1];
    var ref7 = (0,compat_module.useState)({
        dealershipName: "",
        gstType: "",
        gstNumber: "",
        panNumber: "",
        panFileUpload: ""
    }), validationErr = ref7[0], setValidationErr = ref7[1];
    var ref8 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref8[0], setSnackbar = ref8[1];
    var ref9 = (0,compat_module.useState)(false), submitButtonEnabled = ref9[0], setSubmitButtonEnabled = ref9[1];
    var ref10 = (0,compat_module.useState)(GSTDetailsFormState.INITATED), state = ref10[0], setState = ref10[1];
    var ref11 = (0,compat_module.useState)(false), processing = ref11[0], setProcessing = ref11[1];
    var ref12 = (0,compat_module.useState)(false), pageLoading = ref12[0], setPageLoading = ref12[1];
    var router = (0,next_router.useRouter)();
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    (0,compat_module.useEffect)(function() {
        var getButtonDisability = function getButtonDisability() {
            var isError = false;
            if (dealershipName.length === 0) {
                setSubmitButtonEnabled(false);
                isError = true;
            }
            if (gstType.value.length === 0) {
                setSubmitButtonEnabled(false);
                isError = true;
            }
            if (gstNumber.length > 0) {
                if (gstNumber.length === 15 && gstNumberRegex.test(gstNumber)) {
                    setPanNumber(gstNumber.substring(2, 12));
                    setValidationErr(function(validationErr) {
                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                            gstNumber: ""
                        });
                    });
                } else {
                    isError = true;
                    setValidationErr(function(validationErr) {
                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validationErr), {
                            gstNumber: "GST Number is mandatory"
                        });
                    });
                    setPanNumber("");
                }
            } else {
                isError = true;
                setSubmitButtonEnabled(false);
            }
            if (panFileUpload.url.length === 0) {
                isError = true;
                setSubmitButtonEnabled(false);
            }
            if (isError) {
                setSubmitButtonEnabled(false);
                return;
            }
            setSubmitButtonEnabled(true);
        };
        getButtonDisability();
    }, [
        gstNumber,
        dealershipName,
        gstType,
        panFileUpload
    ]);
    (0,compat_module.useEffect)(function() {
        var fetchCurrentGSTDetails = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var response, _error_message, _data, gst_details, pan_details;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setPageLoading(true);
                            return [
                                4,
                                (0,services.fetchCurrentGSTDetailsOfUser)(getPartnerIdFromPermission(), permissions.group)
                            ];
                        case 1:
                            response = _state.sent();
                            if (response.is_error) {
                                ;
                                setSnackbar({
                                    type: "failure",
                                    message: (_error_message = response.error_message) !== null && _error_message !== void 0 ? _error_message : "Failed to fetch current GST Details"
                                });
                            } else {
                                if (response.data) {
                                    _data = response.data, gst_details = _data.gst_details, pan_details = _data.pan_details;
                                    setGstData(function(gstData) {
                                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, gstData), {
                                            dealershipName: gst_details.dealership_name,
                                            gstNumber: gst_details.number,
                                            gstType: gst_details.type,
                                            panNumber: pan_details.number,
                                            panUrl: pan_details.image_url
                                        });
                                    });
                                }
                                setSnackbar({
                                    type: "",
                                    message: ""
                                });
                            }
                            setPageLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchCurrentGSTDetails() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchCurrentGSTDetails();
    }, []);
    var onChangeGSTType = function(e) {
        setGstType((0,src_object_spread/* default */.Z)({}, e));
    };
    var onChangeGSTNumber = function(e) {
        var value = e.target.value;
        setGstNumber(value);
    };
    var onSelectFile = function(id, file) {
        setPanFileUpload(function(fileUpload) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fileUpload), {
                name: id,
                uploadStatus: "uploading"
            });
        });
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1349)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var url, ref, data, statusCode, status;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            url = "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/").concat(urls/* newPlanUrls.documentUpload */.Q2.documentUpload);
                            return [
                                4,
                                req.uploadDocument(url, file, "PAN_IMAGE", userDetails.user_id, function() {})
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, statusCode = ref.statusCode, status = ref.status;
                            if (statusCode === 401) {
                                router.push("/login");
                                return [
                                    2
                                ];
                            }
                            if (status && data) {
                                setPanFileUpload(function(fileUpload) {
                                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fileUpload), {
                                        uploadStatus: "uploaded",
                                        url: data.url
                                    });
                                });
                                return [
                                    2
                                ];
                            }
                            setPanFileUpload(function(fileUpload) {
                                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fileUpload), {
                                    uploadStatus: "failed"
                                });
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var onDeleteFile = function() {
        setPanFileUpload(function(fileUpload) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fileUpload), {
                name: "",
                uploadStatus: ""
            });
        });
    };
    var onSubmitHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var isError, updatedValidationErr, request, response, _error_message, success, _error_message1, _error_message2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isError = false;
                        updatedValidationErr = (0,src_object_spread/* default */.Z)({}, validationErr);
                        if (dealershipName.length === 0) {
                            isError = true;
                            updatedValidationErr = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updatedValidationErr), {
                                dealershipName: "Dealership name is mandatory"
                            });
                        }
                        if (gstType.value.length === 0) {
                            isError = true;
                            updatedValidationErr = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updatedValidationErr), {
                                gstType: "GST Type is mandatory"
                            });
                        }
                        if (gstNumber.length > 0) {
                            if (gstNumber.length === 15 && gstNumberRegex.test(gstNumber)) {
                                updatedValidationErr = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updatedValidationErr), {
                                    gstNumber: ""
                                });
                            } else {
                                isError = true;
                                updatedValidationErr = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updatedValidationErr), {
                                    gstNumber: "GST Number is mandatory"
                                });
                            }
                        } else {
                            isError = true;
                            updatedValidationErr = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updatedValidationErr), {
                                gstNumber: "GST Number is mandatory"
                            });
                        }
                        if (panFileUpload.url.length === 0) {
                            isError = true;
                            updatedValidationErr = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updatedValidationErr), {
                                panFileUpload: "Pan Image is mandatory"
                            });
                        }
                        if (isError) {
                            setValidationErr((0,src_object_spread/* default */.Z)({}, updatedValidationErr));
                            return [
                                2
                            ];
                        }
                        setProcessing(true);
                        request = {
                            gst_details: {
                                dealership_name: dealershipName,
                                number: gstNumber,
                                type: gstType.value
                            },
                            pan_details: {
                                image_url: panFileUpload.url,
                                number: panNumber
                            }
                        };
                        return [
                            4,
                            (0,services.submitGSTDetailsOfUser)(getPartnerIdFromPermission(), permissions.group, request)
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.is_error) {
                            ;
                            setSnackbar({
                                type: "failure",
                                message: (_error_message = response.error_message) !== null && _error_message !== void 0 ? _error_message : "Failed to fetch current GST Details"
                            });
                            setState(GSTDetailsFormState.FAILED);
                            setProcessing(false);
                            return [
                                2
                            ];
                        }
                        if (response.data) {
                            success = response.data.success;
                            if (success) {
                                setState(GSTDetailsFormState.COMPLETED);
                                setGstDetailsValid(true);
                            } else {
                                setState(GSTDetailsFormState.FAILED);
                                ;
                                setSnackbar({
                                    type: "failure",
                                    message: (_error_message1 = response.error_message) !== null && _error_message1 !== void 0 ? _error_message1 : "Failed to submit GST Details"
                                });
                            }
                        } else {
                            ;
                            setSnackbar({
                                type: "failure",
                                message: (_error_message2 = response.error_message) !== null && _error_message2 !== void 0 ? _error_message2 : "Failed to submit GST Details"
                            });
                            setState(GSTDetailsFormState.FAILED);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmitHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    if (pageLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(gstDetails_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Content, {
                        children: state === GSTDetailsFormState.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Section, {
                            $index: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstCompleted, {})
                        }) : state === GSTDetailsFormState.FAILED ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Section, {
                            $index: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstFailed, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Section, {
                                    $index: 0,
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstDetails_styles_EnterMoreDetails, {
                                        children: "Update your GST to unlock transactions"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Section, {
                                    $index: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Details, {
                                            children: "Current Details"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_InputLabel, {
                                                    children: "Dealership Name"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "current_dealership_name",
                                                    type: "text",
                                                    value: gstData.dealershipName,
                                                    disabled: true,
                                                    onChange: function() {}
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_InputLabel, {
                                                    children: "GST Type"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "current_gst_type",
                                                    type: "text",
                                                    value: gstData.gstType,
                                                    disabled: true,
                                                    onChange: function() {}
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_InputLabel, {
                                                    children: "GST Number"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "current_gst_number",
                                                    type: "text",
                                                    value: gstData.gstNumber,
                                                    disabled: true,
                                                    onChange: function() {}
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_InputLabel, {
                                                    children: "Pan Number"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "current_pan_number",
                                                    type: "text",
                                                    value: gstData.panNumber,
                                                    disabled: true,
                                                    onChange: function() {}
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Section, {
                                    $index: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Details, {
                                            children: "To Be Updated"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_InputLabel, {
                                                    children: [
                                                        "Dealership Name",
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MandatoryStar, {
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "dealershipName",
                                                    placeHolder: "Dealership Name",
                                                    type: "text",
                                                    value: dealershipName,
                                                    onChange: function(e) {
                                                        return setDealershipName(e.target.value);
                                                    },
                                                    hasError: validationErr.dealershipName.length > 0,
                                                    errMsg: validationErr.dealershipName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_InputLabel, {
                                                    children: [
                                                        "GST Type",
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MandatoryStar, {
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                                                    value: gstType,
                                                    heading: "Select GST Type",
                                                    label: "GST Type",
                                                    options: GSTTypes,
                                                    onChange: onChangeGSTType,
                                                    error: validationErr.gstType
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_InputLabel, {
                                                    children: [
                                                        "GST Number",
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MandatoryStar, {
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "gstNumber",
                                                    placeHolder: "We'll validate this with GST authorities",
                                                    type: "text",
                                                    value: gstNumber,
                                                    onChange: onChangeGSTNumber,
                                                    errMsg: validationErr.gstNumber,
                                                    hasError: validationErr.gstNumber.length > 0
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_InputLabel, {
                                                    children: [
                                                        "PAN Number",
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MandatoryStar, {
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    name: "panNumber",
                                                    placeHolder: "Auto-filled based on the GST number",
                                                    type: "text",
                                                    value: panNumber,
                                                    disabled: true,
                                                    onChange: function() {}
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StaticWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(documentUpload, {
                                                    id: "pan",
                                                    label: "Upload PAN card photo (front)",
                                                    title: "PAN Image",
                                                    documentName: panFileUpload.name,
                                                    uploadStatus: panFileUpload.uploadStatus,
                                                    isMandatory: true,
                                                    onSelect: onSelectFile,
                                                    onDelete: onDeleteFile
                                                }),
                                                validationErr.panFileUpload.length > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_DocumentUploadErrorMessage, {
                                                    children: validationErr.panFileUpload
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StaticWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                                onClick: onSubmitHandler,
                                                disabled: !submitButtonEnabled,
                                                children: "Submit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                                            show: processing,
                                            urlhash: "",
                                            onHide: function() {},
                                            padding: "20px",
                                            maxWidth: "500px",
                                            wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                                            showOverlayBackground: true,
                                            hideCloseButton: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(loading, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var gstDetails = (GSTDetails);

// EXTERNAL MODULE: ./utils/helpers/partnerLogo.ts
var partnerLogo = __webpack_require__(8089);
;// CONCATENATED MODULE: ./components/serviceCenterOnboarding/styles.ts

function serviceCenterOnboarding_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media (prefers-reduced-motion: no-preference) {\n        ",
        "\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    min-height: 100vh;\n    width: 100%;\n    max-width: 440px;\n    margin: 0 auto;\n    box-sizing: border-box;\n    overflow-x: hidden;\n    background: #ffffff;\n\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n\n    @media screen and (min-width: 768px) {\n        max-width: 1080px;\n        padding: 32px 40px 48px;\n        min-height: auto;\n    }\n\n    @media screen and (min-width: 1200px) {\n        padding: 40px 56px 56px;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.35s ease-out;\n    "
    ]);
    serviceCenterOnboarding_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    min-height: 0;\n\n    ",
        "\n\n    @media screen and (min-width: 768px) {\n        display: flex;\n        gap: 24px;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            animation: ",
        " 0.35s ease-out backwards;\n            animation-delay: ",
        "s;\n        "
    ]);
    serviceCenterOnboarding_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                grid-column: auto;\n            "
    ]);
    serviceCenterOnboarding_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    ",
        "\n\n    @media screen and (min-width: 768px) {\n        ",
        "\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n    padding: 24px 20px 22px;\n    border-radius: 24px;\n    background: radial-gradient(\n            circle at top right,\n            rgba(15, 164, 87, 0.12),\n            transparent 34%\n        ),\n        linear-gradient(180deg, #ffffff 0%, #f7fbf8 100%);\n    border: 1px solid #dcefe3;\n\n    @media screen and (min-width: 768px) {\n        margin-top: 12px;\n        padding: 28px 28px 24px;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #0d8e4b;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin-top: 20px;\n\n    @media screen and (min-width: 768px) {\n        margin-top: 12px;\n        font-size: 28px;\n        line-height: 36px;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 10px 0 0;\n    max-width: 760px;\n    color: #5b5675;\n    font-size: 14px;\n    line-height: 22px;\n\n    @media screen and (min-width: 768px) {\n        font-size: 15px;\n        line-height: 24px;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-color: #d7e8fb;\n            background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n        "
    ]);
    serviceCenterOnboarding_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-color: #dcefe3;\n            background: linear-gradient(180deg, #ffffff 0%, #f8fcf9 100%);\n        "
    ]);
    serviceCenterOnboarding_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n    padding: 20px;\n    background: #ffffff;\n    border: 1px solid #e7e7f0;\n    border-radius: 16px;\n    box-shadow: 0 8px 24px rgba(16, 18, 35, 0.04);\n\n    ",
        "\n\n    ",
        "\n\n    @media screen and (min-width: 768px) {\n        padding: 24px;\n        border-radius: 20px;\n        min-height: 100%;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 16px;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    color: #040222;\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 600;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            color: #0f5fb8;\n            background: #e8f2ff;\n        "
    ]);
    serviceCenterOnboarding_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            color: #0d8e4b;\n            background: #e8f7ee;\n        "
    ]);
    serviceCenterOnboarding_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-shrink: 0;\n    padding: 6px 10px;\n    border-radius: 999px;\n    font-size: 11px;\n    line-height: 14px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #040222;\n    background: #eef0f4;\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    serviceCenterOnboarding_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                grid-column: 1 / -1;\n            "
    ]);
    serviceCenterOnboarding_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 16px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    @media screen and (min-width: 768px) {\n        margin-bottom: 0;\n\n        ",
        "\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                grid-column: 1 / -1;\n            "
    ]);
    serviceCenterOnboarding_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 16px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    @media screen and (min-width: 768px) {\n        margin-bottom: 0;\n\n        ",
        "\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #5b5675;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 500;\n    margin-bottom: 8px;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    min-height: 180px;\n    padding: 12px;\n    border: 1px solid #e7e7f0;\n    border-radius: 12px;\n    background: #f7f8fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    img {\n        width: 100%;\n        height: auto;\n        max-height: 240px;\n        object-fit: contain;\n        border-radius: 8px;\n        display: block;\n    }\n\n    @media screen and (min-width: 768px) {\n        min-height: 220px;\n        padding: 16px;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n    margin-bottom: 16px;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    min-height: 20px;\n    padding-top: 2px;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 14px;\n    line-height: 20px;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 16px;\n\n    @media screen and (min-width: 768px) {\n        grid-column: 1 / -1;\n        margin-bottom: 0;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 360px;\n    border: 1px solid #e7e7f0;\n    border-radius: 12px;\n    overflow: auto;\n    background: #f7f8fa;\n\n    iframe {\n        width: 100%;\n        height: 720px;\n        border: 0;\n        display: block;\n        background: #ffffff;\n    }\n\n    @media screen and (min-width: 768px) {\n        height: 480px;\n\n        iframe {\n            height: 960px;\n        }\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 8px;\n    color: #5b5675;\n    font-size: 12px;\n    line-height: 16px;\n"
    ]);
    serviceCenterOnboarding_styles_templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function serviceCenterOnboarding_styles_templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n\n    @media screen and (min-width: 768px) {\n        max-width: 280px;\n        margin-top: 20px;\n    }\n"
    ]);
    serviceCenterOnboarding_styles_templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}

var serviceCenterOnboarding_styles_fadeSlideUp = (0,styled_components_browser_esm.keyframes)(serviceCenterOnboarding_styles_templateObject());
var serviceCenterOnboarding_styles_motionSafe = function(styles) {
    return (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject1(), styles);
};
var serviceCenterOnboarding_styles_Wrapper = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject2());
var styles_Content = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject4(), serviceCenterOnboarding_styles_motionSafe((0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject3(), serviceCenterOnboarding_styles_fadeSlideUp)));
var serviceCenterOnboarding_styles_Section = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject7(), function(param) {
    var $index = param.$index;
    return typeof $index === "number" && serviceCenterOnboarding_styles_motionSafe((0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject5(), serviceCenterOnboarding_styles_fadeSlideUp, Math.min($index, 4) * 0.06));
}, function(param) {
    var $variant = param.$variant;
    return $variant && (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject6());
});
var HeroCard = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject8());
var HeroEyebrow = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject9());
var serviceCenterOnboarding_styles_Title = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject10());
var Subtitle = styled_components_browser_esm["default"].p(serviceCenterOnboarding_styles_templateObject11());
var styles_Card = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject14(), function(param) {
    var $variant = param.$variant;
    return $variant === "editable" && (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject12());
}, function(param) {
    var $variant = param.$variant;
    return $variant === "tnc" && (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject13());
});
var CardHeader = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject15());
var styles_SectionTitle = styled_components_browser_esm["default"].h2(serviceCenterOnboarding_styles_templateObject16());
var SectionBadge = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject19(), function(param) {
    var $variant = param.$variant;
    return $variant === "editable" && (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject17());
}, function(param) {
    var $variant = param.$variant;
    return $variant === "tnc" && (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject18());
});
var FieldsGrid = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject20());
var serviceCenterOnboarding_styles_InputWrapper = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject22(), function(param) {
    var $fullWidth = param.$fullWidth;
    return $fullWidth && (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject21());
});
var PreviewWrapper = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject24(), function(param) {
    var $fullWidth = param.$fullWidth;
    return $fullWidth && (0,styled_components_browser_esm.css)(serviceCenterOnboarding_styles_templateObject23());
});
var PreviewLabel = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject25());
var PreviewCard = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject26());
var TncControlRow = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject27());
var serviceCenterOnboarding_styles_CheckBoxFlex = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject28());
var serviceCenterOnboarding_styles_TncText = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject29(), function(param) {
    var $disabled = param.$disabled;
    return $disabled ? "#9a97ad" : "#040222";
});
var TncPreviewSection = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject30());
var TncPreviewCard = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject31());
var TncHint = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject32());
var serviceCenterOnboarding_styles_SubmitButtonWrapper = styled_components_browser_esm["default"].div(serviceCenterOnboarding_styles_templateObject33());

;// CONCATENATED MODULE: ./components/serviceCenterOnboarding/apis.ts






function fetchServicePartnerStatus(partnerId, groupName) {
    return _fetchServicePartnerStatus.apply(this, arguments);
}
function _fetchServicePartnerStatus() {
    _fetchServicePartnerStatus = _async_to_generator(function(partnerId, groupName) {
        var ref, data, status, error, ref1, ref2, ref3;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios(_object_spread({
                            method: "GET",
                            url: "".concat(getDomainOrigin(), "/api/mpos/genie/onboarding/").concat(partnerId, "/service-partner/status?user_group=").concat(groupName)
                        }, getAxiosConfig()))
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, status = ref.status;
                    if (status === 200 && Array.isArray(data)) {
                        return [
                            2,
                            {
                                is_error: false,
                                data: data,
                                error_message: ""
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            is_error: true,
                            data: null,
                            error_message: "Failed to load service partner status"
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            is_error: true,
                            data: null,
                            error_message: (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "Failed to load service partner status",
                            statusCode: error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchServicePartnerStatus.apply(this, arguments);
}
function fetchServicePartnerData(partnerId, groupName) {
    return _fetchServicePartnerData.apply(this, arguments);
}
function _fetchServicePartnerData() {
    _fetchServicePartnerData = (0,src_async_to_generator/* default */.Z)(function(partnerId, groupName) {
        var ref, data, status, error, ref1, ref2, ref3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "GET",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/genie/onboarding/").concat(partnerId, "/service-partner/get-data?user_group=").concat(groupName)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, status = ref.status;
                    if (status === 200 && Array.isArray(data)) {
                        return [
                            2,
                            {
                                is_error: false,
                                data: data,
                                error_message: ""
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            is_error: true,
                            data: null,
                            error_message: "Failed to load service partner data"
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            is_error: true,
                            data: null,
                            error_message: (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "Failed to load service partner data",
                            statusCode: error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchServicePartnerData.apply(this, arguments);
}
function saveServicePartnerData(partnerId, groupName, request) {
    return _saveServicePartnerData.apply(this, arguments);
}
function _saveServicePartnerData() {
    _saveServicePartnerData = (0,src_async_to_generator/* default */.Z)(function(partnerId, groupName, request) {
        var ref, data, status, error, ref1, ref2, ref3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/genie/onboarding/").concat(partnerId, "/service-partner/save?user_group=").concat(groupName)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: request
                        }))
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, status = ref.status;
                    if (status === 200) {
                        return [
                            2,
                            {
                                is_error: false,
                                data: data,
                                error_message: ""
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            is_error: true,
                            data: null,
                            error_message: "Failed to save service partner data"
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            is_error: true,
                            data: null,
                            error_message: (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "Failed to save service partner data",
                            statusCode: error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _saveServicePartnerData.apply(this, arguments);
}

;// CONCATENATED MODULE: ./components/serviceCenterOnboarding/mockFormConfig.ts

var serviceCenterOnboardingMockFormConfig = [
    {
        form_type: utils_constants/* FORM_TYPES.SERVICE_CENTER_DETAILS */.dz.SERVICE_CENTER_DETAILS,
        section_title: "Service Center Details",
        should_capture_details: false,
        details_update_required: false,
        captured_data: {
            service_center_name: "",
            service_center_phone: "",
            service_center_email: "",
            service_center_address: "",
            service_center_pincode: ""
        },
        ui_config: [
            {
                id: "service-center-name",
                type: "text",
                label: "Name",
                title: "Service center name",
                component: "input",
                required: true,
                props: {
                    key_name: "service_center_name",
                    editable: false,
                    section: "service_center_details"
                }
            },
            {
                id: "service-center-phone",
                type: "tel",
                label: "Phone",
                title: "Service center phone",
                component: "input",
                required: true,
                props: {
                    key_name: "service_center_phone",
                    editable: false,
                    section: "service_center_details"
                }
            },
            {
                id: "service-center-email",
                type: "email",
                label: "Email",
                title: "Service center email",
                component: "input",
                required: false,
                props: {
                    key_name: "service_center_email",
                    editable: false,
                    section: "service_center_details"
                }
            },
            {
                id: "service-center-address",
                type: "text",
                label: "Address",
                title: "Service center address",
                component: "input",
                required: true,
                props: {
                    key_name: "service_center_address",
                    editable: false,
                    section: "service_center_details"
                }
            },
            {
                id: "service-center-pincode",
                type: "text",
                label: "Pincode",
                title: "Service center pincode",
                component: "input",
                required: true,
                props: {
                    key_name: "service_center_pincode",
                    editable: false,
                    section: "service_center_details"
                }
            }, 
        ]
    },
    {
        form_type: utils_constants/* FORM_TYPES.SERVICE_CENTER_PROFESSIONAL_DETAILS */.dz.SERVICE_CENTER_PROFESSIONAL_DETAILS,
        section_title: "Professional Details",
        should_capture_details: false,
        details_update_required: false,
        captured_data: {
            gst_number: "",
            pan_number: "",
            pan_image: ""
        },
        ui_config: [
            {
                id: "gst-number",
                type: "text",
                label: "GST number",
                title: "GST number",
                component: "input",
                required: true,
                props: {
                    key_name: "gst_number",
                    editable: false,
                    section: "professional_details"
                }
            },
            {
                id: "pan-number",
                type: "text",
                label: "PAN number",
                title: "PAN number",
                component: "input",
                required: true,
                props: {
                    key_name: "pan_number",
                    editable: false,
                    section: "professional_details"
                }
            },
            {
                id: "pan-image",
                type: "image",
                label: "PAN image",
                title: "PAN image",
                component: "image_preview",
                required: false,
                props: {
                    key_name: "pan_image",
                    editable: false,
                    section: "professional_details"
                }
            }, 
        ]
    },
    {
        form_type: utils_constants/* FORM_TYPES.SERVICE_CENTER_BANK_DETAILS */.dz.SERVICE_CENTER_BANK_DETAILS,
        section_title: "Bank Account Details",
        should_capture_details: false,
        details_update_required: false,
        captured_data: {
            bank_name: "",
            ifsc_code: "",
            bank_account_name: "",
            account_number: "",
            cancelled_cheque: ""
        },
        ui_config: [
            {
                id: "bank-name",
                type: "text",
                label: "Bank name",
                title: "Bank name",
                component: "input",
                required: true,
                props: {
                    key_name: "bank_name",
                    editable: false,
                    section: "bank_details"
                }
            },
            {
                id: "ifsc-code",
                type: "text",
                label: "IFSC code",
                title: "IFSC code",
                component: "input",
                required: true,
                props: {
                    key_name: "ifsc_code",
                    editable: false,
                    section: "bank_details"
                }
            },
            {
                id: "bank-account-name",
                type: "text",
                label: "Bank account name",
                title: "Bank account name",
                component: "input",
                required: true,
                props: {
                    key_name: "bank_account_name",
                    editable: false,
                    section: "bank_details"
                }
            },
            {
                id: "account-number",
                type: "text",
                label: "Account number",
                title: "Account number",
                component: "input",
                required: true,
                props: {
                    key_name: "account_number",
                    editable: false,
                    section: "bank_details"
                }
            },
            {
                id: "cancelled-cheque",
                type: "image",
                label: "Cancelled cheque",
                title: "Cancelled cheque",
                component: "image_preview",
                required: false,
                props: {
                    key_name: "cancelled_cheque",
                    editable: false,
                    section: "bank_details"
                }
            }, 
        ]
    },
    {
        form_type: utils_constants/* FORM_TYPES.SERVICE_CENTER_POC_DETAILS */.dz.SERVICE_CENTER_POC_DETAILS,
        section_title: "POC Details",
        should_capture_details: true,
        details_update_required: false,
        captured_data: {
            communication_name: "",
            communication_phone: "",
            communication_email: ""
        },
        ui_config: [
            {
                id: "communication-name",
                type: "text",
                label: "Communication name",
                title: "Enter communication name",
                component: "input",
                required: true,
                props: {
                    key_name: "communication_name",
                    editable: true,
                    section: "poc_details"
                }
            },
            {
                id: "communication-phone",
                type: "tel",
                label: "Communication phone",
                title: "Enter communication phone",
                component: "input",
                required: true,
                props: {
                    key_name: "communication_phone",
                    editable: true,
                    section: "poc_details"
                }
            },
            {
                id: "communication-email",
                type: "email",
                label: "Communication email (optional)",
                title: "Enter communication email",
                component: "input",
                required: false,
                props: {
                    key_name: "communication_email",
                    editable: true,
                    section: "poc_details"
                }
            }, 
        ]
    },
    {
        form_type: utils_constants/* FORM_TYPES.SERVICE_CENTER_TNC */.dz.SERVICE_CENTER_TNC,
        section_title: "I agree to terms and conditions",
        should_capture_details: true,
        details_update_required: false,
        captured_data: {
            tnc_reveal: false,
            tnc_accepted: false,
            tnc_url: ""
        },
        ui_config: [
            {
                id: "tnc-reveal",
                type: "checkbox",
                label: "I agree to terms and conditions",
                title: "Open terms and conditions",
                component: "tnc_reveal_checkbox",
                required: true,
                props: {
                    key_name: "tnc_reveal",
                    editable: true,
                    section: "tnc"
                }
            },
            {
                id: "tnc-preview",
                type: "url",
                label: "Terms and conditions preview",
                title: "Terms and conditions",
                component: "tnc_preview",
                required: true,
                props: {
                    key_name: "tnc_url",
                    editable: false,
                    section: "tnc"
                }
            },
            {
                id: "tnc-accepted",
                type: "checkbox",
                label: "I have read and accept the terms and conditions",
                title: "Accept terms and conditions",
                component: "tnc_accept_checkbox",
                required: true,
                props: {
                    key_name: "tnc_accepted",
                    editable: true,
                    section: "tnc"
                }
            }, 
        ]
    }, 
];

;// CONCATENATED MODULE: ./components/serviceCenterOnboarding/index.tsx
/* eslint-disable @next/next/no-img-element */ 
























function resolvePreviewSrc(src) {
    if (!src) {
        return "";
    }
    var sanitizedSrc = (0,partnerLogo/* sanitizePartnerLogoUrl */.Ur)(src);
    if (sanitizedSrc.startsWith("http") || sanitizedSrc.startsWith("data:")) {
        return sanitizedSrc;
    }
    return (0,generics/* getImageBasePath */.m4)(sanitizedSrc);
}
function resolveTncSrc(src) {
    if (!src) {
        return "";
    }
    return (0,partnerLogo/* sanitizePartnerLogoUrl */.Ur)(src);
}
function getSectionVariant(formType) {
    switch(formType){
        case utils_constants/* FORM_TYPES.SERVICE_CENTER_POC_DETAILS */.dz.SERVICE_CENTER_POC_DETAILS:
            return "editable";
        case utils_constants/* FORM_TYPES.SERVICE_CENTER_TNC */.dz.SERVICE_CENTER_TNC:
            return "tnc";
        default:
            return "readonly";
    }
}
function mergeServicePartnerForms(baseForms, incomingForms) {
    var incomingMap = incomingForms.reduce(function(acc, form) {
        acc[form.form_type] = form;
        return acc;
    }, {});
    var mergedForms = baseForms.map(function(form) {
        var incomingForm = incomingMap[form.form_type];
        if (!incomingForm) {
            return form;
        }
        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, form, incomingForm), {
            ui_config: incomingForm.ui_config || form.ui_config,
            captured_data: incomingForm.captured_data === undefined ? form.captured_data : incomingForm.captured_data
        });
    });
    var additionalForms = incomingForms.filter(function(incomingForm) {
        return !baseForms.some(function(form) {
            return form.form_type === incomingForm.form_type;
        });
    });
    return (0,_to_consumable_array/* default */.Z)(mergedForms).concat((0,_to_consumable_array/* default */.Z)(additionalForms));
}
function buildInitialFormValues(forms) {
    return forms.reduce(function(acc, form) {
        return (0,src_object_spread/* default */.Z)({}, acc, form.captured_data || {});
    }, {});
}
var servicePartnerFormTypes = new Set([
    utils_constants/* FORM_TYPES.SERVICE_CENTER_DETAILS */.dz.SERVICE_CENTER_DETAILS,
    utils_constants/* FORM_TYPES.SERVICE_CENTER_PROFESSIONAL_DETAILS */.dz.SERVICE_CENTER_PROFESSIONAL_DETAILS,
    utils_constants/* FORM_TYPES.SERVICE_CENTER_BANK_DETAILS */.dz.SERVICE_CENTER_BANK_DETAILS,
    utils_constants/* FORM_TYPES.SERVICE_CENTER_POC_DETAILS */.dz.SERVICE_CENTER_POC_DETAILS,
    utils_constants/* FORM_TYPES.SERVICE_CENTER_TNC */.dz.SERVICE_CENTER_TNC, 
]);
function buildServicePartnerFormsFromContext(formConfigsMap) {
    return Object.entries(formConfigsMap).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), formType = _param[0];
        return servicePartnerFormTypes.has(formType);
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), formType = _param[0], formConfig = _param[1];
        return {
            form_type: formType,
            ui_config: (formConfig === null || formConfig === void 0 ? void 0 : formConfig.uiConfig) || [],
            captured_data: (formConfig === null || formConfig === void 0 ? void 0 : formConfig.captured_data) || {},
            should_capture_details: formConfig === null || formConfig === void 0 ? void 0 : formConfig.should_capture_details,
            details_update_required: formConfig === null || formConfig === void 0 ? void 0 : formConfig.details_update_required
        };
    });
}
function ServiceCenterOnboarding() {
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), permissions = ref.permissions, setSnackbar = ref.setSnackbar, formConfigsMap = ref.formConfigsMap, setFormConfigsMap = ref.setFormConfigsMap;
    var ref1 = (0,compat_module.useState)(serviceCenterOnboardingMockFormConfig), forms = ref1[0], setForms = ref1[1];
    var formConfigMap = (0,helpers/* mapFormConfigs */.c)(forms);
    var ref2 = (0,compat_module.useState)(buildInitialFormValues(serviceCenterOnboardingMockFormConfig)), formValues = ref2[0], setFormValues = ref2[1];
    var ref3 = (0,compat_module.useState)(false), hasScrolledTncToBottom = ref3[0], setHasScrolledTncToBottom = ref3[1];
    var ref4 = (0,compat_module.useState)(true), isLoading = ref4[0], setIsLoading = ref4[1];
    var ref5 = (0,compat_module.useState)(false), isSubmitting = ref5[0], setIsSubmitting = ref5[1];
    var ref6 = (0,compat_module.useState)(""), errorMessage = ref6[0], setErrorMessage = ref6[1];
    (0,compat_module.useEffect)(function() {
        var partnerId = permissions === null || permissions === void 0 ? void 0 : permissions.partner_id;
        var groupName = permissions === null || permissions === void 0 ? void 0 : permissions.group;
        if (!partnerId || !groupName) {
            setIsLoading(false);
            return;
        }
        var loadServicePartnerConfig = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var contextForms, nextForms, dataResponse;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            contextForms = buildServicePartnerFormsFromContext(formConfigsMap);
                            nextForms = mergeServicePartnerForms(serviceCenterOnboardingMockFormConfig, contextForms);
                            return [
                                4,
                                fetchServicePartnerData(partnerId, groupName)
                            ];
                        case 1:
                            dataResponse = _state.sent();
                            if (dataResponse.statusCode === 401) {
                                router.push("/login");
                                return [
                                    2
                                ];
                            }
                            if (!dataResponse.is_error && dataResponse.data) {
                                nextForms = mergeServicePartnerForms(nextForms, dataResponse.data);
                                if (setFormConfigsMap) {
                                    setFormConfigsMap(function(prev) {
                                        return (0,src_object_spread/* default */.Z)({}, prev, (0,helpers/* mapFormConfigs */.c)(dataResponse.data || []));
                                    });
                                }
                            } else {
                                setSnackbar({
                                    type: "failure",
                                    message: dataResponse.error_message || "Failed to fetch service partner data"
                                });
                            }
                            setForms(nextForms);
                            setFormValues(buildInitialFormValues(nextForms));
                            setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadServicePartnerConfig() {
                return _ref.apply(this, arguments);
            };
        }();
        loadServicePartnerConfig();
    }, [
        permissions === null || permissions === void 0 ? void 0 : permissions.partner_id,
        permissions === null || permissions === void 0 ? void 0 : permissions.group
    ]);
    var handleFieldChange = function(key) {
        return function(e) {
            var ref;
            var value = (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "";
            setFormValues(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, value));
            });
        };
    };
    var handleCheckboxToggle = function(key) {
        return function() {
            if (key === "tnc_accepted" && !isMobile && !hasScrolledTncToBottom) {
                return;
            }
            var isTurningOff = Boolean(formValues[key]);
            var nextValue = !formValues[key];
            if (key === "tnc_reveal" && nextValue && isMobile && formValues.tnc_url) {
                window.open(String(formValues.tnc_url), "_blank", "noopener,noreferrer");
            }
            setFormValues(function(prev) {
                return (0,src_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, nextValue)), key === "tnc_reveal" && isTurningOff ? {
                    tnc_accepted: false
                } : {});
            });
            if (key === "tnc_reveal" && isTurningOff) {
                setHasScrolledTncToBottom(false);
            }
        };
    };
    var handleTncScroll = function(e) {
        var target = e.currentTarget;
        var reachedBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 8;
        if (reachedBottom) {
            setHasScrolledTncToBottom(true);
        }
    };
    var isSubmitEnabled = Boolean(formValues.communication_name) && Boolean(formValues.communication_phone) && Boolean(formValues.tnc_reveal) && Boolean(formValues.tnc_accepted);
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var partnerId, groupName, currentLob, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        partnerId = permissions === null || permissions === void 0 ? void 0 : permissions.partner_id;
                        groupName = permissions === null || permissions === void 0 ? void 0 : permissions.group;
                        currentLob = Array.isArray(router.query.slug) ? router.query.slug[0] : "";
                        if (!partnerId || !groupName) {
                            setErrorMessage("Partner information is missing.");
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        return [
                            4,
                            saveServicePartnerData(partnerId, groupName, {
                                service_center_poc_details: {
                                    communication_name: formValues.communication_name || "",
                                    communication_phone: formValues.communication_phone || "",
                                    communication_email: formValues.communication_email || ""
                                },
                                service_center_tnc: {
                                    tnc_reveal: !!formValues.tnc_reveal,
                                    tnc_accepted: !!formValues.tnc_accepted
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.statusCode === 401) {
                            router.push("/login");
                            return [
                                2
                            ];
                        }
                        if (response.is_error) {
                            setSnackbar({
                                type: "failure",
                                message: response.error_message || "Failed to save service partner details"
                            });
                            setIsSubmitting(false);
                            return [
                                2
                            ];
                        }
                        setSnackbar({
                            type: "success",
                            message: "Service partner details saved successfully"
                        });
                        setIsSubmitting(false);
                        router.push("/".concat(currentLob || "embedded", "/").concat(partnerId, "/dashboard"));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (errorMessage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            errorMessage: errorMessage
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(serviceCenterOnboarding_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_Section, {
                        $index: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(HeroCard, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HeroEyebrow, {
                                    children: "Service Partner Onboarding"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_Title, {
                                    children: "Service Partner"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Subtitle, {
                                    children: "Review the prefilled partner information, complete the POC details, and accept the terms to submit the onboarding request."
                                })
                            ]
                        })
                    }),
                    forms.map(function(form, index) {
                        var ref;
                        var mappedConfig = formConfigMap[form.form_type];
                        var variant = getSectionVariant(form.form_type);
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_Section, {
                            $index: index + 1,
                            $variant: variant,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Card, {
                                $variant: variant,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_SectionTitle, {
                                                children: form.section_title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SectionBadge, {
                                                $variant: variant,
                                                children: variant === "readonly" ? "Prefilled" : variant === "editable" ? "Action needed" : "Required"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FieldsGrid, {
                                        $variant: variant,
                                        children: mappedConfig === null || mappedConfig === void 0 ? void 0 : (ref = mappedConfig.uiConfig) === null || ref === void 0 ? void 0 : ref.map(function(field) {
                                            var ref, ref1;
                                            var key = (field === null || field === void 0 ? void 0 : (ref = field.props) === null || ref === void 0 ? void 0 : ref.key_name) || field.id;
                                            var value = formValues[key] || "";
                                            if (form.form_type === utils_constants/* FORM_TYPES.SERVICE_CENTER_TNC */.dz.SERVICE_CENTER_TNC) {
                                                if (field.component === "tnc_reveal_checkbox") {
                                                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TncControlRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_CheckBoxFlex, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_checkbox, {
                                                                    isSelected: !!value,
                                                                    onSelectHandler: handleCheckboxToggle(key),
                                                                    color: "#0FA457",
                                                                    width: "18px",
                                                                    height: "18px"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_TncText, {
                                                                children: field.label
                                                            })
                                                        ]
                                                    }, field.id);
                                                }
                                                if (field.component === "tnc_accept_checkbox" && formValues.tnc_reveal) {
                                                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TncControlRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_CheckBoxFlex, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_checkbox, {
                                                                    isSelected: !!value,
                                                                    onSelectHandler: handleCheckboxToggle(key),
                                                                    color: "#0FA457",
                                                                    width: "18px",
                                                                    height: "18px"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_TncText, {
                                                                $disabled: !isMobile && !hasScrolledTncToBottom,
                                                                children: field.label
                                                            })
                                                        ]
                                                    }, field.id);
                                                }
                                                if (field.component === "tnc_preview" && formValues.tnc_reveal && !isMobile) {
                                                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TncPreviewSection, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TncPreviewCard, {
                                                                onScroll: handleTncScroll,
                                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("iframe", {
                                                                    src: resolveTncSrc(String(value)),
                                                                    title: "Terms and conditions"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TncHint, {
                                                                children: "Scroll to the bottom to enable acceptance."
                                                            })
                                                        ]
                                                    }, field.id);
                                                }
                                            }
                                            if (field.component === "image_preview" && value) {
                                                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PreviewWrapper, {
                                                    $fullWidth: variant !== "readonly",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PreviewLabel, {
                                                            children: field.label
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PreviewCard, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("img", {
                                                                src: resolvePreviewSrc(value),
                                                                alt: field.label
                                                            })
                                                        })
                                                    ]
                                                }, field.id);
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_InputWrapper, {
                                                $fullWidth: field.type !== "text" && field.type !== "email" && field.type !== "tel",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_input_dist.Input, {
                                                    className: "",
                                                    labelText: field.label,
                                                    name: key,
                                                    type: field.type,
                                                    value: value,
                                                    placeHolder: field.title,
                                                    onChange: handleFieldChange(key),
                                                    disabled: ((ref1 = field.props) === null || ref1 === void 0 ? void 0 : ref1.editable) === false
                                                })
                                            }, field.id);
                                        })
                                    }),
                                    form.form_type === utils_constants/* FORM_TYPES.SERVICE_CENTER_TNC */.dz.SERVICE_CENTER_TNC ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding_styles_SubmitButtonWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                            disabled: !isSubmitEnabled,
                                            loading: isSubmitting,
                                            onClick: handleSubmit,
                                            children: "Submit"
                                        })
                                    }) : null
                                ]
                            })
                        }, form.form_type);
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var serviceCenterOnboarding = (ServiceCenterOnboarding);

;// CONCATENATED MODULE: ./components/routesConfig/ather.tsx




















function getRoutePathAther(route) {
    (0,compat_module.useEffect)(function() {
        window.lob = utils_constants/* LOB.AUTO */.r6.AUTO;
    }, []);
    switch(route){
        case "dashboard":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboard/* default */.Z, {});
        case "form":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dealerForm, {});
        case "manage-dealers":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(manageDealers, {});
        case "new-plan":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_newPlan, {});
        case "payment":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(auto_lob_payment, {});
        case "transactions":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions, {});
        case "thankyou":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyou, {});
        case "contact-us":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs, {});
        case "report-dashboard":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reportDashboard, {});
        case "dealer-details":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_dealerDetails, {});
        case "legal-documents":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocuments, {});
        case "gst-details":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstDetails, {});
        case "details":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(details, {});
        case "wallet-transactions":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(walletTransactions, {});
        case "payment-mode":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(paymentMode, {});
        case "service-partner":
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding, {});
        default:
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {});
    }
}
/* harmony default export */ var ather = (getRoutePathAther);

;// CONCATENATED MODULE: ./components/legalTnc/styles.ts

function legalTnc_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    legalTnc_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var legalTnc_styles_Wrapper = building_blocks_ui_common_dist.styled.div(legalTnc_styles_templateObject());

;// CONCATENATED MODULE: ./components/legalTnc/index.tsx





function LegalTnc() {
    var setShowHamburger = (0,compat_module.useContext)(context/* MPosContext */.w).setShowHamburger;
    var onClick = function() {
        setShowHamburger(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalTnc_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tnc, {
            onClick: onClick
        })
    });
}
/* harmony default export */ var legalTnc = (LegalTnc);

// EXTERNAL MODULE: ./widgets/cards/iconTextArrow/index.tsx + 1 modules
var iconTextArrow = __webpack_require__(1268);
;// CONCATENATED MODULE: ./components/dashboardV2/newPlan/styles.ts

function dashboardV2_newPlan_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 32px;\n"
    ]);
    dashboardV2_newPlan_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var NewPlanWrapper = building_blocks_ui_common_dist.styled.div(dashboardV2_newPlan_styles_templateObject());

;// CONCATENATED MODULE: ./components/dashboardV2/newPlan/index.tsx




function dashboardV2_newPlan_NewPlan() {
    var onClickNewPlan = function() {
        window.location.href = "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/auto-partnership-buy/mpos/dealer/pre-quote?current_node=enter_mmv_details_node");
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NewPlanWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(iconTextArrow/* default */.Z, {
            icon: "/icons/claim.svg",
            text: "Create new plan",
            backgroundColor: "161.3deg, #FFF7E5 -2.04%, #FBE9F6 102.81%",
            onClick: onClickNewPlan
        })
    });
}
/* harmony default export */ var dashboardV2_newPlan = (dashboardV2_newPlan_NewPlan);

// EXTERNAL MODULE: ./widgets/tab/index.tsx + 1 modules
var tab = __webpack_require__(89);
;// CONCATENATED MODULE: ./components/dashboardV2/transactions/detailsModal/styles.ts

function detailsModal_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    detailsModal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n"
    ]);
    detailsModal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n    margin-top: 4px;\n"
    ]);
    detailsModal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 14px;\n    background: ",
        ";\n    border-radius: 4px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: ",
        ";\n    padding: 6px;\n    width: fit-content;\n"
    ]);
    detailsModal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 12px;\n    flex-direction: column;\n    background: #ffffff;\n    border-radius: 12px;\n    margin-top: 26px;\n    border: 1px solid #e7e7f0;\n"
    ]);
    detailsModal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 10px;\n"
    ]);
    detailsModal_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    detailsModal_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    text-align: end;\n"
    ]);
    detailsModal_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    opacity: 0.1;\n    border: 1px solid #040222;\n    margin-top: 10px;\n"
    ]);
    detailsModal_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 24px;\n"
    ]);
    detailsModal_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 2;\n    flex-direction: column;\n"
    ]);
    detailsModal_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    detailsModal_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 6px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    detailsModal_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    align-items: flex-end;\n"
    ]);
    detailsModal_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: ",
        ";\n"
    ]);
    detailsModal_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #1b73e8;\n    justify-content: center;\n"
    ]);
    detailsModal_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    detailsModal_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n"
    ]);
    detailsModal_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    margin-top: 8px;\n    justify-content: space-between;\n"
    ]);
    detailsModal_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #1b73e8;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    max-width: calc(100% - 10%);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin: 0px;\n    padding: 0px;\n"
    ]);
    detailsModal_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%{\n    opacity : 0\n  }\n  50%{\n    opacity : 1\n  }\n  51%{\n    opacity : 1\n  }\n  85%{\n    opacity : 0;\n    display: none;\n  }\n  100%{\n    opacity : 0;\n    display: none;\n  }\n"
    ]);
    detailsModal_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function detailsModal_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    width: max-content;\n    box-sizing: border-box;\n    background-color: #0fa457;\n    color: white;\n    padding: 0.5rem;\n    border-radius: 8px;\n    font-size: 12px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: -100%;\n    animation: ",
        " 1.5s ease-in-out;\n"
    ]);
    detailsModal_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}

var detailsModal_styles_Wrapper = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject());
var ModalName = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject1());
var LastUpdatedDate = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject2());
var StatusText = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject3(), function(props) {
    return props.background;
}, function(props) {
    return props.color;
});
var detailsModal_styles_PlanDetailsWrapper = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject4());
var detailsModal_styles_RowWrapper = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject5());
var detailsModal_styles_LabelText = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject6());
var detailsModal_styles_ValueText = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject7());
var detailsModal_styles_Hr = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject8());
var CustomerDetailsWrapper = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject9());
var CustomerMobileFlex = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject10());
var CustomerMobileText = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject11());
var CustomerMobileNumber = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject12());
var CustomerAmountFlex = (0,building_blocks_ui_common_dist.styled)(CustomerMobileFlex)(detailsModal_styles_templateObject13());
var ResendLinkWrapper = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject14(), function(props) {
    return props.mt || "32px";
});
var ResendLinkText = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject15());
var RedirectionLinkText = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject16());
var detailsModal_styles_LinkWrapper = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject17());
var LinkContainer = building_blocks_ui_common_dist.styled.div(detailsModal_styles_templateObject18());
var LinkText = building_blocks_ui_common_dist.styled.p(detailsModal_styles_templateObject19());
var styles_Appear = (0,building_blocks_ui_common_dist.keyframes)(detailsModal_styles_templateObject20());
var styles_Copied = (0,building_blocks_ui_common_dist.styled)(building_blocks_ui_common_dist.Box)(detailsModal_styles_templateObject21(), styles_Appear);

;// CONCATENATED MODULE: ./components/dashboardV2/transactions/detailsModal/index.tsx







var TabOptions;
(function(TabOptions) {
    TabOptions["PENDING"] = "Pending";
    TabOptions["COMPLETED"] = "Completed";
})(TabOptions || (TabOptions = {}));
function TransactionDetailsModal(param) {
    var selectedTab = param.selectedTab, variantName = param.variantName, lastUpdatedAt = param.lastUpdatedAt, status = param.status, statusMessage = param.statusMessage, planName = param.planName, mobileNumber = param.mobileNumber, amount = param.amount, onClick = param.onClick, isBtnLoading = param.isBtnLoading, vin = param.vin, customerName = param.customerName, redirectUrl = param.redirectUrl;
    var ref = (0,compat_module.useState)(false), linkCopied = ref[0], setLinkCopied = ref[1];
    (0,compat_module.useEffect)(function() {
        var timer;
        if (linkCopied) {
            timer = setTimeout(function() {
                setLinkCopied(false);
            }, 1200);
        }
        return function() {
            timer && clearTimeout(timer);
        };
    }, [
        linkCopied
    ]);
    var getColors = function() {
        switch(statusMessage){
            case "Expired":
                return {
                    color: "#D83D37",
                    background: "#FBEAEA"
                };
            case "Payment Done, KYC Pending":
                return {
                    color: "#F58700",
                    background: "#FFF7E5"
                };
            case "Payment Pending":
                return {
                    color: "#5920C5",
                    background: "#EFE9FB"
                };
            default:
                return {
                    color: "#0FA457",
                    background: "#EBFBEE"
                };
        }
    };
    var ref1 = getColors(), background = ref1.background, color = ref1.color;
    var copyLink = function(link) {
        navigator.clipboard.writeText(link);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(detailsModal_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalName, {
                children: customerName
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LastUpdatedDate, {
                children: [
                    "Last updated ",
                    (0,date/* getHHMM */["in"])(lastUpdatedAt)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StatusText, {
                background: background,
                color: color,
                children: statusMessage || status
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(detailsModal_styles_PlanDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(detailsModal_styles_RowWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_LabelText, {
                                children: "Vehicle model"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_ValueText, {
                                children: variantName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_Hr, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(detailsModal_styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_LabelText, {
                                        children: "Chassis number"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_ValueText, {
                                        children: vin
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(detailsModal_styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_LabelText, {
                                        children: "Plan Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal_styles_ValueText, {
                                        children: planName
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerMobileFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerMobileText, {
                                children: "Customer mobile number"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerMobileNumber, {
                                children: mobileNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerAmountFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerMobileFlex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerMobileText, {
                                    children: "Amount"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerMobileNumber, {
                                    children: [
                                        "₹",
                                        amount
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            redirectUrl && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(detailsModal_styles_LinkWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                gap: "1rem",
                                width: "max-content",
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RedirectionLinkText, {
                                    children: "Customer link"
                                }),
                                linkCopied && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Copied, {
                                    children: "Link copied"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LinkContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LinkText, {
                                    children: redirectUrl
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    width: "16px",
                                    height: "16px",
                                    alt: "",
                                    src: (0,generics/* getImageBasePath */.m4)("/icons/copy.svg"),
                                    onClick: function() {
                                        copyLink(redirectUrl);
                                        setLinkCopied(true);
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            selectedTab === TabOptions.PENDING && (statusMessage === "Payment Pending" || statusMessage === "Payment Done, KYC Pending") && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ResendLinkWrapper, {
                mt: "32px",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    loading: isBtnLoading,
                    isFullWidth: true,
                    size: "medium",
                    onClick: function() {
                        return onClick();
                    },
                    children: "Resend link"
                })
            })
        ]
    });
}
/* harmony default export */ var detailsModal = (TransactionDetailsModal);

;// CONCATENATED MODULE: ./components/dashboardV2/transactions/itemCard/styles.ts

function transactions_itemCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 10px;\n"
    ]);
    transactions_itemCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function transactions_itemCard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 9;\n    flex-direction: column;\n    gap: 8px;\n"
    ]);
    transactions_itemCard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function transactions_itemCard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    align-items: center;\n"
    ]);
    transactions_itemCard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function transactions_itemCard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n"
    ]);
    transactions_itemCard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function transactions_itemCard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    transactions_itemCard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function transactions_itemCard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 26px;\n    color: #040222;\n"
    ]);
    transactions_itemCard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function transactions_itemCard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;a\n"
    ]);
    transactions_itemCard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function transactions_itemCard_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n    margin-left: 6px;\n"
    ]);
    transactions_itemCard_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    itemCard_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    itemCard_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function itemCard_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 2px 6px;\n    border-radius: 4px;\n"
    ]);
    itemCard_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var transactions_itemCard_styles_Wrapper = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject());
var styles_DivFlex = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject1());
var RightArrowIconFlex = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject2());
var styles_RowFlex = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject3());
var styles_Value1 = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject4());
var styles_Value2 = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject5());
var styles_Value3 = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject6());
var styles_Value4 = building_blocks_ui_common_dist.styled.div(transactions_itemCard_styles_templateObject7());
var Value5 = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject8());
var Value6 = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject9());
var styles_Value4BackgroundText = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject10(), function(props) {
    return props.background;
}, function(props) {
    return props.color;
});

;// CONCATENATED MODULE: ./components/dashboardV2/transactions/itemCard/index.tsx




function itemCard_TransactionItemCard(param) {
    var value1 = param.value1, value2 = param.value2, value3 = param.value3, value4 = param.value4, value5 = param.value5, value6 = param.value6, labelColor = param.labelColor;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(transactions_itemCard_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_DivFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value1, {
                                children: value1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value2, {
                                children: value2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value3, {
                                children: value3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                width: "16px",
                                height: "16px",
                                alt: "",
                                src: (0,generics/* getImageBasePath */.m4)("/icons/call.svg")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value4, {
                                children: value4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value5, {
                                children: (labelColor === null || labelColor === void 0 ? void 0 : labelColor.background) ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value4BackgroundText, {
                                    background: labelColor.background,
                                    color: labelColor.color,
                                    children: value5
                                }) : value5
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value6, {
                                children: value6
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RightArrowIconFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "12px",
                    height: "12px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/icons/rightArrow.svg")
                })
            })
        ]
    });
}
/* harmony default export */ var transactions_itemCard = (itemCard_TransactionItemCard);

;// CONCATENATED MODULE: ./components/dashboardV2/transactions/styles.ts

function dashboardV2_transactions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    dashboardV2_transactions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dashboardV2_transactions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #000000;\n"
    ]);
    dashboardV2_transactions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dashboardV2_transactions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 10px;\n"
    ]);
    dashboardV2_transactions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function dashboardV2_transactions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 6px 0;\n"
    ]);
    dashboardV2_transactions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function dashboardV2_transactions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    height: 0;\n    border: 1px solid #e7e7f0;\n"
    ]);
    dashboardV2_transactions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function dashboardV2_transactions_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    dashboardV2_transactions_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function dashboardV2_transactions_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    height: 200px;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    dashboardV2_transactions_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var dashboardV2_transactions_styles_Wrapper = building_blocks_ui_common_dist.styled.div(dashboardV2_transactions_styles_templateObject());
var AllTransactionText = building_blocks_ui_common_dist.styled.div(dashboardV2_transactions_styles_templateObject1());
var TabWrapper = building_blocks_ui_common_dist.styled.div(dashboardV2_transactions_styles_templateObject2());
var ItemCardWrapper = building_blocks_ui_common_dist.styled.div(dashboardV2_transactions_styles_templateObject3());
var dashboardV2_transactions_styles_Hr = building_blocks_ui_common_dist.styled.div(dashboardV2_transactions_styles_templateObject4());
var transactions_styles_NoResult = building_blocks_ui_common_dist.styled.div(dashboardV2_transactions_styles_templateObject5());
var ModalLoaderWrapper = building_blocks_ui_common_dist.styled.div(dashboardV2_transactions_styles_templateObject6());

;// CONCATENATED MODULE: ./components/dashboardV2/transactions/constants.ts
var ProposalStatus;
(function(ProposalStatus) {
    ProposalStatus["payment_ready"] = "Payment Pending";
    ProposalStatus["order_initialised"] = "Payment Pending";
    ProposalStatus["payment_initiated"] = "Payment Pending";
    ProposalStatus["payment_done"] = "Payment done";
    ProposalStatus["policy_ready"] = "Payment done";
    ProposalStatus["pi_pending"] = "Payment done";
    ProposalStatus["pi_scheduled"] = "Payment done";
    ProposalStatus["pi_approved"] = "Payment done";
    ProposalStatus["pi_not_scheduled_by_user"] = "Payment done";
    ProposalStatus["pi_rejected"] = "Payment done";
    ProposalStatus["pi_cancelled"] = "Payment done";
    ProposalStatus["terminated"] = "Expired";
    ProposalStatus["refund_ready"] = "Payment done";
    ProposalStatus["refund_issued"] = "Payment done";
    ProposalStatus["policy_issued"] = "Policy Issued";
})(ProposalStatus || (ProposalStatus = {}));
var KycStatus;
(function(KycStatus) {
    KycStatus["KYC_COMPLETED"] = "Done";
    KycStatus["KYC_RECORD_NOT_PRESENT"] = "Pending";
    KycStatus["KYC_VERIFICATION_PENDING"] = "Pending";
})(KycStatus || (KycStatus = {}));
var OrderStatusLabel;
(function(OrderStatusLabel) {
    OrderStatusLabel["Payment Pending"] = "Payment Pending";
    OrderStatusLabel["Payment Done"] = "Payment Done, KYC Pending";
    OrderStatusLabel["Pending"] = "Payment Done, KYC Pending";
    OrderStatusLabel["Done"] = "Payment Done, KYC Done";
    OrderStatusLabel["Policy Issued"] = "Policy Issued";
    OrderStatusLabel["Expired"] = "Expired";
})(OrderStatusLabel || (OrderStatusLabel = {}));

;// CONCATENATED MODULE: ./components/dashboardV2/transactions/index.tsx



















var transactions_TabOptions;
(function(TabOptions) {
    TabOptions["PENDING"] = "Pending";
    TabOptions["COMPLETED"] = "Completed";
})(transactions_TabOptions || (transactions_TabOptions = {}));
function OrderHistory(param) {
    var pendingOrders = param.pendingOrders, completedOrders = param.completedOrders, hasMorePending = param.hasMorePending, hasMoreCompleted = param.hasMoreCompleted, onLoadMore = param.onLoadMore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var router = (0,next_router.useRouter)();
    var ref26 = (0,compat_module.useState)(null), selectedOrder = ref26[0], setSelectedOrder = ref26[1];
    var ref27 = (0,compat_module.useState)(transactions_TabOptions.PENDING), selectedTab = ref27[0], setSelectedTab = ref27[1];
    var ref28 = (0,compat_module.useState)(false), modalStatus = ref28[0], setModalStatus = ref28[1];
    var ref29 = (0,compat_module.useState)(false), showLoader = ref29[0], setShowLoader = ref29[1];
    var ref30 = (0,compat_module.useState)(false), isBtnLoading = ref30[0], setIsBtnLoading = ref30[1];
    var ref31 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref31[0], setSnackbar = ref31[1];
    var onSelectTab = function(option) {
        setSelectedTab(option);
    };
    var getActiveOrdersList = function() {
        if (selectedTab === transactions_TabOptions.COMPLETED) {
            return completedOrders;
        }
        return pendingOrders;
    };
    var onClickOrder = function(order) {
        setModalStatus(true);
        setShowLoader(true);
        __webpack_require__.e(/* import() */ 275).then(__webpack_require__.bind(__webpack_require__, 1275)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, status, data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getOrder(order === null || order === void 0 ? void 0 : order.order_id)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status && data) {
                                setSelectedOrder(data);
                                setShowLoader(false);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var orderStatus = function(status) {
        switch(status){
            case "FAILED":
                return {
                    text: "Failed",
                    color: "#D83D37",
                    background: "#FBEAEA"
                };
            case "PENDING_VERIFICATION":
                return {
                    text: "Pending Verification",
                    color: "#F58700",
                    background: "#FFF7E5"
                };
            case "PAYMENT_PENDING":
                return {
                    text: "Payment Pending",
                    color: "#5920C5",
                    background: "#EFE9FB"
                };
            default:
                return {
                    text: "Policy Issued",
                    color: "#0FA457",
                    background: "#EBFBEE"
                };
        }
    };
    var getValueObjects = function(order) {
        var ref, ref1, ref2;
        var ref3 = orderStatus(order.status), text = ref3.text, color = ref3.color, background = ref3.background;
        return {
            value1: order === null || order === void 0 ? void 0 : (ref = order.data) === null || ref === void 0 ? void 0 : ref.name,
            value2: "₹".concat(order === null || order === void 0 ? void 0 : order.amount),
            value3: order === null || order === void 0 ? void 0 : (ref1 = order.data) === null || ref1 === void 0 ? void 0 : ref1.mmv,
            value4: order === null || order === void 0 ? void 0 : (ref2 = order.data) === null || ref2 === void 0 ? void 0 : ref2.phone,
            value5: text,
            labelColor: {
                color: color,
                background: background
            },
            value6: (0,date/* getDD_Month_Time */.Se)(new Date(order.created_on))
        };
    };
    var onClick = function() {
        __webpack_require__.e(/* import() */ 275).then(__webpack_require__.bind(__webpack_require__, 1275)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, ref1, status, statusCode, errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsBtnLoading(true);
                            return [
                                4,
                                req.resendLinkToCustomer((selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref = selectedOrder.proposal) === null || ref === void 0 ? void 0 : ref.proposal_id) || "")
                            ];
                        case 1:
                            ref1 = _state.sent(), status = ref1.status, statusCode = ref1.statusCode, errorMessage = ref1.errorMessage;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            setIsBtnLoading(false);
                            if (status) {
                                setSnackbar({
                                    type: "success",
                                    message: "Payment link has sent successfully."
                                });
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: errorMessage || "Oops. Something went wrong."
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var getStatusMessage = function(status) {
        var statusValue = ProposalStatus[status === null || status === void 0 ? void 0 : status.policy_status];
        if (statusValue === "Payment done") {
            var ref;
            statusValue = KycStatus[status === null || status === void 0 ? void 0 : (ref = status.parameters) === null || ref === void 0 ? void 0 : ref.kyc_status];
        }
        var label = OrderStatusLabel[statusValue];
        return label;
    };
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dashboardV2_transactions_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AllTransactionText, {
                children: "Recent transactions"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tab/* default */.Z, {
                    items: [
                        transactions_TabOptions.PENDING,
                        transactions_TabOptions.COMPLETED
                    ],
                    color: "#0FA457",
                    selectedTab: selectedTab,
                    onSelectTab: onSelectTab
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                children: getActiveOrdersList().length === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions_styles_NoResult, {
                    children: "No transactions"
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                    dataLength: getActiveOrdersList().length,
                    next: function() {
                        return onLoadMore(selectedTab.toLowerCase());
                    },
                    hasMore: selectedTab === transactions_TabOptions.PENDING ? hasMorePending : hasMoreCompleted,
                    loader: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                    children: getActiveOrdersList().map(function(order, index) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ItemCardWrapper, {
                            onClick: function() {
                                return onClickOrder(order);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions_itemCard, (0,src_object_spread/* default */.Z)({}, getValueObjects(order))),
                                index !== getActiveOrdersList().length - 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboardV2_transactions_styles_Hr, {})
                            ]
                        }, order.ekey);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                show: modalStatus,
                onHide: function() {
                    return setModalStatus(false);
                },
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                children: showLoader ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalLoaderWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* ModalLoader */.C7, {
                        src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal, {
                    selectedTab: selectedTab,
                    customerName: (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref = selectedOrder.proposal) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || "",
                    variantName: (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref3 = selectedOrder.proposal) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.insured) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.variant) || "",
                    lastUpdatedAt: (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref6 = selectedOrder.proposal) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.meta) === null || ref7 === void 0 ? void 0 : ref7.updated_on) || "",
                    status: (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref8 = selectedOrder.proposal) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.status) === null || ref9 === void 0 ? void 0 : ref9.policy_status) || "",
                    statusMessage: getStatusMessage(selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref10 = selectedOrder.proposal) === null || ref10 === void 0 ? void 0 : ref10.status),
                    planName: (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref11 = selectedOrder.proposal) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.plans) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.plan_name) || "",
                    mobileNumber: (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref14 = selectedOrder.proposal) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.users) === null || ref15 === void 0 ? void 0 : ref15[0].phone) || "",
                    amount: (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref16 = selectedOrder.proposal) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.premium) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.plan) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.insured) === null || ref20 === void 0 ? void 0 : ref20.gross_premium) || 0,
                    onClick: onClick,
                    isBtnLoading: isBtnLoading,
                    vin: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref21 = selectedOrder.proposal) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.insured) === null || ref22 === void 0 ? void 0 : (ref23 = ref22[0]) === null || ref23 === void 0 ? void 0 : ref23.chassis_number,
                    redirectUrl: selectedTab === (transactions_TabOptions === null || transactions_TabOptions === void 0 ? void 0 : transactions_TabOptions.PENDING) ? (selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref24 = selectedOrder.proposal) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.meta) === null || ref25 === void 0 ? void 0 : ref25.redirect_url) || "" : null
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var dashboardV2_transactions = (OrderHistory);

;// CONCATENATED MODULE: ./components/dashboardV2/styles.ts

function dashboardV2_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"
    ]);
    dashboardV2_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dashboardV2_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media (prefers-reduced-motion: no-preference) {\n        ",
        "\n    }\n"
    ]);
    dashboardV2_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dashboardV2_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    box-sizing: border-box;\n\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    dashboardV2_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function dashboardV2_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.35s ease-out;\n    "
    ]);
    dashboardV2_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function dashboardV2_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    ",
        "\n"
    ]);
    dashboardV2_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function dashboardV2_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n            /* "backwards" (not "both") on purpose: "both" would leave a\n               non-none transform on this element permanently after the\n               animation ends, which creates a new containing block for any\n               position:fixed descendant (e.g. the transaction details\n               modal), pinning it near the top of this section instead of\n               centering in the real viewport. */\n            animation: ',
        " 0.35s ease-out backwards;\n            animation-delay: ",
        "s;\n        "
    ]);
    dashboardV2_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function dashboardV2_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    ",
        "\n"
    ]);
    dashboardV2_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function dashboardV2_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n    width: 100%;\n"
    ]);
    dashboardV2_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var dashboardV2_styles_fadeSlideUp = (0,styled_components_browser_esm.keyframes)(dashboardV2_styles_templateObject());
var dashboardV2_styles_motionSafe = function(styles) {
    return (0,styled_components_browser_esm.css)(dashboardV2_styles_templateObject1(), styles);
};
var dashboardV2_styles_Wrapper = styled_components_browser_esm["default"].div(dashboardV2_styles_templateObject2());
var dashboardV2_styles_Content = styled_components_browser_esm["default"].div(dashboardV2_styles_templateObject4(), dashboardV2_styles_motionSafe((0,styled_components_browser_esm.css)(dashboardV2_styles_templateObject3(), dashboardV2_styles_fadeSlideUp)));
var dashboardV2_styles_Section = styled_components_browser_esm["default"].div(dashboardV2_styles_templateObject6(), function(param) {
    var $index = param.$index;
    return typeof $index === "number" && dashboardV2_styles_motionSafe((0,styled_components_browser_esm.css)(dashboardV2_styles_templateObject5(), dashboardV2_styles_fadeSlideUp, Math.min($index, 4) * 0.06));
});
var styles_TransactionSearchFlex = styled_components_browser_esm["default"].div(dashboardV2_styles_templateObject7());

// EXTERNAL MODULE: ./utils/localStorage/partnerStorage.js
var partnerStorage = __webpack_require__(1246);
;// CONCATENATED MODULE: ./components/dashboardV2/legalDocumentPending/styles.ts

function legalDocumentPending_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 20px;\n"
    ]);
    legalDocumentPending_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n"
    ]);
    legalDocumentPending_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    text-align: center;\n"
    ]);
    legalDocumentPending_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    margin-top: 20px;\n    width: 100%;\n    max-width: 220px;\n"
    ]);
    legalDocumentPending_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    button {\n        width: 100%;\n    }\n"
    ]);
    legalDocumentPending_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var legalDocumentPending_styles_Wrapper = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject());
var styles_TextWrapper = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject1());
var legalDocumentPending_styles_Text = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject2());
var styles_Actions = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject3());
var styles_ActionButton = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject4());

;// CONCATENATED MODULE: ./components/dashboardV2/legalDocumentPending/index.tsx









function LegalDocumentPendingState() {
    var router = (0,next_router.useRouter)();
    var userAccessList = (0,compat_module.useContext)(context/* MPosContext */.w).userAccessList;
    var ref = (0,compat_module.useState)(false), isSwitchingPartner = ref[0], setIsSwitchingPartner = ref[1];
    var accessList = (userAccessList === null || userAccessList === void 0 ? void 0 : userAccessList.length) > 0 ? userAccessList : (0,partnerStorage/* getUserAccess */.Fu)();
    var uniquePartnerIds = new Set((accessList || []).map(function(access) {
        return access === null || access === void 0 ? void 0 : access.partner_id;
    }).filter(Boolean));
    var hasMultiplePartners = uniquePartnerIds.size > 1;
    var onSwitchBrand = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSwitchingPartner(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        (0,partnerStorage/* setPartnerNavState */.sy)(partnerStorage/* PARTNER_NAV_STATES.SELECTING */.I0.SELECTING);
                        return [
                            4,
                            router.push("/partners")
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsSwitchingPartner(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSwitchBrand() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocumentPending_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_TextWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocumentPending_styles_Text, {
                    children: "We have requested your dealer to submit the bank and GST details."
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocumentPending_styles_Text, {
                    children: "Once the dealer completes this step, you will be able to start selling the plans."
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Actions, {
                    children: [
                        hasMultiplePartners ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ActionButton, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.SecondaryButton, {
                                onClick: onSwitchBrand,
                                disabled: isSwitchingPartner,
                                children: isSwitchingPartner ? "Switching..." : "Switch brand"
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ActionButton, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                onClick: function() {
                                    return router.push("/logout");
                                },
                                disabled: isSwitchingPartner,
                                children: "Logout"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var legalDocumentPending = (LegalDocumentPendingState);

;// CONCATENATED MODULE: ./components/dashboardV2/index.tsx



















function DashboardV2() {
    var getTransactions = function getTransactions() {
        __webpack_require__.e(/* import() */ 149).then(__webpack_require__.bind(__webpack_require__, 5149)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, pendingStatus, pendingData, ref1, completedStatus, completedData, ref2, ref3;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsPageSearchLoading(true);
                            return [
                                4,
                                req.getDealerDashboard(1, "PAYMENT_PENDING, PENDING_VERIFICATION , FAILED", searchValue)
                            ];
                        case 1:
                            ref = _state.sent(), pendingStatus = ref.status, pendingData = ref.data;
                            return [
                                4,
                                req.getDealerDashboard(1, "ISSUED", searchValue)
                            ];
                        case 2:
                            ref1 = _state.sent(), completedStatus = ref1.status, completedData = ref1.data;
                            if (pendingStatus && (pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders) && completedStatus && (completedData === null || completedData === void 0 ? void 0 : completedData.orders)) {
                                ;
                                setPendingOrders((pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders) || []);
                                setCompletedOrders((completedData === null || completedData === void 0 ? void 0 : completedData.orders) || []);
                                if ((pendingData === null || pendingData === void 0 ? void 0 : (ref2 = pendingData.orders) === null || ref2 === void 0 ? void 0 : ref2.length) > 9) {
                                    setPendingOrdersPage(2);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hasMore), {
                                        pending: (pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders.length) > 9,
                                        completed: (completedData === null || completedData === void 0 ? void 0 : completedData.orders.length) > 9
                                    }));
                                }
                                if ((completedData === null || completedData === void 0 ? void 0 : (ref3 = completedData.orders) === null || ref3 === void 0 ? void 0 : ref3.length) > 9) {
                                    setCompletedOrdersPage(2);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hasMore), {
                                        pending: (pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders.length) > 9,
                                        completed: (completedData === null || completedData === void 0 ? void 0 : completedData.orders.length) > 9
                                    }));
                                }
                                setErrorMessage("");
                            } else {
                                setErrorMessage("Something went wrong.");
                            }
                            setIsPageSearchLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), legalDetailsUploadedStatus = ref.legalDetailsUploadedStatus, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref1 = (0,compat_module.useState)([]), pendingOrders = ref1[0], setPendingOrders = ref1[1];
    var ref2 = (0,compat_module.useState)([]), completedOrders = ref2[0], setCompletedOrders = ref2[1];
    var ref3 = (0,compat_module.useState)(1), pendingOrdersPage = ref3[0], setPendingOrdersPage = ref3[1];
    var ref4 = (0,compat_module.useState)(1), completedOrdersPage = ref4[0], setCompletedOrdersPage = ref4[1];
    var ref5 = (0,compat_module.useState)({
        pending: true,
        completed: true
    }), hasMore = ref5[0], setHasMore = ref5[1];
    var ref6 = (0,compat_module.useState)(true), isPageLoading = ref6[0], setIsPageLoading = ref6[1];
    var ref7 = (0,compat_module.useState)(false), isPageSearchLoading = ref7[0], setIsPageSearchLoading = ref7[1];
    var ref8 = (0,compat_module.useState)(""), errorMesssage = ref8[0], setErrorMessage = ref8[1];
    var ref9 = (0,compat_module.useState)(""), searchValue = ref9[0], setSearchValue = ref9[1];
    var ref10 = (0,compat_module.useState)(false), isSearchInteracted = ref10[0], setIsSearchInteracted = ref10[1];
    (0,compat_module.useEffect)(function() {
        setPlanDetails(newPlan_constants/* policyDetailsInitState */.c8);
        setActiveStage(newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL);
    }, []);
    (0,compat_module.useEffect)(function() {
        __webpack_require__.e(/* import() */ 149).then(__webpack_require__.bind(__webpack_require__, 5149)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var ref, pendingStatus, pendingData, ref1, completedStatus, completedData, ref2, ref3;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getDealerDashboard(1, "PAYMENT_PENDING, PENDING_VERIFICATION , FAILED")
                            ];
                        case 1:
                            ref = _state.sent(), pendingStatus = ref.status, pendingData = ref.data;
                            return [
                                4,
                                req.getDealerDashboard(1, "ISSUED")
                            ];
                        case 2:
                            ref1 = _state.sent(), completedStatus = ref1.status, completedData = ref1.data;
                            if (pendingStatus && (pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders) && completedStatus && (completedData === null || completedData === void 0 ? void 0 : completedData.orders)) {
                                ;
                                setPendingOrders((pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders) || []);
                                setCompletedOrders((completedData === null || completedData === void 0 ? void 0 : completedData.orders) || []);
                                if ((pendingData === null || pendingData === void 0 ? void 0 : (ref2 = pendingData.orders) === null || ref2 === void 0 ? void 0 : ref2.length) > 9) {
                                    setPendingOrdersPage(2);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hasMore), {
                                        pending: (pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders.length) > 9,
                                        completed: (completedData === null || completedData === void 0 ? void 0 : completedData.orders.length) > 9
                                    }));
                                }
                                if ((completedData === null || completedData === void 0 ? void 0 : (ref3 = completedData.orders) === null || ref3 === void 0 ? void 0 : ref3.length) > 9) {
                                    setCompletedOrdersPage(2);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hasMore), {
                                        pending: (pendingData === null || pendingData === void 0 ? void 0 : pendingData.orders.length) > 9,
                                        completed: (completedData === null || completedData === void 0 ? void 0 : completedData.orders.length) > 9
                                    }));
                                }
                                setErrorMessage("");
                            } else {
                                setErrorMessage("Something went wrong.");
                            }
                            setIsPageLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    }, []);
    var onLoadMore = function(selectedTab) {
        __webpack_require__.e(/* import() */ 149).then(__webpack_require__.bind(__webpack_require__, 5149)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(req) {
                var page, ref, status, data, ref1, ref2, ref3, ref4;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            page = selectedTab === "pending" ? pendingOrdersPage : completedOrdersPage;
                            return [
                                4,
                                req.getDealerDashboard(page, selectedTab === "pending" ? "PAYMENT_PENDING, PENDING_VERIFICATION , FAILED" : "ISSUED")
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status && (data === null || data === void 0 ? void 0 : data.orders)) {
                                if (selectedTab === "pending") {
                                    ;
                                    if ((data === null || data === void 0 ? void 0 : (ref1 = data.orders) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                                        ;
                                        setPendingOrders(pendingOrders.concat(data === null || data === void 0 ? void 0 : data.orders));
                                        (data === null || data === void 0 ? void 0 : (ref2 = data.orders) === null || ref2 === void 0 ? void 0 : ref2.length) > 9 && setPendingOrdersPage(pendingOrdersPage + 1);
                                    }
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hasMore), {
                                        pending: (data === null || data === void 0 ? void 0 : data.orders.length) > 9
                                    }));
                                } else if (selectedTab === "completed") {
                                    ;
                                    if ((data === null || data === void 0 ? void 0 : (ref3 = data.orders) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                                        ;
                                        setCompletedOrders(completedOrders.concat(data === null || data === void 0 ? void 0 : data.orders));
                                        (data === null || data === void 0 ? void 0 : (ref4 = data.orders) === null || ref4 === void 0 ? void 0 : ref4.length) > 9 && setCompletedOrdersPage(completedOrdersPage + 1);
                                    }
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hasMore), {
                                        completed: (data === null || data === void 0 ? void 0 : data.orders.length) > 9
                                    }));
                                }
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    // TODO : This is causing 2 api call on page load
    (0,compat_module.useEffect)(function() {
        var timeout;
        if (isSearchInteracted && (searchValue.length === 10 || searchValue.length === 0)) {
            timeout = setTimeout(function() {
                setHasMore({
                    pending: true,
                    completed: true
                });
                setPendingOrdersPage(1);
                setCompletedOrdersPage(1);
                getTransactions();
                setIsPageSearchLoading(true);
            }, 1000);
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchValue,
        isSearchInteracted
    ]);
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    if (isPageLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (errorMesssage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            isPageSearchLoading && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dashboardV2_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dashboardV2_styles_Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboardV2_styles_Section, {
                                $index: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboardV2_newPlan, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboardV2_styles_Section, {
                                $index: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_TransactionSearchFlex, {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_search_input_dist_default()), {
                                            className: "",
                                            placeholder: "Search by mobile number",
                                            handleChange: function(value) {
                                                setSearchValue(value);
                                                setIsSearchInteracted(true);
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboardV2_styles_Section, {
                                $index: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboardV2_transactions, {
                                    pendingOrders: pendingOrders,
                                    completedOrders: completedOrders,
                                    hasMorePending: hasMore.pending,
                                    hasMoreCompleted: hasMore.completed,
                                    onLoadMore: onLoadMore
                                })
                            })
                        ]
                    })
                ]
            }),
            legalDetailsUploadedStatus && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                show: true,
                urlhash: "",
                onHide: function() {},
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                hideCloseButton: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocumentPending, {})
            })
        ]
    });
}
/* harmony default export */ var dashboardV2 = (DashboardV2);

;// CONCATENATED MODULE: ./components/thankyouV1/styles.ts

function thankyouV1_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 20px;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    thankyouV1_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n"
    ]);
    thankyouV1_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 22px;\n    color: #040222;\n    margin-top: 12px;\n"
    ]);
    thankyouV1_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    thankyouV1_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    margin-top: 10px;\n"
    ]);
    thankyouV1_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 22px;\n    text-align: center;\n    color: #040222;\n    margin: 0 0 12px 0;\n"
    ]);
    thankyouV1_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    color: #5b5675;\n    margin-top: 10px;\n"
    ]);
    thankyouV1_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    color: #5b5675;\n    margin-top: 10px;\n    padding: 20px;\n    border-radius: 4px;\n    background-color: #ffebfa;\n"
    ]);
    thankyouV1_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    color: #5b5675;\n    margin-top: 10px;\n"
    ]);
    thankyouV1_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 150%;\n    color: #5b5675;\n    margin-top: 16px;\n    text-align: center;\n"
    ]);
    thankyouV1_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function thankyouV1_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    thankyouV1_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var thankyouV1_styles_Wrapper = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject());
var thankyouV1_styles_Banner = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject1());
var TextBlock = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject2());
var OrderedList = styled_components_browser_esm["default"].ol(thankyouV1_styles_templateObject3());
var OrderListItem = styled_components_browser_esm["default"].li(thankyouV1_styles_templateObject4());
var thankyouV1_styles_Text = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject5());
var SubTextBlock = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject6());
var LightSubTextBlock = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject7());
var styles_SubText = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject8());
var thankyouV1_styles_Description = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject9());
var thankyouV1_styles_GoHomeButtonWrapper = styled_components_browser_esm["default"].div(thankyouV1_styles_templateObject10());

;// CONCATENATED MODULE: ./components/thankyouV1/successV1/index.tsx






var SuccessV1 = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(thankyouV1_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TextBlock, {
                children: "Congratulations \uD83E\uDD29"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubTextBlock, {
                children: "The protection plan has been issued for the customer and the details sent to their phone number and email."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1_styles_Banner, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "250px",
                    height: "250px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/Success.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TextBlock, {
                children: "Few Points to Remember \uD83D\uDCCC"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(OrderedList, {
                type: "a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OrderListItem, {
                        children: "Please furnish the plan invoice to the customer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OrderListItem, {
                        children: "View your commission under Completed Transaction"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1_styles_GoHomeButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onClick,
                    children: "Got it"
                })
            })
        ]
    });
};
/* harmony default export */ var successV1 = (SuccessV1);

;// CONCATENATED MODULE: ./components/thankyouV1/failureV1/index.tsx





var FailureV1 = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(thankyouV1_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TextBlock, {
                children: "Sorry \uD83D\uDE14"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubTextBlock, {
                children: "Unfortunately, the payment to Acko has failed and plan hasn 't been issued. Please retry the transaction again"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1_styles_Banner, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "250px",
                    height: "250px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/payment_failure.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1_styles_GoHomeButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onClick,
                    children: "Retry the transaction"
                })
            })
        ]
    });
};
/* harmony default export */ var failureV1 = (FailureV1);

;// CONCATENATED MODULE: ./components/thankyouV1/pendingV1/index.tsx





var PendingV1 = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(thankyouV1_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1_styles_Banner, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "250px",
                    height: "250px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/payment_pending.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LightSubTextBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1_styles_Text, {
                        children: "Payment Pending"
                    }),
                    "Your payment is currently being processed. Please check the transactions tab in 5 minutes for the final status."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1_styles_GoHomeButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    onClick: onClick,
                    children: "Go to Home"
                })
            })
        ]
    });
};
/* harmony default export */ var pendingV1 = (PendingV1);

;// CONCATENATED MODULE: ./components/thankyouV1/paymentStatusPoller.ts
/**
 * Pure, framework-free payment-status polling controller.
 *
 * Extracted out of `thankyouV1/index.tsx` so the concurrency/abort
 * guards can be unit tested (see `paymentStatusPoller.test.ts`) without a
 * DOM or React renderer, matching the pattern used by
 * `features/imeiScanner/cameraSelection.ts`.
 */ 

var FINAL_STATUSES = new Set([
    "success",
    "failure"
]);
function createPaymentStatusPoller(fetchStatus, callbacks) {
    var maxAttempts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var isFetching = false;
    var stopped = false;
    var attemptCount = 0;
    var abortController = new AbortController();
    var stop = function() {
        var ref;
        if (stopped) return;
        stopped = true;
        abortController.abort();
        (ref = callbacks.onDone) === null || ref === void 0 ? void 0 : ref.call(callbacks);
    };
    var poll = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var signal, response, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isFetching || stopped) return [
                            2
                        ];
                        isFetching = true;
                        signal = abortController.signal;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchStatus(signal)
                        ];
                    case 2:
                        response = _state.sent();
                        // This attempt completed a real round trip — count it even if
                        // the answer turns out to be stale (see below), but not if it
                        // was cancelled (handled in the catch branch instead).
                        isFetching = false;
                        attemptCount += 1;
                        callbacks.onAttemptSettled(attemptCount);
                        // The poller may have been stopped (e.g. another mechanism
                        // already reached a final status) while this request was
                        // in flight — ignore this now-stale response instead of
                        // overwriting already-resolved state.
                        if (stopped) return [
                            2
                        ];
                        if (response.status === 200 && response.data) {
                            callbacks.onStatus(response.data);
                            if (FINAL_STATUSES.has(response.data)) {
                                stop();
                                return [
                                    2
                                ];
                            }
                        }
                        if (attemptCount >= maxAttempts) {
                            stop();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        isFetching = false;
                        if (signal.aborted) {
                            // Deliberately cancelled mid-flight (final status reached
                            // elsewhere, or the caller stopped polling) — not a
                            // completed attempt, so it must not count towards
                            // attemptCount or surface as an error.
                            return [
                                2
                            ];
                        }
                        attemptCount += 1;
                        callbacks.onAttemptSettled(attemptCount);
                        if (!stopped) {
                            callbacks.onError(err);
                        }
                        if (attemptCount >= maxAttempts) {
                            stop();
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function poll() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        poll: poll,
        stop: stop,
        isDone: function() {
            return stopped;
        },
        getAttemptCount: function() {
            return attemptCount;
        }
    };
}

;// CONCATENATED MODULE: ./components/thankyouV1/index.tsx




















var POLL_INTERVAL_MS = 5000;
var MAX_POLL_ATTEMPTS = 3;
var ThankYouV1 = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, dealerType = ref.dealerType;
    var payment_order_ekey = router.query.payment_order_ekey;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var ref1 = (0,compat_module.useState)({
        id: Date.now(),
        status: ""
    }), paymentStatus = ref1[0], setPaymentStatus = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,compat_module.useState)(""), errorMessage = ref3[0], setErrorMessage = ref3[1];
    var callCount = (0,compat_module.useRef)(0);
    (0,compat_module.useEffect)(function() {
        // Each effect run polls for a fresh (partnerId, payment_order_ekey)
        // pair (e.g. once router.query hydrates) — start from a clean
        // attempt count instead of carrying over whatever a previous run
        // left behind on this ref.
        callCount.current = 0;
        var intervalId = null;
        var stopInterval = function() {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };
        // Guards against the race that caused "Oops. Something went wrong":
        // a call already in-flight (e.g. started just before a success
        // response landed) could resolve/fail afterwards — often with a
        // 410 once the backend considers the order finalized — and
        // clobber a perfectly good success/failure state. The serialize /
        // final-status / abort guards live in `paymentStatusPoller` so
        // they can be unit tested directly.
        var poller = createPaymentStatusPoller(function(signal) {
            return (0,lib_axios/* default */.Z)((0,src_object_spread/* default */.Z)({
                method: "GET",
                url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/payment"),
                params: {
                    payment_order_ekey: payment_order_ekey,
                    user_type: "dealer"
                },
                signal: signal
            }, (0,serverConfig/* getAxiosConfig */.uZ)()));
        }, {
            onStatus: function(data) {
                setErrorMessage("");
                var eventName = data === "success" ? constants/* SegmentViewEvents.VIEW_PAYMENT_SUCCESS */.od.VIEW_PAYMENT_SUCCESS : constants/* SegmentViewEvents.VIEW_PAYMENT_FAILURE */.od.VIEW_PAYMENT_FAILURE;
                (0,building_blocks_ui_acko_analytics_dist.pageEvent)(eventName, {
                    page: constants/* SegmentPages.PAYMENT */.IT.PAYMENT,
                    partner: partnerId,
                    product: "pos",
                    journey: "buy",
                    platform: "mweb",
                    type: dealerType
                });
                setPaymentStatus(function() {
                    return {
                        id: Date.now(),
                        status: data
                    };
                });
            },
            onError: function() {
                setErrorMessage("Oops. Something went wrong.");
            },
            // Only real, completed attempts land here — an aborted
            // poll (cancelled mid-flight) never reaches this callback,
            // so it can no longer inflate callCount.
            onAttemptSettled: function(attemptCount) {
                callCount.current = attemptCount;
                setIsLoading(false);
            },
            onDone: stopInterval
        }, MAX_POLL_ATTEMPTS);
        poller.poll();
        intervalId = setInterval(function() {
            poller.poll();
        }, POLL_INTERVAL_MS);
        return function() {
            stopInterval();
            poller.stop();
        };
    }, [
        partnerId,
        payment_order_ekey,
        dealerType
    ]);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                    src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
                })
            ]
        });
    }
    if (errorMessage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {}),
                ";"
            ]
        });
    }
    var goHome = function() {
        router.push("/".concat(lob, "/").concat(partnerId, "/dashboard"));
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.ThemeProvider, {
        theme: dist.AckoMainTheme,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(thankyouV1_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                callCount.current < 3 ? paymentStatus.status === "success" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(successV1, {
                    onClick: goHome
                }) : paymentStatus.status === "failure" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(failureV1, {
                    onClick: goHome
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
                    src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
                }) : // paymentStatus.status === 'pending'
                paymentStatus.status === "success" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(successV1, {
                    onClick: goHome
                }) : paymentStatus.status === "failure" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(failureV1, {
                    onClick: goHome
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(pendingV1, {
                    onClick: goHome
                })
            ]
        })
    });
};
/* harmony default export */ var thankyouV1 = (ThankYouV1);

;// CONCATENATED MODULE: ./components/thankYouPage/index.tsx





var ThankYouPage = function() {
    var permissions = (0,compat_module.useContext)(context/* MPosContext */.w).permissions;
    if (permissions.purchase_journey === "v1") {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyouV1, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankyou, {});
};
/* harmony default export */ var thankYouPage = (ThankYouPage);

;// CONCATENATED MODULE: ./components/CommissionListing/styles.ts

function CommissionListing_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    CommissionListing_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% + 40px);\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-top: 10px;\n    transform: translateX(-20px);\n"
    ]);
    CommissionListing_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    CommissionListing_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CommissionListing_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CommissionListing_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 10px;\n"
    ]);
    CommissionListing_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n    display: flex;\n"
    ]);
    CommissionListing_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin: 10px 0;\n    ",
        "\n"
    ]);
    CommissionListing_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 10px 0;\n"
    ]);
    CommissionListing_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    line-height: 16px;\n    margin-top: 4px;\n    color: rgb(216, 61, 55);\n"
    ]);
    CommissionListing_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n"
    ]);
    CommissionListing_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: '100%';\n    display: 'grid';\n    place-items: 'center';\n"
    ]);
    CommissionListing_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    gap: 10px;\n"
    ]);
    CommissionListing_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    border: none;\n    background: transparent;\n"
    ]);
    CommissionListing_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    height: 300px;\n    @media screen and (min-width: 768px) {\n        min-width: 400px;\n        height: 200px;\n    }\n"
    ]);
    CommissionListing_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 30%;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid black;\n"
    ]);
    CommissionListing_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    border: none;\n    text-align: left;\n"
    ]);
    CommissionListing_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    text-transform: capitalize;\n"
    ]);
    CommissionListing_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 70%;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n"
    ]);
    CommissionListing_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    border: none;\n    text-align: left;\n    display: flex;\n    align-items: center;\n"
    ]);
    CommissionListing_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid black;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    margin-right: 4px;\n    padding: 3px;\n"
    ]);
    CommissionListing_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n"
    ]);
    CommissionListing_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function CommissionListing_styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    text-transform: capitalize;\n"
    ]);
    CommissionListing_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}

var CommissionListing_styles_Wrapper = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject());
var CommissionListing_styles_Hr = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject1());
var CommissionListing_styles_Header = styled_components_browser_esm["default"].header(CommissionListing_styles_templateObject2());
var CommissionListing_styles_HeaderTextWrapper = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject3());
var CommissionListing_styles_HeaderText = styled_components_browser_esm["default"].h3(CommissionListing_styles_templateObject4());
var styles_HeaderIcon = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject5());
var styles_CommisionFilterWrapper = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject6());
var styles_DropDownBox = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject7(), function(props) {
    return props.is_mobile ? "justify-content: space-around;" : "align-items:center;";
});
var CommissionListing_styles_CalendarWrapper = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject8());
var CommissionListing_styles_ErrorText = styled_components_browser_esm["default"].p(CommissionListing_styles_templateObject9());
var styles_ListingWrapper = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject10());
var styles_LoaderBox = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject11());
var CommissionListing_styles_ButtonWrapper = styled_components_browser_esm["default"].footer(CommissionListing_styles_templateObject12());
var styles_FilterOptionButtonWrapper = styled_components_browser_esm["default"].button(CommissionListing_styles_templateObject13());
var FilterOption = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject14());
var FilterOptionKeys = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject15());
var FilterOptionKeyBox = styled_components_browser_esm["default"].button(CommissionListing_styles_templateObject16());
var FilterOptionKey = styled_components_browser_esm["default"].p(CommissionListing_styles_templateObject17());
var FilterOptionValues = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject18());
var FilterOptionValueBox = styled_components_browser_esm["default"].button(CommissionListing_styles_templateObject19());
var FilterOptionCheckBox = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject20());
var FilterOptionCheckInnerBox = styled_components_browser_esm["default"].div(CommissionListing_styles_templateObject21());
var FilterOptionValue = styled_components_browser_esm["default"].p(CommissionListing_styles_templateObject22());

;// CONCATENATED MODULE: ./components/CommissionListing/api.ts






var api_getCommissionSummary = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(request, partnerId) {
        var response, data, status, e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/order/commission-summary")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: request
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        return [
                            2,
                            (0,src_object_spread/* default */.Z)({
                                status: true
                            }, data)
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCommissionSummary(request, partnerId) {
        return _ref.apply(this, arguments);
    };
}();
var downloadCommissionReport = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(request, partnerId, onProgress) {
        var response, data, status, e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,lib_axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/order/commission-summary/download")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: request,
                            responseType: "blob",
                            onDownloadProgress: function(progressEvent) {
                                if (onProgress) {
                                    var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                                    onProgress(percentCompleted);
                                }
                            }
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        return [
                            2,
                            {
                                status: true,
                                blobData: data
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function downloadCommissionReport(request, partnerId, onProgress) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/CommissionListing/PaginatedTable/index.tsx

function PaginatedTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 40px auto;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    width: 100%;\n    overflow: scroll;\n"
    ]);
    PaginatedTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PaginatedTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-collapse: collapse;\n"
    ]);
    PaginatedTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PaginatedTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #f4f4f4;\n    padding: 12px;\n    text-align: center;\n    font-weight: bold;\n    border-bottom: 2px solid #ddd;\n"
    ]);
    PaginatedTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PaginatedTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &:nth-child(even) {\n        background-color: #f9f9f9;\n    }\n"
    ]);
    PaginatedTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PaginatedTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 8px;\n    border-bottom: 1px solid #ddd;\n    text-align: center;\n    text-wrap: nowrap;\n"
    ]);
    PaginatedTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PaginatedTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    padding: 16px;\n    align-items: center;\n"
    ]);
    PaginatedTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PaginatedTable_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 5px;\n    padding: 4px 6px;\n    border: 1px solid #ddd;\n    background-color: white;\n    cursor: pointer;\n\n    &:disabled {\n        cursor: not-allowed;\n        color: #aaa;\n    }\n"
    ]);
    PaginatedTable_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PaginatedTable_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    PaginatedTable_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var PaginatedTable_TableContainer = styled_components_browser_esm["default"].div(PaginatedTable_templateObject());
var PaginatedTable_StyledTable = styled_components_browser_esm["default"].table(PaginatedTable_templateObject1());
var PaginatedTable_TableHeader = styled_components_browser_esm["default"].th(PaginatedTable_templateObject2());
var PaginatedTable_TableRow = styled_components_browser_esm["default"].tr(PaginatedTable_templateObject3());
var PaginatedTable_TableData = styled_components_browser_esm["default"].td(PaginatedTable_templateObject4());
var Pagination = styled_components_browser_esm["default"].div(PaginatedTable_templateObject5());
var PaginatedTable_PageButton = styled_components_browser_esm["default"].button(PaginatedTable_templateObject6());
var PaginatedTable_NoResult = styled_components_browser_esm["default"].div(PaginatedTable_templateObject7());
var PaginatedTable_PaginatedTable = function(props) {
    var headers = props.headers, data = props.data, totalPages = props.totalPages, onNext = props.onNext, onBack = props.onBack, currentPage = props.currentPage;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: data.length === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_NoResult, {
            children: "No commissions"
        }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_TableContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PaginatedTable_StyledTable, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tr", {
                                    children: headers.map(function(header) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_TableHeader, {
                                            children: header.name
                                        }, header.key);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tbody", {
                                children: data.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_TableRow, {
                                        children: headers.map(function(header) {
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_TableData, {
                                                children: item[header.key]
                                            }, header.key);
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Pagination, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_PageButton, {
                            onClick: onBack,
                            disabled: currentPage === 1,
                            hidden: currentPage === 1,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                                alt: "Previous",
                                width: "20px",
                                height: "20px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                            children: [
                                currentPage,
                                " / ",
                                totalPages
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PaginatedTable_PageButton, {
                            onClick: onNext,
                            disabled: currentPage === totalPages,
                            hidden: currentPage === totalPages,
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                                alt: "Previous",
                                width: "20px",
                                height: "20px",
                                style: {
                                    rotate: "180deg"
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CommissionListing_PaginatedTable = (PaginatedTable_PaginatedTable);

;// CONCATENATED MODULE: ./components/CommissionListing/index.tsx




















var CommissionListing = function() {
    var partnerId = (0,compat_module.useContext)(context/* MPosContext */.w).partnerId;
    var ref = (0,compat_module.useState)({
        from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
        end: new Date()
    }), dateRange = ref[0], setDateRange = ref[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref1 = (0,compat_module.useState)(false), loader = ref1[0], setLoader = ref1[1];
    var ref2 = (0,compat_module.useState)(false), filterClicked = ref2[0], setFilterClicked = ref2[1];
    var ref3 = (0,compat_module.useState)("group_by"), selectedKey = ref3[0], setSelectedKey = ref3[1];
    var ref4 = (0,compat_module.useState)("DATE"), selectedValue = ref4[0], setSelectedValue = ref4[1];
    var ref5 = (0,compat_module.useState)([]), filters = ref5[0], setFilters = ref5[1];
    var ref6 = (0,compat_module.useState)(0), page = ref6[0], setPage = ref6[1];
    var ref7 = (0,compat_module.useState)([]), headers = ref7[0], setHeaders = ref7[1];
    var ref8 = (0,compat_module.useState)([]), data = ref8[0], setData = ref8[1];
    var ref9 = (0,compat_module.useState)(0), totalPages = ref9[0], setTotalPages = ref9[1];
    var ref10 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref10[0], setSnackbar = ref10[1];
    var ref11 = (0,compat_module.useState)(0), progress = ref11[0], setProgress = ref11[1];
    var ref12 = (0,compat_module.useState)(false), isApiTriggered = ref12[0], setIsApiTriggered = ref12[1];
    var ref13 = (0,compat_module.useState)(""), calendarError = ref13[0], setCalendarError = ref13[1];
    var ref14 = (0,compat_module.useState)(false), buttonLoader = ref14[0], setButtonLoader = ref14[1];
    var getSummary = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(page) {
            var request, data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoader(true);
                        request = (0,_define_property/* default */.Z)({
                            from_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.from),
                            to_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.end),
                            page: page
                        }, selectedKey, selectedValue);
                        return [
                            4,
                            api_getCommissionSummary(request, partnerId)
                        ];
                    case 1:
                        data = _state.sent();
                        setFilters(data.filters);
                        setHeaders(data.headers);
                        setData(data.data);
                        setTotalPages(data.total_pages);
                        if (!data.status) {
                            setSnackbar({
                                type: "failure",
                                message: "Failed to fetch commission"
                            });
                        } else {
                            setSnackbar({
                                type: "",
                                message: ""
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        setSnackbar({
                            type: "failure",
                            message: "Failed to fetch commissions"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoader(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getSummary(page) {
            return _ref.apply(this, arguments);
        };
    }();
    // const clickApply = () => {
    //     setPage(0);
    //     getSummary(0);
    // };
    (0,compat_module.useEffect)(function() {
        if (isApiTriggered) {
            setPage(0);
            getSummary(0);
        }
    }, [
        selectedValue
    ]);
    (0,compat_module.useEffect)(function() {
        if (!isApiTriggered) {
            getSummary(0);
            setIsApiTriggered(true);
        }
    }, []);
    console.log("Progress", progress);
    (0,compat_module.useEffect)(function() {
        if (isApiTriggered) {
            if (dateRange.from.getTime() > dateRange.end.getTime()) {
                setCalendarError("Start Date cannot be greater than End date");
            } else {
                setCalendarError("");
                getSummary(0);
            }
        }
    }, [
        dateRange
    ]);
    (0,compat_module.useEffect)(function() {
        if (isApiTriggered) {
            getSummary(page);
        }
    }, [
        page
    ]);
    var onChange = function(e, id) {
        switch(id){
            case "from":
                setDateRange(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        from: e
                    });
                });
                break;
            case "end":
                setDateRange(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        end: e
                    });
                });
                break;
            default:
        }
    };
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    var valueSelected = function() {
        setFilterClicked(false);
    };
    var onNextPage = function() {
        setPage(page + 1);
    };
    var onPrevioudPage = function() {
        setPage(page - 1);
    };
    var handleDownload = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var _obj, request, response, url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setButtonLoader(true);
                        setProgress(0); // Reset progress before starting
                        request = (_obj = {
                            from_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.from),
                            to_date: (0,date/* getDD_MM_YYYY */.PZ)(dateRange.end)
                        }, (0,_define_property/* default */.Z)(_obj, selectedKey, selectedValue), (0,_define_property/* default */.Z)(_obj, "page", page), _obj);
                        return [
                            4,
                            downloadCommissionReport(request, partnerId, function(progress) {
                                setProgress(progress);
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status && response.blobData) {
                            url = window.URL.createObjectURL(response.blobData);
                            window.open(url, "_blank", "noopener,noreferrer");
                        } else {
                            setSnackbar({
                                type: "failure",
                                message: "Failed to download the report."
                            });
                        }
                        setButtonLoader(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CommissionListing_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListing_styles_Hr, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListingHeader, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CommisionFilterWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_DropDownBox, {
                            is_mobile: isMobile,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CommissionListing_styles_CalendarWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                                            title: "From",
                                            defaultDate: dateRange.from,
                                            onSelect: function(date) {
                                                onChange(date, "from");
                                            },
                                            enableWindow: {
                                                start: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
                                                current: dateRange.from,
                                                end: new Date()
                                            },
                                            isDesktop: !isMobile
                                        }),
                                        calendarError && calendarError !== null && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListing_styles_ErrorText, {
                                            children: calendarError
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListing_styles_CalendarWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_calendar_dist_default()), {
                                        title: "To",
                                        defaultDate: dateRange.end,
                                        onSelect: function(date) {
                                            onChange(date, "end");
                                        },
                                        enableWindow: {
                                            start: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
                                            current: dateRange.end,
                                            end: new Date()
                                        },
                                        isDesktop: !isMobile
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ListingWrapper, {
                        children: loader ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LoaderBox, {
                            style: {
                                height: "100%",
                                display: "grid",
                                placeItems: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: "/gif/pageLoader.gif",
                                alt: "",
                                height: "150px",
                                width: "150px",
                                style: {
                                    margin: "0 auto"
                                }
                            })
                        }) : data && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListing_PaginatedTable, {
                            headers: headers,
                            data: data,
                            totalPages: totalPages,
                            onNext: onNextPage,
                            onBack: onPrevioudPage,
                            currentPage: page + 1
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CommissionListing_styles_ButtonWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_FilterOptionButtonWrapper, {
                                onClick: function() {
                                    setFilterClicked(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                        src: (0,generics/* getImageBasePath */.m4)("/icons/filter.svg"),
                                        alt: "",
                                        width: "40px",
                                        height: "40px"
                                    }),
                                    "Filter"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                onClick: handleDownload,
                                loading: buttonLoader,
                                children: "Download"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                show: filterClicked,
                urlhash: "",
                onHide: function() {
                    setFilterClicked(false);
                },
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                hideCloseButton: false,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptions, {
                    filters: filters,
                    selectedKey: selectedKey,
                    selectedValue: selectedValue,
                    setSelectedKey: setSelectedKey,
                    setSelectedValue: setSelectedValue,
                    close: valueSelected
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
var CommissionListingHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CommissionListing_styles_Header, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_HeaderIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: (0,generics/* getImageBasePath */.m4)("/icons/commissions_light.svg"),
                    alt: "",
                    width: "30px",
                    height: "30px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListing_styles_HeaderTextWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CommissionListing_styles_HeaderText, {
                    children: "Sales Report"
                })
            })
        ]
    });
};
var FilterOptions = function(props) {
    var filters = props.filters, selectedKey = props.selectedKey, selectedValue = props.selectedValue, setSelectedKey = props.setSelectedKey, setSelectedValue = props.setSelectedValue, close = props.close;
    var ref = (0,compat_module.useState)(selectedKey), filterKey = ref[0], setFilterKey = ref[1];
    var ref1 = (0,compat_module.useState)(selectedValue), filterValue = ref1[0], setFilterValue = ref1[1];
    var ref2 = (0,compat_module.useState)([]), values = ref2[0], setValues = ref2[1];
    var keys = filters === null || filters === void 0 ? void 0 : filters.map(function(filter) {
        return filter.key;
    });
    (0,compat_module.useEffect)(function() {
        if (filterKey !== "") {
            Object.values(filters).forEach(function(filter) {
                if ((filter === null || filter === void 0 ? void 0 : filter.key) === filterKey) {
                    setValues(filter.values);
                    setSelectedKey(filterKey);
                }
            });
        }
    }, [
        filterKey
    ]);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FilterOption, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptionKeys, {
                children: keys.map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptionKeyBox, {
                        onClick: function() {
                            setFilterKey(key);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptionKey, {
                            style: {
                                color: filterKey === key ? "green" : "black"
                            },
                            children: (0,date/* snakeToCapitalized */.tj)(key)
                        })
                    }, key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptionValues, {
                children: values.map(function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FilterOptionValueBox, {
                        onClick: function() {
                            setFilterValue(value.key);
                            setSelectedValue(value.key);
                            close();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptionCheckBox, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptionCheckInnerBox, {
                                    style: {
                                        backgroundColor: value.key === filterValue ? "green" : "transparent"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FilterOptionValue, {
                                style: {
                                    color: value.key === filterValue ? "green" : "black"
                                },
                                children: value.display_name
                            })
                        ]
                    }, value.key);
                })
            })
        ]
    });
};
/* harmony default export */ var components_CommissionListing = (CommissionListing);

;// CONCATENATED MODULE: ./pages/[...slug]/index.tsx










// routes

// components













function Routes() {
    var getRoutePath = function getRoutePath(route) {
        switch(route){
            case "dashboard":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboard/* default */.Z, {});
            case "commissions-earned":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_CommissionListing, {});
            case "commissions-earned-v1":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_CommissionListingV1, {
                    showHeader: true
                });
            case "manage-dealers":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(manageDealers, {});
            case "new-plan":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan, {});
            case "payment":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(payment, {});
            case "payment-mode":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(paymentMode, {});
            case "transactions":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions, {});
            case "thankyou":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(thankYouPage, {});
            case "contact-us":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs, {});
            case "legal-documents":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocuments, {});
            case "gst-details":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstDetails, {});
            case "details":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(details, {});
            case "legal-tnc":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalTnc, {});
            case "report-dashboard":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reportDashboard, {});
            case "dealer-details":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_dealerDetails, {});
            case "wallet-transactions":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(walletTransactions, {});
            case "service-partner":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(serviceCenterOnboarding, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
                    errorCode: 404,
                    errorMessage: "Page not found"
                });
        }
    };
    var getRoutePathPartnership = function getRoutePathPartnership() {
        switch(route){
            case "dashboard":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dashboardV2, {});
            case "manage-dealers":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(manageDealers, {});
            case "contact-us":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(contactUs, {});
            case "transactions":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions, {});
            case "payment-mode":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(paymentMode, {});
            case "dealer-details":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_dealerDetails, {});
            case "details":
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(details, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
                    errorCode: 404,
                    errorMessage: "Page not found"
                });
        }
    };
    var ref = (0,useFetchParams/* useFetchParams */.u)(), route = ref.route, lob = ref.lob;
    var getRouteFunction = function() {
        switch(lob){
            case "auto-lob":
                return ather;
            case "auto-partnership":
                return getRoutePathPartnership;
            case "embedded":
            default:
                return getRoutePath;
        }
    };
    var renderComponent = getRouteFunction();
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.ThemeProvider, {
        theme: dist.AckoMainTheme,
        children: renderComponent(route)
    });
}
/* harmony default export */ var _slug_ = (Routes);


/***/ }),

/***/ 816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q2": function() { return /* binding */ newPlanUrls; },
/* harmony export */   "VV": function() { return /* binding */ partnershipDealerUrls; },
/* harmony export */   "WQ": function() { return /* binding */ authUrls; }
/* harmony export */ });
/* unused harmony export dealerUrls */
var authUrls = {
    login: "/authentication/api/v1/auth/initiate",
    sendOtp: "/authentication/api/v1/auth/otp/send",
    verifyOtp: "/authentication/api/v1/auth/otp/verify"
};
var dealerUrls = {
    dashboardDashboard: "api/mpos/dealer-dashboard"
};
var newPlanUrls = {
    documentUpload: "api/mpos/upload"
};
var partnershipDealerUrls = {
    dashboardDashboard: "auto-insurance/mpos/dashboard/orders",
    order: "auto-insurance/mpos/order"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [864,9,987,674,485,937,888,179], function() { return __webpack_exec__(5620); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);